/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		75: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"chunk-offersSingleCode","1":"chunk-offersMultipleCode","2":"chunk-participationLeadGen","3":"chunk-eventsCalendar","4":"chunk-participationFeedback","5":"chunk-participationCounter","6":"chunk-participationContest","7":"chunk-participationSignUp","8":"chunk-storeLocator","9":"chunk-commerceProduct360","10":"chunk-showcaseMultiHotspot","11":"chunk-participationPoll","12":"chunk-offersOfferOnAndOffline","13":"chunk-offersBanner","14":"chunk-gamesAndAppsDriveUsage","15":"chunk-gamesAndAppsDriveInstalls","16":"chunk-commerceCollections","17":"chunk-commerce","18":"chunk-booking","19":"chunk-decisions","20":"chunk-decisionsV2","21":"chunk-bookingFlight","22":"chunk-showcaseGallery","23":"chunk-showcaseChapter","24":"chunk-eventsWebinar","25":"chunk-participationGates","26":"chunk-participationBookDemo","27":"chunk-commerceMultiStores","28":"chunk-socialShare","29":"chunk-socialEmotion","30":"chunk-participationCall","31":"chunk-storeLocator-style","32":"chunk-socialShare-style","33":"chunk-socialEmotion-style","34":"chunk-showcaseMultiHotspot-style","35":"chunk-showcaseGallery-style","36":"chunk-showcaseChapter-style","37":"chunk-participationSignUp-style","38":"chunk-participationPoll-style","39":"chunk-participationLeadGen-style","40":"chunk-participationGates-style","41":"chunk-participationFeedback-style","42":"chunk-participationCounter-style","43":"chunk-participationContest-style","44":"chunk-participationCall-style","45":"chunk-participationBookDemo-style","46":"chunk-offersSingleCode-style","47":"chunk-offersOfferOnAndOffline-style","48":"chunk-offersMultipleCode-style","49":"chunk-offersBanner-style","50":"chunk-gamesAndAppsDriveUsage-style","51":"chunk-gamesAndAppsDriveInstalls-style","52":"chunk-eventsWebinar-style","53":"chunk-eventsCalendar-style","54":"chunk-decisionsV2-style","55":"chunk-decisions-style","56":"chunk-commerceProduct360-style","57":"chunk-commerceMultiStores-style","58":"chunk-commerceCollections-style","59":"chunk-commerce-style","60":"chunk-booking-style","61":"chunk-screenads-layout","62":"chunk-screen-layout","63":"chunk-customEndCards","64":"chunk-eventsCalendar-icons-yahoo-png","65":"chunk-eventsCalendar-icons-outlook-png","66":"chunk-eventsCalendar-icons-ical-png","67":"chunk-eventsCalendar-icons-google-png","68":"chunk-scratch","69":"chunk-fsGalleryAd-layout","70":"chunk-fsGallery-layout","71":"chunk-miloCampaign","72":"chunk-dpSplitCampaign","73":"chunk-netflixCampaign","74":"chunk-bridge"}[chunkId]||chunkId) + ".chunk." + {"0":"98fde","1":"685a5","2":"e07c3","3":"2a638","4":"df8f5","5":"31666","6":"6beb8","7":"44f3f","8":"0ccbd","9":"e74bd","10":"9bb88","11":"6e90c","12":"70c79","13":"5d01a","14":"358a9","15":"cafb5","16":"ee86f","17":"d52b7","18":"b0810","19":"1c235","20":"21f6c","21":"2a7e1","22":"9749e","23":"d6547","24":"ca5c8","25":"09f73","26":"cf746","27":"7979d","28":"c789d","29":"0c9d8","30":"1fffe","31":"7bc72","32":"99f5c","33":"9e820","34":"854b2","35":"4e156","36":"1146e","37":"6f2f5","38":"c9449","39":"9a985","40":"6cb55","41":"f777e","42":"11468","43":"987f6","44":"bef1f","45":"df0c9","46":"36498","47":"5219b","48":"6e22f","49":"2d0be","50":"a91ae","51":"02c45","52":"f61a5","53":"f2377","54":"26820","55":"a5a11","56":"72145","57":"6f439","58":"dbcd4","59":"60b28","60":"b59af","61":"6c542","62":"6b940","63":"bb06d","64":"bd798","65":"5e868","66":"37af8","67":"ca339","68":"44873","69":"695c3","70":"5766d","71":"42ffb","72":"238a6","73":"b4297","74":"6582f"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/player/v3/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "1WOQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1XEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/spareparts/templates/intro/style.less
var style = __webpack_require__("LpE2");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/config.js
var config = __webpack_require__("xdL+");

// EXTERNAL MODULE: ./components/spareparts/social/style.less
var social_style = __webpack_require__("T1Xn");
var social_style_default = /*#__PURE__*/__webpack_require__.n(social_style);

// CONCATENATED MODULE: ./components/spareparts/social/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var social_SocialIcons = function (_Component) {
  _inherits(SocialIcons, _Component);

  function SocialIcons() {
    _classCallCheck(this, SocialIcons);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  SocialIcons.prototype.render = function render(props, state) {
    var _this2 = this;

    var templateTheme = this.props.template.template_bg_color || 'light';
    var themeConfig = config["g" /* themes */].variants[templateTheme];
    var socialIcon = { color: themeConfig.TEXT };

    return Object(preact_min["h"])(
      'div',
      { 'class': 'socialIconsContainer' },
      Object(preact_min["h"])(
        'div',
        { 'class': 'socialIconsWrapper' },
        this.props.icons && Object.keys(this.props.icons).map(function (item) {
          if (_this2.props.icons[item]) {
            return Object(preact_min["h"])(
              'a',
              { 'class': social_style_default.a.socialIcon, style: socialIcon, href: _this2.props.icons[item], target: '_top' },
              Object(preact_min["h"])('i', { 'class': config["c" /* icons */][item] })
            );
          }
        })
      )
    );
  };

  SocialIcons.prototype.handleClose = function handleClose() {
    this.props.destroyTag();
  };

  return SocialIcons;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/spareparts/templates/intro/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return intro_TmplIntro; });


function intro__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function intro__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function intro__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var intro_TmplIntro = function (_Component) {
	intro__inherits(TmplIntro, _Component);

	function TmplIntro() {
		intro__classCallCheck(this, TmplIntro);

		return intro__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	TmplIntro.prototype.render = function render(props, state) {
		var templateTheme = this.props.template && this.props.template.template_bg_color || 'light';
		var themeConfig = config["g" /* themes */].variants[templateTheme];

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'ottTemplate' },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'ottTemplateContainer intro' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'introCardWrapper' },
					Object(preact_min["h"])('h1', { 'class': 'videoTitle',
						dangerouslySetInnerHTML: { __html: props.title.toString().toLowerCase() } }),
					Object(preact_min["h"])('p', { 'class': 'videoDescription', dangerouslySetInnerHTML: { __html: props.desc } })
				),
				Object(preact_min["h"])(social_SocialIcons, { icons: props.social, destroyTag: this.props.destroyTag, template: this.props.template })
			)
		);
	};

	return TmplIntro;
}(preact_min["Component"]);



/***/ }),

/***/ "1yJE":
/***/ (function(module, exports, __webpack_require__) {

!function (e, t) {
   true ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.ReactPixel = t() : e.ReactPixel = t();
}(this, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;var o = n[r] = { i: r, l: !1, exports: {} };return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }var n = {};return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: r });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 1);
  }([function (e, t, n) {
    "use strict";
    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }return n;
      }return Array.from(e);
    }Object.defineProperty(t, "__esModule", { value: !0 });var o = !1,
        i = !1,
        a = function a() {
      return o || console.warn("Pixel not initialized before using call ReactPixel.init with required params"), o;
    },
        c = function c() {
      for (var e, t = arguments.length, n = Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }(e = console).info.apply(e, r(["[react-facebook-pixel]"].concat(n)));
    },
        f = { autoConfig: !0, debug: !1 };t.default = { init: function init(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : f;!function (e, t, n, r, o, i, a) {
          e.fbq || (o = e.fbq = function () {
            o.callMethod ? o.callMethod.apply(o, arguments) : o.queue.push(arguments);
          }, e._fbq || (e._fbq = o), o.push = o, o.loaded = !0, o.version = "2.0", o.queue = [], i = t.createElement(n), i.async = !0, i.src = r, a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(i, a));
        }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js"), e ? (!1 === n.autoConfig && fbq("set", "autoConfig", !1, e), fbq("init", e, t), o = !0, i = n.debug) : console.warn("Please insert pixel id for initializing");
      }, pageView: function pageView() {
        a() && (fbq("track", "PageView"), i && c("called fbq('track', 'PageView');"));
      }, track: function track(e, t) {
        a() && (fbq("track", e, t), i && (c("called fbq('track', '" + e + "');"), t && c("with data", t)));
      }, trackCustom: function trackCustom(e, t) {
        a() && (fbq("trackCustom", e, t), i && (c("called fbq('trackCustom', '" + e + "');"), t && c("with data", t)));
      }, fbq: function (e) {
        function t() {
          return e.apply(this, arguments);
        }return t.toString = function () {
          return e.toString();
        }, t;
      }(function () {
        if (a()) {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }fbq.apply(void 0, t), i && (c("called fbq('" + t.slice(0, 2).join("', '") + "')"), t[2] && c("with data", t[2]));
        }
      }) };
  }, function (e, t, n) {
    e.exports = n(0);
  }]);
});
//# sourceMappingURL=fb-pixel.js.map

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "7iVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tagsCover":"tagsCover__3CJ3n","tagsCoverContainer":"tagsCoverContainer__1tXq6","tagsCoverHeader":"tagsCoverHeader__1cMcy","tagsCoverFooter":"tagsCoverFooter__1_9gR","tagsLength":"tagsLength__2-e0h"};

/***/ }),

/***/ "8Jr4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"galleryWrapper":"galleryWrapper__27DbX","swiper-container":"swiper-container__3xZ3k","slideContainer":"slideContainer__z1RhX","iconZoom":"iconZoom__3Ng4C"};

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "BcX+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pulsate":"pulsate__rLXy9","pulsateBubbles":"pulsateBubbles__3kC3w","moveX":"moveX__1bbq-","click2Call__ring":"click2Call__ring__35N92","click2Call__disc":"click2Call__disc__2Jvnn","flip":"flip__TNl7v","displayImageAnim":"displayImageAnim__2XdyO","scaleIntoView":"scaleIntoView__6mA18","scaleOutOfView":"scaleOutOfView__15auj","fadeOut":"fadeOut__Ew7nt","pulse":"pulse__IoeGZ","ctaAnimation":"ctaAnimation__16DYu","ctaAnimationPulse":"ctaAnimationPulse__1L8P_","LandscapeOTTAnimateIntoView":"LandscapeOTTAnimateIntoView__3196z","fadeIn":"fadeIn__1ySPb","moveOutTop":"moveOutTop__1ZgcP","moveOutBottom":"moveOutBottom__1yuws","moveOutRight":"moveOutRight__3HFFl","rotate":"rotate__31SB-","dash":"dash__1kVsR","move":"move__1GGv0","collectionPreviewTitle":"collectionPreviewTitle__3kLuV","collectionThumb":"collectionThumb__3BOjD","displayImageFadeIn":"displayImageFadeIn__3gYlR","displayImageZoomIn":"displayImageZoomIn__3MBwy","displayTextMoveIn":"displayTextMoveIn__18CDX","displayFadeOut":"displayFadeOut__3wgPA","scale":"scale__tEG7T","progressWidth":"progressWidth__fcL7-","slideIn":"slideIn__1TGHb","slideInLeft":"slideInLeft__3n1jf","hotspotCtaFadeIn":"hotspotCtaFadeIn__235E7","hotspotCtaScaleIn":"hotspotCtaScaleIn__2jQ6N","hotspotCtaScaleOut":"hotspotCtaScaleOut__2Hjdx"};

/***/ }),

/***/ "ECIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("xdL+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__("EIet");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PlayerLayout = function (_Component) {
  _inherits(PlayerLayout, _Component);

  function PlayerLayout(props) {
    _classCallCheck(this, PlayerLayout);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.mapPostMsgProp = function () {
      var tag = _this.props.tag;
      var subcategory = tag.settings.subcategory;
      var engagement = subcategory && subcategory[0] && subcategory[0].engagements && subcategory[0].engagements[0];

      return function (key) {
        switch (key) {
          case 'cta_link':
            return engagement && engagement['value|' + engagement.slug] || '';
          case 'cta_text':
            return engagement && engagement['label|' + engagement.slug] || '';
          case 'video_id':
            return _this.props.json.video_id;
        }
      };
    };

    _this.getExternalLinkMessage = function (postMsg) {
      var data = postMsg.data;
      var message = {};

      for (var key in data) {
        message[key] = _this.mapPostMsgProp(data[key]);
      }

      return message;
    };

    _this.handleExternalLink = function (url) {
      var json = _this.props.json;
      var tag = _this.props.tag;
      var postMsg = json.post_msg;
      var isEnabledGlobal = postMsg && postMsg.enablement === 'ALL';
      var isPostMsgEnabled = isEnabledGlobal || tag.post_msg_enabled;
      // let isPostMsgEnabled = true;

      if (!__WEBPACK_IMPORTED_MODULE_1__config__["e" /* regex */].httpCheck.test(url)) url = 'http://' + url;
      if (isPostMsgEnabled && window.parent && window.parent.postMessage) {
        window.parent.postMessage(JSON.stringify(_this.getExternalLinkMessage(json.post_msg)), json.post_msg.url || '*');
        // window.parent.postMessage(JSON.stringify(this.getExternalLinkMessage({
        //   "enablement": "ALL",
        //     "url":"https://www.paypal.com",
        //     "data": {
        //       "link": "cta_link",
        //       "content": "cta_text",
        //       "video_id":"video_id",
        //     }
        // })), ('*'));
      } else {
        // let redirect = window.open(url, '_blank');
        // OneAd clickThru---
        __WEBPACK_IMPORTED_MODULE_2__helper__["B" /* handleExternalLinksViaClickThru */](url, _this.props.creativeData);
        //---
        _this.handleVideoResume();
        // redirect.location;
      }
    };

    _this.handleTagClick = function (e, skipLogDataEvent) {
      var classList = e.target.classList;
      var clickPassThrough = _this.checkCtaPassThrough();

      if (!_this.props.isLandscape && !classList.contains('swiper-button-next') && !classList.contains('swiper-button-prev') && !_this.props.isFacebookAd && !_this.props.lsCards || clickPassThrough) {
        if (_this.props.tag && !__WEBPACK_IMPORTED_MODULE_2__helper__["H" /* isSkipEnabled */](_this.props.tag, _this.props.creativeData) && !_this.props.isExpanded) {
          _this.props.activateTag(_this.props.index, null, true);
        }

        if (!skipLogDataEvent) {
          _this.logInteractionEvent(_this.props.getCurrentTime(), 'manual');
        }
      }

      if (_this.props.displayAdClickThroughLink) {
        // Engagement event for display ad click & traffic---
        if (_this.props.displayAdClickThroughLink.length > 0) {
          _this.logEngagement({ engagement_type: 'out-video', event_type: 'display-ad' });
        }
        //---
        _this.props.displayAdClickThroughLink.forEach(function (link) {
          setTimeout(function () {
            window.open(link);
          }, 0);
        });
      }
    };

    _this.handleCardClose = function (e) {
      _this.props.renderLandscapeCards(false);
    };

    _this.handleTagClose = function (e) {
      if (e) {
        e.stopPropagation();
      }

      _this.props.destroyTag();
      _this.props.deactivateTag();
      _this.handleCardClose(false);

      _this.logTagCloseEvent();
    };

    _this.handleCTA = function (e, updatedEngagements) {
      var engagements = updatedEngagements || _this.getEngagements();
      var action = engagements && engagements[0];
      var engagementMode = action.meta;
      var type = action.validationType;
      var actionValue = action['value|' + action.slug];

      if (engagementMode === __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].engagementTypes.outVideo) {
        _this.handleOutVideo(type, actionValue);
        // fire `interacting` as soon as CTA is clicked---
        _this.interactingEventMaxOnUserClick();
      }
    };

    _this.handleOutVideo = function (type, actionValue) {
      switch (type) {
        case 'text':
        case 'url':
          return _this.handleExternalLink(actionValue);
        case 'email':
          window.location.href = 'mailto:' + actionValue;
          break;
      }
    };

    _this.handleSlideChange = function () {
      var engagements = _this.getEngagements();
      var action = engagements && engagements[0];
      var actionLabel = action['label|' + action.slug];
      var actionValueFormtted = action.slug;

      var tag_id = _this.props.tag.id;
      var tag_label = _this.props.tag && _this.props.tag.details && (_this.props.tag.details.preview_title || _this.props.tag.details.title);
      var engagement_id = action && action.id;
      var engagement_label = actionLabel;

      var logDataObj = {
        type: actionValueFormtted,
        sub_type: null,
        event_type: actionValueFormtted,
        tag_id: tag_id,
        tag_label: tag_label,
        engagement_id: engagement_id,
        engagement_label: engagement_label,
        current_duration: _this.props.getCurrentTime()
      };

      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].LOG_EVENT_GALLERY_INTERACTION, _extends({
        tag: _this.props.tag
      }, logDataObj, {
        duration: _this.props.getCurrentTime()
      }));
      // this.props.logDataEvent(logDataObj);
    };

    _this.checkEnforcedOrExpandedTag = function () {
      var custom = _this.props.json && _this.props.json.custom;
      var customEnforeEndCardEnabled = custom && custom.endcards && custom.endcards.enforceEndCard;
      var customEnforeEndCardTagId = custom && custom.endcards && custom.endcards.enforceEndCardTag;

      var showEndCardPreviewEnabled = custom && custom.endcards && custom.endcards.showEndCardPreview;
      var showEndCardPreviewTagId = custom && custom.endcards && custom.endcards.showEndCardTag;

      var tagId = _this.props.tag.id;
      var hasVideoEnded = _this.props.hasVideoEnded();
      return hasVideoEnded && (customEnforeEndCardEnabled && tagId === customEnforeEndCardTagId || showEndCardPreviewEnabled && tagId === showEndCardPreviewTagId);
    };

    _this.logEngagement = function (data) {
      var engagements = _this.getEngagements();
      var action = engagements && engagements[0];
      var actionValueFormtted = action.slug;

      var tag_id = _this.props.tag.id;
      var tag_label = _this.props.tag && _this.props.tag.details && (_this.props.tag.details.preview_title || _this.props.tag.details.title);
      var engagement_id = action && action.id;
      var engagement_label = data && data.engagement_label || action['label|' + action.slug];

      var tag = _this.props.tag;
      var category = tag.settings.category;
      var engagement_type = '';
      switch (category) {
        case 1:
        case 7:
        case 8:
        case 10:
        case 16:
          engagement_type = 'out-video';
          break;

        case 9:
        case 11:
        case 12:
        case 14:
        case 15:
          engagement_type = 'in-video';
          break;
      }
      engagement_type = data && data.engagement_type || engagement_type;
      var event_type = data && data.event_type || actionValueFormtted;

      var requestData = {
        type: actionValueFormtted,
        sub_type: null,
        event_type: event_type,
        tag_id: tag_id,
        tag_label: tag_label,
        engagement_id: engagement_id,
        engagement_label: engagement_label,
        current_duration: _this.props.getCurrentTime(),
        engagement_type: engagement_type,
        tag_type: actionValueFormtted
      };

      if (typeof data !== 'undefined') {
        requestData = _extends(requestData, data);
      }

      if (typeof data !== 'undefined' && data.event_type && data.event_type === 'decision') {
        requestData.engagement_label = tag_label;
      }

      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].LOG_EVENT_ENGAGEMENT, {
        options: requestData
      });

      if (_this.checkEnforcedOrExpandedTag()) {
        _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].LOG_EVENT_INTERACTION, {
          tag: _this.props.tag,
          current_duration: _this.props.getCurrentTime()
        });
      }

      // this.props.logDataEvent(requestData);
    };

    _this.logTagOpenEvent = function (overrideDirectTag) {
      if (_this.props.hasDirectTag && !overrideDirectTag) {
        return false;
      }

      _this.openTs = new Date().getTime();
      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].LOG_EVENT_TAG_OPEN, {
        tag: _this.props.tag,
        duration: _this.props.getCurrentTime()
      });

      /**
       * `interacting` event to be fired after 30sec if tag stays open---
       */
      clearInterval(_this.interactingTimeout);
      var interactingDelay = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].INTERACTING_EVENT_DELAY / 1000;
      _this.interactingTimeout = setTimeout(function () {
        _this.fireInteractingEvent(interactingDelay);
      }, __WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].INTERACTING_EVENT_DELAY);

      _this.interactingEventMaxFired[_this.props.tag.id] = false;
      // max duration for `interacting`---
      var manualMaxTime = _this.props.tag && _this.props.tag.details && _this.props.tag.details.interactingMaxTime;
      var maxInteractingTimeout = manualMaxTime || (_this.props.json.duration <= 7 ? _this.props.json.duration : 7);
      _this.interactingTimeoutMax = setTimeout(function () {
        clearInterval(_this.interactingTimeout);
        if (!_this.interactingEventMaxFired[_this.props.tag.id]) {
          _this.fireInteractingEvent(maxInteractingTimeout - interactingDelay);
          _this.interactingEventMaxFired[_this.props.tag.id] = true;
        }
      }, maxInteractingTimeout * 1000);
    };

    _this.logTagCloseEvent = function () {
      /**
       * Tag interaction time is now calculated by the `interacting` event duration sum in the backend,
       * so if tag open 3sec `interacting` event is already fired, tag close `interactin event duration` will be the remaining time from 30sec to the close event.
       * else it will be time from tag open.
       */
      _this.interactingEventMaxOnUserClick();

      var closeDuration = _this.openTs ? Math.round((new Date().getTime() - _this.openTs) / 1000) : 10;
      _this.props.setTagAutoInteraction(false);
      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].LOG_EVENT_TAG_CLOSE, {
        tag: _this.props.tag,
        duration: closeDuration,
        current_duration: _this.props.getCurrentTime()
      });
    };

    _this.interactingEventMaxOnUserClick = function () {
      var closeDuration = _this.openTs ? Math.round((new Date().getTime() - _this.openTs) / 1000) : 10;
      clearInterval(_this.interactingTimeout);
      clearTimeout(_this.interactingTimeoutMax);
      if (!_this.interactingEventMaxFired[_this.props.tag.id]) {
        _this.interactingEventMaxFired[_this.props.tag.id] = true;
        var interactingDelay = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].INTERACTING_EVENT_DELAY / 1000;
        var duration = closeDuration >= interactingDelay ? closeDuration - interactingDelay : closeDuration;
        if (duration > 0) {
          _this.fireInteractingEvent(duration);
        }
      }
    };

    _this.fireInteractingEvent = function (duration) {
      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].LOG_EVENT_INTERACTING, {
        tag: _this.props.tag,
        duration: duration,
        current_duration: _this.props.getCurrentTime()
      });
    };

    _this.logInteractionEvent = function (current_duration, click_type) {
      // let evt = click_type === 'auto' ? constants.LOG_EVENT_CLICK_AUTO : constants.LOG_EVENT_CLICK_MANUAL;
      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_1__config__["b" /* constants */].LOG_EVENT_INTERACTION, {
        tag: _this.props.tag,
        current_duration: current_duration
      });
    };

    _this.getEngagements = function () {
      return __WEBPACK_IMPORTED_MODULE_2__helper__["n" /* getEngagements */](_this.props.tag);
    };

    _this.getImageCount = function () {
      var hook = _this.props.tag.media && _this.props.tag.media.images;
      var i = 1;
      var count = 0;

      while (hook && hook['img' + i + '_src']) {
        count = i;
        i++;
      }

      return count;
    };

    _this.fetchLayout = function (ns, tmpl) {
      if (!_this[ns]) {
        __webpack_require__("Rrey")("./" + tmpl).then(function (res) {
          _this[ns] = res;
          _this.forceUpdate();
        });
      }
    };

    _this.handleVideoResume = function () {
      var meta = _this.props.json.meta;
      var videoResume = meta && meta.video_resume || {};
      var tagid = _this.props.tag.id;
      if (videoResume[tagid]) {
        _this.handleTagClose();
        // for linked tags---
        if (_this.props.handleTagClose && typeof _this.props.handleTagClose === 'function') {
          _this.props.handleTagClose();
        }
      }
    };

    _this.interactingEventMaxFired = {};
    return _this;
  }

  PlayerLayout.prototype.componentDidMount = function componentDidMount() {
    this.getLayout();
    this.mapPostMsgProp = this.mapPostMsgProp();
  };

  PlayerLayout.prototype.render = function render() {
    return this.renderLayout();
  };

  PlayerLayout.prototype.checkCtaPassThrough = function checkCtaPassThrough() {
    var settings = this.props.tag.settings;
    var category = settings.category;
    var subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    if (this.props.lsCards) {
      return false;
    }

    switch (category) {
      case 1:
      case 7:
      case 8:
      case 10:
      case 16:
        return false;
      case 12:
        switch (subcategory) {
          case 1200:
          case 1201:
          case 1204:
            return false;
          case 1202:
          case 1203:
            return true;
        }
      case 9:
      case 11:
      case 14:
        if (this.props.ottRect && !this.props.isExpanded) {
          return true;
        } else {
          return false;
        }
    }
  };

  PlayerLayout.prototype.getLayout = function getLayout() {
    var settings = this.props.tag.settings;
    var category = settings.category;
    var subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    switch (category) {
      case 1:
        switch (subcategory) {
          case 105:
            return this.fetchLayout('TmplCommerceCollections', 'commerceCollections');
          case 106:
            return this.fetchLayout('TmplCommerceProduct360', 'commerceProduct360');
          case 104:
            return this.fetchLayout('TmplCommerceMultiStores', 'commerceMultiStores');
          case 107:
            return null; // Collections Video doesn't have any details
          default:
            return this.fetchLayout('TmplCommerce', 'commerce');
        }
      case 7:
        return this.fetchLayout('TmplCommerce', 'commerce');
      case 8:
        return this.fetchLayout('TmplBooking', 'booking');
      case 9:
        switch (subcategory) {
          case 900:
            return this.fetchLayout('TmplParticipationPoll', 'participationPoll');
          case 901:
            return this.fetchLayout('TmplParticipationSignUp', 'participationSignUp');
          case 902:
            return this.fetchLayout('TmplParticipationLeadGen', 'participationLeadGen');
          case 904:
            return this.fetchLayout('TmplParticipationCounter', 'participationCounter');
          case 905:
            return this.fetchLayout('TmplParticipationFeedback', 'participationFeedback');
          case 906:
            return this.fetchLayout('TmplParticipationContest', 'participationContest');
          case 907:
            return this.fetchLayout('TmplParticipationCall', 'participationCall');
        }
      case 10:
        switch (subcategory) {
          case 1000:
            return this.fetchLayout('TmplGamesAndAppsDriveInstalls', 'gamesAndAppsDriveInstalls');
          case 1001:
            return this.fetchLayout('TmplGamesAndAppsDriveUsage', 'gamesAndAppsDriveUsage');
        }
      case 11:
        return this.fetchLayout('TmplStoreLocator', 'storeLocator');
      case 12:
        switch (subcategory) {
          case 1200:
          case 1201:
            return this.fetchLayout('TmplOffersOfferOnAndOffline', 'offersOfferOnAndOffline');
          case 1202:
            return this.fetchLayout('TmplOffersSingleCode', 'offersSingleCode');
          case 1203:
            return this.fetchLayout('TmplOffersMultipleCode', 'offersMultipleCode');
          case 1204:
            return this.fetchLayout('TmplOffersBanner', 'offersBanner');
        }
      case 14:
        switch (subcategory) {
          case 1401:
            return this.fetchLayout('TmplShowcaseGallery', 'showcaseGallery');
          case 1402:
            return this.fetchLayout('TmplShowcaseChapter', 'showcaseChapter');
          case 1403:
            return this.fetchLayout('TmplShowcaseMultiHotspot', 'showcaseMultiHotspot');
        }
      case 15:
        switch (subcategory) {
          case 1501:
          case 1502:
            var tag = this.props.tag;
            var engagement = tag.details.engagements && tag.details.engagements[0];

            if (engagement && engagement.dpnative) {
              return this.fetchLayout('TmplDecisionsV2', 'decisionsV2');
            } else {
              return this.fetchLayout('TmplDecisions', 'decisions');
            }
        }
      case 16:
        switch (subcategory) {
          case 1601:
            return this.fetchLayout('TmplSocialShare', 'socialShare');
          case 1602:
            return this.fetchLayout('TmplSocialEmotion', 'socialEmotion');
        }
      case 17:
        switch (subcategory) {
          case 1700:
            return this.fetchLayout('TmplEventsCalendar', 'eventsCalendar');
          case 1701:
            return this.fetchLayout('TmplEventsWebinar', 'eventsWebinar');
        }
      case 18:
        switch (subcategory) {
          case 1801:
            return this.fetchLayout('TmplCommerce', 'commerce');;
          case 1802:
            return this.fetchLayout('TmplCommerceCollections', 'commerceCollections');
          case 1803:
            return this.fetchLayout('TmplParticipationCounter', 'participationCounter');
        }
      case 19:
        switch (subcategory) {
          case 1901:
            return this.fetchLayout('TmplParticipationSignUp', 'participationSignUp');
          case 1902:
          case 1903:
            return this.fetchLayout('TmplParticipationLeadGen', 'participationLeadGen');
        }
      case 20:
        switch (subcategory) {
          case 2001:
            return this.fetchLayout('TmplParticipationLeadGen', 'participationLeadGen');
          case 2002:
            return this.fetchLayout('TmplParticipationCall', 'participationCall');
          case 2003:
            return this.fetchLayout('TmplParticipationBookDemo', 'participationBookDemo');
        }
      case 21:
        switch (subcategory) {
          case 2101:
            return this.fetchLayout('TmplParticipationContest', 'participationContest');
          case 2102:
            return this.fetchLayout('TmplParticipationFeedback', 'participationFeedback');
          case 2103:
            return null;
          case 2104:
            return this.fetchLayout('TmplParticipationPoll', 'participationPoll');
        }
    }
  };

  PlayerLayout.prototype.renderLayout = function renderLayout() {
    var settings = this.props.tag.settings;
    var category = settings.category;
    var subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    switch (category) {
      case 1:
        switch (subcategory) {
          case 105:
            return this.renderTmpl('TmplCommerceCollections');
          case 106:
            return this.renderTmpl('TmplCommerceProduct360');
          case 104:
            return this.renderTmpl('TmplCommerceMultiStores');
          default:
            return this.renderTmpl('TmplCommerce');
        }
      case 7:
        return this.renderTmpl('TmplCommerce');
      case 8:
        return this.renderTmpl('TmplBooking');
      case 9:
        switch (subcategory) {
          case 900:
            return this.renderTmpl('TmplParticipationPoll');
          case 901:
            return this.renderTmpl('TmplParticipationSignUp');
          case 902:
            return this.renderTmpl('TmplParticipationLeadGen');
          case 904:
            return this.renderTmpl('TmplParticipationCounter');
          case 905:
            return this.renderTmpl('TmplParticipationFeedback');
          case 906:
            return this.renderTmpl('TmplParticipationContest');
          case 907:
            return this.renderTmpl('TmplParticipationCall');
        }
      case 10:
        switch (subcategory) {
          case 1000:
            return this.renderTmpl('TmplGamesAndAppsDriveInstalls');
          case 1001:
            return this.renderTmpl('TmplGamesAndAppsDriveUsage');
        }
      case 11:
        return this.renderTmpl('TmplStoreLocator');
      case 12:
        switch (subcategory) {
          case 1200:
          case 1201:
            return this.renderTmpl('TmplOffersOfferOnAndOffline');
          case 1202:
            return this.renderTmpl('TmplOffersSingleCode');
          case 1203:
            return this.renderTmpl('TmplOffersMultipleCode');
          case 1204:
            return this.renderTmpl('TmplOffersBanner');
        }
      case 14:
        switch (subcategory) {
          case 1401:
            return this.renderTmpl('TmplShowcaseGallery');
          case 1402:
            return this.renderTmpl('TmplShowcaseChapter');
          case 1403:
            return this.renderTmpl('TmplShowcaseMultiHotspot');
        }
      case 15:
        switch (subcategory) {
          case 1501:
          case 1402:
            return this.renderTmpl('TmplDecisions');
          case 1502:
            var tag = this.props.tag;
            var engagement = tag.details.engagements && tag.details.engagements[0];

            if (engagement && engagement.dpnative) {
              return this.renderTmpl('TmplDecisionsV2');
            } else {
              return this.renderTmpl('TmplDecisions');
            }
        }
      case 16:
        switch (subcategory) {
          case 1601:
            return this.renderTmpl('TmplSocialShare');
          case 1602:
            return this.renderTmpl('TmplSocialEmotion');
        }
      case 17:
        switch (subcategory) {
          case 1700:
            return this.renderTmpl('TmplEventsCalendar');
          case 1701:
            return this.renderTmpl('TmplEventsWebinar');
        }
      case 18:
        switch (subcategory) {
          case 1801:
            return this.renderTmpl('TmplCommerce');
          case 1802:
            return this.renderTmpl('TmplCommerceCollections');
          case 1803:
            return this.renderTmpl('TmplParticipationCounter');
        }
      case 19:
        switch (subcategory) {
          case 1901:
            return this.renderTmpl('TmplParticipationSignUp');
          case 1902:
          case 1903:
            return this.renderTmpl('TmplParticipationLeadGen');
        }
      case 20:
        switch (subcategory) {
          case 2001:
            return this.renderTmpl('TmplParticipationLeadGen');
          case 2002:
            return this.renderTmpl('TmplParticipationCall');
          case 2003:
            return this.renderTmpl('TmplParticipationBookDemo');
        }
      case 21:
        switch (subcategory) {
          case 2101:
            return this.renderTmpl('TmplParticipationContest');
          case 2102:
            return this.renderTmpl('TmplParticipationFeedback');
          case 2103:
            return null;
          case 2104:
            return this.renderTmpl('TmplParticipationPoll');
        }
    }
  };

  PlayerLayout.prototype.renderTmpl = function renderTmpl(ns) {
    if (this[ns] && this[ns].default) {
      var _Component2 = this[ns].default;
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(_Component2, _extends({}, this.props, {
        getEngagements: this.getEngagements,
        getImageCount: this.getImageCount,
        logEngagement: this.logEngagement,
        logTagOpenEvent: this.logTagOpenEvent,
        logTagCloseEvent: this.logTagCloseEvent,
        logInteractionEvent: this.logInteractionEvent,
        handleCTA: this.handleCTA,
        handleTagClick: this.handleTagClick,
        handleTagClose: this.handleTagClose,
        handleSlideChange: this.handleSlideChange,
        handleExternalLink: this.handleExternalLink,
        checkEnforcedOrExpandedTag: this.checkEnforcedOrExpandedTag,
        videoResumeOnCta: this.handleVideoResume
      }));
    } else {
      this.getLayout();
      return null;
    }
  };

  return PlayerLayout;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "EIet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_WOOTAG_COLOR; });
/* harmony export (immutable) */ __webpack_exports__["L"] = mobileCheck;
/* harmony export (immutable) */ __webpack_exports__["R"] = tabletCheck;
/* harmony export (immutable) */ __webpack_exports__["D"] = isFacebookApp;
/* unused harmony export isFacebookAd */
/* harmony export (immutable) */ __webpack_exports__["s"] = getMinHeight;
/* harmony export (immutable) */ __webpack_exports__["u"] = getOrientation;
/* unused harmony export parseJSON */
/* harmony export (immutable) */ __webpack_exports__["N"] = request;
/* harmony export (immutable) */ __webpack_exports__["K"] = loadJS;
/* harmony export (immutable) */ __webpack_exports__["J"] = loadCSS;
/* harmony export (immutable) */ __webpack_exports__["l"] = getCSSPath;
/* harmony export (immutable) */ __webpack_exports__["m"] = getDomainForAdUnit;
/* harmony export (immutable) */ __webpack_exports__["z"] = getUrlParams;
/* harmony export (immutable) */ __webpack_exports__["M"] = parseJsonToFormData;
/* harmony export (immutable) */ __webpack_exports__["w"] = getScreenDimensions;
/* harmony export (immutable) */ __webpack_exports__["v"] = getReadableTime;
/* unused harmony export pad */
/* harmony export (immutable) */ __webpack_exports__["A"] = getVideoURL;
/* harmony export (immutable) */ __webpack_exports__["o"] = getGUID;
/* harmony export (immutable) */ __webpack_exports__["r"] = getMedium;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSelectionArrayFromObject;
/* unused harmony export isObject */
/* unused harmony export mergeDeep */
/* harmony export (immutable) */ __webpack_exports__["g"] = extendTag;
/* unused harmony export findTag */
/* harmony export (immutable) */ __webpack_exports__["j"] = filterObjJson;
/* harmony export (immutable) */ __webpack_exports__["t"] = getMobileOS;
/* harmony export (immutable) */ __webpack_exports__["x"] = getTagPreviewImage;
/* harmony export (immutable) */ __webpack_exports__["T"] = updateQueryStringParameter;
/* harmony export (immutable) */ __webpack_exports__["f"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["k"] = filterTagsForDecisions;
/* harmony export (immutable) */ __webpack_exports__["S"] = trimLastSlash;
/* harmony export (immutable) */ __webpack_exports__["I"] = launchExternalLink;
/* harmony export (immutable) */ __webpack_exports__["q"] = getLinkedTagImage;
/* unused harmony export getMediaPreviewImage */
/* harmony export (immutable) */ __webpack_exports__["y"] = getTargetImageRes;
/* harmony export (immutable) */ __webpack_exports__["Q"] = sortNumericKeys;
/* harmony export (immutable) */ __webpack_exports__["E"] = isMiniature;
/* harmony export (immutable) */ __webpack_exports__["H"] = isSkipEnabled;
/* harmony export (immutable) */ __webpack_exports__["i"] = filterAgeGate;
/* harmony export (immutable) */ __webpack_exports__["U"] = updateTagProductPrice;
/* harmony export (immutable) */ __webpack_exports__["p"] = getImageLightness;
/* harmony export (immutable) */ __webpack_exports__["G"] = isSkinTemplate;
/* harmony export (immutable) */ __webpack_exports__["F"] = isMultiStoresMapRequired;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return sortCollectionsMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return isCollectionsTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getEngagements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return validHex; });
/* harmony export (immutable) */ __webpack_exports__["W"] = validateEmail;
/* harmony export (immutable) */ __webpack_exports__["X"] = validatePhoneNumber;
/* harmony export (immutable) */ __webpack_exports__["c"] = addPixelImage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return roundToX; });
/* harmony export (immutable) */ __webpack_exports__["B"] = handleExternalLinksViaClickThru;
/* harmony export (immutable) */ __webpack_exports__["d"] = appendThirdPartyScriptToDOM;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCustomCssNode;
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchPersonalizeJson;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("xdL+");


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


var uuidV1 = __webpack_require__("hVVj");

var DEFAULT_WOOTAG_COLOR = '#33B0E8';

function mobileCheck() {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

function tabletCheck() {
  return (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(navigator.userAgent || navigator.vendor || window.opera)
  );
}

function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
}

function isFacebookAd() {
  var urlParams = getUrlParams(window.location.href);

  if (urlParams.fbAd === '1') return true;else return false;
}

function getMinHeight() {
  var width = window.innerWidth;
  var height = window.innerHeight;
  var videoHeight = 56.26 / 100 * width;
  var minHeight = 236 + videoHeight;
  return minHeight;
}

function getOrientation() {
  var width = window.innerWidth;
  var height = window.innerHeight;
  var minHeight = getMinHeight();

  if (isFacebookAd()) return __WEBPACK_IMPORTED_MODULE_0__config__["b" /* constants */].ORIENTATION_PORTRAIT;else if (width > height || width < height && height < minHeight) return __WEBPACK_IMPORTED_MODULE_0__config__["b" /* constants */].ORIENTATION_LANDSCAPE;else return __WEBPACK_IMPORTED_MODULE_0__config__["b" /* constants */].ORIENTATION_PORTRAIT;
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function parseJSON(response) {
  try {
    response = response.json();
  } catch (e) {}

  return response;
}

function request(url, options) {
  var ops = _extends({}, {
    method: 'GET',
    mode: 'cors',
    cache: 'default' }, options);

  return fetch(url, ops).then(checkStatus).then(parseJSON).catch(function (e) {
    // console.log('fetch encountered an error', e)
  });
}

function loadJS(fileURL, parent) {
  return new Promise(function (resolve, reject) {
    var jsFileElement = document.createElement("script");
    jsFileElement.type = "application/javascript";
    jsFileElement.src = fileURL;

    jsFileElement.onreadystatechange = function () {
      if (this.readyState === 'complete') {
        resolve();
      }
    };

    jsFileElement.onload = function () {
      resolve();
    };

    parent.appendChild(jsFileElement);
  });
}

function loadCSS(fileURL, parent) {
  return new Promise(function (resolve, reject) {
    var fileref = document.createElement("link");
    fileref.rel = "stylesheet";
    fileref.type = "text/css";
    fileref.href = fileURL;

    fileref.onreadystatechange = function () {
      if (this.readyState === 'complete') {
        resolve();
      }
    };

    fileref.onload = function () {
      resolve();
    };

    parent.appendChild(fileref);
  });
}

function getCSSPath(target, release_version) {
  var domain = target.split('.com')[0] + '.com';
  var protocol = domain.split('//')[0] + '//';

  var v = release_version || new Date().getTime();

  if (window.location.href.indexOf('localhost') !== -1) {
    return '';
  }

  if (!!domain && domain.indexOf('wootag.com') !== -1) {
    return domain + '/player/v3/style.css?v=' + v;
  }

  return 'https://stagingwt.wootag.com/player/v3/style.css?v=' + v;
}

function getDomainForAdUnit(target) {
  var domain = target.split('.com')[0] + '.com';
  var protocol = domain.split('//')[0] + '//';

  if (domain === 'https://ads.wootag.com' || domain === 'http://ads.wootag.com' || domain.includes('cdn.wootag.com')) {
    return protocol + 'www.wootag.com';
  } else if (!!domain && domain.indexOf('wootag.com') !== -1) {
    return domain;
  } else {
    return protocol + 'stagingwt.wootag.com';
  }
}

function getUrlParams(url) {
  var keyValue,
      params = {};

  try {
    var queryString = url.split("?")[1];
    var keyValuePairs = queryString.split("&");

    keyValuePairs.forEach(function (pair) {
      keyValue = pair.split("=");
      params[keyValue[0]] = decodeURIComponent(keyValue[1]).replace("+", " ");
    });
  } catch (e) {}

  return params;
}

function parseJsonToFormData(obj) {
  var str = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      str.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]));
    }
  }

  return str.join("&");
}

function getScreenDimensions() {
  try {
    var parent = window.parent && window.parent.document && (window.parent.document.body || window.parent.document.documentElement);
    if (parent) {
      return parent.clientWidth + 'x' + parent.clientHeight;
    } else {
      return window.innerWidth + 'x' + window.innerHeight;
    }
  } catch (e) {
    return null;
  }
}

function getReadableTime(value) {
  var hours = Math.floor(value / 3600);
  var mins_remaining = value - hours * 3600;
  var mins = Math.floor(mins_remaining / 60);
  var seconds = Math.floor(mins_remaining - mins * 60);

  if (isNaN(value)) {
    return '00:00';
  }

  if (hours < 1) {
    return pad(mins, '0', 2) + ':' + pad(seconds, '0', 2);
  } else {
    return pad(hours, '0', 2) + ':' + pad(mins, '0', 2) + ':' + pad(seconds, '0', 2);
  }
}

function pad(string, pad, length) {
  var time = (new Array(length + 1).join(pad) + string).slice(-length);
  if (isNaN(time)) {
    return '00';
  } else return time;
}

function getVideoURL(url, sizes) {

  if (typeof sizes === 'number') {
    return url;
  }

  if (url) {
    var lastIndexOfSlash = url.lastIndexOf('/');
    var lastIndexOfExtn = url.lastIndexOf('.');
    var extn = url.substr(lastIndexOfExtn);
    var newURL = url.substr(0, lastIndexOfSlash);

    if (window.innerWidth > 480) {
      return newURL + '/' + sizes[0] + extn;
    } else if (window.innerWidth > 360) {
      if (typeof sizes[1] !== 'undefined') {
        return newURL + '/' + sizes[1] + extn;
      } else {
        return newURL + '/' + sizes[0] + extn;
      }
    } else {
      if (typeof sizes[2] !== 'undefined') {
        return newURL + '/' + sizes[2] + extn;
      } else if (typeof sizes[1] !== 'undefined') {
        return newURL + '/' + sizes[1] + extn;
      } else {
        return newURL + '/' + sizes[0] + extn;
      }
    }
  } else return url;
}

function getGUID() {
  return uuidV1();
}

function getMedium() {
  var referrer = document.referrer;
  var isFacebook = isFacebookApp();
  var medium = void 0;
  // let referrerDomain = referrer.match(/:\/\/(.[^/]+)/)[1];

  if (isFacebook) {
    medium = 'Facebook';
  } else if (referrer === "") {
    medium = 'Embed - ' + window.location.host;
  } else {
    medium = 'Embed - ' + referrer;
  }

  return medium;
}

function createSelectionArrayFromObject(inputArr, defaultSelection) {
  var arr = [];

  inputArr && inputArr.forEach(function (item, index) {
    var tempObj = {};
    tempObj.id = index + 1;
    tempObj.name = item;
    tempObj.enabled = true;

    arr.push(tempObj);
  });

  arr.unshift({
    id: 0,
    name: defaultSelection,
    enabled: true
  });

  return arr;
}

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

function mergeDeep(target, source) {
  var output = _extends({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        var _extends2;

        if (!(key in target)) _extends(output, (_extends2 = {}, _extends2[key] = source[key], _extends2));else output[key] = mergeDeep(target[key], source[key]);
      } else {
        var _extends3;

        _extends(output, (_extends3 = {}, _extends3[key] = source[key], _extends3));
      }
    });
  }
  return output;
}

function extendTag(tags, sourcetag) {
  var target = findTag(tags, sourcetag.src_tag_id);

  if (target) {
    sourcetag = mergeDeep(target, sourcetag);

    if (sourcetag.details.engagements && sourcetag.details.engagements.length > 0) {
      sourcetag.details.engagements[0] = mergeDeep(target.details.engagements[0], sourcetag.details.engagements[0]);
    }

    if (target.src_tag_id) {
      sourcetag.src_tag_id = target.src_tag_id;
      sourcetag = extendTag(tags, sourcetag);
    }
  }

  return sourcetag;
}

function findTag(tags, tagId) {
  var selIndex;
  var selChild;

  tags.some(function (tag, idx) {
    if (tag.id === tagId) {
      selIndex = idx;
      selChild = undefined;
      return true;
    }

    if (tag.child_tags) {
      var result = tag.child_tags.findIndex(function (child) {
        return child.id === tagId;
      });
      if (result >= 0) {
        selIndex = idx;
        selChild = result;
        return true;
      }
    }
  });

  if (typeof selIndex !== 'undefined') {
    if (typeof selChild !== 'undefined') {
      return tags[selIndex].child_tags[selChild];
    } else {
      return tags[selIndex];
    }
  }
}

function filterObjJson(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (!obj[key]) {
        delete obj[key];
      }
    }
  }
  return obj;
}

function getMobileOS() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  // if (/windows phone/i.test(userAgent)) {
  //     return "Windows Phone";
  // }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

function getTagPreviewImage(tag, size, ignorePreviewImage) {
  var subcategory = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
  switch (tag.settings.category) {
    case 1:
    case 7:
    case 8:
    case 10:
    case 11:
    case 12:
    case 15:
    case 16:
    case 18:
    case 19:
    case 20:
      var image = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
      return image;
    case 9:
      switch (subcategory && subcategory.type) {
        case 900:
          var engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
          var answers = engagement && engagement.answer;
          if (engagement && engagement.imagepoll) {
            return answers && answers[0] && answers[0].image;
          } else {
            var _image2 = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
            return _image2;
          }
        case 901:
        case 902:
        case 904:
        case 905:
        case 906:
        case 907:
          var _image = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
          return _image;
      }
    case 14:
      switch (subcategory && subcategory.type) {
        case 1402:
          var _image3 = getLinkedTagImage(tag.media, tag.media.defaultImage, size, ignorePreviewImage);
          return _image3;
        case 1401:
        case 1403:
          var _engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
          var defaultImg = _engagement && _engagement.meta && _engagement.meta.filter(function (item) {
            return item.default;
          });

          if (defaultImg && defaultImg.length > 0) {
            var img = defaultImg[0];
            return img.cover_image_selected || img.url;
          } else {
            var firstGallaryElem = _engagement && _engagement.meta && _engagement.meta[0];
            if (firstGallaryElem) {
              return firstGallaryElem.cover_image_selected || firstGallaryElem.url;
            }
          }
      }
    case 21:
      switch (subcategory && subcategory.type) {
        case 2101:
        case 2102:
        case 2103:
          {
            var _image4 = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
            return _image4;
          }
        case 2104:
          {
            var _engagement2 = tag.details && tag.details.engagements && tag.details.engagements[0];
            var _answers = _engagement2 && _engagement2.answer;
            if (_engagement2 && _engagement2.imagepoll) {
              return _answers && _answers[0] && _answers[0].image;
            } else {
              var _image5 = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
              return _image5;
            }
          }
      }
  }
}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    var hash = '';
    if (uri.indexOf('#') !== -1) {
      hash = uri.replace(/.*#/, '#');
      uri = uri.replace(/#.*/, '');
    }
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    return uri + separator + key + "=" + value + hash;
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

function filterTagsForDecisions(proptags) {
  var tags = proptags && JSON.parse(JSON.stringify(proptags));
  var decisionPoints = tags && tags.filter(function (item) {
    return item.settings.category === 15;
  });

  if (decisionPoints && decisionPoints.length) {
    var _ref;

    var connectedTags = (_ref = []).concat.apply(_ref, decisionPoints.map(function (dp) {
      return dp.details.engagements[0] && dp.details.engagements[0].meta && dp.details.engagements[0].meta.map(function (metaItem) {
        return metaItem.tag;
      });
    }));

    for (var i = tags.length - 1; i >= 0; i--) {
      var index = connectedTags.indexOf(tags[i].id);
      index !== -1 && tags.splice(i, 1);
    }
  }

  return tags;
}

function trimLastSlash(target) {
  if (target.substr(-1) === '/') {
    return target.slice(0, -1);
  } else return target;
}

function launchExternalLink(domain, videoId, tagId) {
  domain = domain.substr(-1) === '/' ? domain + 'videos/share' : domain + '/videos/share';
  var url = domain + '/' + videoId + '?tagid=' + tagId + '&ottOnly=1';
  window.open(url, '_blank');
}

function getLinkedTagImage(media, defaultImage, size, ignorePreviewImage, ignoreOrientation) {
  var previewImages = media && media.previewImages || {};
  var imgSrc = Object.keys(previewImages).find(function (key) {
    return key.includes('_src');
  });
  if (imgSrc && !ignorePreviewImage) {
    return getMediaPreviewImage(previewImages, size);
  }

  var images = media && media.images || {};
  images = images || {};
  var imageKeys = Object.keys(images);
  var availableRes = imageKeys.filter(function (item) {
    return parseInt(item.split('_')[0].substr(-1)) === 1;
  });
  var imageResolutions = sortNumericKeys(availableRes.map(function (item) {
    return item.split('_')[1];
  }));

  var targetRes = size ? size : getTargetImageRes(imageResolutions, ignoreOrientation);
  var image = defaultImage ? defaultImage : 'img1';
  return images[image + '_' + targetRes] || images[image + '_src'];
}

function getMediaPreviewImage() {
  var previewImages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var size = arguments[1];

  var imgSrc = Object.keys(previewImages).find(function (key) {
    return key.includes('_src');
  });
  var imgName = imgSrc && imgSrc.split('_')[0];
  var targetRes = size ? size : 'src';
  var previewImg = imgName && (previewImages[imgName + '_' + targetRes] || previewImages[imgName + '_src']);
  if (previewImg) {
    return previewImg;
  }
}

function getTargetImageRes(imageResolutions, ignoreOrientation) {
  var orientation = getOrientation();
  var viewportWidth = orientation === __WEBPACK_IMPORTED_MODULE_0__config__["b" /* constants */].ORIENTATION_PORTRAIT || ignoreOrientation ? window.innerWidth : window.innerWidth / 2;
  var resClone = imageResolutions.filter(function (t) {
    return t !== 'src';
  });

  var targetRes = void 0;
  var resFound = resClone.some(function (res) {
    targetRes = res;
    return res > viewportWidth;
  });
  return resFound ? targetRes : 'src';
}

function sortNumericKeys(arr) {
  var sortedArr = arr.sort(function (a, b) {
    a = parseInt(a);
    b = parseInt(b);
    return a - b;
  });
  var shiftedNonNumbersToEndArr = [].concat(sortedArr);
  // console.log('>>>>>>', { shiftedNonNumbersToEndArr, firt: shiftedNonNumbersToEndArr[3], sortedArr, test: [ ...sortedArr ] })
  sortedArr.forEach(function (item, idx) {
    if (isNaN(item / 1)) {
      shiftedNonNumbersToEndArr.push(shiftedNonNumbersToEndArr.splice(idx, 1)[0]);
    }
  });
  // console.log({ arr, sortedArr, shiftedNonNumbersToEndArr })
  return shiftedNonNumbersToEndArr;
}

function isMiniature() {
  return window.innerHeight < 300;
}

function isSkipEnabled(tag, creativeData) {
  // for out-video tags if tag.details.skip = true; on clicking the tagPreview it will directly
  // open the url in blank window instead of showing tag Details---

  if (tag) {
    var category = tag.settings && tag.settings.category;
    var subcategory = tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
    var type = subcategory && subcategory.type;
    var isOutVideo = false;

    if (!category) return false;

    switch (category) {
      case 1:
      case 7:
      case 8:
      case 10:
      case 18:
        isOutVideo = true;
        break;
      default:
        isOutVideo = false;
        break;
    }

    if (type === 1803) {
      isOutVideo = false;
    }

    if (isOutVideo && tag && tag.details && tag.details.skip) {
      // handle out-video tags
      var engagement = subcategory.engagements[0];
      var url = engagement && engagement['value|' + engagement.slug];

      if (category === 10) {
        var playStoreLink = engagement && engagement['linkplaystore|' + engagement.slug];
        var appStoreLink = engagement && engagement['linkappstore|' + engagement.slug];
        var deviceType = getMobileOS();

        if (deviceType === 'Android' && playStoreLink) url = playStoreLink;else if (deviceType === 'iOS' && appStoreLink) url = appStoreLink;
      }

      if (!/^(http|https):\/\//.test(url)) {
        url = 'http://' + url;
      }

      handleExternalLinksViaClickThru(url, creativeData);
      return true;
    }

    return false;
  }
}

function filterAgeGate(json) {
  var tagsWithoutGates = [];
  var gates = [];
  json.tags.forEach(function (item) {
    var settings = item && item.settings;
    var subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    // setting default merchant for commerce thirdpartyapi tags---
    if (item.settings.category === 1 && item.details && item.details.thirdPartyApi && item.details.skuSet && item.details.skuSet.length && !item.details.merchant) {
      item = updateTagProductPrice(item.details.skuSet[0], item);
    }

    if (subcategory && subcategory === 903) {
      gates.push(item);
    } else {
      tagsWithoutGates.push(item);
    }
  });
  json.tags = tagsWithoutGates;

  json.gates = gates;
  json.otags = json.tags;

  return json;
}

function updateTagProductPrice(selectedMerchant, tag) {
  var _updateSettingsEngagm;

  var price = selectedMerchant.offerPrice;
  // const currency = selectedMerchant.currency || '₱';
  // const endUrlId = selectedMerchant.productId;
  // const productLink = `https://api-ph.shortlyst.com/v1/products/${endUrlId}/redirect?apikey=HYx5IJslKjqja3wDcLUzVjyQAOY9amJL`;
  var productLink = selectedMerchant.merchantUrl;
  var slug = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0].engagements[0].slug;
  var updateSettingsEngagments = (_updateSettingsEngagm = {}, _updateSettingsEngagm['value|' + slug] = productLink, _updateSettingsEngagm);

  var settings = _extends({}, tag.settings, { subcategory: [_extends({}, tag.settings.subcategory[0], { engagements: [_extends({}, tag.settings.subcategory[0].engagements[0], updateSettingsEngagments)] })] });

  var updatedTag = _extends({}, tag, {
    details: _extends({}, tag.details, { price: price, merchant: selectedMerchant }),
    settings: settings
  });
  return updatedTag;
}

function getImageLightness(imageSrc, callback) {
  var img = new Image();
  var colorSum = 0;

  img.crossOrigin = "Anonymous";

  img.onload = function () {
    var canvas = document.createElement("canvas");

    canvas.width = this.width;
    canvas.height = this.height;

    var ctx = canvas.getContext("2d");
    ctx.drawImage(this, 0, 0);

    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var data = imageData.data;
    var r, g, b, avg;

    for (var x = 0, len = data.length; x < len; x += 4) {
      r = data[x];
      g = data[x + 1];
      b = data[x + 2];

      avg = Math.floor((r + g + b) / 3);
      colorSum += avg;
    }

    var brightness = Math.floor(colorSum / (this.width * this.height));
    callback(brightness);
  };

  img.src = imageSrc;
}

function isSkinTemplate(json) {
  var meta = json && json.meta;
  var custom = json && json.custom;
  var customSkinData = custom && custom.customskin;
  var customSkinEnabled = customSkinData && customSkinData.enableSkin;
  return customSkinEnabled || meta && meta.skins;
}

function isMultiStoresMapRequired(tags) {
  var multiStoresWithLocation = tags.filter(function (tag) {
    var settings = tag && tag.settings;
    var isMultiStore = settings && settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type && settings.subcategory[0].type === 104;
    if (isMultiStore) {
      var stores = tag && tag.details && tag.details.attributes || [];
      var hasLocation = stores.some(function (store) {
        return store && store.details && store.details.location;
      });
      if (hasLocation) {
        return true;
      }
    }
    return false;
  });
  return multiStoresWithLocation.length > 0; // tags with atleast one store location enabled---
}

var sortCollectionsMedia = function sortCollectionsMedia(products) {
  return products.map(function (prod) {
    var media = prod && prod.media;

    if (Array.isArray(media)) {
      var images = {};
      media.forEach(function (m) {
        return images = _extends({}, images, m);
      });
      prod.media = { images: images };
    }
    return prod;
  });
};

var isCollectionsTag = function isCollectionsTag(tag) {
  if (!tag) return false;
  var subcat = tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
  var subtype = subcat && subcat.type;
  return subtype === 105;
};

var getEngagements = function getEngagements(tag) {
  if (tag && tag.settings && tag.settings.subcategory) {
    return [].concat.apply([], tag.settings.subcategory.map(function (item) {
      return item.engagements;
    }));
  }
  return [];
};

var validHex = function validHex(val) {
  return (/^#(?:[0-9a-fA-F]{3}){1,2}$/.test(val)
  );
};

function validateEmail(email) {
  var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
  var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
  var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
  var sQuotedPair = '\\x5c[\\x00-\\x7f]';
  var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
  var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
  var sDomain_ref = sAtom;
  var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
  var sWord = '(' + sAtom + '|' + sQuotedString + ')';
  var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')+';
  var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
  var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
  var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

  var reValidEmail = new RegExp(sValidEmail);

  return reValidEmail.test(email);
}

function validatePhoneNumber(num) {
  num = num.replace('+', '');
  num = num.replace('(', '');
  num = num.replace(')', '');
  num = num.replace(' ', '');
  var isValid = /^\d+$/.test(num) && num.length >= 8;
  return isValid;
}

function addPixelImage(src) {
  var img = document.createElement('img');
  img.width = 1;
  img.height = 1;
  img.style = 'border-style:none;display:none;';
  img.alt = '';
  img.src = src;
  document.body.appendChild(img);
}

var roundToX = function roundToX() {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var X = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  return +(Math.round(num + ('e' + X)) + ('e-' + X));
};


function handleExternalLinksViaClickThru(url, creativeData) {
  var cltScript = creativeData && creativeData.prod && creativeData.prod.cltScript;
  if (cltScript) {
    appendThirdPartyScriptToDOM(cltScript);
  }
  var network = creativeData && creativeData.network;
  var clickThru = network && __WEBPACK_IMPORTED_MODULE_0__config__["b" /* constants */].CLICKTHRU_NETWORKS.includes(network);
  if (!clickThru) {
    window.open(url, '_blank');
  } else {
    if (window.vpaid) {
      window.vpaid.clickThru({
        url: url,
        playerHandles: true // forces to use the adunit url
      });
      window.vpaid.pauseAd();
    }
  }
}

function appendThirdPartyScriptToDOM(str) {
  var BODY = document.getElementsByTagName('body')[0];
  if (str) {
    var node = document.createRange().createContextualFragment(str);
    BODY.append(node);
  }
}

function addCustomCssNode(styleStr) {
  var HEAD = document.getElementsByTagName('head')[0];
  var st = document.createElement("style");
  st.appendChild(document.createTextNode(styleStr));
  HEAD.appendChild(st);
}

function fetchPersonalizeJson() {
  return fetch('https://cdn.wootag.com/generic/json/personalize-layer.json').then(function (res) {
    return res.json();
  }).catch(function (err) {
    console.error('Error fetching personalize.json', err);
  });
}

/***/ }),

/***/ "EbM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FOH3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("8Jr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__("EIet");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { className: 'imgOverlay' });

var GalleryImage = function (_Component) {
	_inherits(GalleryImage, _Component);

	function GalleryImage(props) {
		_classCallCheck(this, GalleryImage);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			zoom: false
		};
		return _this;
	}

	GalleryImage.prototype.componentWillMount = function componentWillMount() {
		var images = this.props.images;
		var imageKeys = Object.keys(images);
		var actualIndex = this.props.index + 1;
		var availableRes = imageKeys.filter(function (item) {
			return parseInt(item.split('_')[0].substr(-1)) === actualIndex;
		});
		var imageResolutions = Object(__WEBPACK_IMPORTED_MODULE_2__helper__["Q" /* sortNumericKeys */])(availableRes.map(function (item) {
			return item.split('_')[1];
		}));

		this.targetRes = Object(__WEBPACK_IMPORTED_MODULE_2__helper__["y" /* getTargetImageRes */])(imageResolutions);
	};

	GalleryImage.prototype.render = function render(props, state) {
		var image = '' + (this.props.images['img' + (this.props.index + 1) + ('_' + this.targetRes)] || this.props.images['img' + (this.props.index + 1) + '_src']);
		var imageContainerStyle = {
			width: '100%',
			height: '100%',
			position: 'relative',
			overflow: this.state.zoom ? 'scroll' : 'hidden',
			background: 'url(' + image + ') no-repeat center center',
			backgroundSize: props.imageSize || 'contain',
			backgroundColor: props.bgColor + 'B3' || '#fffff' // bg color alpha/opacity 70%
		};

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'swiper-slide' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': __WEBPACK_IMPORTED_MODULE_1__style___default.a.slideContainer },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'imageContainer', style: imageContainerStyle }),
				props.showOverlay ? _ref : null
			)
		);
	};

	GalleryImage.prototype.handleZoom = function handleZoom() {
		this.setState({
			zoom: !this.state.zoom
		});
	};

	return GalleryImage;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "Fv1s":
/***/ (function(module, exports) {

function E() {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function on(name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function once(name, callback, ctx) {
    var self = this;
    function listener() {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback;
    return this.on(name, listener, ctx);
  },

  emit: function emit(name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function off(name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    liveEvents.length ? e[name] = liveEvents : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;

/***/ }),

/***/ "I6Nf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialEmotionIcons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("1WOQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("xdL+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__("EIet");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// const icon_path = "../../../assets/socialEmoji/";

var SocialEmotionIcons = function (_Component) {
  _inherits(SocialEmotionIcons, _Component);

  function SocialEmotionIcons(props) {
    _classCallCheck(this, SocialEmotionIcons);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleEmotionIconClick = function (icon) {
      _this.setState({ emotionSelected: icon.name }, function () {
        if (_this.props.onEmotionIconClick) {
          _this.props.onEmotionIconClick(_this.props.tag, icon.name);
        }
        // track thirdparty events---
        _this.props.trackEvent("LeadTagEvents", _this.props.tag, {
          emotion: icon.name
        });
        //---
        _this.logEngagementEvent(icon.name); // emotion specific engagement event
        _this.logEngagementEvent(icon.name, 'engagement');
      });
    };

    _this.logEngagementEvent = function (name, event) {
      var engagements = Object(__WEBPACK_IMPORTED_MODULE_3__helper__["n" /* getEngagements */])(_this.props.tag);
      var action = engagements && engagements[0];
      var actionValueFormtted = action.slug || "emotion";

      var tag_id = _this.props.tag.id;
      var tag_label = _this.props.tag && _this.props.tag.details && (_this.props.tag.details.preview_title || _this.props.tag.details.title);
      var engagement_id = action && action.id;

      var options = {
        type: actionValueFormtted,
        sub_type: null,
        event: event || "emotion_engagement",
        event_type: actionValueFormtted,
        tag_id: tag_id,
        tag_label: tag_label,
        engagement_id: engagement_id,
        emotion: name,
        current_duration: _this.props.getCurrentTime()
      };
      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* constants */].LOG_EVENT_ENGAGEMENT, {
        tag: _this.props.tag,
        options: options
      });
    };

    _this.state = {
      emotionSelected: null
    };
    return _this;
  }

  SocialEmotionIcons.prototype.render = function render(props, state) {
    var _this2 = this;

    var tag = props.tag,
        size = props.size;

    var title = tag && tag.details && tag.details.title;
    var engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
    var layout = props.layout || engagement && engagement.layout || "black";
    var attr = engagement && engagement.attr && JSON.parse(engagement.attr);
    var enabledAttr = attr && attr.filter(function (item) {
      return item.enabled;
    });
    var hideTitle = engagement && !!engagement.hide_title;
    var tagColor = tag && tag.details && tag.details.color || "#ffffff";
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "div",
      { "class": "wt-social-emotion-container" },
      !hideTitle && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { "class": "wt-social-emotion-title", style: { color: tagColor, textAlign: size ? 'center' : 'auto' } },
        title
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "ul",
        { "class": "wt-social-emotion " + layout + " " + (size || "") },
        enabledAttr && enabledAttr.map(function (icon, idx) {
          var emojiStyle = {
            // background: `url(${icon_path}${icon.name}.svg)`,
            backgroundSize: "cover",
            width: "100%",
            height: "100%"
          };
          if (state.emotionSelected) {
            if (state.emotionSelected === icon.name) {
              emojiStyle = _extends({}, emojiStyle, { transform: "scale(1.5)" });
            } else {
              emojiStyle = _extends({}, emojiStyle, { opacity: "0.5" });
            }
          }
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "li",
            {
              key: "icon-" + idx,
              onClick: _this2.handleEmotionIconClick.bind(_this2, icon)
            },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("div", { style: emojiStyle, "class": "emoji_" + icon.name })
          );
        })
      )
    );
  };

  return SocialEmotionIcons;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "JUot":
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) {// .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' && selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function (range) {
        selection.addRange(range);
      });
    }

    active && active.focus();
  };
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var core_namespaceObject = {};
__webpack_require__.d(core_namespaceObject, "initialize", function() { return core_initialize; });
__webpack_require__.d(core_namespaceObject, "ga", function() { return ga; });
__webpack_require__.d(core_namespaceObject, "set", function() { return set; });
__webpack_require__.d(core_namespaceObject, "send", function() { return send; });
__webpack_require__.d(core_namespaceObject, "pageview", function() { return pageview; });
__webpack_require__.d(core_namespaceObject, "modalview", function() { return modalview; });
__webpack_require__.d(core_namespaceObject, "timing", function() { return timing; });
__webpack_require__.d(core_namespaceObject, "event", function() { return core_event; });
__webpack_require__.d(core_namespaceObject, "exception", function() { return exception; });
__webpack_require__.d(core_namespaceObject, "plugin", function() { return core_plugin; });
__webpack_require__.d(core_namespaceObject, "outboundLink", function() { return outboundLink; });
__webpack_require__.d(core_namespaceObject, "testModeAPI", function() { return core_testModeAPI; });
__webpack_require__.d(core_namespaceObject, "default", function() { return core; });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style/index.less
var style = __webpack_require__("EbM4");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/config.js
var components_config = __webpack_require__("xdL+");

// EXTERNAL MODULE: ./components/helper.js
var helper = __webpack_require__("EIet");

// CONCATENATED MODULE: ./components/env.js

var unknown = '-';

// screen
var screenSize = '';
if (screen.width) {
  var env_width = screen.width ? screen.width : '';
  var env_height = screen.height ? screen.height : '';
  screenSize += '' + env_width + " x " + env_height;
}

// browser
var nVer = navigator.appVersion;
var nAgt = navigator.userAgent;
var browser = navigator.appName;
var version = '' + parseFloat(navigator.appVersion);
var majorVersion = parseInt(navigator.appVersion, 10);
var nameOffset, verOffset, ix;

// Opera
if ((verOffset = nAgt.indexOf('Opera')) != -1) {
  browser = 'Opera';
  version = nAgt.substring(verOffset + 6);
  if ((verOffset = nAgt.indexOf('Version')) != -1) {
    version = nAgt.substring(verOffset + 8);
  }
}

// Opera Next
if ((verOffset = nAgt.indexOf('OPR')) != -1) {
  browser = 'Opera';
  version = nAgt.substring(verOffset + 4);
}

// Edge
else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
    browser = 'Microsoft Edge';
    version = nAgt.substring(verOffset + 5);
  }

  // MSIE
  else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browser = 'Microsoft Internet Explorer';
      version = nAgt.substring(verOffset + 5);
    }

    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
      }

      // Safari
      else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
          browser = 'Safari';
          version = nAgt.substring(verOffset + 7);
          if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
          }
        }

        // Firefox
        else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
            browser = 'Firefox';
            version = nAgt.substring(verOffset + 8);
          }

          // MSIE 11+
          else if (nAgt.indexOf('Trident/') != -1) {
              browser = 'Microsoft Internet Explorer';
              version = nAgt.substring(nAgt.indexOf('rv:') + 3);
            }

            // Other browsers
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                browser = nAgt.substring(nameOffset, verOffset);
                version = nAgt.substring(verOffset + 1);
                if (browser.toLowerCase() == browser.toUpperCase()) {
                  browser = navigator.appName;
                }
              }

// trim the version string
if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

majorVersion = parseInt('' + version, 10);

if (isNaN(majorVersion)) {
  version = '' + parseFloat(navigator.appVersion);
  majorVersion = parseInt(navigator.appVersion, 10);
}

// cookie
var cookieEnabled = navigator.cookieEnabled ? true : false;

if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
  document.cookie = 'testcookie';
  cookieEnabled = document.cookie.indexOf('testcookie') != -1 ? true : false;
}

// system
var os = unknown;
var bitset;
var clientStrings = [{ s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ }, { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ }, { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ }, { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ }, { s: 'Windows Vista', r: /Windows NT 6.0/ }, { s: 'Windows Server 2003', r: /Windows NT 5.2/ }, { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ }, { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ }, { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ }, { s: 'Windows 98', r: /(Windows 98|Win98)/ }, { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ }, { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ }, { s: 'Windows CE', r: /Windows CE/ }, { s: 'Windows 3.11', r: /Win16/ }, { s: 'Android', r: /Android/ }, { s: 'Open BSD', r: /OpenBSD/ }, { s: 'Sun OS', r: /SunOS/ }, { s: 'Linux', r: /(Linux|X11)/ }, { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
// { s:'MacOS', r:/Mac OS X/ },
{ s: 'MacOS', r: /(Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ }, { s: 'ChromeOS', r: /\bCrOS\b/ }, { s: 'QNX', r: /QNX/ }, { s: 'UNIX', r: /UNIX/ }, { s: 'BeOS', r: /BeOS/ }, { s: 'OS/2', r: /OS\/2/ }, { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver) / }];

for (var env_id in clientStrings) {
  var cs = clientStrings[env_id];
  if (cs.r.test(nAgt)) {
    os = cs.s;
    break;
  }
}

var osVersion = unknown;

if (/Windows/.test(os)) {
  osVersion = /Windows (.*)/.exec(os)[1];
  os = 'Windows';
  bitset = '10000';
}

switch (os) {
  case 'MacOS':
    osVersion = /Mac OS X (\d[\.\_\d]+)/.exec(nAgt);
    osVersion = osVersion && osVersion[1];
    bitset = '01000';
    break;

  case 'Android':
    osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
    bitset = '00001';
    break;

  case 'iOS':
    osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
    osVersion = osVersion && osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
    bitset = '00100';
    break;
  case 'ChromeOS':
    osVersion: 1;
    bitset = '00010';
};

var envs = {
  screen: screenSize,
  screenWidth: env_width,
  screenHeight: env_height,
  browser: browser,
  browserVersion: version,
  browserMajorVersion: majorVersion,
  os: os,
  osVersion: osVersion,
  bitset: bitset,
  cookies: cookieEnabled
};

/* harmony default export */ var env = (envs);
// CONCATENATED MODULE: ./components/targets.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var deviceTargets = [];
var tempArr = [];
var targets_bitset = '' + getDevice() + env.bitset;

function checkTarget(tag, isChild) {
  if (tag.target && tag.target.devices !== undefined) {
    var target = pad(tag.target.devices.toString(2), 8);
    var result = compare(targets_bitset, target);
    if (result) {
      return true;
    } else return false;
  } else {
    if (isChild) return false;else return true;
  }
}

function iterateChildren(tags, children, parent) {
  children.some(function (item) {
    if (checkTarget(item) && item.show_tag && item.tag_enabled) {
      // let tagSource = findTag(tags, item.src_tag_id);
      // item = extendTag(tagSource ? tagSource : parent, item);
      item = Object(helper["g" /* extendTag */])(tags, item);
      tempArr.push(item);
      return true;
    }
  });
}

function iterateTags(tags) {
  try {
    var _ref;

    var decisionTags = tags.filter(function (item) {
      return item.settings.category === '15';
    });
    var decisions = decisionTags.map(function (item) {
      var meta = item.details.engagements && item.details.engagements[0] && item.details.engagements[0].meta;
      // added the DP tag target to its linked tags obj---
      meta = meta.map(function (linkedTag) {
        return _extends({}, linkedTag, { dpTarget: item.target });
      });
      return meta;
    });
    // created mapping between the linked tag [key] and its dp tag target [value]---
    var linkedTagMap = {};
    decisions && (_ref = []).concat.apply(_ref, decisions).forEach(function (item) {
      linkedTagMap[item.tag] = item.dpTarget;
    });
  } catch (e) {}

  tags.map(function (item, index) {
    if (decisionTags.length && !!linkedTagMap[item.id]) {
      // overwriting the linked tag target by its DP tag target---
      item.target = linkedTagMap[item.id];
      if (checkTarget(item)) {
        tempArr.push(item);
      }
    } else if (checkTarget(item) && item.show_tag && item.tag_enabled) {
      tempArr.push(item);
    } else {
      if (item.child_tags) {
        iterateChildren(tags, item.child_tags, item);
      }
    }
  });
}

function getDevice() {
  if (Object(helper["L" /* mobileCheck */])()) return '010';else if (Object(helper["R" /* tabletCheck */])()) return '001';else return '100';
}

function pad(s, size) {
  while (s.length < size) {
    s = '0' + s;
  }return s;
}

function compare(bitset, target) {
  var result = true;

  if (target === '00000000') {
    return true;
  }

  for (var i = 0; i < bitset.length; i++) {
    if (bitset[i] === '1') {
      if (bitset[i] !== target[i]) {
        result = false;
        break;
      }
    }
  }

  return result;
}

function resolveTargets(json) {
  var tags = json.tags.slice();
  iterateTags(tags);

  return tempArr;
}
// EXTERNAL MODULE: ../node_modules/react-facebook-pixel/dist/fb-pixel.js
var fb_pixel = __webpack_require__("1yJE");
var fb_pixel_default = /*#__PURE__*/__webpack_require__.n(fb_pixel);

// EXTERNAL MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js
var preact_compat_es = __webpack_require__("eW0v");

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/console/warn.js
function warn(s) {
  console.warn('[react-ga]', s);
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/components/OutboundLink.js
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;return o;
  };return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink_OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      return preact_compat_es["default"].createElement('a', props);
    }
  }]);

  return OutboundLink;
}(preact_compat_es["Component"]);

_defineProperty(OutboundLink_OutboundLink, "trackLink", function () {
  warn('ga tracking not enabled');
});

_defineProperty(OutboundLink_OutboundLink, "propTypes", {
  eventLabel: prop_types_default.a.string.isRequired,
  target: prop_types_default.a.string,
  to: prop_types_default.a.string,
  onClick: prop_types_default.a.func,
  trackerNames: prop_types_default.a.arrayOf(prop_types_default.a.string)
});

_defineProperty(OutboundLink_OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});


// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/mightBeEmail.js
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return (/[^@]+@[^@]+/.test(s)
  );
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/trim.js
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/toTitleCase.js
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return trim(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/format.js



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (mightBeEmail(s)) {
    warn('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return toTitleCase(s);
  }

  return s;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/removeLeadingSlash.js
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/loadGA.js
/* harmony default export */ var loadGA = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/console/log.js
function log_log(s) {
  console.info('[react-ga]', s);
}
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/utils/testModeAPI.js
var gaCalls = [];
/* harmony default export */ var testModeAPI = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/core.js
function core__objectWithoutProperties(source, excluded) {
  if (source == null) return {};var target = core__objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];
    }
  }return target;
}

function core__objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];
  }return target;
}

function core__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }ownKeys.forEach(function (key) {
      core__defineProperty(target, key, source[key]);
    });
  }return target;
}

function core__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function core__typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    core__typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    core__typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }return core__typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }
}

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var core_internalGa = function internalGa() {
  var _window;

  if (_testMode) return testModeAPI.ga.apply(testModeAPI, arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return warn('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return format(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof core_internalGa === 'function') {
    if (typeof command !== 'string') {
      warn('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) core_internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        core_internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    warn('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    core_internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    core_internalGa('create', gaTrackingID, 'auto');
  }
}

function core_initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) loadGA(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (core__typeof(config) !== 'object') {
        warn('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    core_internalGa.apply(void 0, args);

    if (_debug) {
      log_log('called ga(\'arguments\');');
      log_log("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    warn('`fieldsObject` is required in .set()');
    return;
  }

  if (core__typeof(fieldsObject) !== 'object') {
    warn('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    warn('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    log_log('called ga(\'set\', fieldsObject);');
    log_log("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    log_log('called ga(\'send\', fieldObject);');
    log_log("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    log_log("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    warn('path is required in .pageview()');
    return;
  }

  var path = trim(rawPath);

  if (path === '') {
    warn('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', core__objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      log_log('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      log_log("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    warn('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = removeLeadingSlash(trim(rawModalName));

  if (modalName === '') {
    warn('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      log_log('called ga(\'send\', \'pageview\', path);');
      log_log("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      warn('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function core_event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = core__objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      warn('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        warn('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        warn('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        warn('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          warn('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        warn('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var core_plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        warn('`name` is required in .require()');
        return;
      }

      var name = trim(rawName);

      if (name === '') {
        warn('`name` cannot be an empty string in .require()');
        return;
      } // Optional Fields


      if (options) {
        if (core__typeof(options) !== 'object') {
          warn('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          warn('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          log_log("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga('require', name);

        if (_debug) {
          log_log("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        warn('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        warn('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            log_log("called ga('".concat(command, "');"));
            log_log("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            log_log("called ga('".concat(command, "');"));
            log_log("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            log_log("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    warn('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      warn('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var core_testModeAPI = testModeAPI;
/* harmony default export */ var core = ({
  initialize: core_initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: core_event,
  exception: exception,
  plugin: core_plugin,
  outboundLink: outboundLink,
  testModeAPI: testModeAPI
});
// CONCATENATED MODULE: ../node_modules/react-ga/dist/esm/index.js
function esm__objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }ownKeys.forEach(function (key) {
      esm__defineProperty(target, key, source[key]);
    });
  }return target;
}

function esm__defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}



var esm_initialize = core_initialize;
var esm_ga = ga;
var esm_set = set;
var esm_send = send;
var esm_pageview = pageview;
var esm_modalview = modalview;
var esm_timing = timing;
var esm_event = core_event;
var esm_exception = exception;
var esm_plugin = core_plugin;
var esm_outboundLink = outboundLink;
var esm_testModeAPI = core_testModeAPI;
OutboundLink_OutboundLink.origTrackLink = OutboundLink_OutboundLink.trackLink;
OutboundLink_OutboundLink.trackLink = outboundLink;
var esm_OutboundLink = OutboundLink_OutboundLink;
/* harmony default export */ var esm = (esm__objectSpread({}, core_namespaceObject, {
  OutboundLink: esm_OutboundLink
}));
// CONCATENATED MODULE: ./components/tracker.js
var tracker__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





function tracker_setTrackers(trackers) {
	if (trackers) {
		Object.entries(trackers).forEach(function (_ref) {
			var key = _ref[0],
			    value = _ref[1];

			if (value.type === 'FB') {
				var options = {
					autoConfig: true,
					debug: false
				};

				try {
					fb_pixel_default.a.init(value.code, {}, options);
					value.ref = fb_pixel_default.a;
				} catch (e) {}
			} else if (value.type === 'GOOGL') {
				try {
					esm.initialize(value.code);
					// ReactGA.pageview(window.location.pathname);
					value.ref = esm;
				} catch (e) {}
			} else {
				// no initialization for others ---
			}
		});
	}
	return trackers;
}

function tracker_trackEvent(trackers, event, tag, eventDataObj, logDataEvent) {
	var subcategory = tag && tag.settings && tag.settings.subcategory;
	var subcategoryEngagement = subcategory && subcategory[0] && subcategory[0].engagements && subcategory[0].engagements[0];
	var engSlug = subcategoryEngagement && subcategoryEngagement.slug;

	var tag_id = tag && tag.id;
	var tag_title = tag && tag.details && (tag.details.preview_title || tag.details.title);
	var video_title = eventDataObj.video_title;
	var tag_duration = eventDataObj.tag_duration;
	var eng_label = subcategoryEngagement && subcategoryEngagement['label|' + engSlug];
	var sub_objective = subcategory && subcategory[0] && subcategory[0].name;
	var cat_type = tag && tag.settings && tag.settings.category;
	var sub_cat_type = subcategory && subcategory[0] && subcategory[0].type;
	var view_event = eventDataObj.view_event;
	var gate_response = eventDataObj.gate_response;
	var emotion = eventDataObj.emotion;
	var macros = {
		tag_id: tag_id,
		tag_title: tag_title,
		tag_duration: tag_duration,
		eng_label: eng_label,
		sub_objective: sub_objective,
		cat_type: cat_type,
		sub_cat_type: sub_cat_type,
		video_title: video_title,
		view_event: view_event,
		gate_response: gate_response,
		emotion: emotion
	};

	var eventMacros = [];
	var fbEventName = '';
	var enabledTagTrackers = tag && tag.target && tag.target.trackers || [];

	switch (event) {
		case 'ViewContent':
			eventMacros = ['tag_title', 'video_title', 'tag_duration'];
			fbEventName = 'ViewContent';
			break;
		case 'AddToCart':
			switch (macros.cat_type) {
				case 1:
					eventMacros = ['tag_title', 'video_title'];
					break;
				case 8:
					eventMacros = ['tag_title', 'video_title', 'eng_label'];
					break;
			}
			fbEventName = 'AddToCart';
			break;
		case 'Lead':
			switch (macros.cat_type) {
				case 9:
				case 12:
					eventMacros = ['tag_title', 'video_title'];
					break;
				case 10:
					eventMacros = ['tag_title', 'video_title', 'sub_objective'];
					break;
			}
			fbEventName = 'Lead';
			break;
		case 'LeadTagEvents':
			switch (macros.sub_cat_type) {
				case 900:
					eventMacros = ['tag_title', 'video_title', 'selected_poll'];
					break;
				case 903:
					eventMacros = ['tag_title', 'video_title', 'gate_response'];
					break;
				case 1602:
					eventMacros = ['tag_title', 'video_title', 'emotion'];
					break;
			}
			fbEventName = 'Lead';
			break;
		case 'Impression':
			eventMacros = ['tag_title', 'video_title', 'sub_objective'];
			fbEventName = 'Impression';
			break;
	}

	// View Tracking - tracks on video play
	if (trackers && event === 'VideoViewTracking') {
		var viewEventMacros = ['video_title', 'view_event'];
		var clientSelectedMacros = ['video_title', 'view_event'];
		var macrosToSend = filterMacros(viewEventMacros, clientSelectedMacros, macros);
		var _fbEventName = 'ViewContent';
		Object.entries(trackers).forEach(function (_ref2) {
			var key = _ref2[0],
			    value = _ref2[1];

			var trackViewEnabled = value.meta.filter(function (item) {
				return item === 'track_view';
			}).length;
			var eventKey = eventDataObj.event_key; // can be one of [0,25,50,75,100]
			var keyEnabled = true;
			if (value.view_tracking_enabled) {
				keyEnabled = !!value.view_tracking_enabled.filter(function (num) {
					return num === eventKey;
				}).length;
			}
			if (trackViewEnabled && keyEnabled) {
				if (value.type === 'FB') {
					value.ref.track(_fbEventName, macrosToSend);
				} else if (value.type === 'GOOGL') {
					value.ref.set({ dimension1: JSON.stringify(macrosToSend) });
					value.ref.ga('send', 'dimension1');
					value.ref.event({ category: _fbEventName, action: _fbEventName });
				} else {
					macrosToSend = tracker__extends({ event: _fbEventName }, macrosToSend);
					var urlParameters = Object(helper["M" /* parseJsonToFormData */])(macrosToSend);
					var trackerUrl = value.code && value.code.toString();
					if (trackerUrl) {
						var operator = trackerUrl.indexOf('?') !== -1 ? '&' : '?';
						trackerUrl = trackerUrl.replace('[timestamp]', Date.now());
						var url = '' + trackerUrl + operator + urlParameters;
						Object(helper["N" /* request */])(url, { mode: 'no-cors' });
					}
				}
			}
		});
	}

	if (trackers) {
		Object.entries(trackers).forEach(function (_ref3) {
			var key = _ref3[0],
			    value = _ref3[1];

			if (enabledTagTrackers.join('^').indexOf(key) !== -1) {
				var _macrosToSend = {};
				if (value.type === 'FB') {
					var _clientSelectedMacros = value.micros;
					_macrosToSend = filterMacros(eventMacros, _clientSelectedMacros, macros);
					//console.log(fbEventName, macrosToSend);
					value.ref.track(fbEventName, _macrosToSend);
				} else if (value.type === 'GOOGL') {
					var _clientSelectedMacros2 = value.micros;
					_macrosToSend = filterMacros(eventMacros, _clientSelectedMacros2, macros);

					value.ref.set({ dimension1: JSON.stringify(_macrosToSend) });
					value.ref.ga('send', 'dimension1');
					value.ref.event({ category: fbEventName, action: fbEventName });
				} else {
					var _clientSelectedMacros3 = value.micros;
					_macrosToSend = filterMacros(eventMacros, _clientSelectedMacros3, macros);
					// in NON-google/fb case event will be sent as extra parameter to url---
					_macrosToSend = tracker__extends({ event: fbEventName }, _macrosToSend);

					var urlParameters = Object(helper["M" /* parseJsonToFormData */])(_macrosToSend);
					var trackerUrl = value.code;
					if (trackerUrl) {
						var operator = trackerUrl.indexOf('?') !== -1 ? '&' : '?';
						trackerUrl = trackerUrl.replace('[timestamp]', Date.now());
						var url = '' + trackerUrl + operator + urlParameters;
						Object(helper["N" /* request */])(url, { mode: 'no-cors' });
						// let wnd = window.open(url);
						// if (wnd){
						// 	wnd.close();
						// }
					}
				}
				//log data event for stats---
				statsDataEvent(_macrosToSend, tag, fbEventName, value.type, logDataEvent);
			}
		});
	}
}

function filterMacros(eventMacros, clientSelectedMacros, macros) {
	var macrosToSend = {};
	// modifying for age gate to include `gate_response` as it is not in the checkbox list in dashboard for client to select---
	if (eventMacros.includes('gate_response')) {
		clientSelectedMacros.push('gate_response');
	}
	// for social emotion
	if (eventMacros.includes('emotion')) {
		clientSelectedMacros.push('emotion');
	}
	//---


	eventMacros.forEach(function (macro) {
		if (clientSelectedMacros && clientSelectedMacros.indexOf(macro) !== -1) {
			macrosToSend[macro] = macros[macro];
		}
	});
	return macrosToSend;
}

function statsDataEvent(macrosToSend, tag, trackerEventType, eventType, logDataEvent) {
	var tag_id = tag && tag.id;
	var tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
	var engagement_data = tracker__extends(macrosToSend, { tracker_event_type: trackerEventType });
	var logDataObj = {
		sub_type: null,
		event: 'tracker',
		event_type: eventType,
		tag_id: tag_id,
		tag_label: tag_label,
		engagement_data: JSON.stringify(engagement_data)
	};
	logDataEvent(logDataObj);
}
// CONCATENATED MODULE: ./components/events.js
var events__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function dispatchEvent(action, data) {
  switch (action) {
    case components_config["b" /* constants */].LOG_EVENT_CLICK_MANUAL:
      return logEventClickManual(data);
    // case constants.LOG_EVENT_CLICK_AUTO: return logEventClickAuto(data);
    // case constants.LOG_EVENT_CLICK_PREVIEW: return logEventClickPreview(data);
    case components_config["b" /* constants */].LOG_EVENT_ENGAGEMENT:
      return logEventEngagement(data);

    case components_config["b" /* constants */].LOG_EVENT_TAG_OPEN:
      return logEventTagOpen(data);
    case components_config["b" /* constants */].LOG_EVENT_TAG_CLOSE:
      return logEventTagClose(data);

    case components_config["b" /* constants */].LOG_EVENT_UNIQUE:
      return logEventUnique();
    case components_config["b" /* constants */].LOG_EVENT_UNIQUE_2SEC:
      return logEventUnique2Sec();
    case components_config["b" /* constants */].LOG_EVENT_VIEW:
      return logEventView(data);

    case components_config["b" /* constants */].LOG_EVENT_PLAY:
      return logEventPlay(data);
    case components_config["b" /* constants */].LOG_EVENT_PAUSE:
      return logEventPause(data);
    case components_config["b" /* constants */].LOG_EVENT_FF:
      return logEventFF(data);
    case components_config["b" /* constants */].LOG_EVENT_VOLUME:
      return logEventVolume(data);
    case components_config["b" /* constants */].LOG_EVENT_FOCUS_OUT:
      return logEventFocusOut();
    case components_config["b" /* constants */].LOG_EVENT_FOCUS_IN:
      return logEventFocusIn();
    case components_config["b" /* constants */].LOG_EVENT_CONTINUE:
      return logEventContinue(data);
    case components_config["b" /* constants */].LOG_EVENT_REPEAT:
      return logEventRepeat(data);

    case components_config["b" /* constants */].LOG_EVENT_EMOJI_CLICK:
      return logEmojiClick(data);
    case components_config["b" /* constants */].LOG_EVENT_COMPLETION:
      return logVideoCompletion(data);
    case components_config["b" /* constants */].LOG_EVENT_QUARTILE:
      return logEventQuartile(data);
    case components_config["b" /* constants */].LOG_EVENT_INTERACTING:
      return logEventInteracting(data);
    // case constants.LOG_EVENT_INTERACTION_START: return logEventInteractionStart(data);
    case components_config["b" /* constants */].LOG_EVENT_ENDCARD_PREVIEW:
      return logEventEndcardPreview(data);

    case components_config["b" /* constants */].LOG_EVENT_INTERACTION:
      return logEventInteraction(data);
    case components_config["b" /* constants */].LOG_EVENT_GALLERY_INTERACTION:
      return logEventGalleryInteraction(data);
    case components_config["b" /* constants */].LOG_EVENT_FORM_INSIGHT:
      return logEventFormInsight(data);
  }
}

function getTagType(tag) {
  var engagements = tag && Object(helper["n" /* getEngagements */])(tag);
  var engagement = engagements && engagements[0];
  var tag_type = engagement && engagement.slug || '';
  return tag_type;
}

function logEventInteraction() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tag = data.tag;

  var tag_id = tag && tag.id;
  var tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  var duration = Math.round(data.current_duration);
  delete data.tag;
  return events__extends({
    event: 'interaction',
    type: 'interaction',
    tag_id: tag_id,
    tag_label: tag_label,
    duration: duration,
    event_type: 'preview',
    tag_type: getTagType(tag)
  }, data);
}

function logEventFormInsight() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tag = data.tag;

  var tag_id = tag && tag.id;
  var tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  var duration = Math.round(data.current_duration);
  delete data.tag;
  return events__extends({
    event: 'form_insight',
    type: 'form_insight',
    tag_id: tag_id,
    tag_label: tag_label,
    duration: duration,
    event_type: 'form_insight',
    tag_type: getTagType(tag)
  }, data);
}

function logEventGalleryInteraction() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var tag = data.tag;

  var tag_id = tag && tag.id;
  var tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  var duration = Math.round(data.duration || data.current_duration);
  delete data.tag;
  return events__extends({
    event: 'gallery_interaction',
    tag_id: tag_id,
    tag_label: tag_label,
    duration: duration,
    event_type: data.event_type || 'preview',
    tag_type: getTagType(tag)
  }, data);
}

function logEventClickManual(data) {
  var tag = data.tag;
  var current_duration = data.current_duration;
  var tag_id = tag && tag.id;
  var tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);
  var evtObject = {
    type: 'click',
    event: 'click',
    click_type: 'manual',
    current_duration: current_duration,
    tag_type: getTagType(tag)
  };

  if (typeof tag !== 'undefined') {
    evtObject['tag_id'] = tag_id;
    evtObject['tag_label'] = tag_label;
  }

  if (data.info) {
    evtObject['event_type'] = 'info';
  }

  if (data.options && typeof data.options === 'object') {
    evtObject = events__extends({}, evtObject, data.options);
  }

  return evtObject;
}

// function logEventClickAuto(data) {
//   let tag = data.tag;
//   let current_duration = data.current_duration;
//   let tag_id = tag.id;
//   let tag_label = tag.details && (tag.details.preview_title || tag.details.title);
//   let evtObject = {
//     type: 'click',
//     event: 'click',
//     click_type: 'auto',
//     current_duration,
//     tag_id,
//     tag_label,
//   };

//   if (data.info) {
//     evtObject['event_type'] = 'info';
//   }

//   return evtObject;
// }

function logEventEndcardPreview(_ref) {
  var current_duration = _ref.current_duration,
      event_type = _ref.event_type;

  return {
    type: 'end_card_preview',
    sub_type: null,
    event: 'end_card_preview',
    event_type: event_type,
    current_duration: current_duration
  };
}

// function logEventClickPreview(data) {
//   let tag = data.tag;
//   let current_duration = data.currentTime;
//   let tag_id = tag && tag.id;
//   let tag_label = tag && tag.details && (tag.details.preview_title || tag.details.title);

//   return {
//     type: 'click',
//     sub_type: null,
//     event: 'click',
//     click_type: 'manual',
//     event_type: data.event_type || 'preview',
//     current_duration,
//     tag_id,
//     tag_label
//   };
// }

function logEventEngagement(data) {
  var tag = data.tag;
  var engagements = tag && Object(helper["n" /* getEngagements */])(tag);
  var engagement = engagements && engagements[0];

  var actionValueFormtted = engagement && engagement.slug;
  var tag_id = tag && tag.id;
  var tag_label = tag && (tag.details.preview_title || tag.details.title);
  var engagement_id = engagement && engagement.id;
  var engagement_label = engagement && engagement['label|' + engagement.slug];
  var engagement_type = data.engagement_type;

  return events__extends({
    type: actionValueFormtted,
    sub_type: null,
    event: 'engagement',
    event_type: actionValueFormtted,
    tag_id: tag_id,
    tag_label: tag_label,
    engagement_id: engagement_id,
    engagement_label: engagement_label,
    engagement_type: engagement_type,
    tag_type: getTagType(tag)
  }, data.options || {});
}

function logEventTagOpen(data) {
  var tag = data.tag;
  var tag_id = tag.id;
  var tag_label = tag.details && (tag.details.preview_title || tag.details.title);
  var duration = Math.round(data.duration);

  return {
    type: 'tag',
    sub_type: null,
    event: 'tag',
    event_type: 'open',
    duration: duration,
    tag_id: tag_id,
    tag_label: tag_label
  };
}

function logEventTagClose(data) {
  var tag = data.tag;
  var tag_id = tag.id;
  var tag_label = tag.details && (tag.details.preview_title || tag.details.title);
  var duration = data.duration;

  return {
    type: 'tag',
    sub_type: null,
    event: 'tag',
    event_type: 'close',
    duration: duration,
    tag_id: tag_id,
    tag_label: tag_label,
    current_duration: data.current_duration
  };
}

function logEventUnique() {
  return {
    type: 'unique_view',
    sub_type: null,
    event: 'unique_view',
    event_type: null
  };
}

function logEventUnique2Sec() {
  return {
    type: 'unique_2sec_view',
    sub_type: null,
    event: 'unique_2sec_view',
    event_type: null
  };
}

function logEventView(_ref2) {
  var current_duration = _ref2.current_duration,
      percent_value = _ref2.percent_value;

  return {
    type: 'view',
    subtype: null,
    event: 'view',
    current_duration: current_duration,
    percent_value: percent_value,
    // duration: 5,
    duration: Math.round(current_duration)
  };
}

function logEventPlay(current_duration) {
  return {
    type: 'player_control',
    subtype: 'play',
    event: 'player',
    event_type: 'play',
    current_duration: current_duration
  };
}

function logEventPause(current_duration) {
  return {
    type: 'player_control',
    subtype: 'pause',
    event: 'player',
    event_type: 'pause',
    current_duration: current_duration
  };
}

function logEventFF(current_duration) {
  return {
    type: 'player_control',
    subtype: 'ff',
    event: 'player',
    event_type: 'ff',
    current_duration: current_duration
  };
}

function logEventVolume(current_duration) {
  return {
    type: 'player_control',
    subtype: 'volume',
    event: 'player',
    event_type: 'volume',
    current_duration: current_duration
  };
}

function logEventFocusOut(current_duration) {
  return {
    type: 'player_control',
    subtype: 'focus_out',
    event: 'player',
    event_type: 'focus_out',
    current_duration: current_duration
  };
}

function logEventFocusIn(current_duration) {
  return {
    type: 'player_control',
    subtype: 'focus_in',
    event: 'player',
    event_type: 'focus_in',
    current_duration: current_duration
  };
}

function logEventContinue(current_duration) {
  return {
    event: 'player',
    event_type: 'continue',
    current_duration: current_duration
  };
}

function logEventRepeat(current_duration) {
  return {
    event: 'repeat_view',
    event_type: null,
    current_duration: current_duration
  };
}

function logEmojiClick(data) {
  return {
    event: data.event || 'emoticons',
    event_type: data.emoji,
    current_duration: data.current_duration
  };
}

function logVideoCompletion(data) {
  return {
    event: data.event || 'completion',
    event_type: data.event_type || 'completion',
    current_duration: data.current_duration
  };
}

function logEventQuartile(data) {
  var current_duration = data.current_duration,
      event_type = data.event_type,
      _data$type = data.type,
      type = _data$type === undefined ? 'quartile' : _data$type,
      _data$event = data.event,
      event = _data$event === undefined ? 'quartile' : _data$event,
      tag = data.tag;

  var eventObj = {
    type: type,
    event_type: event_type,
    subtype: null,
    event: event,
    current_duration: current_duration
  };
  if (tag) {
    var video_id = data.video_id,
        parent_video_id = data.parent_video_id,
        engagementId = data.engagementId,
        engagementLabel = data.engagementLabel,
        tagLabel = data.tagLabel,
        tagId = data.tagId;

    var subcategory = tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
    var engagement = subcategory && subcategory.engagements && subcategory.engagements[0];

    var actionValueFormtted = engagement && engagement.slug;
    var tag_id = tagId || tag.id;
    var tag_label = tagLabel || tag.details.preview_title || tag.details.title;
    var engagement_id = engagementId || engagement && engagement.id;
    var engagement_label = engagementLabel || engagement && engagement['label|' + actionValueFormtted];

    eventObj = events__extends({}, eventObj, { tag_id: tag_id, tag_label: tag_label, engagement_id: engagement_id, engagement_label: engagement_label, video_id: video_id, parent_video_id: parent_video_id });
  }

  return eventObj;
}

function logEventInteracting(data) {
  var tag = data.tag;
  var tag_id = tag.id;
  var tag_label = tag.details && (tag.details.preview_title || tag.details.title);
  var duration = Math.round(data.duration);
  return {
    type: 'interacting',
    event: 'interacting',
    tag_id: tag_id,
    tag_label: tag_label,
    duration: duration,
    current_duration: data.current_duration,
    tag_type: getTagType(tag)
  };
}

// function logEventInteractionStart(data) {
//   let tag = data.tag;
//   let tag_id = tag.id;
//   let tag_label = tag.details && (tag.details.preview_title || tag.details.title);
//   let duration = Math.round(data.duration);

//   return {
//     type: 'interaction_start',
//     sub_type: null,
//     event: 'interaction_start',
//     event_type: 'interaction_start',
//     duration,
//     tag_id,
//     tag_label
//   };
// }
// CONCATENATED MODULE: ./components/store.js


var store__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var store_Store = function () {
  function Store() {
    var _this = this;

    store__classCallCheck(this, Store);

    this.setThirdParyTrackerData = function () {
      var macros = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.data.tpMacros = macros;
    };

    this.data = {};
    this.viewer_id = components_config["b" /* constants */].TEMP_VIEWER_ID;
    this.session_id = helper["o" /* getGUID */]();
    this.getUser();
    this.eventsHeldForId = [];
  }

  Store.prototype.setId = function setId(wtUUID) {
    var _this2 = this;

    this.viewer_id = wtUUID;
    this.setUser();
    // console.log(this.eventsHeldForId, this.session_id)
    this.eventsHeldForId.forEach(function (evt) {
      var eventObj = JSON.parse('{"' + decodeURI(evt).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      eventObj.session_id = _this2.session_id;
      eventObj.viewer_id = _this2.user && _this2.user.id;
      var event = helper["M" /* parseJsonToFormData */](eventObj);
      _this2.fireEventApiCall(event);
    });
    this.eventsHeldForId = [];
  };

  Store.prototype.initialize = function initialize(bucketId, videoId, json, forceStart) {
    var _this3 = this;

    this.data = {};
    this.data.isMobileDevice = helper["L" /* mobileCheck */]();
    this.data.isTabletDevice = helper["R" /* tabletCheck */]();
    this.data.isFacebookApp = helper["D" /* isFacebookApp */]();
    this.data.orientation = helper["u" /* getOrientation */]();

    if (!bucketId || !videoId) {
      var videoString = window.location.pathname.match(components_config["e" /* regex */].extractVideoID);

      if (videoString) {
        this.data.bucketId = videoString[0].substr(0, 16);
        this.data.videoId = videoString[0].substr(16);
      } else {
        this.data.bucketId = components_config["a" /* config */].DEFAULT_BUCKET_ID;
        this.data.videoId = components_config["a" /* config */].DEFAULT_VIDEO_ID;
      }
    } else {
      this.data.bucketId = bucketId;
      this.data.videoId = videoId;
      this.data.json = json;
    }

    this.data.id = 'wtPlay_' + this.data.videoId;

    return new Promise(function (resolve, reject) {
      if (!json) {
        if (forceStart) {
          var currentScriptUrl = document.currentScript;
          var url = new URL(currentScriptUrl && currentScriptUrl.src);
          if (url) {
            var origin = window.location.host.indexOf('localhost') !== -1 ? components_config["a" /* config */].STAGING_DOMAIN : url.origin;
            var metaTag = document.querySelector('meta[name="wootag:origin_domain"');
            var metaOrigin = metaTag && metaTag.getAttribute('content');
            origin = metaOrigin || origin;
            Object(components_config["f" /* setDomain */])(origin);
          } else {
            Object(components_config["f" /* setDomain */])(components_config["a" /* config */].PREPROD_DOMAIN);
          }
        }

        _this3.fetchUserJSON().then(function (json) {
          var addon = json && json.addon;
          if (addon) {
            var branding = addon.find(function (item) {
              return item.name === 'branding';
            });
            _this3.data.branding = branding;
          }
        });

        _this3.fetchJSON().then(function (json) {
          json.tags = resolveTargets(json);
          _this3.data.json = json;
          _this3.resolveInitPromise(resolve);
        });

        _this3.fetchCaptions().then(function (res) {
          _this3.data.json = store__extends({}, _this3.data.json, { captions: res });
        });
      } else {
        _this3.resolveInitPromisePromise(resolve);
      }
    });
  };

  Store.prototype.initializeAd = function initializeAd(creativeData, videoString, target, adType, adData) {
    var _this4 = this;

    this.adType = adType;
    this.data = {};
    this.data.isMobileDevice = helper["L" /* mobileCheck */]();
    this.data.isTabletDevice = helper["R" /* tabletCheck */]();
    this.data.isFacebookApp = helper["D" /* isFacebookApp */]();
    this.data.orientation = helper["u" /* getOrientation */]();
    this.data.adNetwork = adData.network;
    this.data.tid = adData.tid;

    var urlMarcros = creativeData && creativeData.prod && creativeData.prod.urlMacros || [];
    var impScript = creativeData && creativeData.prod && creativeData.prod.impScript;
    if (impScript) {
      helper["d" /* appendThirdPartyScriptToDOM */](impScript);
    }
    this.data.eventMacros = {};
    urlMarcros.forEach(function (item) {
      _this4.data.eventMacros[item.id] = item.macro;
    });

    if (!videoString) {
      videoString = creativeData && creativeData.id;
    }

    if (videoString) {
      this.data.bucketId = videoString.substr(0, 16);
      this.data.videoId = videoString.substr(16);
    } else {
      this.data.bucketId = components_config["a" /* config */].DEFAULT_BUCKET_ID;
      this.data.videoId = components_config["a" /* config */].DEFAULT_VIDEO_ID;
    }

    this.data.id = 'wtPlay_' + this.data.videoId;
    this.adUnit = {
      videoString: videoString,
      srv: creativeData && creativeData.srv && helper["S" /* trimLastSlash */](creativeData.srv) || helper["m" /* getDomainForAdUnit */](target)
    };

    return new Promise(function (resolve, reject) {
      _this4.fetchAdJSON(creativeData).then(function (json) {
        json.tags = resolveTargets(json);
        _this4.data.json = json;
        _this4.resolveInitPromise(resolve, true);
      });
    });
  };
  // for MRAID project adunit only---


  Store.prototype.fetchProjectVideoId = function fetchProjectVideoId(videoString, target) {
    var url = components_config["d" /* links */].getProjectVideoId(helper["m" /* getDomainForAdUnit */](target), videoString);
    return helper["N" /* request */](url);
  };

  Store.prototype.fetchJSON = function fetchJSON() {
    var queryParams = helper["z" /* getUrlParams */](window.location.href);
    var isPreviewLink = queryParams && queryParams.previewlink === '1';
    var isVideoDetails = queryParams && queryParams.edit === '1';
    var isTagEditor = queryParams && queryParams.editorMode === 'true';
    var url = components_config["d" /* links */].getJSON(this.data.bucketId, this.data.videoId, isPreviewLink || isVideoDetails || isTagEditor);
    return helper["N" /* request */](url);
  };

  Store.prototype.fetchCaptions = function fetchCaptions() {
    try {
      var url = components_config["d" /* links */].getCaptions(this.data.bucketId, this.data.videoId);
      return helper["N" /* request */](url);
    } catch (error) {
      return Promise.resolve([]);
    }
  };

  Store.prototype.fetchAdJSON = function fetchAdJSON(creativeData) {
    var url = components_config["d" /* links */].getAdJSON(this.adUnit.srv, this.data.bucketId, this.data.videoId);
    return helper["N" /* request */](url);
  };

  Store.prototype.fetchUserJSON = function fetchUserJSON() {
    var url = components_config["d" /* links */].getUserJSON(this.data.bucketId);
    return helper["N" /* request */](url);
  };

  Store.prototype.fetchThirdPartyProductData = function fetchThirdPartyProductData(tagId, platform) {
    var args = {
      domain: this.adUnit && this.adUnit.srv,
      bucket: this.data.bucketId,
      videoId: this.data.videoId,
      tagId: tagId,
      platform: platform
    };
    var url = components_config["d" /* links */].getThirdPartyProductData(args);
    return helper["N" /* request */](url);
  };

  Store.prototype.setUser = function setUser() {
    try {
      this.user = {
        id: this.viewer_id
      };

      localStorage.setItem('user', JSON.stringify(this.user));
    } catch (e) {
      console.warn('localStorage is not present');
      this.user = {
        id: this.viewer_id
      };
    }
  };

  Store.prototype.getUser = function getUser() {
    try {
      this.user = typeof localStorage !== 'undefined' && localStorage.getItem('user');
      this.user = JSON.parse(this.user);

      if (!this.user) {
        this.user = {
          id: this.viewer_id
        };

        localStorage.setItem('user', JSON.stringify(this.user));
      }
    } catch (e) {
      console.warn('localStorage is not present');
      this.user = {
        id: this.viewer_id
      };
    }
  };

  Store.prototype.resolveInitPromise = function resolveInitPromise(resolve, isAd) {
    resolve({
      id: this.data.id,
      json: this.data.json,
      isMobileDevice: this.data.isMobileDevice && !this.data.isTabletDevice,
      isTabletDevice: this.data.isTabletDevice,
      isFacebookApp: this.data.isFacebookApp,
      orientation: this.data.orientation,
      branding: this.data.branding,
      adUnit: isAd ? this.adUnit : null
    });
  };

  Store.prototype.set = function set(key, value) {
    var _this5 = this;

    return new Promise(function (resolve, reject) {
      _this5.data[key] = value;
      resolve(_this5.data);
    });
  };

  Store.prototype.setTags = function setTags(data) {
    var _this6 = this;

    return new Promise(function (resolve, reject) {
      if (_this6.data.json) {
        for (var key in data) {
          _this6.data.json[key] = data[key];
        }
      }

      resolve(_this6.data.json);
    });
  };

  Store.prototype.getLogObject = function getLogObject(log) {
    var timestamp = new Date().toISOString().split('T').join(' ');
    var getScreenRes = helper["w" /* getScreenDimensions */]();
    var medium = helper["r" /* getMedium */]();
    var origin = window.location.origin || '';
    if (!origin) {
      try {
        origin = window.parent && window.parent.location && window.parent.location.origin;
      } catch (err) {
        origin = '';
      }
    }

    var pathname = window.location.pathname;
    if (!pathname || pathname.includes('text/html;')) {
      try {
        var parent = window.parent;
        pathname = parent && parent.location && parent.location.pathname && !parent.location.pathname.includes('text/html;') && parent.location.pathname;
      } catch (error) {
        pathname = '';
      }
    }
    var event = store__extends({
      type: log.type,
      subtype: log.subtype,
      brand_id: this.data.json.brand_id,
      user_id: this.data.json.user_id,
      video_id: this.data.json.video_id,
      session_id: this.session_id,
      viewer_id: this.user && this.user.id,
      request_date: timestamp,
      requesttime: timestamp,
      host: '' + origin + pathname,
      screen_orientation: this.data.orientation,
      screen_resolution: '' + getScreenRes,
      player_resolution: window.innerWidth + 'x' + window.innerHeight,
      play_type: this.adType ? 'paid' : 'organic',
      medium: this.adType ? this.adType : medium,
      network: this.data.adNetwork || null,
      tid: this.data.tid || null,
      data_connection_type: navigator.connection && navigator.connection.type || 'NA',
      data_connection_effectivetype: navigator.connection && navigator.connection.effectiveType || 'NA',
      playback_duration: this.data.json.duration,
      video_type_id: this.data.json.tags && this.data.json.tags.length > 0 ? 1 : 2
    }, this.data.eventMacros || {});

    // `variant_id` and `comparison_id` added in all events in case of AB Platform variants---
    var abVariantObj = {};
    var meta = this.data.json && this.data.json.meta;
    if (meta && meta.ab_comparison && meta.ab_variant) {
      abVariantObj.comparison_id = meta.ab_comparison;
      abVariantObj.variant_id = meta.ab_variant;
    }

    // additional third party tracker data like %%TTDDEVID%%
    var tpMacros = this.data.tpMacros || {};
    event = store__extends({}, event, log, abVariantObj, tpMacros);

    if (log.current_duration) {
      event.current_duration = helper["v" /* getReadableTime */](Math.round(log.current_duration));
    } else if (log.duration) {
      event.current_duration = helper["v" /* getReadableTime */](Math.round(log.duration));
    }

    delete event.type;
    delete event.subtype;
    delete event.sub_type;

    var params = new URLSearchParams(window.location.search);
    var utm_medium = params.get('utm_medium');
    var wt_utm_content = params.get('wt_utm_content');
    var utm_content = params.get('utm_content');

    var utmContentParam = wt_utm_content || utm_content;
    var utm = utm_medium || utmContentParam ? { utm_medium: utm_medium, utm_content: utmContentParam } : {};
    event = store__extends({}, event, utm);

    return helper["M" /* parseJsonToFormData */](event);
  };

  // logDataEvent(log) {
  //   let event = this.getLogObject(log);
  //   // let queryParams = Helper.getUrlParams(window.location.href);
  //   // let isPreviewLink = queryParams && queryParams.previewlink === '1';
  //   // let isVideoDetails = queryParams && queryParams.edit === '1';
  //   // let isTagEditor = queryParams && queryParams.editorMode === 'true';
  //   // const shouldFireEvent = isPreviewLink || isVideoDetails || isTagEditor;
  //   // console.log({ shouldFireEvent });
  //   // if (shouldFireEvent) return;

  //   try {
  //     let headers = new Headers();
  //     headers.set('Content-Type', 'application/x-www-form-urlencoded');

  //     Helper.request(links.sendLogs(this.adUnit && this.adUnit.srv), {
  //       method: 'POST',
  //       body: event,
  //       headers,
  //     });
  //   } catch (e) {}
  // }

  Store.prototype.logDataEvent = function logDataEvent(log) {
    var event = this.getLogObject(log);
    if (this.viewer_id === components_config["b" /* constants */].TEMP_VIEWER_ID) {
      this.eventsHeldForId.push(event);
    } else {
      this.fireEventApiCall(event);
    }
  };

  Store.prototype.fireEventApiCall = function fireEventApiCall(event) {
    try {
      var headers = new Headers();
      headers.set('Content-Type', 'application/x-www-form-urlencoded');

      helper["N" /* request */](components_config["d" /* links */].sendLogs(this.adUnit && this.adUnit.srv), {
        method: 'POST',
        body: event,
        headers: headers
      });
    } catch (e) {}
  };

  Store.prototype.logPollOption = function logPollOption(log) {
    var event = this.getLogObject(log);

    try {
      var headers = new Headers();
      headers.set('Content-Type', 'application/x-www-form-urlencoded');

      return helper["N" /* request */](components_config["d" /* links */].submitPoll(this.adUnit && this.adUnit.srv), {
        method: 'POST',
        body: event,
        headers: headers
      });
    } catch (e) {}
  };

  Store.prototype.fetchRedeemCode = function fetchRedeemCode(log) {
    var event = this.getLogObject(log);

    try {
      var headers = new Headers();
      headers.set('Content-Type', 'application/x-www-form-urlencoded');

      var domain = this.adUnit && this.adUnit.srv ? this.adUnit.srv : components_config["a" /* config */].DOMAIN;
      var url = domain + '/api/v1/getoffercode';

      return helper["N" /* request */](url, {
        method: 'POST',
        body: event,
        headers: headers
      });
    } catch (e) {}
  };

  Store.prototype.setTrackers = function setTrackers(trackers) {
    return tracker_setTrackers(trackers);
  };

  Store.prototype.trackEvent = function trackEvent(trackers, logDataEvent, eventType, tag, eventDataObj) {
    var updatedData = store__extends(eventDataObj, {
      video_title: this.data.json.title
    });
    tracker_trackEvent(trackers, eventType, tag, updatedData, logDataEvent);
  };

  Store.prototype.eventBus = function eventBus(action, data) {
    var eventArr = action.split('/');
    var logObject = this.delegateEvents(eventArr[0], action, data);

    this.logDataEvent(logObject);
  };

  Store.prototype.delegateEvents = function delegateEvents(evt, action, data) {
    switch (evt) {
      case 'EVT':
        return dispatchEvent(action, data);
    }
  };

  return Store;
}();


// EXTERNAL MODULE: ./components/player/style.less
var player_style = __webpack_require__("takr");
var player_style_default = /*#__PURE__*/__webpack_require__.n(player_style);

// EXTERNAL MODULE: ./components/ott/style.less
var ott_style = __webpack_require__("7iVu");
var ott_style_default = /*#__PURE__*/__webpack_require__.n(ott_style);

// EXTERNAL MODULE: ./components/spareparts/templates/intro/index.js + 1 modules
var intro = __webpack_require__("1XEb");

// EXTERNAL MODULE: ./components/playerLayout/index.js
var playerLayout = __webpack_require__("ECIQ");

// EXTERNAL MODULE: ./components/ottPreview/style.less
var ottPreview_style = __webpack_require__("BcX+");
var ottPreview_style_default = /*#__PURE__*/__webpack_require__.n(ottPreview_style);

// CONCATENATED MODULE: ./components/ottPreview/index.js


function ottPreview__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ottPreview__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ottPreview__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ottPreview_OTTPreview = function (_Component) {
  ottPreview__inherits(OTTPreview, _Component);

  function OTTPreview(props) {
    ottPreview__classCallCheck(this, OTTPreview);

    var _this = ottPreview__possibleConstructorReturn(this, _Component.call(this, props));

    _this.animationClass = function () {
      var tagAni = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var animate = { img: '', txt: '' };

      switch (tagAni.image_ani) {
        case 'Zoom':
          animate.img = 'ZOOM_IN';
          break;
        case 'Fade':
          animate.img = 'FADE_IN';
          break;
        case 'None':
        default:
          animate.img = '';
          break;
      }

      switch (tagAni.text_ani) {
        case 'MoveIn':
          animate.txt = 'MOVE_IN';
          break;
        case 'Fade':
          animate.txt = 'FADE_IN';
          break;
        case 'None':
        default:
          animate.txt = '';
          break;
      }

      return animate;
    };

    _this.startAnimation = function () {
      _this.count++;
      clearTimeout(_this.animationTimeout);
      if (_this.count > 2) return;
      _this.animationTimeout = setTimeout(function () {
        _this.setState({ fadeOut: true }, function () {
          _this.animationTimeout = setTimeout(function () {
            _this.setState({ animate: false });
          }, 200);
          _this.animationTimeout = setTimeout(function () {
            _this.setState({ fadeOut: false, animate: true });
            _this.startAnimation();
          }, 300);
        });
      }, 9000);
    };

    _this.handleClickThrough = function () {
      if (_this.props.displayAdClickThroughLink) {
        // Engagement event for display ad click & traffic---
        if (_this.props.displayAdClickThroughLink.length > 0) {
          _this.logEngagementEvent({ event_type: 'display-ad' });
        }
        //---
        _this.props.displayAdClickThroughLink.forEach(function (link) {
          window.open(link);
        });
      }
    };

    _this.getImageFromTag = function (tag, orientation) {
      var isLandscape = orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE;
      if (tag && tag.media && tag.media.images) {
        return tag && (isLandscape ? tag.media.images.img1_src : typeof tag.media.images.img2_src !== 'undefined' ? tag.media.images.img2_src : tag.media.images.img1_src);
      }
    };

    _this.getImage = function (tag, orientation) {
      if (tag) {
        var subcategory = tag && tag.settings.subcategory && tag.settings.subcategory[0];
        switch (tag.settings.category) {
          case 1:
          case 7:
          case 8:
          case 10:
          case 11:
          case 12:
          case 15:
          case 18:
          case 19:
          case 20:
            return _this.getImageFromTag(tag, orientation);
          case 9:
            switch (subcategory.type) {
              case 900:
                var engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
                var answers = engagement && engagement && engagement.answer;
                if (engagement && engagement.imagepoll) {
                  return answers && answers[0].image;
                } else return _this.getImageFromTag(tag, orientation);
              case 901:
              case 902:
              case 904:
              case 905:
              case 906:
                return _this.getImageFromTag(tag, orientation);
            }
          case 14:
            switch (subcategory.type) {
              case 1402:
                return _this.getImageFromTag(tag, orientation);
              case 1401:
              case 1403:
                var _engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
                var firstGallaryElem = _engagement.meta && _engagement.meta[0];
                if (firstGallaryElem) {
                  return firstGallaryElem.cover_image_selected || firstGallaryElem.url;
                }
            }
          case 21:
            {
              switch (subcategory.type) {
                case 2104:
                  var _engagement2 = tag.details && tag.details.engagements && tag.details.engagements[0];
                  var _answers = _engagement2 && _engagement2 && _engagement2.answer;
                  if (_engagement2 && _engagement2.imagepoll) {
                    return _answers && _answers[0].image;
                  } else return _this.getImageFromTag(tag, orientation);
                case 2101:
                case 2102:
                case 2103:
                  return _this.getImageFromTag(tag, orientation);
              }
            }
        }
      }
    };

    _this.logEngagementEvent = function (data) {
      var engagements = Object(helper["n" /* getEngagements */])(_this.props.tag);
      var action = engagements && engagements[0];
      var actionValueFormtted = data.event_type || action.slug;

      var tag_id = _this.props.tag.id;
      var tag_label = _this.props.tag && _this.props.tag.details && (_this.props.tag.details.preview_title || _this.props.tag.details.title);
      var engagement_id = action && action.id;

      var options = {
        type: actionValueFormtted,
        sub_type: null,
        event: 'engagement',
        event_type: actionValueFormtted,
        tag_id: tag_id,
        tag_label: tag_label,
        engagement_id: engagement_id,
        engagement_type: 'out-video',
        current_duration: null
      };
      _this.props.eventBus(components_config["b" /* constants */].LOG_EVENT_ENGAGEMENT, {
        tag: _this.props.tag,
        options: options
      });
    };

    _this.state = {
      animate: false,
      fadeOut: false
    };
    _this.animationTimeout = null;
    _this.count = 0;
    return _this;
  }

  OTTPreview.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var displayAdAnimation = this.props.json.meta && this.props.json.meta.display_ad_animation || [];
    var tagAni = displayAdAnimation.find(function (t) {
      return t.id === _this2.props.tag.id;
    });
    var aniClass = this.animationClass(tagAni);
    if (aniClass.txt || aniClass.img) {
      this.setState({ animate: true }, function () {
        _this2.startAnimation();
      });
    }
  };

  OTTPreview.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.animationTimeout);
  };

  OTTPreview.prototype.render = function render(props, state) {
    var displayAdAnimation = props.json.meta && props.json.meta.display_ad_animation || [];
    var tagAni = displayAdAnimation.find(function (t) {
      return t.id === props.tag.id;
    });
    var aniClass = this.animationClass(tagAni);
    var image = this.getImage(props.tag, props.orientation);
    var engagement = props.tag && props.tag.settings.subcategory[0].engagements[0];
    var cta = engagement && engagement['label|' + engagement.slug];
    var previewImageAnimation = aniClass.img;
    if (previewImageAnimation) {
      previewImageAnimation += state.animate ? ' animate' : '';
    }
    var previewDetailsAnimation = aniClass.txt;
    if (previewDetailsAnimation) {
      previewDetailsAnimation += state.animate ? ' animate' : '';
    }
    return Object(preact_min["h"])(
      'div',
      { 'class': 'ottPreview ' + (state.fadeOut ? ' fadeOut' : ''), onClick: this.handleClickThrough },
      Object(preact_min["h"])(
        'div',
        { 'class': 'previewImageWrapper' },
        Object(preact_min["h"])('div', { 'class': 'previewImage ' + previewImageAnimation, style: {
            background: 'url(' + image + ') center center / contain no-repeat'
          } })
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'previewDetails ' + previewDetailsAnimation },
        Object(preact_min["h"])('div', { 'class': 'previewTitle', dangerouslySetInnerHTML: { __html: props.tag.details.title } }),
        Object(preact_min["h"])('div', {
          'class': 'previewCTA',
          onClick: props.unmount,
          style: {
            background: props.tag.details.color || '#1fbcf0'
          },
          dangerouslySetInnerHTML: { __html: cta } })
      )
    );
  };

  return OTTPreview;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/ott/index.js
var ott__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function ott__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ott__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ott__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var swiperJS = components_config["d" /* links */].swiperJS;
var swiperCSS = components_config["d" /* links */].swiperCSS;

var HEAD = document.getElementsByTagName('head')[0];

var ott_OTT = function (_Component) {
  ott__inherits(OTT, _Component);

  function OTT(props) {
    ott__classCallCheck(this, OTT);

    var _this = ott__possibleConstructorReturn(this, _Component.call(this, props));

    _this.fetchLayout = function (ns, tmpl) {
      if (!_this[ns]) {
        __webpack_require__("Rrey")("./" + tmpl).then(function (res) {
          _this[ns] = res;
          // this.forceUpdate();
        });
      }
    };

    _this.renderGate = function (ns, gate) {
      var currentVideoTime = Math.floor(_this.props.getCurrentTime());
      var gateStartTime = gate.duration && gate.duration.tag_start_time;
      var shouldRenderGate = currentVideoTime >= gateStartTime;
      var isPreviewMode = document.body.classList.contains(components_config["b" /* constants */].PREVIEW_MODE);
      var alreadyChecked = _this.user[gate.id] && _this.user[gate.id] === components_config["b" /* constants */].AGE_GATE_ACCEPTED && !isPreviewMode;
      if (_this[ns] && _this[ns].default && shouldRenderGate && !alreadyChecked) {
        var _Component2 = _this[ns].default;
        return Object(preact_min["h"])(_Component2, {
          tag: gate,
          logDataEvent: _this.props.logDataEvent,
          getCurrentTime: _this.props.getCurrentTime,
          setAgeGateActive: _this.props.setAgeGateActive,
          eventBus: _this.props.eventBus,
          trackEvent: _this.props.trackEvent
        });
      }
    };

    _this.shouldShowOTTPreview = function () {
      var tag = _this.props.tags.find(function (item) {
        return item.id == _this.props.hasDirectTag;
      });
      if (tag) {
        var settings = tag.settings;
        var category = settings.category;
        var subcategory = settings.subcategory[0].type;

        if (subcategory === 907 || subcategory === 2002) return false; // click to call
        else if (subcategory === 104) return true; // multistore

        switch (category) {
          case 1: // commerce
          case 7: // contact
          case 8: // booking
          case 10: // games & apps
          case 15:
            // decision point
            return false;
          case 9: // participation
          case 11: // store locator
          case 12: // offers
          case 14:
            // showcase 
            return true;
        }
      } else return false;
    };

    _this.setTagsToState = function () {
      return new Promise(function (resolve, reject) {
        var tags = _this.props.json && _this.props.json.tags && JSON.parse(JSON.stringify(_this.props.json.tags));
        var decisionPoints = tags && tags.filter(function (item) {
          return item.settings.category === 15;
        });

        if (decisionPoints && decisionPoints.length) {
          var _ref;

          var decisionPointIds = decisionPoints.map(function (t) {
            return t.id;
          });
          var connectedTags = (_ref = []).concat.apply(_ref, decisionPoints.map(function (dp) {
            return dp.details && dp.details.engagements && dp.details.engagements[0] && dp.details.engagements[0].meta && dp.details.engagements[0].meta.map(function (metaItem) {
              return metaItem.tag;
            });
          }));
          for (var i = tags.length - 1; i >= 0; i--) {
            var index = connectedTags.indexOf(tags[i].id);
            // the second condition below skips the decision point tag from splicing out as it can be a connected tag also. So it reads as, splice (remove) a connected tag which is also not a decision tag
            index !== -1 && tags[i].settings.category !== 15 && tags.splice(i, 1);
          }
        }
        var isPreviewMode = document.body.classList.contains(components_config["b" /* constants */].PREVIEW_MODE);

        if (_this.props.editorMode && !isPreviewMode) {
          tags = _this.props.json && _this.props.json.otags && JSON.parse(JSON.stringify(_this.props.json.otags));
        }
        // console.log('setTagsToState isPreviewMode', isPreviewMode, this.props.editorMode, tags.length);

        if (_this.props.json.gates.length > 0) {
          _this.props.json.gates.forEach(function (gate) {
            _this.fetchLayout('TmplParticipationGates', 'participationGates');
          });
        }
        //---
        _this.setState({
          tags: tags,
          hasAgeGate: _this.props.json.gates.length > 0
        }, function () {
          resolve();
          // console.log({ tags: this.state.tags });
        });
      });
    };

    _this.nextSlide = function () {
      _this.swiper.slideNext();
    };

    _this.prevSlide = function () {
      _this.swiper.slidePrev();
    };

    _this.activateDirectTag = function (tagIndex) {
      _this.ottReadyPromise.then(function () {
        _this.activateTag(tagIndex);
      });
    };

    _this.unmountPreview = function (e) {
      _this.setState({
        showOTTPreview: false
      });

      _this.playerLayout.logTagOpenEvent(true);

      /**
       * for display ads the html will have `previewCallback` function
       * which will be used for preview event trackers
       *  */
      window.previewCallback && window.previewCallback();

      e && e.stopPropagation();
    };

    _this.updateCustomClassForOTT = function (c) {
      _this.setState({
        customClassForOTT: c
      });
    };

    _this.destroyTag = function () {
      clearTimeout(_this.autoDisplayTagTimeout);
      _this.props.destroyTag();
    };

    _this.state = {
      activeIndex: 0,
      compressedSlideSize: props.isFacebookAd ? 1 : 1.15,
      expand: false,
      mapsApiLoaded: false,
      ottWrapperBounds: null,
      ready: false,
      showDebugConsole: false,
      dpTagActive: false,
      hasAgeGate: false,
      showOTTPreview: props.hasDirectTag && _this.shouldShowOTTPreview(),
      isCollectionsTagWithCustomTheme: ''
    };

    _this.activateTag = _this.activateTag.bind(_this);
    _this.deactivateTag = _this.deactivateTag.bind(_this);
    _this.handleSlideChangeEnd = _this.handleSlideChangeEnd.bind(_this);
    _this.updateCustomClassForOTT = _this.updateCustomClassForOTT.bind(_this);

    _this.autoDisplayTagConfig = _this.props.json && _this.props.json.meta && _this.props.json.meta.auto_display;

    try {
      _this.user = typeof localStorage !== 'undefined' && localStorage.getItem('user');
      _this.user = JSON.parse(_this.user);
    } catch (e) {
      console.warn('localStorage is not present');
    }
    return _this;
  }

  OTT.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    if (this.props.json.tags) {
      var storeLocatorInTags = this.props.json.tags.find(function (item) {
        return item.settings.category === 11;
      });
      var storeLocatorInOtags = this.props.tags.find(function (item) {
        return item.settings.category === 11;
      });
      var isStoreLocatorPresent = storeLocatorInTags || storeLocatorInOtags;
      this.loadSwiperJS = helper["K" /* loadJS */](swiperJS, HEAD);
      this.loadSwiperCSS = helper["J" /* loadCSS */](swiperCSS, HEAD);
      this.initTags = this.setTagsToState();

      var isMultiStorePresent = helper["F" /* isMultiStoresMapRequired */](this.props.json.tags) || helper["F" /* isMultiStoresMapRequired */](this.props.tags);

      if (isStoreLocatorPresent || isMultiStorePresent) {
        this.initializeGoogleMaps();
      }

      this.ottReadyPromise = Promise.all([this.loadSwiperJS, this.loadSwiperCSS, this.initTags]).then(function (res) {
        _this2.initializeSwiper();
      });
    }
  };

  OTT.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
    var _this3 = this;

    if (this.props.isMobileDevice !== nextProps.isMobileDevice || this.props.orientation !== nextProps.orientation) {
      setTimeout(function () {
        if (_this3.swiper) {
          _this3.swiper.params.slidesPerView = _this3.getSlidesPerView();
          _this3.swiper.update(true);
        }

        _this3.props.removeLoader();
      }, 800);
    }

    this.setTagsToState();

    if (!nextState.expand) {
      var ottWrapperHeight = this.ottWrapper && this.ottWrapper.offsetHeight;
      var ottWrapperWidth = this.ottWrapper && this.ottWrapper.offsetWidth;

      this.setState({
        ottRect: ottWrapperWidth > ottWrapperHeight ? 'ottRect' : 'ottSquare'
      });
    }

    // this.tagId gets set with activateTag method call and gets set to null with deactivateTag---
    if (nextProps.deactivateTag && this.tagId) {
      this.deactivateTag();
    }

    if (nextProps.fullWidthOTT && this.swiper) {
      try {
        this.swiper.update(true);
      } catch (e) {}
    }
  };

  OTT.prototype.componentDidMount = function componentDidMount() {
    var ottWrapperHeight = this.ottWrapper && this.ottWrapper.offsetHeight;
    var ottWrapperWidth = this.ottWrapper && this.ottWrapper.offsetWidth;

    if (!this.state.expand) {
      this.setState({
        ottRect: ottWrapperWidth > ottWrapperHeight ? 'ottRect' : 'ottSquare'
      });
    }
  };

  OTT.prototype.componentWillUnmount = function componentWillUnmount() {
    this.swiper.off('onSlideChangeEnd', this.handleSlideChangeEnd);
  };

  OTT.prototype.render = function render(props, state) {
    var _this4 = this;

    var isLandscape = props.orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE;
    var transformValue = 'translate3d(0, ' + (props.videoHeight + props.fbContainerHeightOffsetTop) + 'px, 0)';

    var portraitHeightCollapsed = props.isFacebookApp ? props.isFacebookAd ? window.innerHeight : props.containerHeight - props.videoHeight : props.portraitVideo ? 0 : window.innerHeight - props.videoHeight;
    var portraitHeightExpanded = props.isFacebookApp ? props.isFacebookAd ? state.ottRect ? document.body.clientHeight - 22 : window.innerHeight - 22 : window.innerHeight : '100%';

    if (props.isFacebookAd && props.os === 'Android') {
      portraitHeightCollapsed = window.innerHeight - props.json.aspect_ratio * window.innerWidth - 22;
      portraitHeightExpanded = window.innerHeight - 22;
    }

    var portraitHeight = state.expand ? portraitHeightExpanded : portraitHeightCollapsed;
    var wrapper = {
      width: '100%',
      height: props.isAd ? '100%' : portraitHeight,
      moztransform: transformValue,
      webkitTransform: transformValue,
      transform: transformValue
    };

    var directTag = props.tags.find(function (item) {
      return item.id == props.hasDirectTag;
    });
    var hideCloseTagBtn = !!(props.isFacebookAd || props.noVideo || props.ottOnly) && !!props.deeplinkTagId;
    /**
     * new A/B attribute `endcard_details_mandatory` to DISABLE
     * 1) tag preview on timeline,
     * 2) close buttons on tag details,
     * 3) info icon on screen
     * */
    var custom = this.props.json && this.props.json.custom;
    var customEnforeEndCardEnabled = custom && custom.endcards && custom.endcards.enforceEndCard;
    var meta = this.props.json && this.props.json.meta;
    var hideCloseBtnOnTagDetails = !this.props.editorMode && (meta && meta.endcard_details_mandatory || customEnforeEndCardEnabled);
    hideCloseTagBtn = !!hideCloseBtnOnTagDetails || hideCloseTagBtn;

    if (state.ready) {
      var wrapperClass = props.displayTag ? 'ottWrapper enable ' + (state.expand || isLandscape ? 'expand' : '') : 'ottWrapper ' + (props.lsCards && props.isAd ? 'midExpand' : '') + ' ' + (state.expand ? 'expand' : '') + ' ' + state.ottRect;
      wrapperClass = wrapperClass + ' ' + (props.ottOnly ? 'ottOnly' : '') + ' ' + (props.isAd && !this.state.isCollectionsTagWithCustomTheme ? 'noSplitScreen' : '');

      if (this.props.ageGateActive) {
        wrapperClass = wrapperClass + ' gatesWrapper';
        // { ...wrapper, transform: 'none', moztransform: 'none', webkitTransform: 'none', opacity: 1, zIndex:5 }
      }

      if (this.props.fullWidthOTT) {
        wrapperClass = wrapperClass + ' fullWidth';
      }
      if (!isLandscape && !state.expand) {
        wrapperClass = wrapperClass + ' zeroWidth';
      }

      if (this.state.isCollectionsTagWithCustomTheme) {
        wrapperClass = wrapperClass + ' ' + this.state.isCollectionsTagWithCustomTheme;
      }

      var hasDecisionPoints = state.tags.some(function (item) {
        return item.settings.category === 15;
      });
      // if selected tag is Social Share the video won't pause and so we want the ott NOT blocking the player clicks---
      var currTag = (props.selectedTagIndex || props.selectedTagIndex === 0) && state.tags[props.selectedTagIndex];
      var isSocialShareEmotion = currTag && currTag.settings && currTag.settings.subcategory && currTag.settings.subcategory[0] && (currTag.settings.subcategory[0].type === 1601 || currTag.settings.subcategory[0].type === 1602);

      if (isSocialShareEmotion) {
        wrapperClass = wrapperClass + ' allowClickThrough';
      }

      return Object(preact_min["h"])(
        'div',
        { style: wrapper, ref: function ref(node) {
            return _this4.ottWrapper = node;
          }, 'class': wrapperClass },
        Object(preact_min["h"])(
          'div',
          { 'class': 'ottContainer ' + (state.tags.length <= 1 ? 'single-tag' : 'multi-tag') },
          state.showDebugConsole ? Object(preact_min["h"])(
            'div',
            { 'class': 'debugConsole' },
            Object(preact_min["h"])(
              'div',
              { 'class': 'debug-info' },
              Object(preact_min["h"])(
                'p',
                null,
                'isExpanded: ' + state.expand
              ),
              Object(preact_min["h"])(
                'p',
                null,
                'window.innerHeight: ' + window.innerHeight
              ),
              Object(preact_min["h"])(
                'p',
                null,
                'window.clientHeight: ' + document.body.clientHeight
              ),
              Object(preact_min["h"])(
                'p',
                null,
                'portraitHeightCollapsed: ' + portraitHeightCollapsed
              ),
              Object(preact_min["h"])(
                'p',
                null,
                'portraitHeightExpanded: ' + portraitHeightExpanded
              ),
              Object(preact_min["h"])(
                'p',
                null,
                'document.body.scrollHeight: ' + document.body.scrollHeight
              ),
              Object(preact_min["h"])(
                'p',
                null,
                'isFacebookApp: ' + props.isFacebookApp
              ),
              Object(preact_min["h"])(
                'p',
                null,
                'isFacebookAd: ' + props.isFacebookAd
              )
            )
          ) : null,
          Object(preact_min["h"])(
            'div',
            { ref: function ref(c) {
                return _this4.swiperContainer = c;
              }, 'class': 'swiper-container' },
            Object(preact_min["h"])(
              'div',
              { 'class': 'swiper-wrapper  ' + (state.expand ? 'swiper-no-swiping' : '') },
              props.json.tags.length >= 1 ? Object(preact_min["h"])(
                'div',
                { 'class': 'swiper-slide' },
                Object(preact_min["h"])(intro["default"], {
                  title: props.json.title,
                  desc: props.json.description,
                  social: props.json.social,
                  tag: props.json.tags[0],
                  template: props.json.template
                })
              ) : null,
              state.tags && state.tags.map(function (item, i) {
                var slideType = '';
                var activeSlide = state.activeSlideSoft === i ? 'active-slide-soft' : '';
                var swipeBehavior = '' + (props.isFacebookAd ? 'swiper-no-swiping' : '');
                var decisionPointsOverride = hasDecisionPoints ? 'override-opacity' : '';
                var tagColor = item.details && item.details.color;
                var swiperSlideStyle = { color: tagColor };
                try {
                  slideType = item.settings.subcategory && item.settings.subcategory[0] && item.settings.subcategory[0].type;
                } catch (e) {}

                return Object(preact_min["h"])(
                  'div',
                  {
                    'class': 'swiper-slide slideType_' + slideType + ' ' + swipeBehavior + ' ' + activeSlide + ' ' + decisionPointsOverride,
                    style: swiperSlideStyle
                  },
                  Object(preact_min["h"])(playerLayout["a" /* default */], ott__extends({
                    ref: function ref(c) {
                      return _this4.playerLayout = c;
                    },
                    key: i
                  }, props, {
                    keyIndex: i,
                    index: !props.isFacebookAd ? i + 1 : i + 1,
                    tag: item,
                    decisionPointSelector: state.decisionPointSelector,
                    ottRect: state.ottRect === 'ottRect',
                    isActiveSlide: i === state.activeIndex - 1,
                    isExpanded: state.expand,
                    isLandscape: isLandscape,
                    template: props.json.template,
                    activateTag: _this4.activateTag,
                    deactivateTag: _this4.deactivateTag,
                    hideCloseTagBtn: hideCloseTagBtn,
                    mapsapi: state.mapsApiLoaded,
                    dpTagActive: state.dpTagActive,
                    shouldDeactivateTag: props.deactivateTag,
                    shouldShowOTTPreview: _this4.shouldShowOTTPreview,
                    showOTTPreview: _this4.state.showOTTPreview,
                    updateCustomClassForOTT: _this4.updateCustomClassForOTT,
                    destroyTag: _this4.destroyTag
                  }))
                );
              })
            ),
            props.isFacebookAd ? Object(preact_min["h"])(
              'div',
              { 'class': 'ottBottomNavi' },
              Object(preact_min["h"])('div', {
                'class': 'swiper-button-left zmdi',
                ref: function ref(a) {
                  return _this4.swiperNaviLeft = a;
                },
                onClick: this.prevSlide
              }),
              Object(preact_min["h"])('div', { 'class': 'swiper-pagination', ref: function ref(b) {
                  return _this4.swiperPager = b;
                } }),
              Object(preact_min["h"])('div', {
                'class': 'swiper-button-right zmdi',
                ref: function ref(c) {
                  return _this4.swiperNaviRight = c;
                },
                onClick: this.nextSlide
              })
            ) : null
          )
        ),
        this.props.ageGateActive && this.props.json.gates.map(function (gate) {
          return _this4.renderGate('TmplParticipationGates', gate);
        }),
        state.showOTTPreview && directTag && !directTag.details.skip && Object(preact_min["h"])(ottPreview_OTTPreview, {
          displayAdClickThroughLink: props.displayAdClickThroughLink,
          unmount: this.unmountPreview,
          tag: directTag,
          eventBus: this.props.eventBus,
          orientation: props.orientation,
          json: this.props.json
        })
      );
    } else return null;
  };

  OTT.prototype.initializeSwiper = function initializeSwiper() {
    var _this5 = this;

    this.setState({
      ready: true
    }, function () {
      var slidesPerView = _this5.getSlidesPerView();
      if (_this5.swiperContainer) {
        _this5.swiper = new Swiper(_this5.swiperContainer, {
          speed: 100,
          slidesPerView: slidesPerView,
          spaceBetween: 0,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          },
          nextButton: _this5.swiperNaviRight,
          prevButton: _this5.swiperNaviLeft
        });

        _this5.swiper.on('onSlideChangeEnd', _this5.handleSlideChangeEnd);
      }
      if (_this5.props.isFacebookAd) {
        _this5.ottWrapper.style.display = 'none';
        _this5.ottWrapper.offsetHeight;
        _this5.ottWrapper.style.display = 'block';
      }
    });
  };

  OTT.prototype.initializeGoogleMaps = function initializeGoogleMaps() {
    var _this6 = this;

    if (!window.google && !window.mapsApiLoading) {
      window.mapsApiLoading = true;
      helper["K" /* loadJS */](components_config["d" /* links */].mapsapi, HEAD).then(function () {
        _this6.setState({
          mapsApiLoaded: true
        });
      });
    }
  };

  OTT.prototype.getSlidesPerView = function getSlidesPerView() {
    var orientation = this.props.orientation;
    var isLandscape = orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE ? true : false;
    // return isLandscape ? 1 : (this.state.expand ? 1 : this.state.compressedSlideSize);
    return isLandscape ? this.state.expand ? 1 : this.props.isAd ? this.state.tags.length > 1 ? 1.4 : 1 : 1 : this.state.expand ? 1 : 1.15;
  };

  OTT.prototype.handleSlideChangeEnd = function handleSlideChangeEnd() {
    this.setState({
      activeIndex: this.swiper.snapIndex
    });
  };

  OTT.prototype.setTagIndex = function setTagIndex(index, toggleLock) {
    var _this7 = this;

    if (!this.swiper) return false;
    if (!toggleLock && this.props.editorMode) return false;

    var slideMS = this.props.isFacebookAd || this.props.noVideo ? 0 : 100;
    this.swiper.slideTo(index, slideMS, true);

    if (this.state.activeIndex !== index) {
      setTimeout(function () {
        _this7.handleSlideChangeEnd();
      }, 200);
    }
  };

  OTT.prototype.activateTag = function activateTag(index, toggleLock, trackEvent) {
    var _this8 = this;

    var tagIndex = this.props.isFacebookAd ? index : index - 1;
    var tags = this.props.json && this.props.json.tags && JSON.parse(JSON.stringify(this.props.json.tags));
    var tag = this.props.json.tags && this.props.json.tags[tagIndex];
    var decisionPoints = tags && tags.filter(function (item) {
      return item.settings.category === 15;
    });
    var decisionPointsCheck = this.props.editorMode && decisionPoints && decisionPoints.length > 0;
    var isPreviewMode = document.body.classList.contains(components_config["b" /* constants */].PREVIEW_MODE);

    if (decisionPointsCheck) {
      if (!isPreviewMode) {
        tag = this.props.json.otags[tagIndex];
      }

      var dpArr = decisionPoints.map(function (dp) {
        return dp.details.engagements[0] && dp.details.engagements[0].meta && dp.details.engagements[0].meta.filter(function (t) {
          return t.tag === tag.id;
        });
      });
      var dpIndex;
      dpArr.some(function (item, index) {
        if (item.length) {
          var dpTag = decisionPoints[index];
          var _tag = item && item[0];
          _this8.state.tags.some(function (t, i) {
            if (dpTag.id === t.id) {
              dpIndex = i;
              return true;
            }
          });

          return true;
        }
      });
    }

    var isSocialShareEmotion = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0] && (tag.settings.subcategory[0].type === 1601 || tag.settings.subcategory[0].type === 1602);
    var isDP = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0].type === 1502;
    var isDPV2 = isDP && tag.details.engagements && tag.details.engagements[0].dpnative;

    if (!isSocialShareEmotion && !isDPV2) {
      this.props.pauseVideo();
    }

    var isCollectionsTagWithCustomTheme = helper["C" /* isCollectionsTag */](tag) && tag && tag.details && tag.details.customTheme || '';

    this.setState({
      expand: helper["L" /* mobileCheck */]() && this.props.scriptEmbed ? this.props.noVideo : true,
      activeIndex: decisionPointsCheck && isPreviewMode && dpIndex ? dpIndex : index,
      decisionPointSelector: decisionPointsCheck && isPreviewMode && dpIndex ? [dpIndex, dpArr[dpIndex] && dpArr[dpIndex][0]] : null,
      isCollectionsTagWithCustomTheme: isCollectionsTagWithCustomTheme
    }, function () {
      if (_this8.swiper) {
        if (_this8.swiper.params && _this8.swiper.params.slidesPerView) {
          var isLandscape = _this8.props.orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE;
          var isExpanded = _this8.state.expand;

          _this8.swiper.params.slidesPerView = 1;

          // if (isLandscape && isExpanded) {
          // this.swiper.allowSlidePrev = false;
          // this.swiper.allowSlideNext = false;
          // }
        }

        try {
          _this8.swiper.update(true);
        } catch (e) {}

        _this8.setTagIndex(decisionPointsCheck && isPreviewMode && dpIndex ? dpIndex + 1 : index, toggleLock);
        _this8.setState({
          ottWrapperBounds: document.querySelector('.ottWrapper').getBoundingClientRect()
        });
      }

      if (decisionPoints && decisionPoints.length) {
        tag = _this8.props.json.tags[tagIndex];
      }

      if (_this8.autoDisplayTagConfig) {
        var tagAutoDisplayConfig = _this8.autoDisplayTagConfig.find(function (item) {
          return item.tag === tag.id;
        });
        if (tagAutoDisplayConfig && tagAutoDisplayConfig.tag && !_this8.autoDisplayTagAutoCloseTriggered) {
          _this8.autoDisplayTagAutoCloseTriggered = true;
          _this8.autoDisplayTagTimeout = setTimeout(function () {
            _this8.playerLayout.handleTagClose();
          }, tagAutoDisplayConfig.seconds * 1000);
        }
      }

      //--
      // Since DP handleClose method handles the deactivateTag method call, we send it active tag state so it only fires the close call when the active tag is a DP one---
      var checkDP = decisionPoints.filter(function (item) {
        return item.id === (tag && tag.id);
      });
      _this8.setState({ dpTagActive: checkDP.length > 0 });

      if (!_this8.props.noVideo && !_this8.tagId) {
        _this8.tagId = tag && tag.id;
        var objToPost = { tagid: tag && tag.id };
        _this8.props.postMessage(objToPost);
        // with the dp tag interval call the post message keeps on calling as it sets this.tagId as a valid value and deactivateTag always comes as true so willReceiveProps method always calls the deactivateTag method which sets this.tagId to null and so it gets stuck in loop, so to avoid that we set the player deactivateTag as false---It is required for embed iframe(!noVideo) only as the popover one gets updated on receiving postMessage---
        _this8.props.setDeactivateTagFalse();
      }

      //---
      if (trackEvent && !_this8.props.editorMode) {
        var video_title = _this8.props.json.title;
        var tag_duration = Math.floor(_this8.props.getCurrentTime());
        var eventDataObj = { tag_duration: tag_duration, video_title: video_title };

        // tracker event ---
        // to avoid calling event multiple times---
        var initDuration = _this8.props.getCurrentTime() - (tag && tag.duration.tag_start_time);
        var tag_duration_changed = initDuration !== _this8.prevTagDuration;

        if (tag_duration_changed) {
          _this8.props.trackEvent('ViewContent', tag, eventDataObj);
        }

        _this8.prevTagDuration = initDuration;
        //---
      }
    });
  };

  OTT.prototype.deactivateTag = function deactivateTag(dontPauseVideo) {
    var _this9 = this;

    this.setState({
      expand: false,
      isCollectionsTagWithCustomTheme: ''
    }, function () {
      _this9.tagId = null;
      var hasVideoEnded = _this9.props.hasVideoEnded();
      var isPreviewMode = document.body.classList.contains(components_config["b" /* constants */].PREVIEW_MODE);
      if (!hasVideoEnded && !_this9.props.editorMode || !hasVideoEnded && isPreviewMode) {
        if (!dontPauseVideo) {
          _this9.props.playVideo();
        }
      }

      setTimeout(function () {
        if (_this9.swiper) {
          if (_this9.swiper.params && _this9.swiper.params.slidesPerView && !dontPauseVideo) {
            _this9.swiper.params.slidesPerView = _this9.getSlidesPerView();
            _this9.swiper.update(true);
          }
        }
      }, 250);
    });
  };

  return OTT;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/screenController/style.less
var screenController_style = __webpack_require__("oaCj");
var screenController_style_default = /*#__PURE__*/__webpack_require__.n(screenController_style);

// EXTERNAL MODULE: ./components/spareparts/videoplayer/index.js
var videoplayer = __webpack_require__("wOWE");

// EXTERNAL MODULE: ./components/spareparts/socialShareIcons/index.js
var socialShareIcons = __webpack_require__("vweF");

// EXTERNAL MODULE: ./components/spareparts/socialEmotionIcons/index.js
var socialEmotionIcons = __webpack_require__("I6Nf");

// EXTERNAL MODULE: ./components/skinV3ProductShowcase/style.less
var skinV3ProductShowcase_style = __webpack_require__("f6jQ");
var skinV3ProductShowcase_style_default = /*#__PURE__*/__webpack_require__.n(skinV3ProductShowcase_style);

// EXTERNAL MODULE: ./components/spareparts/galleryImage/index.js
var galleryImage = __webpack_require__("FOH3");

// CONCATENATED MODULE: ./components/skinV3ProductShowcase/index.js
var skinV3ProductShowcase__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, skinV3ProductShowcase__temp, skinV3ProductShowcase__initialiseProps;



function skinV3ProductShowcase__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function skinV3ProductShowcase__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function skinV3ProductShowcase__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var skinV3ProductShowcase_HEAD = document.getElementsByTagName('head')[0];

var skinV3ProductShowcase_swiperCSS = components_config["d" /* links */].swiperCSS;
var skinV3ProductShowcase_swiperJS = components_config["d" /* links */].swiperJS;

var skinV3ProductShowcase__ref = Object(preact_min["h"])('div', { 'class': 'swiper-pagination' });

var skinV3ProductShowcase__ref2 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-close' });

var skinV3ProductShowcase_SkinV3ProductShowcase = (skinV3ProductShowcase__temp = _class = function (_Component) {
  skinV3ProductShowcase__inherits(SkinV3ProductShowcase, _Component);

  function SkinV3ProductShowcase(props) {
    skinV3ProductShowcase__classCallCheck(this, SkinV3ProductShowcase);

    var _this = skinV3ProductShowcase__possibleConstructorReturn(this, _Component.call(this, props));

    skinV3ProductShowcase__initialiseProps.call(_this);

    _this.state = {
      engagements: Object(helper["n" /* getEngagements */])(_this.props.tag),
      showcaseInactive: true
    };
    return _this;
  }

  SkinV3ProductShowcase.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.checkForSwiper().then(function () {
      setTimeout(function () {
        _this2.initializeSwiper(_this2.swiperContainer);
        _this2.handleClick(0);
        console.log('did mount');
        var isCollectionsTag = _this2.checkForCollectionType();
        if (isCollectionsTag) {
          _this2.updateEngagement(0);
        }
      }, 0);
    });
  };

  SkinV3ProductShowcase.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.tag && nextProps.tag.id && nextProps.tag.id !== this.props.tag.id) {
      var isCollectionsTag = this.checkForCollectionType(nextProps);
      if (isCollectionsTag) {
        this.updateEngagement(0, nextProps);
      }
    }
  };

  SkinV3ProductShowcase.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    if (this.props.isExpanded !== prevProps.isExpanded && this.props.isExpanded && this.props.isActiveSlide || this.props.isExpanded && this.props.isActiveSlide && this.props.isActiveSlide !== prevProps.isActiveSlide || (this.props.tag && this.props.tag.id) !== (prevProps.tag && prevProps.tag.id)) {
      setTimeout(function () {
        _this3.initializeSwiper(_this3.swiperContainer);
        _this3.handleClick(0);
        console.log('did update');
      }, 0);
    }
  };

  SkinV3ProductShowcase.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.swiper) {
      this.swiper.destroy();
      console.log('did unmount');
    }
  };

  SkinV3ProductShowcase.prototype.render = function render(props, state) {
    var _this4 = this;

    var swiperContainerStyle = {
      height: '100%'
    };

    var settings = props.tag && props.tag.settings;
    var category = settings.category;
    var subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;
    var isCommerceCollections = category === 1 && subcategory !== 106;
    // show commerce/collections tags only---
    if (!isCommerceCollections) {
      return null;
    }

    var slides = this.getSlides() || [];
    var isNonCollection = category === 1 && subcategory !== 105;
    var tagThemeColor = props.tag && props.tag.details && props.tag.details.color || '#34b0e8';
    var tagTextColor = props.customTagParams && props.customTagParams.textColor || '#454463';

    var tagTitle = props.tag && props.tag.details && props.tag.details.title || '';
    var selectedTagEngagements = Object(helper["n" /* getEngagements */])(props.tag);
    var selectedTagEngagement = selectedTagEngagements && selectedTagEngagements[0];

    var slug = selectedTagEngagement && selectedTagEngagement.slug;
    var selectedTagCta = selectedTagEngagement && selectedTagEngagement['label|' + slug];

    // meta key to enable feature for the product showcase sliding effect---xiaomi
    var showcaseSlide = props.meta && props.meta.showcase_tag_cta;
    var iconImg = Object(helper["x" /* getTagPreviewImage */])(props.tag, '120') || Object(helper["x" /* getTagPreviewImage */])(props.tag, 'src');

    return Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])(
        'div',
        {
          'class': skinV3ProductShowcase_style_default.a.productShowcaseWrapper + ' ' + (showcaseSlide && state.showcaseInactive ? skinV3ProductShowcase_style_default.a.inactive : '') + ' ' + (!isNonCollection ? skinV3ProductShowcase_style_default.a.collections : '') + ' ' + skinV3ProductShowcase_style_default.a[props.orientation]
        },
        Object(preact_min["h"])(
          'div',
          {
            'class': skinV3ProductShowcase_style_default.a.imagesWrapper + ' ' + (!isNonCollection ? skinV3ProductShowcase_style_default.a.collections : '')
          },
          Object(preact_min["h"])(
            'div',
            {
              ref: function ref(node) {
                return _this4.swiperContainer = node;
              },
              'class': 'swiper-container swiperHook gallery-swiper',
              style: swiperContainerStyle
            },
            Object(preact_min["h"])(
              'div',
              {
                'class': 'swiper-wrapper ' + (props.images && props.images.length < 1 ? 'nodata' : '')
              },
              slides
            ),
            skinV3ProductShowcase__ref
          ),
          slides.length === 0 ? null : Object(preact_min["h"])('div', {
            'class': skinV3ProductShowcase_style_default.a.swiperArrowBtn + ' swiper-button-prev fsImg-prev zmdi ' + (this.state.isBeginning ? 'swiper-button-disable' : ''),
            ref: function ref(c) {
              return _this4.swiperNavBtnPrev = c;
            },
            onClick: this.prevSlide
          }),
          slides.length === 0 ? null : Object(preact_min["h"])('div', {
            'class': skinV3ProductShowcase_style_default.a.swiperArrowBtn + ' swiper-button-next fsImg-next zmdi ' + (this.state.isEnd ? 'swiper-button-disable' : ''),
            ref: function ref(c) {
              return _this4.swiperNavBtnNext = c;
            },
            onClick: this.nextSlide
          })
        ),
        isNonCollection && Object(preact_min["h"])(
          'div',
          { 'class': skinV3ProductShowcase_style_default.a.footer },
          Object(preact_min["h"])('div', {
            'class': skinV3ProductShowcase_style_default.a.tagTitle,
            style: { color: tagTextColor },
            dangerouslySetInnerHTML: { __html: tagTitle }
          }),
          Object(preact_min["h"])(
            'div',
            {
              'class': skinV3ProductShowcase_style_default.a.ctaBtn,
              style: {
                backgroundColor: tagThemeColor
              },
              onClick: this.props.onCommerceCtaClick
            },
            Object(preact_min["h"])('span', { dangerouslySetInnerHTML: { __html: selectedTagCta } }),
            Object(preact_min["h"])('div', {
              'class': skinV3ProductShowcase_style_default.a.shadow,
              style: { boxShadow: '0px 18px 20px -6px ' + tagThemeColor }
            })
          )
        )
      ),
      showcaseSlide && state.showcaseInactive && Object(preact_min["h"])(
        'div',
        {
          'class': skinV3ProductShowcase_style_default.a.showcaseIconWrapper,
          onClick: this.handleShowShowcase
        },
        Object(preact_min["h"])(
          'div',
          { 'class': skinV3ProductShowcase_style_default.a.showcaseIcon },
          Object(preact_min["h"])('img', { src: iconImg, alt: '' })
        )
      ),
      showcaseSlide && !state.showcaseInactive && Object(preact_min["h"])(
        'div',
        { 'class': skinV3ProductShowcase_style_default.a.closeBtnWrapper, onClick: this.handleHideShowcase },
        skinV3ProductShowcase__ref2
      )
    );
  };

  SkinV3ProductShowcase.prototype.initializeSwiper = function initializeSwiper() {
    var autoplay = this.props.config_data_json && this.props.config_data_json.abConfig && this.props.config_data_json.abConfig.productSliderAutoslide;
    if (autoplay && typeof autoplay === 'object') {
      autoplay = autoplay;
    } else {
      autoplay = !!autoplay;
    }

    var options = skinV3ProductShowcase__extends({}, {
      speed: 300,
      initialSlide: this.state.activeIndex || 0,
      slidesPerView: 1,
      observer: true,
      observerParents: true,
      nested: true,
      autoplay: autoplay
    });

    if (this.state.swiperJS && this.swiperContainer) {
      if (this.swiper) {
        this.swiper.off('slideChangeTransitionEnd', this.handleSlideChange);
        this.swiper.destroy();
      }

      this.swiper = new Swiper(this.swiperContainer, options);
      this.swiper.on('slideChangeTransitionEnd', this.handleSlideChange);
      this.setSliderArrows();
    }
  };

  SkinV3ProductShowcase.prototype.setSliderArrows = function setSliderArrows() {
    if (this.swiper) {
      var _swiper = this.swiper,
          isEnd = _swiper.isEnd,
          isBeginning = _swiper.isBeginning;

      this.setState({
        isBeginning: isBeginning,
        isEnd: isEnd
      });
    }
  };

  return SkinV3ProductShowcase;
}(preact_min["Component"]), skinV3ProductShowcase__initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getImageCount = function (images) {
    var hook = images;
    var i = 1;
    var count = 0;

    while (hook && hook['img' + i + '_src']) {
      count = i;
      i++;
    }

    return count;
  };

  this.getSlides = function () {
    var tag = _this5.props.tag;
    var isCollectionsTag = _this5.checkForCollectionType(); // Commerce Purchase type---
    var ele = void 0;
    if (!isCollectionsTag) {
      var images = tag && tag.media && tag.media.images;
      var imageCount = _this5.getImageCount(images);
      ele = [];
      for (var i = 0; i < imageCount; i++) {
        ele.push(Object(preact_min["h"])(galleryImage["a" /* default */], { images: images, index: i }));
      }
    } else {
      // For Collections---
      var attributes = tag && tag.details && tag.details.attributes || [];
      var products = Object(helper["P" /* sortCollectionsMedia */])(attributes);
      var tagThemeColor = tag && tag.details && tag.details.color || '#34b0e8';
      var tagTextColor = _this5.props.customTagParams && _this5.props.customTagParams.textColor || '#454463';
      var tagEngagements = _this5.state.engagements;
      var tagEngagement = tagEngagements && tagEngagements[0];
      var slug = tagEngagement && tagEngagement.slug;
      var tagCta = tagEngagement && tagEngagement['label|' + slug];
      ele = products.map(function (prod, idx) {
        var images = prod && prod.media && prod.media.images;
        // const imageCount = this.getImageCount(images);
        var prodTitle = prod && prod.details && prod.details.title;
        var product_id = prod && prod.id;
        var engagement_data = Object(helper["M" /* parseJsonToFormData */])({
          product_id: product_id,
          product_label: prodTitle
        });
        return Object(preact_min["h"])(
          'div',
          { 'class': 'swiper-slide' },
          Object(preact_min["h"])(
            'div',
            { 'class': skinV3ProductShowcase_style_default.a.imagesWrapper + ' ' + skinV3ProductShowcase_style_default.a.collections },
            Object(preact_min["h"])(galleryImage["a" /* default */], { images: images, index: 0 }),
            Object(preact_min["h"])(
              'div',
              { 'class': skinV3ProductShowcase_style_default.a.footer },
              Object(preact_min["h"])('div', {
                'class': skinV3ProductShowcase_style_default.a.tagTitle,
                style: { color: tagTextColor },
                dangerouslySetInnerHTML: { __html: prodTitle }
              }),
              Object(preact_min["h"])(
                'div',
                {
                  'class': skinV3ProductShowcase_style_default.a.ctaBtn,
                  style: {
                    backgroundColor: tagThemeColor
                  },
                  onClick: function onClick(e) {
                    return _this5.props.onCommerceCtaClick(e, { engagement_data: engagement_data });
                  }
                },
                Object(preact_min["h"])('span', { dangerouslySetInnerHTML: { __html: tagCta } }),
                Object(preact_min["h"])('div', {
                  'class': skinV3ProductShowcase_style_default.a.shadow,
                  style: { boxShadow: '0 10px 20px -8px ' + tagThemeColor }
                })
              )
            )
          )
        );
      });
    }
    return ele;
  };

  this.handleHideShowcase = function () {
    _this5.setState({ showcaseInactive: true });
  };

  this.handleShowShowcase = function () {
    _this5.setState({ showcaseInactive: false });
  };

  this.checkForCollectionType = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props;

    var settings = props.tag && props.tag.settings;
    var category = settings.category;
    var subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;

    var isNonCollection = category === 1 && subcategory !== 105;
    return !isNonCollection;
  };

  this.updateEngagement = function (index) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this5.props;

    var tag = props.tag;
    var attributes = tag && tag.details && tag.details.attributes || [];
    var products = Object(helper["P" /* sortCollectionsMedia */])(attributes);
    var currProd = products && products[index];
    var engagement_id = currProd && currProd.id;
    var variants = currProd && currProd.variants;
    if (!(variants && variants.length > 0)) {
      var _extends2;

      var tagEngagements = Object(helper["n" /* getEngagements */])(props.tag);
      var engagement = tagEngagements && tagEngagements[0];
      var url = currProd && currProd.details && currProd.details.cta || engagement && engagement['value|' + engagement.slug];
      var engagements = [skinV3ProductShowcase__extends({}, engagement, (_extends2 = {}, _extends2['value|' + engagement.slug] = url, _extends2.id = engagement_id, _extends2))];
      _this5.setState({ engagements: engagements }, function () {
        var updatedTag = skinV3ProductShowcase__extends({}, tag, {
          settings: skinV3ProductShowcase__extends({}, tag.settings, {
            subcategory: [skinV3ProductShowcase__extends({}, tag.settings.subcategory[0], { engagements: engagements })]
          })
        });
        props.refreshSkinLayout(updatedTag);
      });
    }
  };

  this.handleClick = function (index, e) {
    _this5.setState({
      activeIndex: index,
      selectedImage: index
    }, function () {
      if (_this5.props.isFacebookAd && !_this5.props.isExpanded) {
        if (_this5.props.isFacebookAd && _this5.state.selectedImage !== 0) {
          _this5.initializeSwiper();
        }
        _this5.swiper.slideTo(_this5.state.selectedImage, 300);
        _this5.handleSlideChange();
      }
    });
    e && e.stopPropagation();
  };

  this.logCollectionsEvent = function (prodIndex) {
    var products = _this5.props.tag && _this5.props.tag.details && _this5.props.tag.details.attributes;
    var product = products && products[prodIndex];
    var tag_label = product && product.details && product.details.title;
    var engagement_id = product && product.id;
    var engagement_data = Object(helper["M" /* parseJsonToFormData */])({
      product_id: engagement_id,
      product_label: tag_label
    });
    var eventData = {
      event: 'gallery_interaction',
      event_type: 'collection_product',
      engagement_id: engagement_id,
      engagement_type: 'in-video',
      tag_label: tag_label,
      engagement_label: tag_label,
      engagement_data: engagement_data
    };
    _this5.props.logDataEvent(eventData);
  };

  this.logCommerceEvent = function () {
    var engagements = Object(helper["n" /* getEngagements */])(_this5.props.tag);
    var action = engagements && engagements[0];
    var actionLabel = action['label|' + action.slug];
    var actionValueFormtted = action.slug;

    var tag_id = _this5.props.tag.id;
    var tag_label = _this5.props.tag && _this5.props.tag.details && (_this5.props.tag.details.preview_title || _this5.props.tag.details.title);
    var engagement_id = action && action.id;
    var engagement_label = actionLabel;

    var logDataObj = {
      type: actionValueFormtted,
      sub_type: null,
      event: 'gallery_interaction',
      event_type: actionValueFormtted,
      tag_id: tag_id,
      tag_label: tag_label,
      engagement_id: engagement_id,
      engagement_label: engagement_label,
      current_duration: _this5.props.getCurrentTime()
    };

    _this5.props.logDataEvent(logDataObj);
  };

  this.handleSlideChange = function (e) {
    e && e.stopPropagation();
    // console.log(this.swiper.activeIndex);
    var isCollectionsTag = _this5.checkForCollectionType();
    if (isCollectionsTag) {
      var activeProdIdx = _this5.swiper.activeIndex;
      _this5.updateEngagement(activeProdIdx);
      // collection interaction event---
      _this5.logCollectionsEvent(_this5.swiper.activeIndex);
    } else {
      _this5.logCommerceEvent();
    }
    _this5.setSliderArrows();
  };

  this.checkForSwiper = function () {
    return new Promise(function (resolve, reject) {
      if (!window.Swiper) {
        _this5.loadSwiperJS = Object(helper["K" /* loadJS */])(skinV3ProductShowcase_swiperJS, skinV3ProductShowcase_HEAD);
        _this5.loadSwiperCSS = Object(helper["J" /* loadCSS */])(skinV3ProductShowcase_swiperCSS, skinV3ProductShowcase_HEAD);

        Promise.all([_this5.loadSwiperJS, _this5.loadSwiperCSS]).then(function (res) {
          _this5.setState({
            swiperJS: true
          }, function () {
            resolve();
          });
        });
      } else {
        _this5.setState({
          swiperJS: true
        }, function () {
          resolve();
        });
      }
    });
  };

  this.nextSlide = function (e) {
    _this5.swiper && _this5.swiper.slideNext();
    _this5.setSliderArrows();
    // this.handleSlideChange();
    e && e.stopPropagation();
  };

  this.prevSlide = function (e) {
    _this5.swiper && _this5.swiper.slidePrev();
    // this.handleSlideChange();
    _this5.setSliderArrows();
    e && e.stopPropagation();
  };

  this.handleResize = function () {
    _this5.initializeSwiper();
  };
}, skinV3ProductShowcase__temp);

// EXTERNAL MODULE: ./components/skinV3MultiCta/style.less
var skinV3MultiCta_style = __webpack_require__("WSn2");
var skinV3MultiCta_style_default = /*#__PURE__*/__webpack_require__.n(skinV3MultiCta_style);

// CONCATENATED MODULE: ./components/skinV3MultiCta/index.js


function skinV3MultiCta__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function skinV3MultiCta__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function skinV3MultiCta__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var skinV3MultiCta_SkinV3MultiCta = function (_Component) {
  skinV3MultiCta__inherits(SkinV3MultiCta, _Component);

  function SkinV3MultiCta() {
    var _temp, _this, _ret;

    skinV3MultiCta__classCallCheck(this, SkinV3MultiCta);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = skinV3MultiCta__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getEngagements = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      if (props.tag.settings.subcategory) {
        return [].concat.apply([], props.tag.settings.subcategory.map(function (item) {
          return item.engagements;
        }));
      }
      return [];
    }, _this.handleClick = function (link, label) {
      if (link) {
        // window.open(link);
        // OneAd clickThru---
        Object(helper["B" /* handleExternalLinksViaClickThru */])(link, _this.props.creativeData);
        //---
        _this.logCommerceEvent(label);
      }
    }, _this.logCommerceEvent = function (actionLabel) {
      var engagements = _this.getEngagements();
      var action = engagements && engagements[0];
      var actionValueFormtted = action.slug;

      var tag_id = _this.props.tag.id;
      var tag_label = _this.props.tag && _this.props.tag.details && (_this.props.tag.details.preview_title || _this.props.tag.details.title);
      var engagement_id = action && action.id;
      var engagement_label = actionLabel;

      var logDataObj = {
        event: 'engagement',
        type: actionValueFormtted,
        sub_type: null,
        event_type: actionValueFormtted,
        tag_id: tag_id,
        tag_label: tag_label,
        engagement_id: engagement_id,
        engagement_label: engagement_label,
        current_duration: _this.props.getCurrentTime()
      };

      _this.props.logDataEvent(logDataObj);
    }, _temp), skinV3MultiCta__possibleConstructorReturn(_this, _ret);
  }

  SkinV3MultiCta.prototype.render = function render(props, state) {
    var _this2 = this;

    var useAppButtonsEnabled = props.customTagParams && props.customTagParams.useCta;
    var primaryBtnStyle = {
      backgroundColor: props.customTagParams && Object(helper["V" /* validHex */])(props.customTagParams.cta_color_1) ? props.customTagParams.cta_color_1 : 'transparent',
      borderColor: props.customTagParams && Object(helper["V" /* validHex */])(props.customTagParams.cta_color_1) ? props.customTagParams.cta_color_1 : 'transparent',
      color: props.customTagParams && Object(helper["V" /* validHex */])(props.customTagParams.textColor) ? props.customTagParams.textColor : '#454463'
    };
    var secondaryBtnStyle = {
      borderColor: props.customTagParams && Object(helper["V" /* validHex */])(props.customTagParams.cta_color_2) ? props.customTagParams.cta_color_2 : 'transparent',
      color: props.customTagParams && Object(helper["V" /* validHex */])(props.customTagParams.cta_color_2) ? props.customTagParams.cta_color_2 : '#454463'
    };
    var primaryLink = props.customTagParams && props.customTagParams.cta_link_1;
    var secondaryLink = props.customTagParams && props.customTagParams.cta_link_2;

    var primaryLabel = props.customTagParams && props.customTagParams.cta_label_1 || '';
    var secondaryLabel = props.customTagParams && props.customTagParams.cta_label_2 || '';
    var isVertical = ['top', 'bottom', 'middle'].includes(props.customTagParams && props.customTagParams.align);
    return Object(preact_min["h"])(
      'div',
      {
        'class': skinV3MultiCta_style_default.a.multiCtaWrapper + ' ' + skinV3MultiCta_style_default.a[props.orientation] + ' ' + (isVertical ? skinV3MultiCta_style_default.a.vertical : '')
      },
      Object(preact_min["h"])(
        'div',
        { 'class': skinV3MultiCta_style_default.a.multiCtaPreview + ' ' + skinV3MultiCta_style_default.a[props.orientation] + ' ' + (isVertical ? skinV3MultiCta_style_default.a.vertical : '') + ' ' + (useAppButtonsEnabled ? skinV3MultiCta_style_default.a.appButtons : '') },
        useAppButtonsEnabled ? Object(preact_min["h"])(
          'div',
          { 'class': skinV3MultiCta_style_default.a.ctaBtnWrapper },
          Object(preact_min["h"])('div', { 'class': skinV3MultiCta_style_default.a.multiCtaBtn + ' ' + skinV3MultiCta_style_default.a.playStore, onClick: function onClick() {
              return _this2.handleClick(primaryLink, 'Play Store');
            } }),
          Object(preact_min["h"])('div', { 'class': skinV3MultiCta_style_default.a.multiCtaBtn + ' ' + skinV3MultiCta_style_default.a.appStore, onClick: function onClick() {
              return _this2.handleClick(secondaryLink, 'App Store');
            } })
        ) : Object(preact_min["h"])(
          'div',
          { 'class': skinV3MultiCta_style_default.a.ctaBtnWrapper },
          Object(preact_min["h"])(
            'div',
            { 'class': skinV3MultiCta_style_default.a.multiCtaBtn, style: secondaryBtnStyle, onClick: function onClick() {
                return _this2.handleClick(secondaryLink, secondaryLabel);
              } },
            secondaryLabel
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': skinV3MultiCta_style_default.a.multiCtaBtn, style: primaryBtnStyle, onClick: function onClick() {
                return _this2.handleClick(primaryLink, primaryLabel);
              } },
            primaryLabel
          )
        )
      )
    );
  };

  return SkinV3MultiCta;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/spareparts/iframeVideo/index.js
var iframeVideo = __webpack_require__("tSbV");

// EXTERNAL MODULE: ./components/spareparts/magazineGallery/style.less
var magazineGallery_style = __webpack_require__("SM8z");
var magazineGallery_style_default = /*#__PURE__*/__webpack_require__.n(magazineGallery_style);

// CONCATENATED MODULE: ./components/spareparts/magazineGallery/index.js
var magazineGallery__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function magazineGallery__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function magazineGallery__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function magazineGallery__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function Slide(props) {
  var item = props.item;

  var title = item && item.details && item.details.title || '';
  var description = item && item.details && item.details.description || '';
  var cta = item && item.details && item.details.cta || '';
  var img = item && item.media && item.media[0] && (item.media[0].img1_360 || item.media[0].img1_src) || '';

  return Object(preact_min["h"])(
    'div',
    { 'class': magazineGallery_style_default.a.slide },
    Object(preact_min["h"])(
      'div',
      { 'class': magazineGallery_style_default.a.slideContent },
      Object(preact_min["h"])(
        'div',
        { onClick: function onClick() {
            return props.onItemClick(item);
          } },
        Object(preact_min["h"])(
          'div',
          { 'class': magazineGallery_style_default.a.slideContent__image },
          Object(preact_min["h"])('img', { src: img, alt: title })
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': magazineGallery_style_default.a.slideContent__title + ' block-ellipsis' },
          description
        ),
        Object(preact_min["h"])(
          'div',
          { 'class': magazineGallery_style_default.a.slideContent__description },
          title
        )
      )
    )
  );
}

var magazineGallery_MagazineGallery = function (_Component) {
  magazineGallery__inherits(MagazineGallery, _Component);

  function MagazineGallery(props) {
    magazineGallery__classCallCheck(this, MagazineGallery);

    var _this = magazineGallery__possibleConstructorReturn(this, _Component.call(this, props));

    _this.setPanels = function (items) {
      var panels = [];
      items.forEach(function (item, idx) {
        if (idx % 2 !== 0) return;
        var panel = { front: items[idx - 1], back: item, open: idx === 0, adjust: idx === 0 };
        panels.push(panel);
      });
      if (items.length % 2 === 0) {
        panels.push({ front: items[items.length - 1], back: null, open: false, adjust: false });
      }
      _this.setState({ panels: panels }, function () {
        _this.fireImpressionTrackers([0, 1]); // fires proudct impression on load
      });
    };

    _this.handleClick = function (idx) {
      clearTimeout(_this.timeout);
      var panels = _this.state.panels.map(function (panel, i) {
        if (idx === i) {
          panel = magazineGallery__extends({}, panel, { open: !panel.open });
        }
        return panel;
      });
      _this.setState({ panels: panels }, function () {
        _this.timeout = setTimeout(function () {
          var panels = _this.state.panels.map(function (panel, i) {
            if (idx === i) {
              panel = magazineGallery__extends({}, panel, { adjust: !panel.adjust });
            }
            return panel;
          });
          _this.setState({ panels: panels });
        }, 100);
      });
    };

    _this.handleTouchStart = function (e) {
      _this.setState({ touchStart: e.targetTouches[0].clientX });
    };

    _this.handleTouchMove = function (e) {
      _this.setState({ touchEnd: e.targetTouches[0].clientX });
    };

    _this.handleMouseDown = function (e) {
      console.log(e);
      _this.setState({ touchStart: e.clientX, mouseDown: true });
    };

    _this.handleMouseMove = function (e) {
      if (_this.state.mouseDown) {
        _this.setState({ touchEnd: e.clientX });
      }
    };

    _this.handleTouchEnd = function (idx) {
      _this.setState({ mouseDown: false });
      var preventAction = idx === 0 || _this.props.items.length % 2 === 0 && idx === _this.props.items.length / 2;
      if (preventAction) return;
      var _this$state = _this.state,
          touchStart = _this$state.touchStart,
          touchEnd = _this$state.touchEnd;
      // console.log(touchStart, touchEnd);

      var sensitiviy = 60;
      if (touchStart - touchEnd > sensitiviy) {
        // console.log('moveSliderRight');
        if (!_this.state.panels[idx].open) {
          _this.handleClick(idx);
          _this.props.onProdInteraction(_this.props.items[idx * 2]);
          _this.fireImpressionTrackers([idx * 2, idx * 2 + 1]);
        }
      }

      if (touchStart - touchEnd < -sensitiviy) {
        // console.log('moveSliderLeft');
        if (_this.state.panels[idx].open) {
          _this.handleClick(idx);
          _this.props.onProdInteraction(_this.props.items[idx * 2 - 1]);
          // console.log('Prod >>>>',idx*2 - 1)
          _this.fireImpressionTrackers([idx * 2 - 1, idx * 2 - 2]);
        }
      }
    };

    _this.fireImpressionTrackers = function (productIndex) {
      var items = _this.props.items;

      var prodTrackers = items.filter(function (item, idx) {
        return productIndex.includes(idx);
      }).map(function (prod) {
        return prod.details.impTracker;
      });
      // console.log({trackers});
      var trackers = [];
      prodTrackers.forEach(function () {
        var trackerStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        trackers = trackerStr ? [].concat(trackers, trackerStr.split('||')) : trackers;
      });
      trackers.forEach(function (tracker) {
        if (tracker) {
          Object(helper["c" /* addPixelImage */])(tracker);
        }
      });
    };

    _this.state = {
      panels: [],
      touchStart: 0,
      touchEnd: 0,
      mouseDown: false
    };
    return _this;
  }

  MagazineGallery.prototype.componentWillMount = function componentWillMount() {
    var WT_PLAY = document.getElementById('wtPlay');
    WT_PLAY.classList.add('magazine');
  };

  MagazineGallery.prototype.componentWillUnmount = function componentWillUnmount() {
    var WT_PLAY = document.getElementById('wtPlay');
    WT_PLAY.classList.remove('magazine');
  };

  MagazineGallery.prototype.componentDidMount = function componentDidMount() {
    this.setPanels(this.props.items);
  };

  MagazineGallery.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.items && nextProps.items.length !== this.props.items.length) {
      this.setPanels(nextProps.items);
    }
  };
  /**
   * 
   * @param {array of product index to fire tracker} productIndex 
   */


  MagazineGallery.prototype.render = function render(props, state) {
    var _this2 = this;

    var numPanels = state.panels.length;
    return Object(preact_min["h"])(
      'div',
      { 'class': magazineGallery_style_default.a.container },
      Object(preact_min["h"])(
        'div',
        { 'class': magazineGallery_style_default.a.flipPanel },
        state.panels.map(function (p, idx) {
          var zIdx = numPanels - idx;
          return Object(preact_min["h"])(
            'div',
            {
              'class': magazineGallery_style_default.a.panel + ' ' + (p.open ? magazineGallery_style_default.a.open : ''),
              style: { zIndex: p.adjust ? 1 : zIdx },
              data: idx
            },
            Object(preact_min["h"])(
              'div',
              {
                // onClick={() => this.handleClick(idx)}
                onTouchStart: _this2.handleTouchStart,
                onTouchMove: _this2.handleTouchMove,
                onTouchEnd: function onTouchEnd() {
                  return _this2.handleTouchEnd(idx);
                },
                onMouseDown: _this2.handleMouseDown,
                onMouseMove: _this2.handleMouseMove,
                onMouseUp: function onMouseUp() {
                  return _this2.handleTouchEnd(idx);
                }
              },
              Object(preact_min["h"])(
                'div',
                { 'class': magazineGallery_style_default.a.front },
                Object(preact_min["h"])(Slide, { item: p.front, onItemClick: props.onProdCtaClick })
              ),
              Object(preact_min["h"])(
                'div',
                { 'class': magazineGallery_style_default.a.back },
                p.back && Object(preact_min["h"])(Slide, { item: p.back, onItemClick: props.onProdCtaClick })
              )
            )
          );
        })
      )
    );
  };

  return MagazineGallery;
}(preact_min["Component"]);




magazineGallery_MagazineGallery.defaultProps = {
  panels: []
};
// CONCATENATED MODULE: ./components/screenController/index.js
var screenController__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var screenController__class, screenController__temp, screenController__initialiseProps;



function screenController__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function screenController__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function screenController__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var screenController_HEAD = document.getElementsByTagName('head')[0];
var logo = 'https://www.geekchicelite.com/wp-content/uploads/2013/11/XboxOne_horizontal_rgb.png';
var skinEditorCanvasWidth = 586;
var skinEditorCanvasHeight = 328;

var screenController__ref = Object(preact_min["h"])(
  'div',
  { 'class': 'play-icon-container' },
  Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-play-circle-outline' })
);

var screenController__ref2 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-close' });

var screenController__ref3 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-close' });

var _ref5 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-arrow-right' });

var _ref6 = Object(preact_min["h"])('div', { 'class': 'tempScreenPlaceholder' });

var _ref7 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-arrow-left' });

var _ref8 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-arrow-right' });

var _ref9 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-close' });

var screenController__ref10 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-arrow-back' });

var _ref11 = Object(preact_min["h"])(
  'span',
  null,
  'Go to Video'
);

var _ref14 = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-arrow-right' });

var screenController_ScreenController = (screenController__temp = screenController__class = function (_Component) {
  screenController__inherits(ScreenController, _Component);

  function ScreenController(props) {
    screenController__classCallCheck(this, ScreenController);

    var _this = screenController__possibleConstructorReturn(this, _Component.call(this, props));

    screenController__initialiseProps.call(_this);

    _this.meta = _this.props.json && _this.props.json.meta;
    _this.videoPlayer = [];
    _this.skinmap = {
      tags: {},
      v1: 'skin_generic_banner', // skin without cta and title from json
      v2: 'skin_wootag_banner', // skin with cta and title from json
      v3: 'skin_cube',
      v4: 'skin_tags',
      launch0: 'regular',
      launch1: 'alwayson',
      launch2: 'skip'
    };

    _this.tagParams = {};

    if (_this.meta.skin_tag_object) {
      _this.meta.skin_tag_object.forEach(function (item) {
        _this.tagParams[item.tagid] = item;
      });
    }

    _this.custom = _this.props.json.custom;
    _this.customEndCardsData = _this.custom && _this.custom.endcards;
    _this.customEndCardEnabled = _this.customEndCardsData && _this.customEndCardsData.customEndCard;

    _this.customSkinData = _this.custom && _this.custom.customskin;
    _this.customSkinDataEnabled = _this.customSkinData && _this.customSkinData.enableSkin;
    _this.customSkinApplicableForAll = _this.customSkinDataEnabled && _this.customSkinData.applicalbleForAll;
    _this.customSkinTagsData = _this.customSkinDataEnabled && _this.customSkinData.tagsAttribute || [];

    _this.meta.skins = _this.meta.skins || _this.customSkinDataEnabled;
    if (_this.customSkinTagsData.length > 0) {
      _this.meta.skin_tag_object = [];

      _this.customSkinTagsData.forEach(function (item) {
        var exitstingData = _this.tagParams[item.id] || {};
        var skinVersionMap = {
          generic: 'v1',
          wootag: 'v2',
          cube: 'v3',
          tag: 'v4'
        };
        var skinLaunchMap = {
          regular: 0,
          alwaysOn: 1,
          skip: 2
        };

        var customMappingToAB = screenController__extends({}, item, {
          tagid: item.id,
          theme: item.theme === 'dark' ? 'skins_dark_theme' : 'skins_light_theme',
          bg_overlay_percentage: item.overlayOpacity,
          skin_version: skinVersionMap[item.template],
          skin_launch: skinLaunchMap[item.launch]
        });
        _this.tagParams[item.id] = screenController__extends({}, exitstingData, customMappingToAB);
        _this.meta.skin_tag_object.push(_this.tagParams[item.id]);
      });
    }

    _this.state = {
      activeIndex: 0,
      brandBar: _this.meta && _this.meta.brand_bar,
      enableCube: false,
      isSquareVideo: false,
      layoutEnabled: false,
      layout: _this.getSkinLayout(),
      scaleOut: false,
      startedToPlay: false,
      showCustomEndCard: false,
      hotspotLinkedTag: null,
      progressOverlayImageLinkedTag: null,
      overlayImageLinkedTagIsExpanded: false,
      overlayImageLinkedTagIsActiveSlide: false,
      mapsApiLoaded: false,
      showTileProducts: false,
      tileDimensionClass: '',
      tileProducts: [],
      tileLinkedTag: null,
      animateInTiles: '',
      animateTileNav: false,
      animateScreenShrink: false,
      slideTileHeight: false,
      currentTileIndex: 0,
      initializeConnectedVideo: null,
      closeSkinMode: false,
      collectionsVideoActiveIdxMap: {},
      isSkinSliderActive: false,
      skinSliderConfiguration: null,
      animateInSkinSliderId: 0,
      skipDuration: _this.props.creativeData && _this.props.creativeData.skip_offset,
      showCollectionsMagazine: false,
      videoEnded: false
    };
    return _this;
  }

  ScreenController.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.swiperTile) {
      this.swiperTile.destroy();
      window.removeEventListener('resize', Object(helper["f" /* debounce */])(this.handleResize, 250));
    }
    if (this.isCustomProportionsResizeEventListenerAdded) {
      window.removeEventListener('resize', Object(helper["f" /* debounce */])(this.handleCustomProportionsWhenResize, 250));
    }
  };

  ScreenController.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (this.customEndCardEnabled) {
      __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "f84R")).then(function (res) {
        _this2.setState({
          customEndCardsLoaded: true,
          customEndCards: res
        });
      });
    }

    if (this.meta.scratch) {
      __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "i6Lk")).then(function (res) {
        _this2.setState({
          scratchLoaded: true,
          scratchModule: res
        }, function () {
          if (_this2.meta.scratchTimeoutDelay && _this2.meta.scratchTimeoutDelay > 0) {
            _this2.scratchTimeout = setTimeout(function () {
              _this2.setState({
                scratchUnload: true
              });
            }, _this2.meta.scratchTimeoutDelay * 1000);
          }
        });
      });
    }
  };

  ScreenController.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    var tag = this.state.tag;
    var tagParams = tag && this.tagParams[tag.id];
    var skinVersion = tagParams && tagParams.skin_version;

    /** if collections video swiper needed, for now we will just load the videos directly */
    /* const subcategory = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0];
    const subcategoryType = subcategory && subcategory.type;
    const isCollectionsVideo = subcategoryType === 107; // CHANGE IT TO 107
    */
    var isCollectionsVideo = false;

    if ((this.meta && skinVersion === 'v3' || isCollectionsVideo) && !this.swiper) {
      if (!window.Swiper) {
        this.loadSwiperJS = Object(helper["K" /* loadJS */])(components_config["d" /* links */].swiperJS, screenController_HEAD);
        this.loadSwiperCSS = Object(helper["J" /* loadCSS */])(components_config["d" /* links */].swiperCSS, screenController_HEAD);

        Promise.all([this.loadSwiperJS, this.loadSwiperCSS]).then(function (res) {
          _this3.initializeSlider();
        });
      } else this.initializeSlider();
    }

    var isTileThemeEnabled = this.isTileThemeEnabled(prevProps.json.tags);
    if (isTileThemeEnabled && !this.swiperTile) {
      if (!window.Swiper) {
        this.loadSwiperJS = Object(helper["K" /* loadJS */])(components_config["d" /* links */].swiperJS, screenController_HEAD);
        this.loadSwiperCSS = Object(helper["J" /* loadCSS */])(components_config["d" /* links */].swiperCSS, screenController_HEAD);

        Promise.all([this.loadSwiperJS, this.loadSwiperCSS]).then(function (res) {
          _this3.setState({ swiperJsTile: true }, function () {
            _this3.initializeSliderTile();
          });
        });
      } else {
        this.setState({ swiperJsTile: true }, function () {
          _this3.initializeSliderTile();
        });
      }
      window.addEventListener('resize', Object(helper["f" /* debounce */])(this.handleResize, 250));
    }

    if (this.meta && skinVersion === 'v3') {
      if (this.state.imageCount !== prevState.imageCount) {
        this.imageCount = this.state.imageCount;
        this.swiper && this.swiper.update();
      }

      this.setTranslate(prevState);
    }

    if (this.meta && skinVersion === 'v4') {
      var playerWrapper = this.props.playerWrapper;
      playerWrapper && playerWrapper.classList.add('removeOTT');
    }

    if (this.state.tag) {
      if (prevState.tag && this.state.tag.id !== prevState.tag.id || !prevState.tag && this.state.tag.id) {
        this.setState({
          layout: this.getSkinLayout()
        });
        if (this.state.tag.details && this.state.tag.details.customTheme === 'magazine') {
          this.setState({
            showCollectionsMagazine: true
          });
        }
      }
    }

    var customProportions = tagParams && tagParams.config && tagParams.config.customProportions && tagParams.config.customProportions;

    if (customProportions && customProportions.isEnabled) {
      this.isCustomProportionsResizeEventListenerAdded = true;
      window.addEventListener('resize', Object(helper["f" /* debounce */])(this.handleCustomProportionsWhenResize, 250));
    }

    if (this.props.creativeData && this.props.creativeData.skip_offset && prevProps.creativeData && this.props.creativeData.skip_offset !== prevProps.creativeData.skip_offset) {
      this.setState({ skipDuration: this.props.creativeData && this.props.creativeData.skip_offset });
    }
  };

  ScreenController.prototype.render = function render(props, state) {
    var _this4 = this;

    var meta = this.meta;
    var tag = state.tag;
    var color = tag && tag.details.color || helper["a" /* DEFAULT_WOOTAG_COLOR */];
    var title = tag && tag.details.title;
    var cta = state.cta;
    // Custom Skin---
    var tagParams = this.tagParams && this.tagParams[tag && tag.id];
    var customSkinImages = tagParams && tagParams.image && JSON.parse(tagParams.image);
    var customSkinImage = customSkinImages && Object(helper["q" /* getLinkedTagImage */])({ images: customSkinImages }, null, null, null, true);
    var currTagId = tag && tag.id;
    var currTagCustomSkinData = currTagId && this.customSkinTagsData.find(function (t) {
      return t.id === currTagId;
    });
    if (currTagCustomSkinData) {
      this.meta.skin_orientation = currTagCustomSkinData.align === 'middle' ? 'center' : currTagCustomSkinData.align;
    }
    var customSkinType = this.customSkinData && this.customSkinData.skinType;
    var isProductShowcaseSkin = customSkinType && customSkinType === 'productShowcase';
    var isMultiCtaSkin = customSkinType && customSkinType === 'multiCta';
    var useTagImage = !isProductShowcaseSkin && !isMultiCtaSkin;
    //---
    var currTagIdx = tag && this.props.json.otags.findIndex(function (t) {
      return t.id === tag.id;
    });

    var preLoadImgIdx = 0;
    var currTagImg = '';
    if (typeof currTagIdx === 'number') {
      preLoadImgIdx = currTagIdx + 1 < this.props.json.otags.length ? currTagIdx + 1 : 0;
      currTagImg = meta && meta.skins && (customSkinImage || (useTagImage ? this.getImage(this.props.orientation, this.props.json.otags[currTagIdx]) : ''));
    }
    var nextTag = this.props.json.otags[preLoadImgIdx];
    var nextCustomSkinTagData = this.tagParams && this.tagParams[nextTag && nextTag.id];
    var nextCustomSkinImages = nextCustomSkinTagData && nextCustomSkinTagData.image && JSON.parse(nextCustomSkinTagData.image);
    var nextCustomSkinImage = nextCustomSkinImages && Object(helper["q" /* getLinkedTagImage */])({ images: nextCustomSkinImages }, null, null, null, true);
    var preloadBgImg = meta && meta.skins && (nextCustomSkinImage || (useTagImage ? this.getImage(this.props.orientation, nextTag) : ''));
    var image = currTagImg || (useTagImage ? state.image : '');
    var images = state.images;
    var imageCount = state.imageCount;
    var hideCta = meta && meta.showcase_tag_cta;

    var customSkinBgColor = tagParams && tagParams.backgroundColor;
    var customSkinOverlayImages = tagParams && tagParams.overlayImage && JSON.parse(tagParams.overlayImage);
    var overlayImage = customSkinOverlayImages && Object(helper["q" /* getLinkedTagImage */])({ images: customSkinOverlayImages }, null, null, null, true);

    var nextCustomSkinOverlayImages = nextCustomSkinTagData && nextCustomSkinTagData.overlayImage && JSON.parse(nextCustomSkinTagData.overlayImage);
    var nextCustomSkinOverlayImage = nextCustomSkinOverlayImages && Object(helper["q" /* getLinkedTagImage */])({ images: nextCustomSkinOverlayImages }, null, null, null, true);
    var preloadOverlayImg = meta && meta.skins && (nextCustomSkinOverlayImage || '');

    var orientation = this.customSkinData && this.customSkinData.skinOrientation || 'horizontal';
    var skinHotspots = tagParams && tagParams.hotspots || [];
    var skinHotspotSliders = [];
    if (tagParams && tagParams.hotspots && tagParams.hotspots.some(function (ht) {
      return ht.enableOnSkinSlider;
    })) {
      skinHotspotSliders = tagParams.hotspots.filter(function (ht) {
        return ht.enableOnSkinSlider;
      });
    }
    // console.log(skinHotspots)
    var category = tag && tag.settings.category;
    var subcategory = category && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0];
    var subcategoryType = subcategory && subcategory.type;

    var skinConnectedAssets = [];
    if (tagParams && tagParams.gridLayoutForConnectedAssets && this.meta && this.meta.skin_orientation !== 'center') {
      var isDPTagSelectedWithVideoEnabled = tag && tag.details && tag.details.engagements && tag.details.engagements[0] && tag.details.engagements[0].native_video;
      if (category === 15 && isDPTagSelectedWithVideoEnabled) {
        // dp tag
        skinConnectedAssets = tag && tag.details && tag.details.engagements && tag.details.engagements[0] && tag.details.engagements[0].meta && tag.details.engagements[0].meta.map(function (m) {
          return { type: m.type, sourceCat: category, imgUrl: m.url, id: m.videoId, description: m.description, cltTracker: m.cltTracker };
        });
      }
    }
    // console.log({tagParams})
    var skinVersion = tagParams && tagParams.skin_version;
    var enableSkinsV2 = tagParams && tagParams.skin_version === 'v4' ? 'skinsV2 tag' + subcategoryType : '';
    var noBackground = tagParams && tagParams.transparent ? 'noBackground' : '';
    var isPortraitVideoInLandscape = props.portraitVideo && props.orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE ? 'portraitVideoInLandscape ' + (state.layoutEnabled ? state.layout : '') : '';
    var skinsBgOverlay = tagParams && tagParams.bg_overlay_percentage;

    var skinOrientation = this.meta && this.meta.skin_orientation;
    var portraitVidAlignClass = '';
    if (skinOrientation === 'top') {
      portraitVidAlignClass = 'vidTOP';
    } else if (skinOrientation === 'bottom') {
      portraitVidAlignClass = 'vidBOTTOM';
    }

    var tagStatus = this.state.image ? 'tagPresent' : 'tagAbsent';
    var isLayoutEnabled = state.layoutEnabled ? 'enable' : '';
    var isSquareVideo = state.isSquareVideo ? 'squareVideo' : '';
    var isPortraitVideo = this.props.portraitVideo ? 'portraitVideo' : '';

    var customSkinTagVideoSize = tagParams && tagParams.size;
    var videoSize = this.meta && this.meta.skins && (customSkinTagVideoSize || this.meta.video_size || '').toLowerCase();
    var vidSizeClass = '';
    if (videoSize === 'small') {
      vidSizeClass = 'vidSizeSmall';
    } else if (videoSize === 'medium') {
      vidSizeClass = 'vidSizeMedium';
    } else if (videoSize === 'large') {
      vidSizeClass = 'vidSizeLarge';
    }

    var isEditorMode = props.editorMode ? 'editorMode' : '';

    var portraitWithTagOpened = '';
    if (this.props.isMobileDevice && this.props.orientation === components_config["b" /* constants */].ORIENTATION_PORTRAIT && this.state.progressOverlayImageLinkedTag) {
      portraitWithTagOpened = 'portraitWithTagOpened';
    }
    var screenHasTiles = state.showTileProducts ? 'screenHasTiles' : '';
    var tileProductsClassName = state.showTileProducts ? ' showTileProductsWithScreen ' + state.tileDimensionClass + ' ' : '';

    var screenControllerClass = 'screenController ' + enableSkinsV2 + ' ' + noBackground + ' ' + tagStatus + ' ' + isLayoutEnabled + ' ' + isSquareVideo + ' ' + isPortraitVideo + ' ' + isPortraitVideoInLandscape + ' ' + portraitVidAlignClass + ' ' + isEditorMode + ' ' + portraitWithTagOpened;
    var screen = Object(preact_min["cloneElement"])(props.children[0], screenController__extends({}, props, {
      triggerSkinLayout: this.meta && this.meta.skin_tag_object ? this.triggerSkinLayoutV2 : this.triggerSkinLayout,
      handlePlay: this.handlePlay,
      setTagInScreenController: this.setTagInScreenController,
      setSquareVideo: this.setSquareVideo,
      cusotmEndCardEnabled: this.state.customEndCardsLoaded,
      showCustomEndcards: this.toggleCustomEndcards,
      showProgressOverlayImageLinkedTag: this.toggleProgressOverlayImageLinkedTag,
      setActiveIndexForImageGallery: this.props.setActiveIndexForImageGallery,
      toggleTileProducts: this.toggleTileProducts,
      setElapsedTime: this.setElapsedTime,
      setVideoEnded: this.setVideoEnded
    }));

    var isSkinV2 = tag && this.meta && this.meta.skin_version === 'v2';
    var socialTag = state.isSocialShare || state.isSocialEmotion;
    var screenHandleSocialClass = isSkinV2 && socialTag ? 'middleUp' : '';
    if (tag && tag.emojiSelected && isSkinV2) {
      screenHandleSocialClass = 'middleUp enlarge';
    }

    var CustomEndCards = this.state.customEndCardsLoaded ? this.state.customEndCards && this.state.customEndCards.default : null;

    var ScratchOff = this.state.scratchLoaded ? this.state.scratchModule && this.state.scratchModule.default : null;
    var animate = tagParams && tagParams.animate || this.meta && this.meta.animate_transition;
    var isVertical = ['top', 'bottom', 'middle'].includes(tagParams && tagParams.align);
    var multiCtaStyle = isMultiCtaSkin ? 'multiCtaSkin' : '';
    if (isVertical) {
      multiCtaStyle += ' vertical';
    }

    var isTileThemeEnabled = this.isTileThemeEnabled(props.json.tags);
    var isCollectionsVideo = subcategoryType === 107; // CHANGE IT TO 107
    var collectionsVideos = isCollectionsVideo ? tag && tag.details && tag.details.attributes : null;
    screenControllerClass = screenControllerClass + ' ' + (isCollectionsVideo ? 'collections-videos' : '');
    var activeProdVideoIdx = this.state.collectionsVideoActiveIdxMap[tag && tag.id];

    var enableSkip = this.state.skipDuration && this.state.skipDuration - this.state.elapsedTime > 0;
    var activeSignalRuleValue = tag && tag.activeSignalRuleValue;
    var tagidClass = 'tagid_' + (tag && tag.id);

    var _ref4 = Object(preact_min["h"])(
      'h2',
      { 'class': 'tag-details-title' },
      title
    );

    return Object(preact_min["h"])(
      'div',
      {
        'class': screenControllerClass
      },
      Object(preact_min["h"])('div', { 'class': 'preloadBg', style: { background: skinVersion !== 'v3' && preloadBgImg ? 'url(' + preloadBgImg + ')' : 'none' } }),
      Object(preact_min["h"])('div', { 'class': 'skinBgColor', style: customSkinBgColor ? { backgroundColor: customSkinBgColor } : { display: 'none' } }),
      Object(preact_min["h"])('div', { 'class': 'skinBg', style: { background: skinVersion !== 'v3' && image ? 'url(' + image + ')' : 'none' } }),
      Object(preact_min["h"])('div', { 'class': 'preloadOverlay', style: { background: skinVersion !== 'v3' && preloadOverlayImg ? 'url(' + preloadOverlayImg + ')' : 'none' } }),
      !this.meta.scratch && Object(preact_min["h"])('div', { 'class': 'skinOverlayBg', style: { background: skinVersion !== 'v3' && overlayImage ? 'url(' + overlayImage + ')' : 'none' } }),
      this.meta.scratch && overlayImage && !this.state.unloadScratch && Object(preact_min["h"])(ScratchOff, { unload: this.state.scratchUnload, ready: this.scratchReady, cover: overlayImage, callback: this.scratchDone, start: this.scratchStart, fireEvent: this.scratchClickEvent }),
      Object(preact_min["h"])('div', {
        'class': 'screenControllerBg',
        onClick: this.handleImageClick,
        style: {
          background: 'rgba(0,0,0,' + (skinsBgOverlay ? skinsBgOverlay / 100 : 0) + ')'
        }
      }),
      skinConnectedAssets.length > 0 && Object(preact_min["h"])(
        'div',
        { 'class': 'skinConnectedAssetsWrapper ' + this.getSkinConnectedAssetsLayoutClasses(videoSize) + ' scawHas_' + (skinConnectedAssets.length > 4 ? 'Many' : skinConnectedAssets.length) + ' ' + tagidClass },
        skinConnectedAssets.map(function (item) {
          var type = item.type,
              sourceCat = item.sourceCat,
              imgUrl = item.imgUrl,
              id = item.id,
              description = item.description,
              cltTracker = item.cltTracker;

          return Object(preact_min["h"])(
            'div',
            { key: id, 'class': 'connectedAssetLayout', onClick: function onClick() {
                return _this4.handleSkinConnectedAssetClick(type, sourceCat, id, cltTracker);
              }, style: { background: 'url(' + imgUrl + ')' } },
            screenController__ref,
            Object(preact_min["h"])('div', { className: 'connectedAssetLabel', dangerouslySetInnerHTML: { __html: description } })
          );
        })
      ),
      state.initializeConnectedVideo && Object(preact_min["h"])(
        'div',
        { 'class': 'closeSkinConnectedVideoWrapper ' + (this.meta && this.meta.skin_orientation === 'left' ? 'closeSkinConnectedLeft' : ''), onClick: this.handleSkinConnectedAssetClose },
        screenController__ref2
      ),
      state.initializeConnectedVideo && Object(preact_min["h"])(
        'div',
        { 'class': 'skinConnectedVideoWrapper ' + this.getSkinConnectedAssetsLayoutClasses(videoSize, true) + ' ' + tagidClass },
        Object(preact_min["h"])(iframeVideo["a" /* default */], { video: { videoId: state.initializeConnectedVideo }, domain: props.adUnitSrv })
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'hotspotsWrapper' },
        skinHotspots.map(function (item) {
          var x = item.x,
              y = item.y,
              width = item.width,
              height = item.height,
              id = item.id,
              url = item.url,
              tagId = item.tagId;
          var ctaAnimationType = item.ctaAnimationType,
              ctaAnimateForever = item.ctaAnimateForever,
              ctaBgColor = item.ctaBgColor,
              ctaBorderRadius = item.ctaBorderRadius,
              ctaText = item.ctaText,
              ctaTextColor = item.ctaTextColor,
              ctaType = item.ctaType,
              ctaImage = item.ctaImage,
              enableCta = item.enableCta;
          var enableOnSkinSlider = item.enableOnSkinSlider,
              onSkinSliderCtaLink = item.onSkinSliderCtaLink;

          if (!url && !tagId && enableOnSkinSlider && !onSkinSliderCtaLink) {
            return null;
          }
          var canvasWidth = orientation === 'vertical' ? skinEditorCanvasHeight : skinEditorCanvasWidth;
          var canvasHeight = orientation === 'vertical' ? skinEditorCanvasWidth : skinEditorCanvasHeight;
          var widthRatio = window.innerWidth / canvasWidth;
          var heightRatio = window.innerHeight / canvasHeight;
          var updatedWidth = widthRatio * width;
          var updatedHeight = heightRatio * height;
          var updatedX = widthRatio * x;
          var updatedY = heightRatio * y;
          var hotspotStyle = { width: updatedWidth, height: updatedHeight, top: updatedY, left: updatedX, position: 'absolute' };
          var hasChildComponent = false;
          var imageSrc = false;
          var animationStyle = '';
          if (enableOnSkinSlider) {
            hasChildComponent = 'hotspot';
          } else if (enableCta) {
            animationStyle = ctaAnimationType || '';
            if (ctaType === 'custom') {
              if (ctaText) hasChildComponent = 'text';
            } else {
              // default -> ctaType = 'image'
              if (Object.keys(ctaImage).length > 0) {
                hasChildComponent = 'image';
                imageSrc = ctaImage[Object.keys(ctaImage)[0]].src;
              }
            }
          }
          return Object(preact_min["h"])(
            'div',
            { key: id, style: hotspotStyle, onClick: function onClick() {
                return _this4.handleSkinHotspotClick(item);
              } },
            hasChildComponent === 'text' && Object(preact_min["h"])(
              'div',
              { 'class': animationStyle + ' ' + (ctaAnimateForever ? 'run-forever' : ''), style: {
                  width: '100%',
                  height: '100%',
                  backgroundColor: ctaBgColor || '#3cb1e6',
                  borderRadius: ctaBorderRadius,
                  color: ctaTextColor || '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                } },
              ctaText
            ),
            hasChildComponent === 'hotspot' && Object(preact_min["h"])(
              'div',
              { 'class': 'hotspotPulsateContainer' },
              Object(preact_min["h"])('div', { 'class': 'hotspotPulsate' })
            ),
            hasChildComponent === 'image' && imageSrc && Object(preact_min["h"])('img', { alt: '', 'class': 'hotspotCtaImage ' + animationStyle + ' ' + (ctaAnimateForever ? 'run-forever' : ''), src: imageSrc })
          );
        })
      ),
      Object(preact_min["h"])(
        'div',
        { className: 'skinSliderWrapper' },
        skinHotspotSliders.length > 0 && skinHotspotSliders.map(function (skinHotspotSlider) {
          var imageSrc = skinHotspotSlider.onSkinSliderImage[Object.keys(skinHotspotSlider.onSkinSliderImage)[0]].src;
          return Object(preact_min["h"])(
            'div',
            { 'class': 'skinSliderContainer ' + (state.animateInSkinSliderId === skinHotspotSlider.id ? 'animateInSkinSlider' : '') + ' ' + _this4.getSkinSliderLayoutClasses(videoSize), style: {
                backgroundImage: 'url(' + imageSrc + ')'
              },
              onClick: function onClick() {
                _this4.handleSkinSliderClick(skinHotspotSlider);
              }
            },
            Object(preact_min["h"])(
              'div',
              { 'class': 'skinSlidercloseBtnContainer', onClick: _this4.handleSkinSliderCloseClick },
              screenController__ref3
            ),
            skinHotspotSlider.onSkinSliderCtaText && Object(preact_min["h"])(
              'div',
              { 'class': 'skinSliderCtaContainer', style: { backgroundColor: skinHotspotSlider.onSkinSliderCtaBgColor || '#3cb1e6' } },
              Object(preact_min["h"])('span', { style: { color: skinHotspotSlider.onSkinSliderCtaTextColor || '#ffffff' }, dangerouslySetInnerHTML: { __html: skinHotspotSlider.onSkinSliderCtaText } })
            )
          );
        })
      ),
      Object(preact_min["h"])(
        'div',
        {
          ref: function ref(c) {
            return _this4.screenHandleRef = c;
          },
          'class': 'screenHandle ' + (this.meta.scratch ? 'fullscreenVideo' : '') + ' ' + vidSizeClass + ' ' + (animate ? 'animate' : '') + ' ' + (state.layoutEnabled ? state.layout : '') + ' ' + (state.scaleOut ? 'scaleOut' : '') + ' ' + screenHandleSocialClass + ' ' + multiCtaStyle + ' ' + tileProductsClassName + ' ' + (skinVersion === 'v3' ? 'skincube' : ''),
          style: state.layoutEnabled && props.portraitVideo ? props.orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE ? {
            width: state.isSquareVideo ? window.innerWidth / 2 : 0.5625 * window.innerHeight,
            height: state.isSquareVideo ? window.innerWidth / 2 : window.innerHeight
          } : {
            width: state.isSquareVideo ? window.innerWidth : 0.5625 * window.innerHeight,
            height: state.isSquareVideo ? window.innerWidth : window.innerHeight
          } : state.showCollectionsMagazine ? { overflow: 'visible' } : {}
        },
        this.meta && skinVersion === 'v3' ? Object(preact_min["h"])(
          'div',
          { ref: function ref(c) {
              return _this4.swiperContainer = c;
            }, 'class': 'swiper-container' },
          Object(preact_min["h"])(
            'div',
            {
              'class': 'swiper-wrapper ' + (state.disableAnimation ? 'disable-anim' : ''),
              ref: function ref(c) {
                return _this4.swiperWrapper = c;
              }
            },
            Object(preact_min["h"])(
              'div',
              { 'class': 'swiper-slide' },
              screen
            ),
            imageCount && Array.apply(0, Array(imageCount)).map(function (item, index) {
              var hideFooter = state.isShowcase && hideCta ? 'hide-footer' : '';
              var getImage = _this4.getImageIndex(images, index);
              var image = state.isShowcase ? getImage.url : getImage;
              title = state.isShowcase ? getImage.description : title;
              cta = state.isShowcase ? getImage.ctaLabel : cta;

              return Object(preact_min["h"])(
                'div',
                { 'class': 'swiper-slide' },
                state.isShowcase && getImage.type === 'video' ? Object(preact_min["h"])(videoplayer["a" /* default */], {
                  ref: function ref(c) {
                    return _this4.videoPlayer[index] = c;
                  },
                  eventBus: props.eventBus,
                  index: index,
                  item: getImage,
                  tag: state.tag,
                  videoId: props.videoId,
                  isMuted: true,
                  handleVideoEvent: function handleVideoEvent() {}
                }) : Object(preact_min["h"])('div', {
                  'class': 'fsImage',
                  style: { background: 'url(' + image + ')' },
                  onClick: state.isShowcase ? _this4.handleShowcaseLink.bind(_this4, getImage) : null
                }),
                Object(preact_min["h"])(
                  'div',
                  {
                    'class': 'tag-details-wrapper ' + state.layout + ' ' + hideFooter + ' ' + (state.isShowcase ? 'showcase' : ''),
                    style: { backgroundColor: color }
                  },
                  _ref4,
                  Object(preact_min["h"])(
                    'div',
                    { 'class': 'tag-details-cta' },
                    Object(preact_min["h"])(
                      'button',
                      {
                        'class': 'tag-details-cta-button',
                        style: { background: color },
                        onClick: state.isShowcase ? _this4.handleShowcaseLink.bind(_this4, getImage) : _this4.proxyClickHandler
                      },
                      cta
                    ),
                    _ref5
                  )
                )
              );
            })
          ),
          Object(preact_min["h"])(
            'div',
            { 'class': 'ottBottomNavi ' + (!state.startedToPlay ? 'hide' : '') },
            Object(preact_min["h"])('div', {
              'class': 'swiper-button-left zmdi',
              ref: function ref(a) {
                return _this4.swiperNaviLeft = a;
              },
              onClick: this.prevSlide
            }),
            Object(preact_min["h"])('div', {
              'class': 'swiper-button-right zmdi',
              ref: function ref(b) {
                return _this4.swiperNaviRight = b;
              },
              style: { right: -window.innerWidth },
              onClick: this.nextSlide
            })
          )
        ) : isTileThemeEnabled ? Object(preact_min["h"])(
          'div',
          { ref: function ref(c) {
              return _this4.swiperContainerTile = c;
            }, 'class': 'swiper-container swiper-tile-container ' + screenHasTiles },
          Object(preact_min["h"])(
            'div',
            {
              'class': 'swiper-wrapper ' + (state.disableAnimation ? 'disable-anim' : ''),
              ref: function ref(c) {
                return _this4.swiperWrapperTile = c;
              }
            },
            Object(preact_min["h"])(
              'div',
              { 'class': 'swiper-slide ' + (state.animateScreenShrink ? 'animateScreenShrink' : '') },
              screen,
              state.animateScreenShrink && _ref6,
              !Object(helper["E" /* isMiniature */])() && state.showTileProducts && state.tileProducts && state.tileProducts.length > 0 && state.tileProducts.slice(0, 3).map(function (product, i) {
                return Object(preact_min["h"])(
                  'div',
                  { 'class': 'tileProductContainer ' + state.animateInTiles + ' ' + state.tileDimensionClass + ' animateTile' + (i + 1),
                    key: product.id,
                    id: product.id,
                    onClick: function onClick(e) {
                      return _this4.handleTileClick(e);
                    },
                    style: state.slideTileHeight && { height: state.slideTileHeight }
                  },
                  Object(preact_min["h"])('img', { src: product.img1_src, alt: '', 'class': 'tileProductImage' })
                );
              })
            ),
            function () {
              var groupSize = Object(helper["E" /* isMiniature */])() ? 1 : 4;
              var startingIndex = Object(helper["E" /* isMiniature */])() ? 0 : 3;
              if (state.showTileProducts && state.tileProducts && state.tileProducts.length > startingIndex) {
                var tileSlides = state.tileProducts.slice(startingIndex).map(function (product) {
                  return Object(preact_min["h"])(
                    'div',
                    { 'class': 'tileProductContainer ' + state.animateInTiles + ' ' + state.tileDimensionClass,
                      key: product.id,
                      id: product.id,
                      onClick: function onClick(e) {
                        return _this4.handleTileClick(e);
                      },
                      style: state.slideTileHeight && { height: state.slideTileHeight }
                    },
                    Object(preact_min["h"])('img', { src: product.img1_src, alt: '', 'class': 'tileProductImage' })
                  );
                }).reduce(function (r, element, index) {
                  // create element groups with size 4, result looks like:
                  // [[elem1, elem2, elem3, elem4], [elem5, elem6, ...], ...]
                  index % groupSize === 0 && r.push([]);
                  r[r.length - 1].push(element);
                  return r;
                }, []).map(function (rowContent) {
                  // surround every group with 'swiper-slide'
                  return Object(preact_min["h"])(
                    'div',
                    { 'class': 'swiper-slide' },
                    rowContent
                  );
                });
                return tileSlides;
              }
            }()
          ),
          state.showTileProducts && Object(preact_min["h"])(
            'div',
            { 'class': 'tile-group-pagination-controls' },
            Object(preact_min["h"])(
              'div',
              { 'class': 'tile-group-paginate ' + (this.state.isBeginningTile ? '' : 'show-nav-btn') + ' ' + (this.state.animateTileNav ? 'goto-prev-product' : ''), onClick: this.prevTileGroup, ref: function ref(a) {
                  return _this4.swiperNaviLeftTileGroup = a;
                } },
              _ref7
            ),
            Object(preact_min["h"])(
              'div',
              { 'class': 'tile-group-paginate ' + (this.state.isEndTile ? '' : 'show-nav-btn') + ' ' + (this.state.animateTileNav ? 'goto-next-product' : ''), onClick: this.nextTileGroup, ref: function ref(b) {
                  return _this4.swiperNaviRightTileGroup = b;
                } },
              _ref8
            )
          ),
          state.showTileProducts && Object(preact_min["h"])(
            'div',
            { 'class': 'closeTag', onClick: function onClick() {
                return _this4.toggleTileProducts(false, null, []);
              } },
            _ref9
          )
        ) : screen,
        this.state.showCollectionsMagazine && !this.state.videoEnded && Object(preact_min["h"])(
          'div',
          { 'class': 'collection-magazine' },
          this.renderCollectionsMagazine()
        ),
        this.meta && skinVersion === 'v3' && state.startedToPlay && state.activeIndex !== 0 ? Object(preact_min["h"])(
          'div',
          { 'class': 'swiper-slide-custom-button', onClick: this.handleGoBackToVideo },
          screenController__ref10,
          _ref11
        ) : null,
        isCollectionsVideo && Object(preact_min["h"])(
          'div',
          { ref: function ref(c) {
              return _this4.swiperContainer = c;
            }, 'class': 'swiper-container collections-video-swiper-container' },
          Object(preact_min["h"])(
            'div',
            {
              'class': 'swiper-wrapper ' + (state.disableAnimation ? 'disable-anim' : ''),
              ref: function ref(c) {
                return _this4.swiperWrapper = c;
              }
            },
            collectionsVideos && collectionsVideos.map(function (item, index) {
              var settingsEngagement = subcategory && subcategory.engagements && subcategory.engagements[0];
              var ctaLabel = settingsEngagement && settingsEngagement['label|' + settingsEngagement.slug];
              var colWhite = item.details.color && ['white', '#fff', '#ffffff'].includes(item.details.color);
              var eventData = {};
              if (item && item.details) {
                eventData = { engagementLabel: item.details.title, engagementId: item.id };
              }
              return Object(preact_min["h"])(
                'div',
                { 'class': 'swiper-slide ' + (index === activeProdVideoIdx ? 'active' : '') },
                Object(preact_min["h"])(videoplayer["a" /* default */], {
                  ref: function ref(c) {
                    return _this4.videoPlayer[index] = c;
                  },
                  eventBus: props.eventBus,
                  index: index,
                  item: item.video,
                  tag: tag,
                  videoId: props.videoId,
                  isMuted: true,
                  autoplay: index === activeProdVideoIdx,
                  handleVideoEvent: function handleVideoEvent() {},
                  hideControls: true,
                  eventData: eventData
                }),
                Object(preact_min["h"])(
                  'div',
                  { 'class': 'collections-video-footer' },
                  Object(preact_min["h"])(
                    'div',
                    { 'class': 'title' },
                    item.details.title
                  ),
                  Object(preact_min["h"])('div', { 'class': 'cta', style: { backgroundColor: item.details.color, color: colWhite ? 'black' : 'white' }, dangerouslySetInnerHTML: { __html: ctaLabel }, onClick: function onClick() {
                      return _this4.handleProdCtaClick(item);
                    } })
                )
              );
            })
          )
        ),
        isCollectionsVideo && collectionsVideos && Object(preact_min["h"])(
          'div',
          { 'class': 'collections-video-prod-thumb ' + (collectionsVideos.length > 5 ? 'scrollable' : '') },
          collectionsVideos.map(function (item, idx) {
            var itemImg = item && item.media && (item.media.img1_120 && !item.media.img1_120.toLowerCase().endsWith('.gif') ? item.media.img1_120 : item.media.img1_src);
            var col = item && item.details && item.details.color;
            return Object(preact_min["h"])(
              'div',
              { key: item && item.details && item.details.title, style: { backgroundColor: col }, 'class': idx === activeProdVideoIdx ? 'active' : '', onClick: function onClick() {
                  return _this4.handleActiveProdVideo(idx);
                } },
              itemImg ? Object(preact_min["h"])('img', { src: itemImg, alt: item && item.details && item.details.title }) : null
            );
          })
        )
      ),
      tag && this.meta && skinVersion === 'v1' && isProductShowcaseSkin && state.layoutEnabled && this.renderProductShowcase({ tag: tag, orientation: skinOrientation, tagParams: tagParams }),
      tag && this.meta && skinVersion === 'v1' && isMultiCtaSkin && state.layoutEnabled && this.renderMultiCta({ tag: tag, orientation: skinOrientation, tagParams: tagParams }),
      tag && this.meta && skinVersion === 'v2' && this.renderV2(color, title, cta),
      tagParams && enableSkinsV2 && this.renderTag(),
      Object(preact_min["h"])(
        'div',
        { 'class': 'activeSignalRuleValue', style: { transform: 'scale(' + window.innerWidth / 1008 + ')' } },
        activeSignalRuleValue && activeSignalRuleValue.map(function (item) {
          return Object(preact_min["h"])(
            'div',
            { id: 'rule_' + item.id, key: item.id },
            item.val
          );
        })
      ),
      state.brandBar ? Object(preact_min["h"])(
        'div',
        { 'class': 'brandbar' },
        Object(preact_min["h"])('div', { 'class': 'logo-placeholder', style: { background: 'url(' + logo + ')' } })
      ) : null,
      socialTag && cta && state.ctaValue && Object(preact_min["h"])(
        'div',
        { 'class': 'wt-social-cta', onClick: this.proxyClickHandler },
        cta
      ),
      this.state.showCustomEndCard && Object(preact_min["h"])(CustomEndCards, {
        cards: this.customEndCardsData.customEndCards,
        handleReplay: this.handleReplay,
        skinTag: true,
        keyIndex: 0,
        index: 0,
        tags: props.tags,
        json: props.json,
        updateMerchantData: props.updateMerchantData,
        isAd: props.isAd,
        adUnits: props.adUnits,
        adUnitsArgs: props.adUnitsArgs,
        adType: props.adType,
        adUnitSrv: props.adUnitSrv,
        creativeData: props.creativeData,
        initAd: props.initAd,
        lsCards: props.lsCards,
        eventBus: props.eventBus,
        decisionPointSelector: state.decisionPointSelector,
        ottRect: props.ottRect,
        videoId: props.videoId,
        videoWidth: props.videoWidth,
        videoHeight: props.videoHeight,
        isActiveSlide: true,
        isExpanded: true,
        isLandscape: props.orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE,
        isMobileDevice: props.isMobileDevice,
        editorMode: props.editorMode,
        orientation: props.orientation,
        template: props.json.template,
        toggleModal: props.toggleModal,
        activateTag: props.activateTag,
        deactivateTag: props.deactivateTag,
        getCurrentTime: props.getCurrentTime,
        destroyTag: props.destroyTag,
        logDataEvent: props.logDataEvent,
        logPollOption: props.logPollOption,
        fetchRedeemCode: props.fetchRedeemCode,
        isFacebookAd: props.isFacebookAd,
        mapsapi: props.mapsApiLoaded,
        handleChapterSelect: props.handleChapterSelect,
        trackEvent: props.trackEvent,
        noVideo: props.noVideo,
        forceStart: props.forceStart,
        decisionClose: props.decisionClose,
        postMessage: props.postMessage,
        dpTagActive: state.dpTagActive,
        setDecisionCloseFalse: props.setDecisionCloseFalse,
        handleAutoPauseException: props.handleAutoPauseException,
        shouldDeactivateTag: props.deactivateTag,
        renderLandscapeCards: props.renderLandscapeCards,
        setTagAutoInteraction: props.setTagAutoInteraction,
        setFullWidthOTT: props.setFullWidthOTT,
        tagAutoInteraction: props.tagAutoInteraction,
        hasDirectTag: props.hasDirectTag,
        updateJsonTag: props.updateJsonTag,
        pauseVideo: props.pauseVideo,
        playVideo: props.playVideo
      }),
      this.state.hotspotLinkedTag ? Object(preact_min["h"])(
        'div',
        { 'class': 'ottWrapper enable expand' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'ottContainer' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'ottTemplate' },
            Object(preact_min["h"])(
              'div',
              { 'class': 'passive-tag-container skin-passive-container' },
              Object(preact_min["h"])(playerLayout["a" /* default */], screenController__extends({}, props, { tags: props.json && props.json.otags, tag: this.state.hotspotLinkedTag, isDecisionInput: true, deactivateTag: this.deactivateHotspotTag, isExpanded: true, mapsapi: state.mapsApiLoaded }))
            )
          )
        )
      ) : null,
      this.state.progressOverlayImageLinkedTag ? Object(preact_min["h"])(
        'div',
        { 'class': 'ottWrapper enable expand' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'ottContainer' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'ottTemplate' },
            Object(preact_min["h"])(
              'div',
              { 'class': 'passive-tag-container skin-passive-container' },
              Object(preact_min["h"])(playerLayout["a" /* default */], screenController__extends({}, props, { tags: props.json && props.json.otags, tag: this.state.progressOverlayImageLinkedTag, isDecisionInput: true, deactivateTag: this.deactivateProgressOverlayImageTag, isExpanded: this.state.overlayImageLinkedTagIsExpanded, isActiveSlide: this.state.overlayImageLinkedTagIsActiveSlide, mapsapi: state.mapsApiLoaded }))
            )
          )
        )
      ) : null,
      this.state.skipDuration && props.isAd && Object(preact_min["h"])(
        'div',
        { onClick: enableSkip ? null : this.handleAdSkip, 'class': 'skip-ad-button ' + (enableSkip ? '' : 'enable') },
        enableSkip ? '' + (this.state.skipDuration - this.state.elapsedTime) : 'Skip Video'
      )
    );
  };

  ScreenController.prototype.initializeGoogleMaps = function initializeGoogleMaps() {
    var _this5 = this;

    if (!window.google && !window.mapsApiLoading) {
      window.mapsApiLoading = true;
      Object(helper["K" /* loadJS */])(components_config["d" /* links */].mapsapi, screenController_HEAD).then(function () {
        _this5.setState({
          mapsApiLoaded: true
        });
      });
    } else {
      this.setState({
        mapsApiLoaded: true
      });
    }
  };

  return ScreenController;
}(preact_min["Component"]), screenController__initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleAdSkip = function (e) {
    e && e.stopPropagation();
    window.vpaid && window.vpaid.stopAd();
  };

  this.setElapsedTime = function (elapsedTime) {
    if (_this6.state.skipDuration && _this6.props.isAd) {
      _this6.setState({ elapsedTime: Math.round(elapsedTime) });
    }
  };

  this.setVideoEnded = function (videoEnded) {
    _this6.setState({ videoEnded: videoEnded });
  };

  this.renderCollectionsMagazine = function () {
    var tag = _this6.state.tag;
    var details = tag && tag.details;
    var title = details && details.title;
    var attributes = tag && tag.details && tag.details.attributes;

    return Object(preact_min["h"])(
      'div',
      { 'class': 'collections-magazine' },
      Object(preact_min["h"])(
        'div',
        { 'class': 'collections-magazine__title block-ellipsis' },
        title
      ),
      Object(preact_min["h"])(magazineGallery_MagazineGallery, { items: attributes, onProdCtaClick: _this6.handleProdCtaClick, onProdInteraction: _this6.handleProdGalleryInteraction })
    );
  };

  this.renderMultiCta = function (_ref12) {
    var tag = _ref12.tag,
        orientation = _ref12.orientation,
        tagParams = _ref12.tagParams;

    return Object(preact_min["h"])(skinV3MultiCta_SkinV3MultiCta, {
      tag: tag,
      isExpanded: _this6.props.isExpanded,
      isActiveSlide: _this6.props.isActiveSlide,
      orientation: orientation,
      onCommerceCtaClick: _this6.proxyClickHandler,
      refreshSkinLayout: _this6.refreshSkinLayout,
      logDataEvent: _this6.props.logDataEvent,
      getCurrentTime: _this6.props.getCurrentTime,
      customTagParams: tagParams
    });
  };

  this.renderProductShowcase = function (_ref13) {
    var tag = _ref13.tag,
        orientation = _ref13.orientation,
        tagParams = _ref13.tagParams;

    return Object(preact_min["h"])(skinV3ProductShowcase_SkinV3ProductShowcase, {
      tag: tag,
      isExpanded: _this6.props.isExpanded,
      isActiveSlide: _this6.props.isActiveSlide,
      orientation: orientation,
      onCommerceCtaClick: _this6.proxyClickHandler,
      refreshSkinLayout: _this6.refreshSkinLayout,
      logDataEvent: _this6.props.logDataEvent,
      getCurrentTime: _this6.props.getCurrentTime,
      customTagParams: tagParams,
      meta: _this6.props.json.meta,
      config_data_json: _this6.props.json.config_data_json
    });
  };

  this.refreshSkinLayout = function (tag) {
    _this6.setState({ tag: tag }, function () {
      _this6.props.updateJsonTag(tag);
    });
  };

  this.renderSkinHotspots = function (skinHotspots) {
    return skinHotspots.length > 0 && Object(preact_min["h"])(
      'div',
      { 'class': 'hotspotsWrapper' },
      skinHotspots.length > 0
    );
  };

  this.renderV2 = function (color, title, cta) {
    if (_this6.state.isSocialShare) {
      return Object(preact_min["h"])(
        'div',
        { 'class': 'tag-details-wrapper tag-details-share ' + _this6.state.layout, style: { backgroundColor: color } },
        Object(preact_min["h"])(
          'div',
          { 'class': 'title', style: { color: color } },
          title
        ),
        Object(preact_min["h"])(socialShareIcons["a" /* default */], {
          tag: _this6.state.tag,
          eventBus: _this6.props.eventBus,
          getCurrentTime: _this6.props.getCurrentTime
        })
      );
    } else if (_this6.state.isSocialEmotion) {
      return Object(preact_min["h"])(
        'div',
        {
          'class': 'tag-details-wrapper tag-details-share emotion ' + _this6.state.layout + ' ' + (_this6.state.tag.emojiSelected ? 'hideEmotionSelection' : ''),
          style: { backgroundColor: color }
        },
        Object(preact_min["h"])(socialEmotionIcons["a" /* default */], {
          tag: _this6.state.tag,
          eventBus: _this6.props.eventBus,
          getCurrentTime: _this6.props.getCurrentTime,
          onEmotionIconClick: _this6.handleEmotionIconClick,
          trackEvent: _this6.props.trackEvent
        })
      );
    }

    return Object(preact_min["h"])(
      'div',
      { 'class': 'tag-details-wrapper ' + _this6.state.layout, style: { backgroundColor: color } },
      Object(preact_min["h"])(
        'h2',
        { 'class': 'tag-details-title' },
        title
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'tag-details-cta' },
        Object(preact_min["h"])(
          'button',
          { 'class': 'tag-details-cta-button', style: { background: color }, onClick: _this6.proxyClickHandler },
          cta
        ),
        _ref14
      )
    );
  };

  this.renderTag = function () {
    var props = _this6.props;
    var state = _this6.state;
    var hideCloseTagBtn = !!(props.isFacebookAd || props.noVideo || props.ottOnly) && !!props.deeplinkTagId;
    var tag = _this6.state.tag;
    var category = tag && tag.settings.category;
    var subcategory = category && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0].type;
    var layout = _this6.state.layoutEnabled ? _this6.state.layout : '';
    var expand = _this6.state.layoutEnabled ? 'expand' : '';

    var tagParams = _this6.tagParams && _this6.tagParams[tag && tag.id];
    var noBackground = tagParams && tagParams.transparent ? 'noBackground' : '';
    var darkTheme = tagParams && tagParams.theme === 'skins_dark_theme' ? 'darkTheme' : 'lightTheme';

    if (!_this6.state.tag || !_this6.state.image && tagParams && tagParams.skin_launch === 1) return;
    return Object(preact_min["h"])(
      'div',
      { 'class': 'ottDisplay ' + expand + ' ' + layout + ' ' + darkTheme + ' ' + noBackground + ' tag' + subcategory },
      Object(preact_min["h"])(playerLayout["a" /* default */], screenController__extends({}, props, {
        skinTag: true,
        keyIndex: 0,
        index: 0,
        tag: state.tag,
        tags: props.json && props.json.otags,
        decisionPointSelector: state.decisionPointSelector,
        isActiveSlide: true,
        isExpanded: true,
        isLandscape: props.orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE,
        template: props.json.template,
        hideCloseTagBtn: hideCloseTagBtn,
        mapsapi: props.mapsApiLoaded,
        shouldDeactivateTag: props.deactivateTag
      }))
    );
  };

  this.scratchReady = function () {
    console.log('READY');
    if (window.vpaid) {
      window.vpaid.on('AdStarted', function () {
        console.log('AD Started - scratch pause');
        setTimeout(function () {
          _this6.props.pauseVideo();
        }, 0);
      });
    } else {
      _this6.props.pauseVideo();
    }
  };

  this.scratchClickEvent = function () {
    _this6.props.eventBus(components_config["b" /* constants */].LOG_EVENT_CLICK_MANUAL, {
      current_duration: _this6.props.getCurrentTime(),
      options: { event_type: 'scratch' }
    });
  };

  this.scratchStart = function () {
    // clearTimeout(this.scratchTimeout);
  };

  this.scratchDone = function () {
    _this6.setState({ unloadScratch: true }, function () {
      _this6.props.playVideo();
    });
  };

  this.toggleCustomEndcards = function (value) {
    _this6.setState({ showCustomEndCard: typeof value === 'boolean' ? value : !_this6.state.showCustomEndCard });
  };

  this.toggleProgressOverlayImageLinkedTag = function (value) {
    _this6.setState({ progressOverlayImageLinkedTag: value }, function () {
      setTimeout(function () {
        var storeLocatorInTags = _this6.props.json.tags.find(function (item) {
          return item.settings.category === 11;
        });
        var storeLocatorInOtags = _this6.props.json.otags.find(function (item) {
          return item.settings.category === 11;
        });
        var isStoreLocatorPresent = storeLocatorInTags || storeLocatorInOtags;
        if (isStoreLocatorPresent) {
          _this6.setState({ overlayImageLinkedTagIsExpanded: true, overlayImageLinkedTagIsActiveSlide: true });
          _this6.initializeGoogleMaps();
        }
      }, 300);
    });
  };

  this.handleReplay = function () {
    _this6.toggleCustomEndcards();
    _this6.props.screenReplay();
  };

  this.triggerSkinLayout = function (tagIndex, tag) {
    var layoutEnabled = void 0;

    if (_this6.meta.skins) {
      if (_this6.meta && (_this6.meta.skin_launch === 1 || _this6.meta.skin_launch === 2)) {
        if (_this6.state.layoutEnabled && typeof tag === 'undefined') {
          layoutEnabled = true;
          _this6.setState({
            layoutEnabled: layoutEnabled
          });

          return;
        } else if (!_this6.state.layoutEnabled && typeof tag === 'undefined' || tag === null) {
          layoutEnabled = false;
        } else if (_this6.state.layoutEnabled && typeof tag !== 'undefined' && tag !== null) {
          layoutEnabled = true;
        }
      } else {
        layoutEnabled = tag !== null && typeof tag !== 'undefined';

        if (!_this6.state.startedToPlay) {
          _this6.setState({
            startedToPlay: true
          });
        }
      }

      if (typeof tag !== 'undefined' && tag.tag_enabled) {
        _this6.setLayoutProps(tag, tagIndex, layoutEnabled);
        _this6.fireSkinDisplayEvent();
      }
    }
  };

  this.triggerSkinLayoutV2 = function (tagIndex, tag) {
    var layoutEnabled = void 0;
    var tagParams = _this6.tagParams[tag && tag.id];
    if (!tagParams || _this6.state.closeSkinMode) {
      _this6.setState({
        layoutEnabled: false
      });
      return;
    }

    if (_this6.meta.skins) {
      if (tagParams && (tagParams.skin_launch === 1 || tagParams.skin_launch === 2)) {
        if (_this6.state.layoutEnabled && typeof tag === 'undefined') {
          layoutEnabled = true;
          _this6.setState({
            layoutEnabled: layoutEnabled
          });

          return;
        } else if (!_this6.state.layoutEnabled && typeof tag === 'undefined' || tag === null) {
          layoutEnabled = false;
        } else if (_this6.state.layoutEnabled && typeof tag !== 'undefined' && tag !== null) {
          layoutEnabled = true;
        }
      } else {
        layoutEnabled = tag !== null && typeof tag !== 'undefined';

        if (!_this6.state.startedToPlay) {
          _this6.setState({
            startedToPlay: true
          });
        }
      }

      if (typeof tag !== 'undefined' && tag.tag_enabled) {
        _this6.setLayoutProps(tag, tagIndex, layoutEnabled);
        _this6.fireSkinDisplayEvent();
      }
    }
  };

  this.setLayoutProps = function (tag, tagIndex, layoutEnabled) {
    var subcategory = tag && tag.settings.subcategory && tag.settings.subcategory[0];
    var isShowcase = subcategory && (subcategory.type === 1401 || subcategory.type === 1403);
    var isSocialShare = subcategory && subcategory.type === 1601;
    var isSocialEmotion = subcategory && subcategory.type === 1602;
    var engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
    var images = isShowcase ? engagement && engagement.meta : tag && tag.media.images;
    var imageCount = isShowcase ? images.length : _this6.getImageCount(images);
    var image = tag && _this6.getImage(_this6.props.orientation);
    var settingsEngagement = subcategory && subcategory.engagements && subcategory.engagements[0];
    var cta = settingsEngagement && settingsEngagement['label|' + settingsEngagement.slug];
    var ctaValue = settingsEngagement && settingsEngagement['value|' + settingsEngagement.slug];

    var updatedTimeStamp = tag && tag.updatedTagData && tag.updatedTagData.timeStamp;
    var currTimeStamp = _this6.state.tag && _this6.state.tag.updatedTagData && _this6.state.tag.updatedTagData.timeStamp;

    if (layoutEnabled !== _this6.state.layoutEnabled || tagIndex !== _this6.state.tagIndex || (tag && tag.id) !== (_this6.state.tag && _this6.state.tag.id) || image !== _this6.state.image || updatedTimeStamp && updatedTimeStamp !== currTimeStamp && updatedTimeStamp > currTimeStamp) {
      _this6.setState({
        layoutEnabled: layoutEnabled,
        tagIndex: tagIndex,
        tag: tag,
        isShowcase: isShowcase,
        isSocialShare: isSocialShare,
        isSocialEmotion: isSocialEmotion,
        engagement: engagement,
        images: images,
        imageCount: imageCount,
        image: image,
        cta: cta,
        ctaValue: ctaValue
      });
    }
  };

  this.setTranslate = function (prevState) {
    if (prevState && _this6.state.layoutEnabled === prevState.layoutEnabled) return;
    if (_this6.state.layoutEnabled) {
      _this6.setState({
        scaleOut: true
      }, function () {
        setTimeout(function () {
          _this6.swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(-60deg)';
        }, 500);
      });
    } else {
      _this6.setState({
        scaleOut: false
      }, function () {
        _this6.swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg)';
      });
    }
  };

  this.handleImageClick = function (e) {
    var target = e.target;
    var isScreenController = target.classList.contains('screenControllerBg');
    if (isScreenController) {
      _this6.proxyClickHandler(e);
    }

    return false;
  };

  this.setTagInScreenController = function (tag) {
    var subcategory = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
    var collectionsVideoActiveIdxMap = screenController__extends({}, _this6.state.collectionsVideoActiveIdxMap || {});
    var isCollectionsVideo = subcategory && subcategory.type === 107;
    if (isCollectionsVideo && collectionsVideoActiveIdxMap[tag.id] === undefined) {
      collectionsVideoActiveIdxMap[tag.id] = 0;
    }
    if (isCollectionsVideo) {
      _this6.setState({ tag: tag, collectionsVideoActiveIdxMap: collectionsVideoActiveIdxMap });
    }
  };

  this.handleActiveProdVideo = function (idx) {
    var _extends2;

    var tag = _this6.state.tag;
    var tagid = tag && tag.id;
    if (!tagid) {
      return;
    }
    var syncVideos = tag && tag.details && tag.details.productImageTypePreview;
    var prevIdx = _this6.state.collectionsVideoActiveIdxMap[tagid];
    _this6.setState({
      collectionsVideoActiveIdxMap: screenController__extends({}, _this6.state.collectionsVideoActiveIdxMap, (_extends2 = {}, _extends2[tagid] = idx, _extends2))
    }, function () {
      var currentTime = 0;
      if (typeof prevIdx === 'number') {
        currentTime = _this6.videoPlayer[prevIdx].getCurrentTime();
      }
      _this6.videoPlayer.forEach(function (item) {
        item.pause();
      });
      if (syncVideos) {
        _this6.videoPlayer[idx].setCurrentTime(currentTime);
      }
      _this6.videoPlayer[idx].play();
    });
  };

  this.handleProdCtaClick = function (item) {
    var link = item && item.details && item.details.cta;
    var ctaTrackers = item && item.details && item.details.ctaTracker || '';
    ctaTrackers = ctaTrackers.split('||');
    if (ctaTrackers.length > 0) {
      ctaTrackers.forEach(function (tracker) {
        if (tracker) {
          Object(helper["c" /* addPixelImage */])(tracker);
        }
      });
    }
    window.open(link, '_blank');
    _this6.fireOutVideoEvent({
      event_type: 'collection_product',
      engagement_id: item && item.id,
      engagement_label: item && item.details && item.details.title
    });
  };

  this.handleProdGalleryInteraction = function (product) {
    var tag_label = product && product.details && product.details.title;
    var engagement_id = product && product.id;
    var engagement_data = Object(helper["M" /* parseJsonToFormData */])({ product_id: engagement_id, product_label: tag_label });
    _this6.props.eventBus(components_config["b" /* constants */].LOG_EVENT_GALLERY_INTERACTION, {
      tag: _this6.props.tag,
      duration: _this6.props.getCurrentTime(),
      event_type: 'collection_product',
      engagement_data: engagement_data,
      engagement_id: engagement_id,
      tag_label: tag_label,
      engagement_label: tag_label
    });
  };

  this.handlePlay = function (tagIndex, tag, e) {
    _this6.setState({
      startedToPlay: true
    });

    setTimeout(function () {
      if (_this6.meta.skins) {
        _this6.setLayoutProps(tag, tagIndex, true);
        _this6.fireSkinDisplayEvent();
      }
    }, _this6.meta.skin_launch === 1 ? 0 : 4000);
  };

  this.setSquareVideo = function (isSquareVideo) {
    _this6.setState({
      isSquareVideo: isSquareVideo
    }, function () {
      _this6.props.setSquareVideo(isSquareVideo);
    });
  };

  this.handleShowcaseLink = function (item, e) {
    if (item.ctaUrl && item.ctaUrl !== '') {
      var url = item.ctaUrl;

      if (!/^(http|https):\/\//.test(url)) {
        url = 'http://' + url;
      }

      // window.open(url, '_blank');
      // OneAd clickThru---
      Object(helper["B" /* handleExternalLinksViaClickThru */])(url, _this6.props.creativeData);
      //---
      _this6.fireOutVideoEvent();
    } else _this6.proxyClickHandler.call(_this6, e);
  };

  this.handleGoBackToVideo = function (e) {
    _this6.setState({
      disableAnimation: true
    }, function () {
      _this6.swiper && _this6.swiper.slideTo(0, 0.1);
      _this6.setState({
        disableAnimation: false
      });
    });
  };

  this.handleEmotionIconClick = function (tag, emojiSelected) {
    // this.setState({ emojiSelected: { ...this.state.emojiSelected, [tag.id]: emojiSelected } });
    var updatedTag = screenController__extends({}, tag, { emojiSelected: emojiSelected });
    _this6.props.updateJsonTag(updatedTag);
  };

  this.proxyClickHandler = function (e) {
    var eventData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (e) e.stopPropagation();

    var tag = _this6.state.tag;
    var tagParams = _this6.tagParams && _this6.tagParams[tag && tag.id];
    var isSkinsV2 = tagParams && tagParams.skin_version === 'v4';

    if (isSkinsV2) return;

    if (typeof tag !== 'undefined') {
      var category = tag.settings.category;
      var subcategory = tag.settings.subcategory && tag.settings.subcategory[0];

      switch (category) {
        case 1:
        case 7:
        case 8:
        case 10:
        case 16:
          // handle out-video tags
          var engagement = subcategory.engagements && subcategory.engagements[0];
          var url = engagement && engagement['value|' + engagement.slug];

          if (category === 10) {
            var playStoreLink = engagement && engagement['linkplaystore|' + engagement.slug];
            var appStoreLink = engagement && engagement['linkappstore|' + engagement.slug];
            var deviceType = Object(helper["t" /* getMobileOS */])();

            if (deviceType === 'Android' && playStoreLink) url = playStoreLink;else if (deviceType === 'iOS' && appStoreLink) url = appStoreLink;
          }

          if (!/^(http|https):\/\//.test(url)) {
            url = 'http://' + url;
          }

          // window.open(url, '_blank');
          // OneAd clickThru---
          Object(helper["B" /* handleExternalLinksViaClickThru */])(url, _this6.props.creativeData);
          //---
          _this6.fireOutVideoEvent(eventData);
          return false;

        case 9:
        case 11:
        case 12:
        case 14:
        case 15:
          // handle in-video tags
          _this6.props.renderTag(_this6.state.tagIndex);
          _this6.fireInVideoEvent();
      }
    }
  };

  this.getImageFromTag = function (tag, orientation) {
    var isLandscape = orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE;
    if (tag && tag.media && tag.media.images) {
      var img1 = Object(helper["q" /* getLinkedTagImage */])({ images: tag.media.images }, 'img1', null, null, true);
      var img2 = Object(helper["q" /* getLinkedTagImage */])({ images: tag.media.images }, 'img2', null, null, true);
      return tag && (isLandscape ? img1 : typeof img2 !== 'undefined' ? img2 : img1);
    }
  };

  this.getImage = function (orientation, attrTag) {
    var tag = attrTag || _this6.state.tag;
    if (tag) {
      var subcategory = tag && tag.settings.subcategory && tag.settings.subcategory[0];
      switch (tag.settings.category) {
        case 1:
        case 7:
        case 8:
        case 10:
        case 11:
        case 12:
        case 15:
        case 16:
        case 18:
        case 19:
        case 20:
          return _this6.getImageFromTag(tag, orientation);
        case 9:
          switch (subcategory.type) {
            case 900:
              var engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
              var answers = engagement && engagement && engagement.answer;
              if (engagement && engagement.imagepoll) {
                return answers && answers[0].image;
              } else return _this6.getImageFromTag(tag, orientation);
            case 901:
            case 902:
            case 904:
            case 905:
            case 906:
              return _this6.getImageFromTag(tag, orientation);
          }
        case 14:
          switch (subcategory.type) {
            case 1402:
              return _this6.getImageFromTag(tag, orientation);
            case 1401:
            case 1403:
              var _engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
              var firstGallaryElem = _engagement.meta && _engagement.meta[0];
              if (firstGallaryElem) {
                return firstGallaryElem.cover_image_selected || firstGallaryElem.url;
              }
          }
        case 21:
          switch (subcategory.type) {
            case 2104:
              var _engagement2 = tag.details && tag.details.engagements && tag.details.engagements[0];
              var _answers = _engagement2 && _engagement2 && _engagement2.answer;
              if (_engagement2 && _engagement2.imagepoll) {
                return _answers && _answers[0].image;
              } else return _this6.getImageFromTag(tag, orientation);
            case 2101:
            case 2102:
            case 2103:
              return _this6.getImageFromTag(tag, orientation);
          }
      }
    }
  };

  this.getImageCount = function () {
    var imagesArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var i = 1;
    var count = 0;

    while (imagesArr && imagesArr['img' + i + '_src']) {
      count = i;
      i++;
    }

    return count;
  };

  this.getImageIndex = function (images, index) {
    if (_this6.state.isShowcase) {
      var tag = _this6.state.tag;
      var meta = tag && tag.details.engagements && tag.details.engagements[0] && tag.details.engagements[0].meta;
      return meta[index];
    } else {
      return Object(helper["q" /* getLinkedTagImage */])({ images: images }, 'img' + (index + 1), null, null, true) || images['img' + (index + 1) + '_src'];
    }
  };

  this.getSkinLayout = function () {
    var tag = _this6.state.tag;
    var tagParams = tag && _this6.tagParams[tag.id];
    var skinVersion = tagParams && tagParams.skin_version;
    var skinOrientation = _this6.meta && _this6.meta.skin_orientation;

    var customProportions = tagParams && tagParams.config && tagParams.config.customProportions && tagParams.config.customProportions;
    if (customProportions && customProportions.isEnabled) {
      var scaledWidth = customProportions.width / customProportions.containerWidth * window.innerWidth + 'px';
      var scaledHeight = customProportions.height / customProportions.containerHeight * window.innerHeight + 'px';
      var movementFromLeft = window.innerWidth / customProportions.containerWidth * customProportions.x;
      var movementFromTop = window.innerHeight / customProportions.containerHeight * customProportions.y;
      if (customProportions.width / customProportions.containerWidth >= 0.99) scaledWidth = '100%';
      if (customProportions.height / customProportions.containerHeight >= 0.99) scaledHeight = '100%';
      _this6.screenHandleRef.style.setProperty('--custom-proportions-width', '' + (scaledWidth || '100%'));
      _this6.screenHandleRef.style.setProperty('--custom-proportions-height', '' + (scaledHeight || '100%'));
      _this6.screenHandleRef.style.setProperty('--custom-proportions-left', (movementFromLeft || 0) + 'px');
      _this6.screenHandleRef.style.setProperty('--custom-proportions-top', (movementFromTop || 0) + 'px');
      return 'skinHasCustomProportions';
    }

    if (_this6.meta) {
      if (skinVersion === 'v3') return 'skincube';
      switch (skinOrientation) {
        case 'left':
          return 'skinLt';
        case 'right':
          return 'skinRt';
        case 'center':
          return 'skinCt';
        case 'top':
          return 'skinTp';
        case 'bottom':
          return 'skinBtm';
      }
    } else return null;
  };

  this.getSkinConnectedAssetsLayoutClasses = function (videoSize, forVideo) {
    var skinOrientation = _this6.meta && _this6.meta.skin_orientation;
    var assetsLayoutClass = '';
    var connVidClass = '';
    if (_this6.meta) {
      switch (skinOrientation) {
        case 'left':
          assetsLayoutClass = 'skinConnAstsRight';
          connVidClass = 'connVidLt';
          break;
        case 'right':
          assetsLayoutClass = 'skinConnAstsLeft';
          connVidClass = 'connVidRt';
          break;
        // case 'center':
        //   assetsLayoutClass = 'skinCt';
        //   break;
        case 'top':
          assetsLayoutClass = 'skinConnAstsBtm';
          connVidClass = 'connVidTop';
          break;
        case 'bottom':
          assetsLayoutClass = 'skinConnAstsTop';
          connVidClass = 'connVidBtm';
          break;
      }
    }

    var assetsGridSizeClass = '2by2';
    var vidSizeClass = '';
    if (videoSize === 'small') {
      vidSizeClass = 'vidSizeSmall';
    } else if (videoSize === 'medium') {
      vidSizeClass = 'vidSizeMedium';
    } else if (videoSize === 'large') {
      vidSizeClass = 'vidSizeLarge';
      assetsGridSizeClass = '1by1';
    }

    if (forVideo) return ' ' + connVidClass + ' ' + vidSizeClass + ' ';

    return ' ' + assetsLayoutClass + ' ' + (videoSize + assetsGridSizeClass) + ' ';
  };

  this.getSkinSliderLayoutClasses = function (videoSize) {
    var skinOrientation = _this6.meta && _this6.meta.skin_orientation;
    var skinSliderClass = '';
    var connVidClass = '';
    if (_this6.meta) {
      switch (skinOrientation) {
        case 'left':
          skinSliderClass = 'skinSliderInRight';
          break;
        case 'right':
          skinSliderClass = 'skinSliderInLeft';
          break;
      }
    }

    var vidSizeClass = '';
    if (videoSize === 'small') {
      vidSizeClass = 'vidSizeSmall';
    } else if (videoSize === 'medium') {
      vidSizeClass = 'vidSizeMedium';
    } else if (videoSize === 'large') {
      vidSizeClass = 'vidSizeLarge';
    }

    return ' ' + skinSliderClass + ' ' + vidSizeClass + ' ';
  };

  this.handleSkinConnectedAssetClick = function (type, sourceCat, id) {
    var cltTracker = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    if (type === 'video' && sourceCat === 15 && id) {
      _this6.props.pauseVideo();
      _this6.setState({ initializeConnectedVideo: id }, function () {
        var cltTrackers = cltTracker.split('||');
        if (cltTrackers.length > 0) {
          cltTrackers.forEach(function (tracker) {
            if (tracker) {
              Object(helper["c" /* addPixelImage */])(tracker);
            }
          });
        }
      });
    }
  };

  this.handleSkinConnectedAssetClose = function () {
    _this6.setState({ initializeConnectedVideo: null });
  };

  this.initializeSlider = function () {
    _this6.swiper = new Swiper(_this6.swiperContainer, {
      speed: 100,
      effect: 'cube',
      grabCursor: true,
      virtualTranslate: true,
      cubeEffect: {
        shadow: false,
        slideShadows: false
      },
      navigation: {
        nextEl: _this6.swiperNaviRight,
        prevEl: _this6.swiperNaviLeft
      },
      on: {
        touchMove: function touchMove(event) {
          _this6.setState({
            scaleOut: true
          });
        },
        touchEnd: function touchEnd(event) {
          _this6.setState({
            scaleOut: false
          });
        },

        slideChange: function slideChange(event) {
          if (_this6.state.images && _this6.state.images.length > 0) {
            var nonVideoPlayerItems = 1; // 1, 'cause first slide is the main video
            for (var i = 0; i < _this6.state.images.length; i++) {
              var item = _this6.state.images[i];
              if (item.type !== 'video') {
                nonVideoPlayerItems++;
                continue;
              }

              _this6.videoPlayer.forEach(function (item, index) {
                item.pause();
              });
              if (_this6.videoPlayer[_this6.swiper.activeIndex - nonVideoPlayerItems]) {
                _this6.videoPlayer[_this6.swiper.activeIndex - nonVideoPlayerItems].play();
              }
            }
          }
          if (_this6.swiper.activeIndex === 0) {
            _this6.props.playVideo();
            _this6.setState({
              activeIndex: _this6.swiper.activeIndex,
              enableLoopBack: false
            });
          } else {
            _this6.props.pauseVideo();
            _this6.setState({
              activeIndex: _this6.swiper.activeIndex,
              enableLoopBack: false
            });
          }
        }
      }
    });
  };

  this.prevSlide = function () {
    _this6.setState({
      scaleOut: true
    }, function () {
      setTimeout(function () {
        setTimeout(function () {
          _this6.setState({
            scaleOut: false
          });
        }, 400);

        _this6.toggleLoopBack();
        _this6.fireClickEvent();
      }, 100);
    });
  };

  this.nextSlide = function (e) {
    _this6.setState({
      scaleOut: true
    }, function () {
      setTimeout(function () {
        setTimeout(function () {
          _this6.setState({
            scaleOut: false
          });
        }, 400);

        if (_this6.state.enableLoopBack) {
          _this6.swiper.slideTo(0);
        }

        _this6.toggleLoopBack();
        _this6.fireClickEvent();
      }, 100);
    });
  };

  this.toggleLoopBack = function () {
    if (_this6.swiper.activeIndex + 1 === _this6.swiper.slides.length) {
      _this6.setState({
        enableLoopBack: true
      });
    } else {
      _this6.setState({
        enableLoopBack: false
      });
    }
  };

  this.fireClickEvent = function () {
    var tag = _this6.state.tag;
    var clickEvent = components_config["b" /* constants */].LOG_EVENT_CLICK_MANUAL;

    _this6.props.eventBus(clickEvent, {
      tag: tag,
      current_duration: _this6.props.getCurrentTime()
    });
  };

  this.fireOutVideoEvent = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var linkedTag = arguments[1];

    var tag = _this6.state.tag;
    if (!tag && linkedTag) tag = linkedTag;

    _this6.props.eventBus(components_config["b" /* constants */].LOG_EVENT_ENGAGEMENT, { tag: tag, engagement_type: 'out-video', options: options });
    _this6.props.eventBus(components_config["b" /* constants */].LOG_EVENT_INTERACTION, {
      tag: tag,
      current_duration: _this6.props.getCurrentTime()
    });
  };

  this.fireInVideoEvent = function (linkedTag) {
    var tag = _this6.state.tag;
    if (!tag && linkedTag) tag = linkedTag;

    _this6.props.eventBus(components_config["b" /* constants */].LOG_EVENT_INTERACTION, {
      tag: tag,
      current_duration: _this6.props.getCurrentTime()
    });
  };

  this.fireSkinDisplayEvent = function () {
    var tag = _this6.state.tag;
    var tagParams = _this6.tagParams && _this6.tagParams[tag && tag.id];
    var skin_version = tagParams && tagParams.skin_version;
    var skin_launch = tagParams && tagParams.skin_launch;

    if (tag && !_this6.skinmap.tags[tag.id]) {
      _this6.props.logDataEvent({
        event: 'display',
        event_type: 'skin:' + _this6.skinmap[skin_version] + ':' + _this6.skinmap['launch' + skin_launch],
        tag_id: tag && tag.id,
        tag_label: tag && tag.details.preview_title || tag.details.title || ''
      });

      _this6.skinmap.tags[tag.id] = true;
    }
  };

  this.disableSkinMode = function () {
    _this6.setState({
      closeSkinMode: true,
      layoutEnabled: false
    });
  };

  this.handleSkinHotspotClick = function (item) {
    var url = item.url,
        tracker = item.tracker,
        id = item.id,
        title = item.title,
        isTagConnected = item.isTagConnected,
        tagId = item.tagId;
    var enableOnSkinSlider = item.enableOnSkinSlider,
        onSkinSliderImage = item.onSkinSliderImage;

    if (isTagConnected) {
      var currTagIdx = tagId && _this6.props.json.otags.findIndex(function (t) {
        return t.id === tagId;
      });
      var selectedTag = _this6.props.json.otags[currTagIdx];
      if (selectedTag) {
        _this6.setState({ hotspotLinkedTag: selectedTag }, function () {
          if (!Object(helper["H" /* isSkipEnabled */])(selectedTag, _this6.props.creativeData)) {

            setTimeout(function () {
              var storeLocatorInTags = _this6.props.json.tags.find(function (item) {
                return item.settings.category === 11;
              });
              var storeLocatorInOtags = _this6.props.json.otags.find(function (item) {
                return item.settings.category === 11;
              });
              var isStoreLocatorPresent = storeLocatorInTags || storeLocatorInOtags;
              if (isStoreLocatorPresent) {
                _this6.initializeGoogleMaps();
              }
            }, 300);

            _this6.fireInVideoEvent();
            _this6.props.pauseVideo();
          } else {
            var network = _this6.props.creativeData && _this6.props.creativeData.network;
            var clickThru = network && components_config["b" /* constants */].CLICKTHRU_NETWORKS.includes(network);
            if (!clickThru) {
              _this6.fireOutVideoEvent({
                event_type: 'skinhotspot',
                engagement_id: id,
                engagement_label: title
              });
            }
          }
        });
      }
    } else if (enableOnSkinSlider && Object.keys(onSkinSliderImage).length > 0) {
      _this6.setState({
        animateInSkinSliderId: id
      });
      _this6.fireInVideoEvent();
    } else {
      // window.open(url, "_blank");
      // OneAd clickThru---
      Object(helper["B" /* handleExternalLinksViaClickThru */])(url, _this6.props.creativeData);
      //---
      var network = _this6.props.creativeData && _this6.props.creativeData.network;
      var clickThru = network && components_config["b" /* constants */].CLICKTHRU_NETWORKS.includes(network);
      if (!clickThru) {
        _this6.fireOutVideoEvent({
          event_type: 'skinhotspot',
          engagement_id: id,
          engagement_label: title
        });
      }
    }
    if (tracker) {
      Object(helper["c" /* addPixelImage */])(tracker);
    }
  };

  this.handleSkinSliderClick = function (_ref15) {
    var url = _ref15.onSkinSliderCtaLink,
        id = _ref15.id,
        title = _ref15.title;

    // OneAd clickThru---
    Object(helper["B" /* handleExternalLinksViaClickThru */])(url, _this6.props.creativeData);
    //---
    _this6.fireOutVideoEvent({
      event_type: 'skinhotspot',
      engagement_id: id,
      engagement_label: title
    });
  };

  this.handleSkinSliderCloseClick = function (e) {
    e && e.stopPropagation();
    _this6.setState({
      animateInSkinSliderId: 0
    });
  };

  this.deactivateHotspotTag = function (e) {
    e && e.stopPropagation();
    _this6.setState({ hotspotLinkedTag: null });
    _this6.props.deactivateTag();
  };

  this.deactivateProgressOverlayImageTag = function (e) {
    e && e.stopPropagation();
    _this6.setState({ progressOverlayImageLinkedTag: null, overlayImageLinkedTagIsExpanded: false, overlayImageLinkedTagIsActiveSlide: false, mapsApiLoaded: false });
    _this6.props.deactivateTag();
  };

  this.destroySliderTile = function () {
    if (_this6.swiperTile) {
      _this6.swiperTile.off('slideChangeTransitionEnd', _this6.handleTileSlideChange);
      _this6.swiperTile.destroy();
    }
  };

  this.initializeSliderTile = function () {
    if (_this6.state.swiperJsTile && _this6.swiperContainerTile) {
      _this6.destroySliderTile();

      _this6.swiperTile = new Swiper(_this6.swiperContainerTile, {
        speed: 100,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        noSwiping: true,
        allowTouchMove: false
      });
      _this6.swiperTile.on('slideChangeTransitionEnd', _this6.handleTileSlideChange);
      _this6.setSliderArrows();
      _this6.setTileDimensionClass();
      _this6.setState({ currentTileIndex: 0 }, function () {
        _this6.swiperTile && _this6.swiperTile.slideTo(_this6.state.currentTileIndex);
      });
    }
  };

  this.toggleTileProducts = function (show, tag, tileProducts) {
    if (!show && !_this6.state.showTileProducts) return;
    _this6.setState({
      showTileProducts: !!show,
      tileProducts: tileProducts,
      tileLinkedTag: tag,
      animateInTiles: '',
      animateScreenShrink: !!show
    }, function () {
      if (_this6.state.showTileProducts) {
        // hides tag preview in mobile mode, via player/index.js
        _this6.props.tileModeStatus(true);

        _this6.initializeSliderTile();
        if (Object(helper["E" /* isMiniature */])()) {
          _this6.props.pauseVideo();
          _this6.setState({ currentTileIndex: 1 }, function () {
            _this6.swiperTile && _this6.swiperTile.slideTo(_this6.state.currentTileIndex);
          });
        }

        // animate tiles entry from below
        setTimeout(function () {
          _this6.setState({ animateInTiles: 'animateInTiles' });
          if (_this6.props.isMobileDevice && _this6.props.orientation === components_config["b" /* constants */].ORIENTATION_PORTRAIT) {
            // for mobile devices, calculate tile height
            var screenWrapperElement = _this6.swiperWrapperTile && _this6.swiperWrapperTile.querySelector('.screenWrapper');
            if (screenWrapperElement && _this6.props.videoWidth > _this6.props.videoHeight) {
              _this6.setState({ slideTileHeight: screenWrapperElement.offsetHeight });
            }
          }
        }, 200);

        // animate screen shrink to it's position
        setTimeout(function () {
          _this6.setState({ animateScreenShrink: false });
        }, 900);
        _this6.setTileDimensionClass();
      } else {
        _this6.destroySliderTile();
        _this6.props.tileModeStatus(false);
        _this6.setState({ animateScreenShrink: false });
      }
    });
  };

  this.setTileDimensionClass = function () {
    // this.state.tileDimensionClass
    // only in a vertical video in mobile size, would the scroll be vertical, else horizontal always
    var playerIsAtEmbedSize = Object(helper["E" /* isMiniature */])();
    if (playerIsAtEmbedSize) {
      _this6.setState({ tileDimensionClass: 'tile1By1' });
      // player would need horizontal scroll via swiper
    } else {
      // 2by2
      _this6.setState({ tileDimensionClass: 'tile2By2' });
    }
  };

  this.handleTileClick = function (e) {
    var id = e && e.target && e.target.id;
    var prodId = Number(id.split('_')[0]);
    var selectedProd = _this6.state.tileLinkedTag && _this6.state.tileLinkedTag.details && _this6.state.tileLinkedTag.details.attributes && _this6.state.tileLinkedTag.details.attributes.length > 0 && _this6.state.tileLinkedTag.details.attributes.filter(function (p) {
      return p.id === prodId;
    });
    if (selectedProd && selectedProd.length > 0) selectedProd = selectedProd[0];
    if (selectedProd && selectedProd.details && selectedProd.details.skipDetails) {
      var url = selectedProd.details.cta;

      if (!/^(http|https):\/\//.test(url)) {
        url = 'http://' + url;
      }

      // window.open(url, '_blank');
      // OneAd clickThru---
      Object(helper["B" /* handleExternalLinksViaClickThru */])(url, _this6.props.creativeData);
      //---
      _this6.fireOutVideoEvent({
        event_type: 'collection_product',
        engagement_id: selectedProd.id,
        engagement_label: selectedProd.details.title
      }, _this6.state.tileLinkedTag);
      return;
    }
    var updatedTag = screenController__extends({}, _this6.state.tileLinkedTag, {
      selectedProdIndex: Number(id.split('_')[1]) || 0
    });
    _this6.props.updateJsonTag(updatedTag);
    var toggleLock = false;
    if (_this6.state.editorMode) toggleLock = true;
    var currTagIdx = updatedTag && updatedTag.id && _this6.props.json.otags.findIndex(function (t) {
      return t.id === updatedTag.id;
    });

    var tag_label = selectedProd && selectedProd.details && selectedProd.details.title;
    var engagement_id = selectedProd && selectedProd.id;
    var engagement_data = Object(helper["M" /* parseJsonToFormData */])({ product_id: engagement_id, product_label: tag_label });

    var eventData = {
      tag: _this6.state.tileLinkedTag,
      current_duration: _this6.props.getCurrentTime(),
      engagement_data: engagement_data
    };
    _this6.props.eventBus(components_config["b" /* constants */].LOG_EVENT_INTERACTION, eventData);

    // this.fireInVideoEvent(this.state.tileLinkedTag);
    _this6.props.renderTag(currTagIdx, toggleLock, true);
  };

  this.nextTileGroup = function (e) {
    _this6.setState({ currentTileIndex: _this6.state.currentTileIndex + 1 }, function () {
      _this6.swiperTile && _this6.swiperTile.slideTo(_this6.state.currentTileIndex);
    });
    e && e.stopPropagation();
  };

  this.prevTileGroup = function (e) {
    _this6.setState({ currentTileIndex: _this6.state.currentTileIndex - 1 }, function () {
      _this6.swiperTile && _this6.swiperTile.slideTo(_this6.state.currentTileIndex);
    });
    e && e.stopPropagation();
  };

  this.setSliderArrows = function () {
    if (_this6.swiperTile) {
      var _swiperTile = _this6.swiperTile,
          isEnd = _swiperTile.isEnd,
          isBeginning = _swiperTile.isBeginning;

      _this6.setState({
        isBeginningTile: isBeginning,
        isEndTile: isEnd
      }, function () {
        setTimeout(function () {
          _this6.setState({ animateTileNav: true });
        }, 500);
      });
    }
  };

  this.handleTileSlideChange = function (e) {
    e && e.stopPropagation();
    _this6.setSliderArrows();
  };

  this.handleResize = function () {
    _this6.initializeSliderTile();
  };

  this.isTileThemeEnabled = function (tags) {
    var isTileThemeEnabled = false;
    if (tags && tags.length > 0) {
      for (var i = 0; i < tags.length; i++) {
        var tag = tags[i];
        isTileThemeEnabled = tag && tag.details && tag.details.customTheme === 'tiles';
        if (isTileThemeEnabled) break;
      }
    }
    return isTileThemeEnabled;
  };

  this.handleCustomProportionsWhenResize = function () {
    _this6.setState({
      layout: _this6.getSkinLayout()
    });
  };
}, screenController__temp);

// EXTERNAL MODULE: ./components/spareparts/modal/style.less
var modal_style = __webpack_require__("ipN0");
var modal_style_default = /*#__PURE__*/__webpack_require__.n(modal_style);

// CONCATENATED MODULE: ./components/spareparts/modal/index.js


function modal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function modal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function modal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var modal__ref = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-close' });

var modal_OTT = function (_Component) {
	modal__inherits(OTT, _Component);

	function OTT() {
		modal__classCallCheck(this, OTT);

		return modal__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	OTT.prototype.render = function render(props, state) {
		return Object(preact_min["h"])(
			'div',
			{ 'class': 'modalWrapper' },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'modalContainer' },
				props.content
			),
			this.props.showControls ? Object(preact_min["h"])(
				'div',
				{ 'class': 'controls' },
				this.props.customControl ? this.props.customControl : null,
				Object(preact_min["h"])(
					'div',
					{ 'class': 'iconClose', onClick: this.handleClick.bind(this) },
					modal__ref
				)
			) : null
		);
	};

	OTT.prototype.handleClick = function handleClick() {
		this.props.toggleModal(false, null);
	};

	return OTT;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/player/index.js
var player__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function player__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function player__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function player__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var wtPlay = document.getElementById('wtPlay');
var directTagID = document.querySelector('meta[name="wootag:direct_tag"]');
var player_HEAD = document.getElementsByTagName('head')[0];
var videoCSSFile = 'https://cdn.wootag.com/wootag/css/videojs/video-js.min.css';

var bridgeAPI = {
  playerReady: 'playerReady',
  setDuration: 'setDuration'
};

var player__ref = Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-arrow-right' });

var player__ref2 = Object(preact_min["h"])('div', { 'class': 'tagPortraitContainer' });

var player_Player = function (_Component) {
  player__inherits(Player, _Component);

  function Player(props) {
    player__classCallCheck(this, Player);

    var _this = player__possibleConstructorReturn(this, _Component.call(this, props));

    _this.setSquareVideo = function (isSquareVideo) {
      _this.setState({ isSquareVideo: isSquareVideo });
    };

    _this.importScreenLayout = function () {
      if (_this.props.isAd) {
        __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "0yJN")).then(function (res) {
          _this.screenTmpl = res;
          _this.setState({ ready: true });
        });
      } else {
        __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "Ncbg")).then(function (res) {
          _this.screenTmpl = res;
          _this.setState({ ready: true });
        });
      }
    };

    _this.receiveMessage = function (event) {
      var data = event && event.data;
      var decisionClose = false;
      var deactivateTag = false;

      try {
        data = typeof data !== 'object' ? JSON.parse(data) : data;
      } catch (e) {}

      if (data.tagid && _this.state.noVideo) {
        _this.openTagInFrame(data.tagid);
        _this.setState({ deeplinkTagId: data.tagid });
      }

      if (data.tagid) {
        var tagId = data.tagid;
        var tags = _this.props.json && _this.props.json.otags;
        var dpTags = tags.filter(function (item) {
          return (item && item.settings && item.settings.category) === 15;
        });
        var isDPTag = dpTags.filter(function (item) {
          return item.id === tagId;
        });
        // Setting local state for if current active tag is a DP one---
        _this.setState({ dpTagActive: isDPTag.length > 0 });
      }

      if ((data.time || data.time == 0) && (data.index || data.index == 0)) {
        _this.handleChapterSelect(data.time, data.index);
      }

      if (data.decisionClose) {
        decisionClose = true;
        _this.setState({ decisionClose: decisionClose });
      }

      if (data.deactivateTag) {
        deactivateTag = true;

        // if the current active tag is a DP one then only set decisionClose to true as decision handleClose
        // takes care of deactivateTag call---
        if (deactivateTag && _this.state.dpTagActive) {
          _this.setState({ decisionClose: true });
        } else {
          _this.setState({ deactivateTag: deactivateTag });
        }
      }
    };

    _this.setDecisionCloseFalse = function () {
      _this.setState({ decisionClose: false });
    };

    _this.setDeactivateTagFalse = function () {
      _this.setState({ deactivateTag: false });
    };

    _this.postMessage = function (obj) {
      var objToPost = player__extends(obj, { popoverId: _this.state.popoverId });
      window.parent.postMessage(JSON.stringify(objToPost), '*');
    };

    _this.getCurrentTime = function () {
      return _this.screen && _this.screen.getCurrentTime();
    };

    _this.screenReplay = function () {
      return _this.screen && _this.screen.handleReplay();
    };

    _this.setCurrentTime = function (time) {
      if (_this.screen) {
        _this.screen.setTime(time);
        _this.screen.playVideo();
        _this.screen.hideSummaryCards();
      }
    };

    _this.handleAutoPauseException = function (tag) {
      _this.setState({
        autopauseExceptions: [].concat(_this.state.autopauseExceptions, [tag])
      });
    };

    _this.resetAutoPauseExceptions = function () {
      _this.setState({
        autopauseExceptions: []
      });
    };

    _this.openTagInFrame = function (deeplinkTagId) {
      var tags = _this.props.json && _this.props.json.tags || _this.state.tags;
      var selectedTagIndex = deeplinkTagId && tags.findIndex(function (tag) {
        return tag.id.toString() === deeplinkTagId.toString();
      });
      var tag = tags[selectedTagIndex];
      var subcategory = tag && tag.settings.subcategory && tag.settings.subcategory[0] && tag.settings.subcategory[0].type;

      if (selectedTagIndex !== null && selectedTagIndex >= 0) {
        selectedTagIndex = _this.props.isFacebookAd ? selectedTagIndex - 1 : selectedTagIndex;
      } else {
        selectedTagIndex = null;
      }

      var minIndex = _this.props.isFacebookAd ? -1 : 0;
      if (selectedTagIndex !== null && selectedTagIndex >= minIndex && selectedTagIndex !== _this.selectedTag) {
        if ((subcategory === 1401 || subcategory === 1403) && _this.props.isFacebookAd) {
          _this.setCurrentTag(selectedTagIndex, false);
          return;
        }

        _this.renderTag(selectedTagIndex, true);
      }
    };

    _this.renderLandscapeCards = function (renderLandscapeCards, selectedTagIndex) {
      if (_this.state.portraitVideo && _this.props.isAd) {
        // this.screen.showSummaryCards();
      } else {
        _this.pauseVideo();
        _this.setState({
          renderLandscapeCards: renderLandscapeCards
        }, function () {
          if (!_this.state.renderLandscapeCards) {
            var hasVideoEnded = _this.hasVideoEnded();
            if (!hasVideoEnded) {
              _this.playVideo();
            }
          }
        });
      }
    };

    _this.updateTagHistory = function (tagId) {
      var tags = _this.props.json && _this.props.json.otags;
      var idx = tags.findIndex(function (item) {
        return item.id === tagId;
      });
      var tagHistory = _this.state.tagHistory;

      tagHistory[idx] = 1;
      _this.setState({
        tagHistory: tagHistory
      });
    };

    _this.activateDirectTag = function (tagId) {
      var selectedIndex = _this.props.json.tags.findIndex(function (tag) {
        return tag.id == tagId;
      });
      if (_this.OTT && selectedIndex > -1) {
        _this.OTT.activateDirectTag(selectedIndex + 1);
      }
    };

    _this.tileModeStatus = function (status) {
      _this.setState({ tileModeStatus: status });
    };

    _this.setActiveIndexForImageGallery = function (index) {
      _this.setState({ activeIndexForImageGallery: index });
    };

    var urlParams = helper["z" /* getUrlParams */](window.location.href);
    var meta = _this.props.json && _this.props.json.meta;
    if (props.json.config_data_json && props.json.config_data_json.abConfig) {
      var abConfig = props.json.config_data_json.abConfig;
      if (abConfig.tagPreviewTheme) {
        meta.tagPreviewTheme = abConfig.tagPreviewTheme;
      }
    }

    try {
      directTagID = props.displayDirectTag || parseInt(directTagID && directTagID.content, 10);
    } catch (e) {}

    _this.state = {
      autopauseExceptions: [],
      autoplay: urlParams.autoplay === '1' || meta.thirdpartyapi,
      currentChapter: null,
      deeplinkTagId: urlParams.tagid || null,
      directTag: directTagID || meta && meta.direct_tag_id,
      displayTag: false,
      editorMode: urlParams.editorMode === 'true',
      isFacebookAd: urlParams.fbAd === '1',
      noVideo: urlParams.noVideo === '1' || meta && meta.direct_tag_id || directTagID,
      scriptEmbed: urlParams.scriptEmbed === '1',
      ottOnly: urlParams.ottOnly === '1', // for mobile ads invideo links we pass the ottOnly=1 in parameter, which has two tasks, 1) making `ottWrapper` full width/height and 2) not loading the video
      popoverId: urlParams.popoverId || null,
      deactivateTag: false,
      decisionClose: false,
      modalChildren: null,
      modalProps: null,
      portraitVideo: false,
      ready: false,
      selectedTagIndex: null,
      showModal: false,
      showOTT: false,
      showSlideHint: false,
      showSwipeToast: false,
      tagHistory: null,
      videoActive: false,
      videoWidth: 0,
      videoHeight: 0,
      tagAutoInteraction: false,
      ageGateActive: false,
      fullWidthOTT: false,
      shareControllerIsOpen: false,
      tagPreviewThemeDark: meta && meta.tagPreviewTheme === 'dark' ? 'tagPreviewThemeDark' : '',
      activeIndexForImageGallery: 0,
      originalWidth: 0,
      originalHeight: 0,
      tileModeStatus: false,
      isSquareVideo: false
    };

    _this.createCues = _this.createCues.bind(_this);
    _this.toggleModal = _this.toggleModal.bind(_this);
    _this.playVideo = _this.playVideo.bind(_this);
    _this.pauseVideo = _this.pauseVideo.bind(_this);
    _this.getCurrentTime = _this.getCurrentTime.bind(_this);
    _this.hasVideoEnded = _this.hasVideoEnded.bind(_this);
    _this.renderTag = _this.renderTag.bind(_this);
    _this.unmountTag = _this.unmountTag.bind(_this);
    _this.setCurrentTag = _this.setCurrentTag.bind(_this);
    _this.destroyTag = _this.destroyTag.bind(_this);
    _this.setVideoDimensions = _this.setVideoDimensions.bind(_this);
    _this.receiveMessage = _this.receiveMessage.bind(_this);
    _this.setDecisionCloseFalse = _this.setDecisionCloseFalse.bind(_this);
    _this.setDeactivateTagFalse = _this.setDeactivateTagFalse.bind(_this);
    _this.setTagAutoInteraction = _this.setTagAutoInteraction.bind(_this);
    _this.setAgeGateActive = _this.setAgeGateActive.bind(_this);
    _this.setFullWidthOTT = _this.setFullWidthOTT.bind(_this);
    _this.disableSkinMode = _this.disableSkinMode.bind(_this);
    _this.toggleTagForPortraitMode = _this.toggleTagForPortraitMode.bind(_this);
    _this.shareControllerIsOpen = _this.shareControllerIsOpen.bind(_this);
    _this.portraitTagTimer = null;
    return _this;
  }

  Player.prototype.componentWillMount = function componentWillMount() {
    if (!this.state.noVideo) {
      this.importScreenLayout();
    } else {
      this.setVideoDimensions(0, 0, 0, 0);
    }
  };

  Player.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.loadCSSPromise = helper["J" /* loadCSS */](videoCSSFile, player_HEAD);
    wtPlay = document.getElementById('wtPlay');

    setTimeout(function () {
      _this2.setState({
        showSwipeToast: true
      }, function () {
        setTimeout(function () {
          _this2.setState({
            showSwipeToast: false
          });
        }, 5000);
      });
    }, 2000);

    // post message received from popover window---
    window.addEventListener('message', this.receiveMessage, false);

    if (!this.state.tagHistory) {
      var tags = this.props.json && this.props.json.otags;
      var tagHistory = {};
      tags.forEach(function (item, index) {
        tagHistory[index] = 0;
      });

      this.setState({
        tagHistory: tagHistory
      });
    }

    if (this.state.deeplinkTagId) {
      var ottInterval = void 0;
      if (!this.OTT) {
        if (ottInterval) {
          clearInterval(ottInterval);
        }
        ottInterval = setInterval(function () {
          if (_this2.OTT) {
            clearInterval(ottInterval);
            _this2.activateDirectTag(_this2.state.deeplinkTagId);
          }
        }, 500);
      } else {
        this.activateDirectTag(this.state.deeplinkTagId);
      }
    }
  };

  Player.prototype.componentDidUnmount = function componentDidUnmount() {
    window.removeEventListener('message', this.receiveMessage, false);
  };

  Player.prototype.render = function render(props, state) {
    var _this3 = this;

    if (state.ready) {
      var facebookCheck = props.isFacebookApp ? 'fbapp' : '';
      var facebookAd = state.isFacebookAd ? 'fbAd' : '';
      var portraitVideoCheck = state.portraitVideo ? 'portraitVideo' : '';
      var tabletCheck = props.isTabletDevice ? 'tablet' : '';
      var isAd = props.isAd ? 'isAd' : '';
      var noVideo = state.noVideo ? 'noVideo' : '';
      var directTag = this.state.directTag ? 'enableDirectTag' : '';
      var shareControllerIsOpen = state.shareControllerIsOpen ? 'shareControllerIsOpen' : '';
      var tileModeStatus = state.tileModeStatus ? 'tileModeStatusEnabled' : '';
      var isSquareVideo = state.isSquareVideo ? 'squareVideo' : '';
      var klassList = 'playerWrapper ' + facebookCheck + ' ' + facebookAd + ' ' + portraitVideoCheck + ' ' + tabletCheck + ' ' + isAd + ' ' + noVideo + ' ' + directTag + ' ' + shareControllerIsOpen + ' ' + tileModeStatus + ' ' + isSquareVideo;

      var ScreenTmpl = this.screenTmpl && this.screenTmpl.default;

      return Object(preact_min["h"])(
        'div',
        { 'class': klassList, ref: function ref(c) {
            return _this3.playerWrapper = c;
          } },
        state.showOTT ? Object(preact_min["h"])(ott_OTT, player__extends({}, props, {
          ref: function ref(c) {
            return _this3.OTT = c;
          },
          tags: props.json && props.json.otags,
          selectedTagIndex: state.selectedTagIndex,
          toggleModal: this.toggleModal,
          displayTag: state.displayTag,
          destroyTag: this.destroyTag,
          containerHeight: props.containerHeight,
          fbContainerHeightOffsetTop: props.fbContainerHeightOffsetTop,
          fbContainerHeightOffsetBottom: props.fbContainerHeightOffsetBottom,
          isAd: props.isAd,
          adUnits: props.adUnits,
          adUnitsArgs: props.adUnitsArgs,
          adType: props.adType,
          adUnitSrv: props.adUnitSrv,
          creativeData: props.creativeData,
          initAd: props.initAd,
          lsCards: state.renderLandscapeCards,
          hasDirectTag: state.directTag,
          videoId: props.json.video_id,
          deeplinkTagId: state.deeplinkTagId,
          isMobileDevice: props.isMobileDevice,
          isFacebookApp: props.isFacebookApp,
          isFacebookAd: state.isFacebookAd,
          noVideo: state.noVideo,
          ottOnly: state.ottOnly,
          forceStart: props.forceStart,
          scriptEmbed: state.scriptEmbed,
          deactivateTag: state.deactivateTag,
          decisionClose: state.decisionClose,
          setDecisionCloseFalse: this.setDecisionCloseFalse,
          setDeactivateTagFalse: this.setDeactivateTagFalse,
          postMessage: this.postMessage,
          orientation: props.orientation,
          portraitVideo: state.portraitVideo,
          renderLandscapeCards: this.renderLandscapeCards,
          os: props.os,
          editorMode: state.editorMode,
          removeLoader: props.removeLoader,
          playVideo: this.playVideo,
          pauseVideo: this.pauseVideo,
          hasVideoEnded: this.hasVideoEnded,
          getCurrentTime: this.getCurrentTime,
          videoWidth: state.videoWidth,
          videoHeight: state.videoHeight,
          logDataEvent: props.logDataEvent,
          fetchRedeemCode: props.fetchRedeemCode,
          handleChapterSelect: this.handleChapterSelect,
          trackEvent: props.trackEvent,
          handleAutoPauseException: this.handleAutoPauseException,
          toggleExpand: props.toggleExpand,
          eventBus: props.eventBus,
          setTagAutoInteraction: this.setTagAutoInteraction,
          tagAutoInteraction: this.state.tagAutoInteraction,
          ageGateActive: this.state.ageGateActive,
          setAgeGateActive: this.setAgeGateActive,
          fullWidthOTT: this.state.fullWidthOTT,
          setFullWidthOTT: this.setFullWidthOTT,
          updateJsonTag: props.updateJsonTag,
          displayAdClickThroughLink: props.displayAdClickThroughLink,
          disableSkinMode: this.disableSkinMode,
          activeIndexForImageGallery: state.activeIndexForImageGallery,
          originalWidth: state.originalWidth,
          originalHeight: state.originalHeight
        })) : null,
        !state.noVideo ? Object(preact_min["h"])(
          screenController_ScreenController,
          player__extends({}, props, {
            isAd: props.isAd,
            adUnits: props.adUnits,
            adUnitsArgs: props.adUnitsArgs,
            adType: props.adType,
            adUnitSrv: props.adUnitSrv,
            creativeData: props.creativeData,
            isMraidProject: props.isMraidProject,
            initAd: props.initAd,
            lsCards: state.renderLandscapeCards,
            cues: state.cues,
            createCues: this.createCues,
            renderTag: this.renderTag,
            renderLandscapeCards: this.renderLandscapeCards,
            unmountTag: this.unmountTag,
            destroyTag: this.destroyTag,
            setJSON: props.setJSON,
            setCurrentTag: this.setCurrentTag,
            resetAutoPauseExceptions: this.resetAutoPauseExceptions,
            setPlaybackState: this.setPlaybackState,
            getCurrentTime: this.getCurrentTime,
            tagHistory: state.tagHistory,
            updateTagHistory: this.updateTagHistory,
            containerHeight: props.containerHeight,
            fbContainerHeightOffsetTop: props.fbContainerHeightOffsetTop,
            fbContainerHeightOffsetBottom: props.fbContainerHeightOffsetBottom,
            playerWrapper: this.playerWrapper,
            isMobileDevice: props.isMobileDevice,
            isFacebookApp: props.isFacebookApp,
            isFacebookAd: state.isFacebookAd,
            noVideo: state.noVideo,
            ottOnly: state.ottOnly,
            isTagOpen: state.displayTag,
            orientation: props.orientation,
            portraitVideo: state.portraitVideo,
            autopauseExceptions: state.autopauseExceptions,
            autoplay: state.autoplay,
            deeplinkTagId: state.deeplinkTagId,
            editorMode: state.editorMode,
            forceMobileEmulation: props.forceMobileEmulation,
            forceDesktopEmulation: props.forceDesktopEmulation,
            setVideoDimensions: this.setVideoDimensions,
            removeLoader: props.removeLoader,
            trackEvent: props.trackEvent,
            logDataEvent: props.logDataEvent,
            eventBus: props.eventBus,
            setTagAutoInteraction: this.setTagAutoInteraction,
            tagAutoInteraction: this.state.tagAutoInteraction,
            network: props.network,
            playVideo: this.playVideo,
            pauseVideo: this.pauseVideo,
            ageGateActive: this.state.ageGateActive,
            setAgeGateActive: this.setAgeGateActive,
            fullWidthOTT: this.state.fullWidthOTT,
            setFullWidthOTT: this.setFullWidthOTT,
            screenReplay: this.screenReplay,
            updateJsonTag: props.updateJsonTag,
            clickThruLinks: props.displayAdClickThroughLink,
            disableSkinMode: this.disableSkinMode,
            deactivateTag: this.OTT && this.OTT.deactivateTag,
            hasVideoEnded: this.hasVideoEnded,
            toggleTagForPortraitMode: this.toggleTagForPortraitMode,
            shareControllerIsOpen: this.shareControllerIsOpen,
            tileModeStatus: this.tileModeStatus,
            videoWidth: state.videoWidth,
            videoHeight: state.videoHeight,
            setActiveIndexForImageGallery: this.setActiveIndexForImageGallery,
            setSquareVideo: this.setSquareVideo,
            ref: function ref(c) {
              return _this3.screenControllerRef = c;
            }
          }),
          Object(preact_min["h"])(ScreenTmpl, { ref: function ref(c) {
              return _this3.screen = c;
            } })
        ) : null,
        state.showModal ? Object(preact_min["h"])(modal_OTT, player__extends({}, state.modalProps, { content: state.modalChildren, toggleModal: this.toggleModal })) : null,
        state.isFacebookAd && state.showSlideHint ? Object(preact_min["h"])(
          'div',
          {
            'class': 'player-toast ' + (state.showSwipeToast ? 'active' : ''),
            style: { top: window.innerHeight - 60 + 'px' }
          },
          'Swipe Left to see more',
          player__ref
        ) : null,
        Object(preact_min["h"])(
          'div',
          { 'class': 'playerVideoTitle' },
          props.json && props.json.title
        ),
        player__ref2
      );
    } else return null;
  };

  Player.prototype.toggleTagForPortraitMode = function toggleTagForPortraitMode(show) {
    var handleClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var tagHTML = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var portraitTagContainer = document.querySelector('.tagPortraitContainer');
    if (!portraitTagContainer) return;
    if (show) {
      if (this.portraitTagTimer) {
        clearTimeout(this.portraitTagTimer);
        this.portraitTagTimer = null;
      };
      portraitTagContainer.innerHTML = tagHTML;
      portraitTagContainer.addEventListener('click', handleClick);
      if (this.state.tagPreviewThemeDark) portraitTagContainer.classList.add(this.state.tagPreviewThemeDark);
      setTimeout(function () {
        portraitTagContainer.classList.add('animatePortraitEntry');
      });
    } else {
      // hide current tag
      portraitTagContainer.classList.remove('animatePortraitEntry');
      portraitTagContainer.removeEventListener('click', handleClick);
      if (this.portraitTagTimer) return;
      this.portraitTagTimer = setTimeout(function () {
        portraitTagContainer.innerHTML = '';
      }, 100);
    }
  };

  Player.prototype.shareControllerIsOpen = function shareControllerIsOpen(v) {
    this.setState({
      shareControllerIsOpen: v
    });
  };

  Player.prototype.disableSkinMode = function disableSkinMode() {
    if (this.screenControllerRef) {
      this.screenControllerRef.disableSkinMode();
    }
  };

  Player.prototype.setVideoDimensions = function setVideoDimensions(videoWidth, videoHeight, originalWidth, originalHeight) {
    var _this4 = this;

    this.setState({
      ready: true,
      showOTT: true,
      videoWidth: videoWidth,
      videoHeight: videoHeight,
      originalWidth: originalWidth,
      originalHeight: originalHeight,
      portraitVideo: originalHeight !== 0 && originalWidth !== 0 ? originalHeight >= originalWidth : false
    }, function () {
      if (!_this4.state.editorMode) {
        setTimeout(function () {
          if (_this4.state.directTag) {
            var tag = _this4.props.json.tags.find(function (tag) {
              return tag.id === _this4.state.directTag;
            });
            var trackers = document.querySelectorAll('meta[name="wootag:impression_tracker"]');
            if (!trackers.length) {
              trackers = _this4.props.displayImpTrackers;
            }

            if (trackers && trackers.length > 0) {
              trackers.forEach(function (tracker) {
                var url = tracker.content;
                if (!components_config["e" /* regex */].httpCheck.test(url)) {
                  url = 'http://' + url;
                }

                helper["N" /* request */](url);
              });
            }

            _this4.activateDirectTag(_this4.state.directTag);
            window.parent.postMessage(JSON.stringify({
              api: bridgeAPI.playerReady,
              data: null
            }), '*');

            _this4.props.logDataEvent({
              event: 'display_tag',
              event_type: 'impression',
              // host: '',
              tag_id: tag && tag.id,
              tag_label: tag && tag.details.preview_title || tag && tag.details.title || ''
            });
          }

          _this4.props.removeLoader();
        }, 800);
      }
    });
  };

  Player.prototype.toggleModal = function toggleModal(showModal, modalChildren, modalProps) {
    this.setState({
      showModal: showModal,
      modalChildren: modalChildren,
      modalProps: modalProps
    });
  };

  Player.prototype.createCues = function createCues(isPreviewMode) {
    var cues = {};
    // in subtag cases the tag index remains the same but startTime can be after the next tag which causes issue as the values get overwritten.
    // example: tags = [{startTime:12, endTime:22},{startTime:6, endTiime:16},{startTime: 15, endTime:25}];
    // so in directly looping through the json.tags the first tag cues get overwritten by second and third tags duration.
    // to prevent that just took a copy of array to avoid mutation, looped through each item to add the original index of the tag, sorted as per the startTime and created cues;
    var tags = this.props.json.tags;
    if (isPreviewMode) {
      tags = helper["k" /* filterTagsForDecisions */](tags);
    }
    var tagsSortedAsPerStartTime = tags.slice(0);
    tagsSortedAsPerStartTime.forEach(function (item, index) {
      return item.index = index;
    });
    tagsSortedAsPerStartTime.sort(function (a, b) {
      return a.duration.tag_start_time - b.duration.tag_start_time;
    });

    tagsSortedAsPerStartTime.map(function (item, i) {
      var startTime = item.duration.tag_start_time;
      var endTime = item.duration.tag_end_time;
      var type = item.settings.subcategory && item.settings.subcategory[0] && item.settings.subcategory[0].type;

      // once a tag disappears and next one shows the prev tag should not show again even if its duration allows.
      // to achieve that we set the last cue to minimum of its endTime and nextTag startTime-1;
      if (i + 1 < tagsSortedAsPerStartTime.length) {
        var nextTag = tagsSortedAsPerStartTime[i + 1];
        var nextTagStartTime = nextTag && nextTag.duration.tag_start_time;
        endTime = endTime > nextTagStartTime - 0.1 ? nextTagStartTime - 0.1 : endTime;
      }

      if (type === 1502) {
        var engagements = item.details.engagements && item.details.engagements[0];
        if (engagements && !engagements.dpnative) {
          endTime = startTime + 0.5;
        }
      }

      for (var i = startTime; i <= endTime; i = helper["O" /* roundToX */](i + 0.1, 1)) {
        cues[i] = item.index;
      }
    });

    return cues;
  };

  Player.prototype.pauseVideo = function pauseVideo() {
    if (this.screen) {
      this.screen.pauseVideo();
    }
  };

  Player.prototype.playVideo = function playVideo() {
    if (this.screen) {
      this.screen.playVideo();
    }
  };

  Player.prototype.hasVideoEnded = function hasVideoEnded() {
    return this.screen && this.screen.hasVideoEnded();
  };

  Player.prototype.renderTag = function renderTag(selectedTagIndex, toggleLock, trackerEvent, dontUpdateHistory) {
    var _this5 = this;

    var tagHistory = JSON.parse(JSON.stringify(this.state.tagHistory));

    if (!dontUpdateHistory) {
      tagHistory[selectedTagIndex] = 1;
    }

    this.setState({
      displayTag: true,
      selectedTagIndex: selectedTagIndex,
      tagHistory: tagHistory
    }, function () {
      if (_this5.OTT && selectedTagIndex !== undefined) {
        _this5.OTT.activateTag(selectedTagIndex + 1, toggleLock, trackerEvent);
      }
    });
  };

  Player.prototype.setCurrentTag = function setCurrentTag(tagIndex, toggleLock) {
    if (tagIndex !== undefined && this.OTT && this.OTT.setTagIndex) {
      this.OTT.setTagIndex(tagIndex + 1, toggleLock);
    }
  };

  Player.prototype.unmountTag = function unmountTag(dontPauseVideo) {
    var _this6 = this;

    this.screen.pauseVideo();
    this.setState({
      displayTag: false
    }, function () {
      if (_this6.OTT) {
        _this6.OTT.deactivateTag(dontPauseVideo);
      }
      wtPlay.classList.remove('decisionpoint__enable');
    });
  };

  Player.prototype.destroyTag = function destroyTag() {
    this.setState({
      displayTag: false,
      selectedTagIndex: null
    }, function () {
      wtPlay.classList.remove('decisionpoint__enable');
    });
  };

  Player.prototype.setTagAutoInteraction = function setTagAutoInteraction(tagAutoInteraction) {
    this.setState({
      tagAutoInteraction: tagAutoInteraction
    });
  };

  Player.prototype.setAgeGateActive = function setAgeGateActive(visible) {
    var _this7 = this;

    this.setState({ ageGateActive: visible }, function () {
      if (visible) {
        _this7.pauseVideo();
        // when scrubbed ahead of start time of age gate it plays inspite of pausing so calling pause with a delay as a hack---
        setTimeout(function () {
          _this7.pauseVideo();
        }, 500);
      } else {
        _this7.playVideo();
      }
    });
  };

  Player.prototype.setFullWidthOTT = function setFullWidthOTT(fullWidthOTT) {
    this.setState({ fullWidthOTT: fullWidthOTT });
  };

  return Player;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/adunits/index.js
function adunits__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdUnits = function () {
  function AdUnits(listener) {
    adunits__classCallCheck(this, AdUnits);

    this.subscribe();
  }

  AdUnits.prototype.subscribe = function subscribe() {
    window.vpaid.subscribe(this.adStarted, 'AdStarted', this);
    window.vpaid.subscribe(this.adPaused, 'AdPaused', this);
    window.vpaid.subscribe(this.adStopped, 'AdStopped', this);
    window.vpaid.subscribe(this.adVolumeChanged, 'AdVolumeChange', this);
    window.vpaid.subscribe(this.adHandleTimeUpdate, 'AdVideoFirstQuartile', this);
  };

  AdUnits.prototype.unsubscribe = function unsubscribe() {};

  AdUnits.prototype.registerListener = function registerListener(listener) {
    this.listener = listener;
  };

  AdUnits.prototype.emit = function emit(evt, params) {
    try {
      this.listener && this.listener(evt, params);
    } catch (e) {
      console.log('call for this.listener failed', e);
    }
  };

  AdUnits.prototype.adStarted = function adStarted() {
    // console.log('---------------------------------------> AdStarted');
  };

  AdUnits.prototype.adPaused = function adPaused() {
    this.emit('AdPaused');
  };

  AdUnits.prototype.adStopped = function adStopped() {
    this.emit('AdStopped');
  };

  AdUnits.prototype.adVolumeChanged = function adVolumeChanged(volume) {
    console.log('AdVolumeChange called');
    this.emit('AdVolumeChange', volume);
  };

  AdUnits.prototype.adHandleTimeUpdate = function adHandleTimeUpdate() {
    // this.emit('')
    // console.log('adHandleTimeUpdate quarter');
  };

  return AdUnits;
}();


// CONCATENATED MODULE: ./components/pixel.js


function pixel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function pixel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function pixel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
* the iframe is used to set cookie against wootag domain,
* which then gets sent to its parent (player) and passed in events
*/

var pixel_Pixel = function (_PureComponent) {
	pixel__inherits(Pixel, _PureComponent);

	function Pixel() {
		pixel__classCallCheck(this, Pixel);

		return pixel__possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	}

	Pixel.prototype.render = function render() {
		var domain = components_config["a" /* config */].DOMAIN;
		if (!domain.includes('wootag')) {
			domain = 'https://www.wootag.com';
		}
		return Object(preact_min["h"])('iframe', {
			src: domain + '/pixel.html',
			style: { display: 'none' }
		});
	};

	return Pixel;
}(preact_compat_es["PureComponent"]);

/* harmony default export */ var pixel = (pixel_Pixel);
// CONCATENATED MODULE: ./components/app.js
var app__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Linear = __webpack_require__("WMjk");
var app_HEAD = document.getElementsByTagName('head')[0];

var app__ref7 = Object(preact_min["h"])(
  'div',
  { className: 'wtMessage' },
  Object(preact_min["h"])('i', { 'class': 'zmdi zmdi-alert-triangle' }),
  Object(preact_min["h"])(
    'p',
    null,
    'Sorry, this video is currently not available'
  )
);

var app__ref8 = Object(preact_min["h"])('div', { 'class': 'loader' });

var app__ref9 = Object(preact_min["h"])(pixel, null);

var app_App = function (_Component) {
  app__inherits(App, _Component);

  function App(props) {
    app__classCallCheck(this, App);

    var _this = app__possibleConstructorReturn(this, _Component.call(this, props));

    _this.initTags = function (proptags, meta) {
      var _ref, _ref2, _ref3, _ref5, _ref6;

      var jsontags = proptags;
      /**
       * BLS
       */
      var blsTagId = meta && meta.bls && meta.bls.tag;
      if (blsTagId) {
        var blsActive = meta && meta.bls && meta.bls.show;
        jsontags = proptags.filter(function (t) {
          return blsActive ? blsTagId === t.id : blsTagId !== t.id;
        });
        if (!blsActive) {
          meta = app__extends({}, meta, { direct_tag_id: null });
        }
      }

      var tags = jsontags && JSON.parse(JSON.stringify(jsontags));
      var decisionPoints = tags && tags.filter(function (item) {
        return item.settings.category === 15;
      });
      var decisionPointIds = decisionPoints && decisionPoints.map(function (t) {
        return t.id;
      });
      var connectedTags = (_ref = []).concat.apply(_ref, decisionPoints.map(function (dp) {
        return dp.details.engagements[0].meta.map(function (metaItem) {
          return metaItem.tag;
        });
      }));
      // connectedTags = connectedTags.filter(t => !decisionPointIds.includes(t));
      var contests = tags && tags.filter(function (item) {
        return item.settings.category === 9 && item.settings.subcategory && item.settings.subcategory[0] && item.settings.subcategory[0].type === 906;
      });
      var contestLinkedTags = (_ref2 = []).concat.apply(_ref2, contests.map(function (item) {
        return item.details.engagements[0].externalLink;
      }));
      var contestAnswerLinkedTags = (_ref3 = []).concat.apply(_ref3, contests.map(function (item) {
        var _ref4;

        var qObjects = JSON.parse(item.details.engagements[0].attr);
        return (_ref4 = []).concat.apply(_ref4, qObjects.map(function (o) {
          return o.answers.map(function (answer) {
            return answer.linkedTag;
          });
        }));
      }));
      contestAnswerLinkedTags = contestAnswerLinkedTags.filter(function (item) {
        return typeof item !== 'undefined';
      });

      var leadGenTags = tags && tags.filter(function (item) {
        return item.settings.category === 9 && item.settings.subcategory && item.settings.subcategory[0] && item.settings.subcategory[0].type === 902 && item.details.engagements[0].linkedTag;
      });
      var leadGenLinkedTags = (_ref5 = []).concat.apply(_ref5, leadGenTags.map(function (item) {
        return item.details.engagements[0].linkedTag;
      }));

      var prod360 = tags && tags.filter(function (item) {
        return item.settings.category === 1 && item.settings.subcategory && item.settings.subcategory[0] && item.settings.subcategory[0].type === 106 && item.details.description;
      });
      var prod360LinkedTags = (_ref6 = []).concat.apply(_ref6, prod360.map(function (item) {
        var linkedTags = item.details.linkedTags || [];
        return linkedTags.length > 0 ? linkedTags : [];
      }));

      var _loop = function _loop() {
        var tag = tags[i];
        var subcat = tag.settings.subcategory && tag.settings.subcategory[0];
        var subtype = subcat && subcat.type;
        // Attaching json meta hotspot tag preview value to tag---
        var hotspotTagPreview = meta && meta.tagpreview_hotspot;
        var targetTagDatajsonHotspotPosition = tag.details && tag.details.config_data_json && tag.details.config_data_json.hotspotEnabled && tag.details.config_data_json.hotspotPosition;
        if (hotspotTagPreview && hotspotTagPreview.length) {
          var targetTag = hotspotTagPreview.find(function (t) {
            return t.id === tag.id;
          });
          if (!targetTag && targetTagDatajsonHotspotPosition) {
            targetTag = { position: targetTagDatajsonHotspotPosition };
          }
          if (targetTag) {
            tags[i] = app__extends({}, tag, { tagpreview_hotspot_position: targetTag.position });
          }
        } else if (targetTagDatajsonHotspotPosition) {
          tags[i] = app__extends({}, tag, {
            tagpreview_hotspot_position: targetTagDatajsonHotspotPosition
          });
        }

        if (decisionPoints && decisionPoints.length) {
          var index = tags[i] && connectedTags.indexOf(tags[i].id);

          if (index !== undefined && index !== -1 || subtype === 1402) {
            tags.splice(i, 1);
          }
        } else if (subtype === 1402) {
          tags.splice(i, 1);
        } else if (tag.tag_completion && !tag.tag_completion.status) {
          tags.splice(i, 1);
        }
        if (contests && contests.length) {
          var _index = tags[i] && contestLinkedTags.indexOf(tags[i].id);
          var answerIndex = tags[i] && contestAnswerLinkedTags.indexOf(tags[i].id);

          if (_index !== undefined && _index !== -1 || answerIndex !== -1 || subtype === 1402) {
            tags.splice(i, 1);
          }
        }
        if (leadGenTags && leadGenTags.length) {
          var _index2 = tags[i] && leadGenLinkedTags.indexOf(tags[i].id);

          if (_index2 !== undefined && _index2 !== -1 || subtype === 1402) {
            tags.splice(i, 1);
          }
        }
        if (prod360 && prod360.length) {
          var _index3 = tags[i] && prod360LinkedTags.indexOf(tags[i].id);

          if (_index3 !== undefined && _index3 !== -1 || subtype === 1402) {
            tags.splice(i, 1);
          }
        }
      };

      for (var i = tags.length - 1; i >= 0; i--) {
        _loop();
      }
      return tags;
    };

    _this.handlePostMessage = function (message) {
      if (message && message.origin.includes('wootag')) {
        var data = message.data && typeof message.data === 'string' && JSON.parse(message.data) || {};
        if (data.viewer_id) {
          _this.store.setId(data.viewer_id);
          _this.setState({ viewer_id: data.viewer_id });
        }
      }
    };

    _this.updateMerchantData = function (selectedMerchant, tag) {
      var updatedTag = helper["U" /* updateTagProductPrice */](selectedMerchant, tag);
      _this.updateJsonTag(updatedTag);
    };

    _this.updateJsonTag = function (updatedTag) {
      // const json = this.state.json;

      var updatedTags = _this.state.allInitialTags.map(function (t) {
        if (t.id === updatedTag.id) {
          return updatedTag;
        }
        return t;
      });

      var json = helper["i" /* filterAgeGate */](app__extends({}, _this.state.json, {
        tags: updatedTags
      }));
      json.tags = _this.initTags(json.tags, json.meta);
      _this.setState({ json: json }, function () {
        _this.forceUpdate();
      });
    };

    _this.toggleExpand = function (expand) {
      _this.setState({
        expand: expand
      });
    };

    _this.filterHotspotTagPreview = function (json) {
      var tags = json.tags;
      var meta = json.meta || {};

      var _loop2 = function _loop2(i) {
        var tag = tags[i];
        // Attaching json meta hotspot tag preview value to tag---
        var hotspotTagPreview = meta && meta.tagpreview_hotspot;
        var targetTagDatajsonHotspotPosition = tag.details && tag.details.config_data_json && tag.details.config_data_json.hotspotEnabled && tag.details.config_data_json.hotspotPosition;
        if (hotspotTagPreview && hotspotTagPreview.length) {
          var targetTag = hotspotTagPreview.find(function (t) {
            return t.id === tag.id;
          });
          if (!targetTag && targetTagDatajsonHotspotPosition) {
            targetTag = { position: targetTagDatajsonHotspotPosition };
          }
          if (targetTag) {
            tags[i] = app__extends({}, tag, { tagpreview_hotspot_position: targetTag.position });
          }
        } else if (targetTagDatajsonHotspotPosition) {
          tags[i] = app__extends({}, tag, {
            tagpreview_hotspot_position: targetTagDatajsonHotspotPosition
          });
        }
      };

      for (var i = tags.length - 1; i >= 0; i--) {
        _loop2(i);
      }
      return tags;
    };

    _this.updateState = function () {
      var updates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this.setState(app__extends({}, updates), function () {
        // console.log(updates);
      });
    };

    var urlParams = helper["z" /* getUrlParams */](window.location.href);
    _this.state = {
      editorMode: urlParams.editorMode === 'true' ? true : false,
      projectScriptMode: urlParams.projectScript === '1',
      expand: false,
      fbContainerHeightOffsetTop: 0,
      fbContainerHeightOffsetBottom: 0,
      id: null,
      isAd: false,
      isFacebookAd: urlParams.fbAd === '1',
      isFacebookApp: false,
      isMobileDevice: false,
      isPluggedIn: _this.props.pluggedIn,
      json: null,
      loader: urlParams.nologo === '1' || urlParams.editorMode === 'true' ? false : true,
      orientation: null,
      os: helper["t" /* getMobileOS */](),
      ready: false,
      showDebugConsole: false,
      noBranding: false,
      projectVideoId: null,
      displayDirectTag: _this.props.displayDirectTag,
      viewer_id: '',
      macroParams: {},
      personalizeMsg: null
    };
    _this.network = null; // ad network to be sent in event log calls---
    _this.tid = null;
    _this.componentShouldBind();
    return _this;
  }

  App.prototype.componentWillMount = function componentWillMount() {
    var self = this;

    this.loadFontsPromise = helper["J" /* loadCSS */](components_config["d" /* links */].fontpath, app_HEAD);
    this.loadTypeFacePromise = helper["J" /* loadCSS */](components_config["d" /* links */].typeface, app_HEAD);
    this.store = new store_Store();

    if (this.props.type === 'MRAID' || window.location.host.indexOf('wootag') !== -1 || window.location.host.indexOf('unlead') !== -1 || window.location.host.indexOf('localhost') !== -1 || window.location.host.indexOf('192.168') !== -1 || this.props.forceStart) {
      this.start();
    }

    window.getVPAIDAd = function () {
      window.vpaid = new app_VpaidAd(self);
      return window.vpaid;
    };
  };

  App.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    window.addEventListener('resize', this.handleOrientationChange);
    window.addEventListener('message', this.handlePostMessage);

    setTimeout(function () {
      document.body.scrollTop = 0;
    }, 500);

    if (this.props.displayDirectTag) {
      var url = new URL(document.currentScript.src);
      var currentDomain = url && url.origin;
      var release_version = url && url.searchParams && url.searchParams.get('v');
      if (currentDomain) {
        helper["J" /* loadCSS */](helper["l" /* getCSSPath */](currentDomain, release_version), app_HEAD);
      }
    }
    this.isUnlead = window.location.host.indexOf('unlead') !== -1;
  };

  App.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
    window.removeEventListener('resize', this.handleOrientationChange);
    window.removeEventListener('message', this.handlePostMessage);
  };

  App.prototype.componentShouldBind = function componentShouldBind() {
    this.setJSON = this.setJSON.bind(this);
    this.handleOrientationChange = this.handleOrientationChange.bind(this);
    this.removeLoader = this.removeLoader.bind(this);
    this.forceDesktopEmulation = this.forceDesktopEmulation.bind(this);
    this.forceMobileEmulation = this.forceMobileEmulation.bind(this);
  };

  App.prototype.render = function render(props, state) {
    if (this.state.ready) {
      // When the player loads in DP video in video mode we need to hide the close buttons on child player tags---
      var parentEle = window.frameElement && window.frameElement.parentElement;
      var isPassivePlayer = parentEle && parentEle.classList.contains('iframeVideoContainer');
      //---
      var orientation = helper["u" /* getOrientation */]();
      var minHeight = helper["s" /* getMinHeight */]();
      var templateLayout = window.innerHeight < minHeight && window.innerWidth < window.innerHeight &&
      //  this.state.isMobileDevice &&
      orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE ? 3 : window.innerHeight > 720 ? 1 : 2;

      var isMobile = state.isMobileDevice ? 'mobile' : 'desktop';
      var network = this.state.network ? this.state.network.toLowerCase() : '';
      var klass = isMobile + ' ' + network + ' ' + orientation + ' template_' + templateLayout + ' ' + (isPassivePlayer ? 'isPassivePlayer' : '');
      var containerHeight = state.isFacebookApp ? document.clientHeight : '100%';

      var videoNotAvailable = props.isProject && props.type === 'MRAID' && !state.projectVideoId;
      var videoNotAvailableByGeo = !state.isAd && state.json && state.json.geo_video_restriction;
      var viewsExhaustedBgStyle = state.json && (state.json.views_exhausted || state.json.no_video_schedule || videoNotAvailable || videoNotAvailableByGeo) ? { backgroundImage: 'url(' + state.json.cover_src + ')' } : {};

      var isLandscape = orientation === components_config["b" /* constants */].ORIENTATION_LANDSCAPE;
      var strictHeight = isLandscape && state.isMobileDevice ? { height: window.innerHeight } : {};
      /*
      * datajson response structure when views have exhausted---
      {
      "tags": [],
      "cover_src": "https://wootag-output-beta.s3.amazonaws.com/wootag/video/new-user/coverimages/720_0000.jpg",
      "views_exhausted": true
      }
      */
      return Object(preact_min["h"])(
        'div',
        {
          id: 'wtPlay',
          'class': klass
          // style={containerHeight}
          , style: strictHeight
        },
        state.json && (state.editorMode || !state.json.views_exhausted && !state.json.no_video_schedule && !videoNotAvailable && !videoNotAvailableByGeo) ? Object(preact_min["h"])(player_Player, {
          id: state.id,
          json: state.json,
          setJSON: this.setJSON,
          updateMerchantData: this.updateMerchantData,
          updateJsonTag: this.updateJsonTag,
          adType: state.adType,
          adUnitSrv: state.adUnitSrv,
          adUnits: this.adUnits,
          adUnitsArgs: state.adUnitsArgs,
          creativeData: state.creativeData,
          isMraidProject: props.isProject && props.type === 'MRAID',
          initAd: state.initAd,
          isAd: state.isAd,
          containerHeight: containerHeight,
          fbContainerHeightOffsetTop: state.fbContainerHeightOffsetTop,
          fbContainerHeightOffsetBottom: state.fbContainerHeightOffsetBottom,
          isFacebookApp: state.isFacebookApp,
          isMobileDevice: state.isMobileDevice,
          isTabletDevice: state.isTabletDevice,
          orientation: orientation,
          os: state.os,
          forceMobileEmulation: this.forceMobileEmulation,
          forceDesktopEmulation: this.forceDesktopEmulation,
          toggleExpand: this.toggleExpand,
          removeLoader: this.removeLoader,
          logDataEvent: this.logDataEvent,
          logPollOption: this.logPollOption,
          fetchRedeemCode: this.fetchRedeemCode,
          trackEvent: this.trackEvent,
          eventBus: this.eventBus,
          network: network,
          forceStart: props.forceStart,
          displayDirectTag: state.displayDirectTag || props.displayDirectTag,
          displayImpTrackers: props.displayImpTrackers,
          displayAdClickThroughLink: props.displayAdClickThroughLink,
          macroParams: state.macroParams,
          projectScriptMode: state.projectScriptMode,
          fetchThirdPartyProductData: this.fetchThirdPartyProductData,
          personalizeMsg: state.personalizeMsg
        }) : null,
        state.json && (state.json.views_exhausted || state.json.no_video_schedule || videoNotAvailable || videoNotAvailableByGeo) && !state.editorMode && Object(preact_min["h"])(
          'div',
          {
            className: 'wtViewsExhaustedContainer',
            style: viewsExhaustedBgStyle
          },
          app__ref7
        ),
        !this.isUnlead && state.noBranding && !state.isAd && Object(preact_min["h"])('div', {
          className: 'wtBrandingLogo'
        }),
        state.loader && !state.json.views_exhausted && !state.json.no_video_schedule && !videoNotAvailable && !videoNotAvailableByGeo && !state.projectScriptMode && (!state.isAd || state.isAd && components_config["b" /* constants */].NO_LOADER_NETWORKS.every(function (nw) {
          return nw.toLowerCase() !== network;
        })) ? Object(preact_min["h"])(
          'div',
          { 'class': 'apploader ' + (this.isUnlead ? 'unlead' : '') },
          app__ref8
        ) : null,
        state.showDebugConsole ? Object(preact_min["h"])(
          'div',
          { 'class': 'debugConsole' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'debug-info' },
            Object(preact_min["h"])(
              'p',
              null,
              'window.innerHeight: ' + window.innerHeight
            ),
            Object(preact_min["h"])(
              'p',
              null,
              'window.innerWidth: ' + window.innerWidth
            ),
            Object(preact_min["h"])(
              'p',
              null,
              'document.body.clientHeight: ' + document.body.clientHeight
            )
          )
        ) : null,
        !this.state.viewer_id && app__ref9
      );
    } else return null;
  };

  App.prototype.start = function start(creativeData) {
    var _this2 = this;

    var init = void 0;
    var isAd = false;
    var mraidProjectVideoFetch = void 0;
    if (typeof creativeData !== 'undefined' || this.props.type === 'MRAID') {
      isAd = true;

      if (this.props.type === 'MRAID') {
        // extracting the network name & tid from the mraid data---
        var networkData = this.props.networkData;
        if (networkData) {
          var temp = networkData.split("'").join('');
          temp = temp.split(';');
          var network = temp.find(function (item) {
            return item.indexOf('network:') !== -1;
          });
          network = network.split(':')[1];
          if (network) {
            this.network = network;
          }
          var tid = temp.find(function (item) {
            return item.indexOf('tid:') !== -1;
          });
          tid = tid.split(':')[1];
          if (tid) {
            this.tid = tid;
          }
        }

        // to fetch the videoId in case of project for MRAID ad---
        if (this.props.isProject) {
          mraidProjectVideoFetch = new Promise(function (resolve, reject) {
            _this2.store.fetchProjectVideoId(_this2.props.videoString, _this2.props.mraidTarget).then(function (res) {
              var projectVideoId = res.data && res.data.guid;

              if (projectVideoId && projectVideoId.length === 16) {
                _this2.setState({ projectVideoId: projectVideoId }, function () {
                  var projectVideoString = '' + _this2.props.videoString.substr(0, 16) + _this2.state.projectVideoId;
                  init = _this2.store.initializeAd(null, projectVideoString, _this2.props.mraidTarget, 'MRAID', { network: _this2.network, tid: _this2.tid }).then(function (resInit, rejInit) {
                    resolve(resInit);
                  });
                });
              } else {
                // mraid dummy data when no project video schedule is available, in that case videoid can't be fetched so no datajson is called---
                var dummyData = {
                  json: {
                    tags: [],
                    trackers: []
                  },
                  id: 0
                };

                resolve(dummyData);
              }
            });
          }).catch(function (err) {
            console.log('error fetching project video id', err);
          });
        } else {
          init = this.store.initializeAd(null, this.props.videoString, this.props.mraidTarget, 'MRAID', { network: this.network, tid: this.tid });
        }

        this.loadCSSPromise = helper["J" /* loadCSS */](helper["l" /* getCSSPath */](this.props.mraidTarget), app_HEAD);
      } else {
        try {
          creativeData = JSON.parse(creativeData);
        } catch (e) {}

        var _network = creativeData && creativeData.network;
        if (_network) {
          this.network = _network;
        }
        var _tid = creativeData && creativeData.tid;
        if (_tid) {
          this.tid = _tid;
        }

        var release_version = creativeData && creativeData.release_version;

        var currentDomain = creativeData && creativeData.srv && helper["S" /* trimLastSlash */](creativeData.srv);
        var staticDomain = creativeData && creativeData.static && helper["S" /* trimLastSlash */](creativeData.static);
        Object(components_config["f" /* setDomain */])(currentDomain);
        init = this.store.initializeAd(creativeData, null, null, 'VPAID', {
          network: this.network,
          tid: this.tid
        });
        var cssDomain = staticDomain || currentDomain;
        this.loadCSSPromise = helper["J" /* loadCSS */](helper["l" /* getCSSPath */](cssDomain, release_version), app_HEAD);
      }
    } else {
      if (this.state.isPluggedIn) {
        var videoId = this.state.projectVideoId || this.props.videoId;
        init = this.store.initialize(this.props.bucketId, videoId, this.props.json, this.props.forceStart);
      } else {
        init = this.store.initialize();
      }
    }

    this.loadCSSPromise = components_config["a" /* config */].env === components_config["b" /* constants */].ENV_DEV ? this.emptyPromise : this.loadCSSPromise;

    Promise.all([init, this.loadCSSPromise, this.loadTypeFacePromise, mraidProjectVideoFetch]).then(function (res) {
      // console.log('promiseAll res', res);
      var response = _this2.props.isProject ? res[3] : res[0];

      _this2.logDataEvent = _this2.state.editorMode ? _this2.noop : _this2.store.logDataEvent.bind(_this2.store);
      _this2.logPollOption = _this2.state.editorMode ? _this2.noop : _this2.store.logPollOption.bind(_this2.store);
      _this2.fetchRedeemCode = _this2.state.editorMode ? _this2.noop : _this2.store.fetchRedeemCode.bind(_this2.store);
      _this2.eventBus = _this2.state.editorMode ? _this2.noop : _this2.store.eventBus.bind(_this2.store);

      _this2.setTrackers = _this2.state.editorMode ? _this2.noop : _this2.store.setTrackers(response.json.trackers);
      _this2.trackEvent = _this2.state.editorMode ? _this2.noop : _this2.store.trackEvent.bind(_this2.store, _this2.setTrackers, _this2.logDataEvent);
      _this2.fetchThirdPartyProductData = _this2.state.editorMode ? _this2.emptyPromise : _this2.store.fetchThirdPartyProductData.bind(_this2.store);
      /**
       * Rules based interactivity---
       */
      if (response.json.active_rules) {
        var allRuleCurrValue = response.json.active_rules.all || {};
        // Weather rules---
        var customEvents = response.json.live && response.json.live.events;
        var weatherData = customEvents && customEvents.find(function (evt) {
          return evt.type === 'weather';
        });
        var weatherRules = weatherData && weatherData.rules || [];
        var activeWeatherRules = response.json.active_rules.weather || [];
        var activeWeatherRuleValue = allRuleCurrValue.weather || [];
        activeWeatherRules = activeWeatherRules.map(function (r) {
          var ruleId = r.rule_id;
          var ruleValue = activeWeatherRuleValue.find(function (v) {
            return v.id === ruleId;
          });
          var currValue = ruleValue && ruleValue.value;
          if (currValue && String(currValue).includes('_precip_')) {
            currValue = Number(currValue.split('_precip_')[1]) * 100;
            currValue = currValue.toFixed(1);
          }
          return app__extends({}, r, {
            currValue: { val: currValue, id: ruleId }
          });
        });
        // Football rules---
        var footballData = customEvents && customEvents.find(function (evt) {
          return evt.type === 'football';
        });
        var footballRules = footballData && footballData.rules || [];
        var activeFootballRules = response.json.active_rules.football || [];

        // Cricket rules---
        var cricketData = customEvents && customEvents.find(function (evt) {
          return evt.type === 'cricket';
        });
        var cricketRules = cricketData && cricketData.rules || [];
        var activecricketRules = response.json.active_rules.cricket || [];
        var cricketDefaultTagids = cricketData && cricketData.default_tagids || [];

        // Forex rules---
        var forexData = customEvents && customEvents.find(function (evt) {
          return evt.type === 'forex';
        });
        var forexRules = forexData && forexData.rules || [];
        var activeforexRules = response.json.active_rules.forex || [];

        // Stock rules---
        var stockData = customEvents && customEvents.find(function (evt) {
          return evt.type === 'stock';
        });
        var stockRules = stockData && stockData.rules || [];
        var activestockRules = response.json.active_rules.stock || [];

        // Crypto rules---
        var cryptoData = customEvents && customEvents.find(function (evt) {
          return evt.type === 'crypto';
        });
        var cryptoRules = cryptoData && cryptoData.rules || [];
        var activecryptoRules = response.json.active_rules.crypto || [];

        // mapping each tagid in active rule to its current value---
        var activeTagidValueMapping = {};

        if (weatherRules.some(function (r) {
          return r.tagids;
        }) || footballRules.some(function (r) {
          return r.tagids;
        }) || cricketRules.some(function (r) {
          return r.tagids;
        }) || forexRules.some(function (r) {
          return r.tagids;
        }) || stockRules.some(function (r) {
          return r.tagids;
        }) || cryptoRules.some(function (r) {
          return r.tagids;
        })) {
          var _concat$concat$concat, _concat$concat$concat2, _concat$concat$concat3, _concat$concat, _concat, _ref10;

          activeWeatherRules.forEach(function (rule) {
            var tags = rule.tagids || [];
            tags.forEach(function (tag) {
              var current = activeTagidValueMapping[tag] || [];
              activeTagidValueMapping[tag] = [].concat(current, [rule.currValue]);
            });
          });
          var tagids = (_concat$concat$concat = (_concat$concat$concat2 = (_concat$concat$concat3 = (_concat$concat = (_concat = (_ref10 = []).concat.apply(_ref10, activeWeatherRules.map(function (rule) {
            var tags = rule.tagids || [];
            return tags;
          }))).concat.apply(_concat, activeFootballRules.map(function (rule) {
            var tags = rule.tagids || [];
            return tags;
          }))).concat.apply(_concat$concat, activecricketRules.map(function (rule) {
            var tags = rule.tagids || [];
            return tags;
          }))).concat.apply(_concat$concat$concat3, activeforexRules.map(function (rule) {
            var tags = rule.tagids || [];
            return tags;
          }))).concat.apply(_concat$concat$concat2, activestockRules.map(function (rule) {
            var tags = rule.tagids || [];
            return tags;
          }))).concat.apply(_concat$concat$concat, activecryptoRules.map(function (rule) {
            var tags = rule.tagids || [];
            return tags;
          }));
          /**
           * will need to concat default tagids later on when they will be available for all signals..
           * for now only cricket has default_tagids.
           * */
          tagids = tagids.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
          if (tagids.length === 0) {
            tagids = cricketDefaultTagids;
          }
          response.json.tags = response.json.tags.filter(function (t) {
            return tagids.includes(t.id);
          }).map(function (t) {
            return app__extends({}, t, {
              activeSignalRuleValue: activeTagidValueMapping[t.id]
            });
          });
        }
        // For Display Ads if any rule is active the first active tag is set as display tag
        if (_this2.props.displayDirectTag && response.json.tags.length > 0) {
          _this2.updateState({ displayDirectTag: response.json.tags[0].id });
        }
      }
      var allInitialTags = response.json.tags;
      // Check if age gate is there in json---
      response.json = helper["i" /* filterAgeGate */](response.json);

      response.json.tags = _this2.initTags(response.json.tags, response.json.meta);

      /**
       * Hotspot skin rules---
       */
      var customSkinData = response.json.custom && response.json.custom.customskin;
      var customSkinDataEnabled = customSkinData && customSkinData.enableSkin;
      var customSkinTagsData = customSkinDataEnabled && customSkinData.tagsAttribute || [];
      if (customSkinTagsData.length > 0) {
        customSkinTagsData.forEach(function (item) {
          if (item.hotspots && item.hotspots.length > 0) {
            item.hotspots.forEach(function (ht) {
              if (ht.tagId) {
                // skip this tag id
                response.json.tags = response.json.tags.filter(function (t) {
                  return t.id != ht.tagId;
                });
              }
            });
          }
        });
      }

      /**
       * Progress Bar connected tag---
       */
      var abConfig = response.json.config_data_json && response.json.config_data_json.abConfig;
      if (abConfig && abConfig.enableProgressBarImage && abConfig.pbTagConnected) {
        response.json.tags = response.json.tags.filter(function (t) {
          return t.id != abConfig.pbConnectedTagId;
        });
      }
      response.json.meta = response.json.meta || {};
      // response.json.meta.skin_version = 'v3';
      // response.json.meta.skin_launch = 0;

      response.json.custom = response.json.custom || {};

      var branding = response.branding;
      var enabled = branding && branding.enabled;
      var expiry = branding && branding.expiry;
      var timeNow = Date.now();
      var expiryToTimestamp = expiry && expiry !== -1 && new Date(expiry).getTime();
      var brandingExpired = expiryToTimestamp && timeNow - expiryToTimestamp > 0;
      var noBranding = enabled === 0 || brandingExpired ? true : false;
      var customCss = response.json && response.json.config_data_json && response.json.config_data_json.customCss;
      if (customCss) {
        helper["b" /* addCustomCssNode */](customCss);
      }

      // Video Impression Trackers---
      var videoImpTrackers = response.json && response.json.config_data_json && response.json.config_data_json.impTracker || '';
      videoImpTrackers = videoImpTrackers.split('||');
      if (videoImpTrackers.length > 0) {
        videoImpTrackers.forEach(function (tracker) {
          if (tracker) {
            helper["c" /* addPixelImage */](tracker);
          }
        });
      }
      //---------------------------
      _this2.setState({
        adType: _this2.props.type === 'MRAID' ? 'mraid' : 'vpaid',
        adUnitSrv: response.adUnit && response.adUnit.srv,
        creativeData: creativeData,

        id: response.id,
        isAd: isAd,
        isFacebookApp: response.isFacebookApp,
        isMobileDevice: response.isMobileDevice,
        isTabletDevice: response.isTabletDevice,
        orientation: response.orientation,
        json: response.json,
        network: _this2.network,
        noBranding: noBranding,
        ready: true,
        allInitialTags: allInitialTags
      }, function () {
        _this2.logUniqueView();
      });
    });
    /** TTDMACROS
     * For Display Ads meta wootag:macro_tracker has the tracker url with macro placeholders which the
     * ad network updates while serving the ad
     * For Vpaid Ads the tracker url is in the AdParameters > macro_tracker key
     * Once we have that url with updated parameters we extract out those parameters and pass it by key name
     * to the desired trackers.
     * Currently implemented on Contest/Survey Answer clicks only...
     */
    var macroParams = this.props.macroParams;

    if (isAd && creativeData) {
      macroParams = creativeData.macro_tracker && helper["z" /* getUrlParams */](creativeData.macro_tracker);
    }
    this.setState({ macroParams: macroParams }, function () {
      _this2.store.setThirdParyTrackerData(macroParams);
    });

    if (!isAd) {
      var urlParams = helper["z" /* getUrlParams */](window.location.href);
      var showPersonalizeMsg = urlParams.wt_name && urlParams.wt_name !== '[RECIPIENT]';
      var templateId = urlParams.hstid || '1';
      if (showPersonalizeMsg) {
        if (urlParams.wt_name === '[RECIPIENT]') {
          urlParams.wt_name = '';
        }
        if (urlParams.wt_org === '[RECIPIENT_ORGANIZATION]') {
          urlParams.wt_org = '';
        };
        helper["h" /* fetchPersonalizeJson */]().then(function (json) {
          // console.log({ json });
          var template = json && json.templates && json.templates[templateId];
          var animations = json && json.animations;
          var animation = template && template.animation;
          var defaultAnimation = animations.find(function (a) {
            return a.type === animation.type;
          });
          var animationData = app__extends({}, defaultAnimation, animation);
          var theme = template && template.theme;
          var keywords = template && template.keywords || [];
          var keywordMap = {};
          keywords.forEach(function (k) {
            return keywordMap[k] = urlParams[k];
          });
          var tagline = template && template.tagline || '';

          keywords.forEach(function (k) {
            if (keywordMap[k]) {
              tagline = tagline.replace('{{' + k + '}}', keywordMap[k]);
              tagline = tagline.replaceAll('[[' + k + ']]', '');
            } else {
              // remove everything between `[[${k}]]` && `[[${k}]]`
              var reg = new RegExp('\\[\\[' + k + '\\]\\].*\\[\\[' + k + '\\]\\]', 'g');
              tagline = tagline.replace(reg, '');
            }
          });
          _this2.setState({
            personalizeMsg: tagline ? { tagline: tagline, style: theme, animation: animationData } : null
          });
        });
      }
    }
  };

  App.prototype.logUniqueView = function logUniqueView() {
    this.logDataEvent({
      type: 'unique_access',
      sub_type: null,
      event: 'unique_access',
      event_type: null
    });
  };

  App.prototype.setJSON = function setJSON(data) {
    var _this3 = this;

    this.store.setTags(data).then(function (json) {
      json.tags = _this3.filterHotspotTagPreview(json);
      if (_this3.state.editorMode) {
        json.otags = json.tags;
      }

      _this3.setState({
        json: json
      }, function () {
        _this3.forceUpdate();
      });
    });
  };

  App.prototype.handleOrientationChange = function handleOrientationChange(e) {
    var _this4 = this;

    if ((!window.keyboardOpen || e.type === 'orientationchange') && !this.state.isFacebookAd) {
      setTimeout(function () {
        _this4.setState({
          orientation: helper["u" /* getOrientation */](_this4.state.orientation),
          loader: true
        });
      }, 100);
      setTimeout(function () {
        if (_this4.state.loader) {
          _this4.setState({
            loader: false
          }, function () {
            document.body.scrollTop = 0;
          });
        }
      }, 1000);
    }
  };

  App.prototype.removeLoader = function removeLoader() {
    var _this5 = this;

    setTimeout(function () {
      _this5.setState({
        loader: false
      });
    }, 100);
  };

  App.prototype.forceMobileEmulation = function forceMobileEmulation() {
    this.setState({
      isMobileDevice: true
      // orientation: 'portrait'
    });
  };

  App.prototype.forceDesktopEmulation = function forceDesktopEmulation() {
    this.setState({
      isMobileDevice: false
    });
  };

  App.prototype.noop = function noop() {
    return;
  };

  App.prototype.emptyPromise = function emptyPromise() {
    return new Promise(function (resolve) {
      return resolve;
    });
  };

  return App;
}(preact_min["Component"]);



var app_VpaidAd = function (_Linear) {
  app__inherits(VpaidAd, _Linear);

  function VpaidAd(props) {
    app__classCallCheck(this, VpaidAd);

    var _this6 = app__possibleConstructorReturn(this, _Linear.call(this));

    _this6.fixIframe = function () {
      // wrapper iframe hacks, when our player loads inside a wrapper---
      var selfIframe = window.frameElement;
      // console.log('selfIframe>>>', selfIframe);

      if (selfIframe) {
        selfIframe.setAttribute('style', 'display:block; position:absolute; top:0; left:0; z-index:100; width: 1px; min-width: 100%; height: 1px; min-height: 100%; border: 0 none;');
        // for double click there is an element just before the iframe which has width and height defined and has absolute position--
        // since the parent div of these two is also positioned absolute with no width/height defined we just update the position of prev div to relative so it loads below our iframe and sets the width/height of parent---

        var prevSibling = selfIframe.previousElementSibling;

        while (prevSibling) {
          if (prevSibling.style.position == 'absolute') {
            prevSibling.style.cssText = 'position: relative !important;';
          }

          prevSibling = prevSibling.previousElementSibling;
        }
      }
      //---
    };

    _this6.app = props;
    return _this6;
  }

  VpaidAd.prototype.initAd = function initAd(width, height, viewMode, desiredBitrate, creativeData, environmentVars) {
    this.app.start(creativeData.AdParameters);
    this.app.adUnits = new AdUnits();
    this.app.setState({
      adUnitsInit: true,
      adUnitsArgs: arguments,
      initAd: _Linear.prototype.initAd
    });

    this.fixIframe();
  };

  return VpaidAd;
}(Linear);
// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return index_WootagPlayer; });


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var index_url = new URL(document.currentScript.src);
__webpack_require__.p = index_url.origin + __webpack_require__.p;

// For Display AdUnit script tag we fetch the required parameters through div tag instead of meta---
var displayAdunitScript = document.querySelector('.wt-display-adunit');
var displayAd = displayAdunitScript && displayAdunitScript.getAttribute('data-adunit');
var displayAdData = {};
if (displayAd) {
  var index_temp = displayAd.split("'").join("");
  index_temp = index_temp.split(';');
  var displayGUID = index_temp.find(function (item) {
    return item.indexOf('guid:') !== -1;
  });
  displayAdData.guid = displayGUID.split(':')[1];
  var displayBucketName = index_temp.find(function (item) {
    return item.indexOf('bucket_name:') !== -1;
  });
  displayAdData.bucketName = displayBucketName.split(':')[1];
  var displayDirectTag = index_temp.find(function (item) {
    return item.indexOf('direct_tag:') !== -1;
  });
  displayAdData.displayDirectTag = displayDirectTag.split(':')[1];
  var displayForceStart = index_temp.find(function (item) {
    return item.indexOf('force_start:') !== -1;
  });
  displayAdData.forceStart = displayForceStart.split(':')[1];
  var displayImpTrackers = index_temp.filter(function (item) {
    return item.indexOf('impression_tracker:') !== -1;
  });
  displayAdData.displayImpTrackers = displayImpTrackers.map(function (item) {
    return { content: item.split('impression_tracker:')[1] };
  });
}

// Getting the bucketId and videoId from the meta tags, required since project level player implementation---
var metaGUID = document.querySelector("meta[name='wootag:guid']");
var wtGUID = metaGUID && metaGUID.getAttribute('content') || displayAdData.guid;
var metaBucketName = document.querySelector("meta[name='wootag:bucket_name']");
var wtBucketName = metaBucketName && metaBucketName.getAttribute('content') || displayAdData.bucketName;
var metaForceStart = document.querySelector("meta[name='wootag:force_start']");
var index_forceStart = metaForceStart && metaForceStart.getAttribute('content') || displayAdData.forceStart;

var clickThroughLink = document.querySelectorAll('meta[name="wootag:click_through"]');

//FOR TTD DISPLAY MACRO---
var metaMacroLink = document.querySelectorAll('meta[name="wootag:macro_tracker"]');
//---

var index_WootagPlayer = function (_Component) {
  index__inherits(WootagPlayer, _Component);

  function WootagPlayer(props) {
    index__classCallCheck(this, WootagPlayer);

    return index__possibleConstructorReturn(this, _Component.call(this, props));
  }

  WootagPlayer.prototype.render = function render() {
    var bucketId = wtBucketName || this.props.bucketId;
    var videoId = wtGUID || this.props.videoId;

    var wootagDiv = document.getElementsByClassName('Wootag');
    var script = wootagDiv && wootagDiv[0] && wootagDiv[0].nextElementSibling;
    var type = void 0;
    var videoString = void 0;
    var isProject = false;
    var networkData = void 0;
    if (wootagDiv.length > 0 && wootagDiv !== null) {
      type = wootagDiv[0].getAttribute('data-af');
      videoString = wootagDiv[0].getAttribute('data-id');
      isProject = !!wootagDiv[0].getAttribute('data-project');
      networkData = wootagDiv[0].getAttribute('data-pr');
    }

    var clickThroughArray = [];
    clickThroughLink && clickThroughLink.forEach(function (item) {
      return clickThroughArray.push(item.content);
    });
    clickThroughArray = window.clickTag && [window.clickTag] || clickThroughArray;
    // console.log(clickThroughArray);
    //FOR TTD DISPLAY MACRO---
    var macroParams = metaMacroLink && metaMacroLink[0] && metaMacroLink[0].content && Object(helper["z" /* getUrlParams */])(metaMacroLink[0].content);
    //---
    return Object(preact_min["h"])(app_App, { pluggedIn: true,
      video: this.props.video,
      bucketId: bucketId,
      videoId: videoId,
      forceStart: index_forceStart === 'true',
      type: type,
      networkData: networkData,
      videoString: videoString,
      mraidTarget: script && script.src,
      json: this.props.json,
      isProject: isProject,
      displayDirectTag: displayAdData.displayDirectTag,
      displayImpTrackers: displayAdData.displayImpTrackers,
      displayAdClickThroughLink: clickThroughArray,
      macroParams: macroParams
    });
  };

  return WootagPlayer;
}(preact_min["Component"]);



/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "LpE2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rrey":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./booking": [
		"mRWA",
		18
	],
	"./booking/": [
		"mRWA",
		18
	],
	"./booking/index": [
		"mRWA",
		18
	],
	"./booking/index.js": [
		"mRWA",
		18
	],
	"./booking/style": [
		"jaLn",
		60
	],
	"./booking/style.less": [
		"jaLn",
		60
	],
	"./bookingFlight": [
		"OPr7",
		21
	],
	"./bookingFlight/": [
		"OPr7",
		21
	],
	"./bookingFlight/index": [
		"OPr7",
		21
	],
	"./bookingFlight/index.js": [
		"OPr7",
		21
	],
	"./commerce": [
		"zTWF",
		17
	],
	"./commerce/": [
		"zTWF",
		17
	],
	"./commerce/index": [
		"zTWF",
		17
	],
	"./commerce/index.js": [
		"zTWF",
		17
	],
	"./commerce/style": [
		"KH3n",
		59
	],
	"./commerce/style.less": [
		"KH3n",
		59
	],
	"./commerceCollections": [
		"7lDg",
		16
	],
	"./commerceCollections/": [
		"7lDg",
		16
	],
	"./commerceCollections/index": [
		"7lDg",
		16
	],
	"./commerceCollections/index.js": [
		"7lDg",
		16
	],
	"./commerceCollections/style": [
		"XhHy",
		58
	],
	"./commerceCollections/style.less": [
		"XhHy",
		58
	],
	"./commerceMultiStores": [
		"8bRK",
		27
	],
	"./commerceMultiStores/": [
		"8bRK",
		27
	],
	"./commerceMultiStores/index": [
		"8bRK",
		27
	],
	"./commerceMultiStores/index.js": [
		"8bRK",
		27
	],
	"./commerceMultiStores/style": [
		"Ox15",
		57
	],
	"./commerceMultiStores/style.less": [
		"Ox15",
		57
	],
	"./commerceProduct360": [
		"mfFQ",
		9
	],
	"./commerceProduct360/": [
		"mfFQ",
		9
	],
	"./commerceProduct360/index": [
		"mfFQ",
		9
	],
	"./commerceProduct360/index.js": [
		"mfFQ",
		9
	],
	"./commerceProduct360/style": [
		"BJbg",
		56
	],
	"./commerceProduct360/style.less": [
		"BJbg",
		56
	],
	"./decisions": [
		"VXd4",
		19
	],
	"./decisions/": [
		"VXd4",
		19
	],
	"./decisions/index": [
		"VXd4",
		19
	],
	"./decisions/index.js": [
		"VXd4",
		19
	],
	"./decisions/style": [
		"Ymfp",
		55
	],
	"./decisions/style.less": [
		"Ymfp",
		55
	],
	"./decisionsV2": [
		"6klD",
		20
	],
	"./decisionsV2/": [
		"6klD",
		20
	],
	"./decisionsV2/index": [
		"6klD",
		20
	],
	"./decisionsV2/index.js": [
		"6klD",
		20
	],
	"./decisionsV2/style": [
		"y7ol",
		54
	],
	"./decisionsV2/style.less": [
		"y7ol",
		54
	],
	"./eventsCalendar": [
		"0Gvi",
		3
	],
	"./eventsCalendar/": [
		"0Gvi",
		3
	],
	"./eventsCalendar/icons/google.png": [
		"FD/J",
		67
	],
	"./eventsCalendar/icons/ical.png": [
		"moCG",
		66
	],
	"./eventsCalendar/icons/outlook.png": [
		"9kKt",
		65
	],
	"./eventsCalendar/icons/yahoo.png": [
		"E5Gl",
		64
	],
	"./eventsCalendar/index": [
		"0Gvi",
		3
	],
	"./eventsCalendar/index.js": [
		"0Gvi",
		3
	],
	"./eventsCalendar/style": [
		"eaH0",
		53
	],
	"./eventsCalendar/style.less": [
		"eaH0",
		53
	],
	"./eventsWebinar": [
		"SLx+",
		24
	],
	"./eventsWebinar/": [
		"SLx+",
		24
	],
	"./eventsWebinar/index": [
		"SLx+",
		24
	],
	"./eventsWebinar/index.js": [
		"SLx+",
		24
	],
	"./eventsWebinar/style": [
		"g/zr",
		52
	],
	"./eventsWebinar/style.less": [
		"g/zr",
		52
	],
	"./gamesAndAppsDriveInstalls": [
		"UpV/",
		15
	],
	"./gamesAndAppsDriveInstalls/": [
		"UpV/",
		15
	],
	"./gamesAndAppsDriveInstalls/index": [
		"UpV/",
		15
	],
	"./gamesAndAppsDriveInstalls/index.js": [
		"UpV/",
		15
	],
	"./gamesAndAppsDriveInstalls/style": [
		"7ask",
		51
	],
	"./gamesAndAppsDriveInstalls/style.less": [
		"7ask",
		51
	],
	"./gamesAndAppsDriveUsage": [
		"C6SR",
		14
	],
	"./gamesAndAppsDriveUsage/": [
		"C6SR",
		14
	],
	"./gamesAndAppsDriveUsage/index": [
		"C6SR",
		14
	],
	"./gamesAndAppsDriveUsage/index.js": [
		"C6SR",
		14
	],
	"./gamesAndAppsDriveUsage/style": [
		"ubS/",
		50
	],
	"./gamesAndAppsDriveUsage/style.less": [
		"ubS/",
		50
	],
	"./intro": [
		"1XEb"
	],
	"./intro/": [
		"1XEb"
	],
	"./intro/index": [
		"1XEb"
	],
	"./intro/index.js": [
		"1XEb"
	],
	"./intro/style": [
		"LpE2"
	],
	"./intro/style.less": [
		"LpE2"
	],
	"./offersBanner": [
		"pV+m",
		13
	],
	"./offersBanner/": [
		"pV+m",
		13
	],
	"./offersBanner/index": [
		"pV+m",
		13
	],
	"./offersBanner/index.js": [
		"pV+m",
		13
	],
	"./offersBanner/style": [
		"dxSp",
		49
	],
	"./offersBanner/style.less": [
		"dxSp",
		49
	],
	"./offersMultipleCode": [
		"bWGP",
		1
	],
	"./offersMultipleCode/": [
		"bWGP",
		1
	],
	"./offersMultipleCode/index": [
		"bWGP",
		1
	],
	"./offersMultipleCode/index.js": [
		"bWGP",
		1
	],
	"./offersMultipleCode/style": [
		"ujL/",
		48
	],
	"./offersMultipleCode/style.less": [
		"ujL/",
		48
	],
	"./offersOfferOnAndOffline": [
		"dqWb",
		12
	],
	"./offersOfferOnAndOffline/": [
		"dqWb",
		12
	],
	"./offersOfferOnAndOffline/index": [
		"dqWb",
		12
	],
	"./offersOfferOnAndOffline/index.js": [
		"dqWb",
		12
	],
	"./offersOfferOnAndOffline/style": [
		"3Uzo",
		47
	],
	"./offersOfferOnAndOffline/style.less": [
		"3Uzo",
		47
	],
	"./offersSingleCode": [
		"gIe9",
		0
	],
	"./offersSingleCode/": [
		"gIe9",
		0
	],
	"./offersSingleCode/index": [
		"gIe9",
		0
	],
	"./offersSingleCode/index.js": [
		"gIe9",
		0
	],
	"./offersSingleCode/style": [
		"/ZWR",
		46
	],
	"./offersSingleCode/style.less": [
		"/ZWR",
		46
	],
	"./participationBookDemo": [
		"7Wi2",
		26
	],
	"./participationBookDemo/": [
		"7Wi2",
		26
	],
	"./participationBookDemo/index": [
		"7Wi2",
		26
	],
	"./participationBookDemo/index.js": [
		"7Wi2",
		26
	],
	"./participationBookDemo/style": [
		"DpQk",
		45
	],
	"./participationBookDemo/style.less": [
		"DpQk",
		45
	],
	"./participationCall": [
		"jfQj",
		30
	],
	"./participationCall/": [
		"jfQj",
		30
	],
	"./participationCall/index": [
		"jfQj",
		30
	],
	"./participationCall/index.js": [
		"jfQj",
		30
	],
	"./participationCall/style": [
		"TnYO",
		44
	],
	"./participationCall/style.less": [
		"TnYO",
		44
	],
	"./participationContest": [
		"OgWt",
		6
	],
	"./participationContest/": [
		"OgWt",
		6
	],
	"./participationContest/index": [
		"OgWt",
		6
	],
	"./participationContest/index.js": [
		"OgWt",
		6
	],
	"./participationContest/style": [
		"CtPq",
		43
	],
	"./participationContest/style.less": [
		"CtPq",
		43
	],
	"./participationCounter": [
		"5B0X",
		5
	],
	"./participationCounter/": [
		"5B0X",
		5
	],
	"./participationCounter/index": [
		"5B0X",
		5
	],
	"./participationCounter/index.js": [
		"5B0X",
		5
	],
	"./participationCounter/style": [
		"JC0l",
		42
	],
	"./participationCounter/style.less": [
		"JC0l",
		42
	],
	"./participationFeedback": [
		"Bsgq",
		4
	],
	"./participationFeedback/": [
		"Bsgq",
		4
	],
	"./participationFeedback/index": [
		"Bsgq",
		4
	],
	"./participationFeedback/index.js": [
		"Bsgq",
		4
	],
	"./participationFeedback/style": [
		"stus",
		41
	],
	"./participationFeedback/style.less": [
		"stus",
		41
	],
	"./participationGates": [
		"5j9i",
		25
	],
	"./participationGates/": [
		"5j9i",
		25
	],
	"./participationGates/index": [
		"5j9i",
		25
	],
	"./participationGates/index.js": [
		"5j9i",
		25
	],
	"./participationGates/style": [
		"hFTb",
		40
	],
	"./participationGates/style.less": [
		"hFTb",
		40
	],
	"./participationLeadGen": [
		"NAg6",
		2
	],
	"./participationLeadGen/": [
		"NAg6",
		2
	],
	"./participationLeadGen/index": [
		"NAg6",
		2
	],
	"./participationLeadGen/index.js": [
		"NAg6",
		2
	],
	"./participationLeadGen/style": [
		"m95Y",
		39
	],
	"./participationLeadGen/style.less": [
		"m95Y",
		39
	],
	"./participationPoll": [
		"BYRk",
		11
	],
	"./participationPoll/": [
		"BYRk",
		11
	],
	"./participationPoll/index": [
		"BYRk",
		11
	],
	"./participationPoll/index.js": [
		"BYRk",
		11
	],
	"./participationPoll/style": [
		"wKAC",
		38
	],
	"./participationPoll/style.less": [
		"wKAC",
		38
	],
	"./participationSignUp": [
		"+uR/",
		7
	],
	"./participationSignUp/": [
		"+uR/",
		7
	],
	"./participationSignUp/index": [
		"+uR/",
		7
	],
	"./participationSignUp/index.js": [
		"+uR/",
		7
	],
	"./participationSignUp/style": [
		"N5tO",
		37
	],
	"./participationSignUp/style.less": [
		"N5tO",
		37
	],
	"./showcaseChapter": [
		"WTVM",
		23
	],
	"./showcaseChapter/": [
		"WTVM",
		23
	],
	"./showcaseChapter/index": [
		"WTVM",
		23
	],
	"./showcaseChapter/index.js": [
		"WTVM",
		23
	],
	"./showcaseChapter/style": [
		"44WX",
		36
	],
	"./showcaseChapter/style.less": [
		"44WX",
		36
	],
	"./showcaseGallery": [
		"G1Lv",
		22
	],
	"./showcaseGallery/": [
		"G1Lv",
		22
	],
	"./showcaseGallery/index": [
		"G1Lv",
		22
	],
	"./showcaseGallery/index.js": [
		"G1Lv",
		22
	],
	"./showcaseGallery/style": [
		"UrnG",
		35
	],
	"./showcaseGallery/style.less": [
		"UrnG",
		35
	],
	"./showcaseMultiHotspot": [
		"tiR3",
		10
	],
	"./showcaseMultiHotspot/": [
		"tiR3",
		10
	],
	"./showcaseMultiHotspot/index": [
		"tiR3",
		10
	],
	"./showcaseMultiHotspot/index.js": [
		"tiR3",
		10
	],
	"./showcaseMultiHotspot/style": [
		"fVgZ",
		34
	],
	"./showcaseMultiHotspot/style.less": [
		"fVgZ",
		34
	],
	"./socialEmotion": [
		"cWbQ",
		29
	],
	"./socialEmotion/": [
		"cWbQ",
		29
	],
	"./socialEmotion/index": [
		"cWbQ",
		29
	],
	"./socialEmotion/index.js": [
		"cWbQ",
		29
	],
	"./socialEmotion/style": [
		"1riS",
		33
	],
	"./socialEmotion/style.less": [
		"1riS",
		33
	],
	"./socialShare": [
		"Zbzj",
		28
	],
	"./socialShare/": [
		"Zbzj",
		28
	],
	"./socialShare/index": [
		"Zbzj",
		28
	],
	"./socialShare/index.js": [
		"Zbzj",
		28
	],
	"./socialShare/style": [
		"74bc",
		32
	],
	"./socialShare/style.less": [
		"74bc",
		32
	],
	"./storeLocator": [
		"vWLP",
		8
	],
	"./storeLocator/": [
		"vWLP",
		8
	],
	"./storeLocator/index": [
		"vWLP",
		8
	],
	"./storeLocator/index.js": [
		"vWLP",
		8
	],
	"./storeLocator/style": [
		"GCmX",
		31
	],
	"./storeLocator/style.less": [
		"GCmX",
		31
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Rrey";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "SM8z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__YF6dX","flipPanel":"flipPanel__HC05E","panel":"panel__S3G5l","front":"front__1nKaL","back":"back__3LSlG","open":"open__1S_Nl","slide":"slide__KYgmA","slideContent":"slideContent__2K7E0","slideContent__image":"slideContent__image__1iwje","slideContent__title":"slideContent__title__aa5hc","slideContent__description":"slideContent__description__2CltF"};

/***/ }),

/***/ "SS9h":
/***/ (function(module, exports) {

module.exports = ['handshakeVersion', 'initAd', 'startAd', 'stopAd', 'skipAd', 'resizeAd', 'pauseAd', 'resumeAd', 'expandAd', 'collapseAd', 'getAdLinear', 'getAdWidth', 'getAdHeight', 'getAdExpanded', 'getAdadSkippableState', 'getAdRemainingTime', 'getAdDuration', 'getAdVolume', 'getAdCompanions', 'getAdIcons', 'setAdVolume'];

/***/ }),

/***/ "T1Xn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"socialIcon":"socialIcon__QO1Ts"};

/***/ }),

/***/ "UHtZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboard = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__("eW0v");

var _react2 = _interopRequireDefault(_react);

var _copyToClipboard = __webpack_require__("xbqV");

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CopyToClipboard = exports.CopyToClipboard = function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react2.default.Children.only(children);

      var result = (0, _copyToClipboard2.default)(text, options);

      if (onCopy) {
        onCopy(text, result);
      }

      // Bypass onClick if it was present
      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CopyToClipboard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _text = _props.text,
          _onCopy = _props.onCopy,
          _options = _props.options,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['text', 'onCopy', 'options', 'children']);

      var elem = _react2.default.Children.only(children);

      return _react2.default.cloneElement(elem, _extends({}, props, { onClick: this.onClick }));
    }
  }]);

  return CopyToClipboard;
}(_react2.default.PureComponent);

CopyToClipboard.defaultProps = {
  onCopy: undefined,
  options: undefined
};

/***/ }),

/***/ "UQex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "UXWH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W8q4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WMjk":
/***/ (function(module, exports, __webpack_require__) {

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TinyEmitter = __webpack_require__("Fv1s");
var vpaidMethods = __webpack_require__("SS9h");
var VideoTracker = __webpack_require__("ew2L");
var isSupported = __webpack_require__("esOn");
var NETWORKS = ['Xandr/Appnexus', 'Xandr/OneAd'];
function $removeAll() {
  this._destroyed = true;
  this._videoSlot.src = '';
  if (!NETWORKS.includes(this.network)) {
    this._slot.innerHTML = '';
  }
  this._ui = null;
}

var Linear = function (_TinyEmitter) {
  _inherits(Linear, _TinyEmitter);

  function Linear() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Linear);

    var _this = _possibleConstructorReturn(this, _TinyEmitter.call(this));

    _this.baseUrl = '';
    _this.emitVpaidMethodInvocations();
    _this._ui = {};
    _this.quartileIndexEmitted = -1;
    _this.hasEngaged = false;

    _this._attributes = {
      companions: '',
      desiredBitrate: 256,
      duration: 30,
      remainingTime: -1,
      expanded: false,
      icons: false,
      linear: true,
      adSkippableState: false,
      viewMode: 'normal',
      width: 0,
      height: 0,
      volume: 1.0
    };

    _this.previousAttributes = _extends({}, _this._attributes);

    // open interactive panel -> AdExpandedChange, AdInteraction
    // when close panel -> AdExpandedChange, AdInteraction

    _this.opts = opts;
    _this.opts.videos = _this.opts.videos || [];
    return _this;
  }

  Linear.prototype.set = function set(attribute, newValue) {
    this.previousAttributes[attribute] = this._attributes[attribute];
    this._attributes[attribute] = newValue;
  };

  /**
   * The video player calls handshakeVersion immediately after loading the ad unit to indicate to the ad unit that VPAID will be used.
   * The video player passes in its latest VPAID version string.
   * The ad unit returns a version string minimally set to “1.0”, and of the form “major.minor.patch” (i.e. “2.1.05”).
   * The video player must verify that it supports the particular version of VPAID or cancel the ad.
   *
   * @param {string} playerVPAIDVersion
   * @return {string} adUnit VPAID version format 'major.minor.patch' minimum '1.0'
   */


  Linear.prototype.handshakeVersion = function handshakeVersion(playerVPAIDVersion) {
    return '2.0';
  };

  Linear.prototype.appendStylesheet = function appendStylesheet(path) {
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = this.baseUrl + path;
    link.media = 'all';
    head.appendChild(link);
  };

  /**
   * After the ad unit is loaded and the video player calls handshakeVersion, the video player calls initAd() to initialize the ad experience.
   *
   * The video player may preload the ad unit and delay calling initAd() until nearing the ad playback time; however, the ad unit does not load its assets until initAd() is called. Once the ad unit’s assets are loaded, the ad unit sends the AdLoaded event to notify the video player that it is ready for display. Receiving the AdLoaded response indicates that the ad unit has verified that all files are ready to execute.
   *
   * @param {number} width    indicates the available ad display area width in pixels
   * @param {number} height   indicates the available ad display area height in pixels
   * @param {string} viewMode indicates either “normal”, “thumbnail”, or “fullscreen” as the view mode
   * for the video player as defined by the publisher. Default is “normal”.
   * @param {number} desiredBitrate indicates the desired bitrate as number for kilobits per second
   * (kbps). The ad unit may use this information to select appropriate bitrate for any
   * streaming content.
   * @param {object} creativeData (optional) used for additional initialization data. In a VAST context,
   * the ad unit should pass the value for either the Linear or Nonlinear AdParameter
   * element specified in the VAST document.
   * @param {object} environmentVars (optional) used for passing implementation-specific runtime
   * variables. Refer to the language specific API description for more details.
   */


  Linear.prototype.initAd = function initAd(width, height, viewMode, desiredBitrate, creativeData, environmentVars) {
    var _this2 = this;

    this._attributes.width = width;
    this._attributes.height = height;
    this._attributes.viewMode = viewMode;
    this._attributes.desiredBitrate = desiredBitrate;

    this._slot = environmentVars.slot || this.emit('AdError', 'Video slot is invalid');
    this._videoSlot = environmentVars.videoSlot || this.emit('AdError', 'Slot is invalid');
    var adParams = creativeData && creativeData.AdParameters;
    adParams = typeof adParams === 'string' ? JSON.parse(creativeData.AdParameters) : adParams;
    var network = adParams && adParams.network;
    if (network) {
      this.network = network;
    }
    console.log(this._slot, network);
    var WT_PLAY = document.getElementById('wtPlay');
    WT_PLAY.classList.add('ad');
    if (this._slot.parentNode === WT_PLAY.parentNode) {
      this._slot.appendChild(WT_PLAY);
    }
    if (NETWORKS.includes(this.network)) {
      if (this._slot) {
        var firstIframe = this._slot.getElementsByTagName('iframe') && this._slot.getElementsByTagName('iframe')[0];
        if (firstIframe) {
          firstIframe.style.width = '100%';
          firstIframe.style.height = '100%';
          firstIframe.style.minWidth = '100%';
          firstIframe.style.minHeight = '100%';
        }
      }
    }

    this.useBestVideo().then(function () {
      _this2.emit('AdLoaded');
    }).catch(function (reason) {
      _this2.emit('AdLog', reason);
      _this2.emit('AdLoaded');
    });
    this.videoTracker = new VideoTracker(this._videoSlot, this);
  };

  Linear.prototype.useBestVideo = function useBestVideo() {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var bestVideo = _this3.opts.videos.filter(function (video) {
        return isSupported(video.type);
      });
      if (bestVideo[0]) {
        _this3.setVideoSource(bestVideo[0].url, bestVideo[0].type).then(resolve).catch(reject);
      } else {
        reject(new Error('no supported video found'));
      }
    });
  };

  Linear.prototype.setVideoSlot = function setVideoSlot(node) {
    this._videoSlot = node;
    this.videoTracker = new VideoTracker(this._videoSlot, this);
  };

  Linear.prototype.setVideoSource = function setVideoSource(src, type) {
    var _this4 = this;

    return new Promise(function (resolve, reject) {
      // As Google is not using an actual DOM video, it doesn't implement
      // `onloadeddata`. In normal cases, `onloadeddata` is `null` when no
      // handler function is assigned to it. However in Google's case, it
      // returns as undefined.
      if (typeof _this4._videoSlot.onloadeddata === 'undefined') {
        resolve();
      } else {
        _this4._videoSlot.onloadeddata = resolve;
      }
      _this4._videoSlot.onerror = function (ev) {
        var msg = void 0;
        /* istanbul ignore next */
        switch (ev.target.error.code) {
          case ev.target.error.MEDIA_ERR_ABORTED:
            msg = 'You aborted the video playback.';
            break;
          case ev.target.error.MEDIA_ERR_NETWORK:
            msg = 'A network error caused the video download to fail part-way.';
            break;
          case ev.target.error.MEDIA_ERR_DECODE:
            msg = 'The video playback was aborted due to a corruption problem or because the video used features your browser did not support.';
            break;
          case ev.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
            msg = 'The video could not be loaded, either because the server or network failed or because the format is not supported.';
            break;
          default:
            msg = 'An unknown error occurred.';
            break;
        }
        reject(new Error(msg + ' Type: ' + type + ', source: ' + src));
      };
      _this4._videoSlot.src = src;
      _this4._videoSlot.type = type;
    });
  };

  /**
   * startAd() is called by the video player when the video player is ready for the ad to
   * display. The ad unit responds by sending an AdStarted event that notifies the video player
   * when the ad unit has started playing. Once started, the video player cannot restart the ad unit
   * by calling startAd() and stopAd() multiple times.
   */


  Linear.prototype.startAd = function startAd() {
    var _this5 = this;

    // As Google is not using an actual DOM video, it doesn't implement
    // `onloadeddata`. In normal cases, `onloadeddata` is `null` when no
    // handler function is assigned to it. However in Google's case, it
    // returns as undefined.

    if (typeof this._videoSlot.onloadeddata === 'undefined') {
      this.emit('AdStarted');
    } else {
      // Ideally we want to wait till the first frame is present
      this._videoSlot.onloadeddata = function () {
        _this5.emit('AdStarted');
        _this5.emit('AdImpression');

        var playPromise = _this5._videoSlot.play();

        if (playPromise !== undefined) {
          playPromise.then(function (_) {
            console.log('play() promise handled success');
          }).catch(function (error) {
            console.log('play() promise failed miserably because, ', error);
            _this5._videoSlot.muted = 'true';
            _this5._videoSlot.play();
          });
        }
      };
    }

    this._videoSlot.load();
  };

  /**
   * The video player calls stopAd() when it will no longer display the ad or needs to cancel
   * the ad unit. The ad unit responds by closing the ad, cleaning up its resources and then sending
   * the AdStopped event. The process for stopping an ad may take time.
   */


  Linear.prototype.stopAd = function stopAd() {
    /* istanbul ignore if */
    if (this._destroyed) return;
    var self = this;

    setTimeout(function () {
      $removeAll.call(self);
      self.emit('AdStopped');
    }, 100);
  };

  /**
   * skipAd
   *
   */


  Linear.prototype.skipAd = function skipAd() {
    /* istanbul ignore if */
    if (this._destroyed) return;
    if (!this._attributes.adSkippableState) {
      return false;
    }
    $removeAll.call(this);
    this.emit('AdSkipped');
    this.emit('AdStopped');
  };

  /**
   * The resizeAd() method is only called when the video player changes the width and
   * height of the video content container, which prompts the ad unit to scale or reposition. The ad
   * unit then resizes itself to a width and height that is equal to or less than the width and height
   * supplied by the video player. Once resized, the ad unit writes updated dimensions to the
   * adWidth and adHeight properties and sends the AdSizeChange event to confirm that
   * it has resized itself.
   *
   * @param  {number} width    The maximum display area allotted for the ad. The ad unit must resize itself to a width and height that is within the values provided. The video player must always provide width and height unless it is in fullscreen mode. In fullscreen mode, the ad unit can ignore width/height parameters and resize to any dimension.
   * @param  {number} height   The maximum display area allotted for the ad. The ad unit must resize itself to a width and height that is within the values provided. The video player must always provide width and height unless it is in fullscreen mode. In fullscreen mode, the ad unit can ignore width/height parameters and resize to any dimension.
   * @param  {string} viewMode Can be one of “normal” “thumbnail” or “fullscreen” to indicate the mode to which the video player is resizing. Width and height are not required when viewmode is fullscreen.
   * @return {[type]}          [description]
   */


  Linear.prototype.resizeAd = function resizeAd(width, height, viewMode) {
    this._attributes.width = width;
    this._attributes.height = height;
    this._attributes.viewMode = viewMode;
    this.emit('AdSizeChange');
  };

  /**
   * pauseAd
   *
   */


  Linear.prototype.pauseAd = function pauseAd() {
    this._videoSlot.pause();
    this.emit('AdPaused');
  };

  /**
   * The AdClickThru event is sent by the ad unit when a clickthrough occurs. Three parameters can be included to give the video player the option for handling the event.
   * Three parameters are available for the event:
   * • String url: enables the ad unit to specify the clickthrough url
   * • String Id: used for tracking purposes
   * • Boolean playerHandles: indicates whether the video player or the ad unit handles
   * the event. Set to true, the video player opens the new browser window to the URL provided. Set to false, the ad unit handles the event.
   * The AdClickThru event is included under the same name in Digital Video In-Stream Ad Metrics Definitions and must be implemented to be IAB compliant.
   *
   * This function does some compatibility to ensure clickThrus can be delivered as either and array or an object.
   *
   * @param  {Object} opts [description]
   * @return {[type]}      [description]
   */


  Linear.prototype.clickThru = function clickThru() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    this.emit('AdClickThru', opts.url, opts.id, opts.playerHandles);
  };

  /**
   * resumeAd
   *
   */


  Linear.prototype.resumeAd = function resumeAd() {
    this._videoSlot.play();
    this.emit('AdPlaying');
  };

  /**
   * expandAd
   *
   */


  Linear.prototype.expandAd = function expandAd() {
    this.hasEngaged = true;
    this.set('expanded', true);
    this.emit('AdExpandedChange');
  };

  /**
   * collapseAd
   *
   */


  Linear.prototype.collapseAd = function collapseAd() {
    this.set('expanded', false);
    this.emit('AdExpandedChange');
  };

  /**
   * The video player calls this method to register a listener to a particular event
   *
   * @param  {Function} fn            fn is a reference to the function that needs to be called when the specified event occurs
   * @param  {string}   event         event is the name of the event that the video player is subscribing to
   * @param  {[type]}   listenerScope [optional] listenerScope is a reference to the object in which the function is
   * defined
   */


  Linear.prototype.subscribe = function subscribe(fn, event, listenerScope) {
    this.on(event, fn, listenerScope);
  };

  /**
   * The video player calls this method to remove a listener for a particular event
   *
   * @param  {Function} fn    the event listener that is being removed
   * @param  {string}   event event is the name of the event that the video player is unsubscribing from
   */


  Linear.prototype.unsubscribe = function unsubscribe(fn, event) {
    this.off(event, fn);
  };

  /**
   * getAdLinear
   *
   * @return {boolean}
   */


  Linear.prototype.getAdLinear = function getAdLinear() {
    return this._attributes.linear;
  };

  /**
   * added to provide current width of ad unit after ad has resized
   *
   * @return {number} pixel's size of the ad, is equal to or less than the values passed in resizeAd/initAd
   */


  Linear.prototype.getAdWidth = function getAdWidth() {
    return this._attributes.width;
  };

  /**
   * added to provide current height of ad unit after ad has resized
   *
   * @return {number} pixel's size of the ad, is equal to or less than the values passed in resizeAd/initAd
   */


  Linear.prototype.getAdHeight = function getAdHeight() {
    return this._attributes.height;
  };

  /**
   * getAdExpanded
   *
   * @return {boolean}
   */


  Linear.prototype.getAdExpanded = function getAdExpanded() {
    return this._attributes.expanded;
  };

  /**
   * in support of skippable ads, this feature enables the video
   * player to identify when the ad is in a state where it can be skipped
   *
   * @return {boolean}
   */


  Linear.prototype.getAdSkippableState = function getAdSkippableState() {
    return this._attributes.adSkippableState;
  };

  /**
   * getAdRemainingTime
   *
   * @return {number} seconds, if not implemented will return -1, or -2 if the time is unknown (user is engaged with the ad)
   */


  Linear.prototype.getAdRemainingTime = function getAdRemainingTime() {
    return this.hasEngaged ? -2 : this._videoSlot.duration - this._videoSlot.currentTime;
  };

  /**
   * reports total duration to more clearly report on the changing
   * duration, which is confusing when both remaining time and duration can
   * change
   *
   * @return {number} seconds, if not implemented will return -1, or -2 if the time is unknown (user is engaged with the ad)
   */


  Linear.prototype.getAdDuration = function getAdDuration() {
    return this.hasEngaged ? -2 : this._videoSlot.duration;
  };

  /**
   * getAdVolume
   *
   * @return {number} between 0 and 1, if is not implemented will return -1
   */


  Linear.prototype.getAdVolume = function getAdVolume() {
    return this._attributes.volume;
  };

  /**
   * getAdCompanions - companions are banners outside the video player to reinforce the ad
   *
   * @return {string} VAST 3.0 formart string for <CompanionAds>
   */


  Linear.prototype.getAdCompanions = function getAdCompanions() {
    return this._attributes.companions;
  };

  /**
   * included to support various industry programs which require the
   * overlay of icons on the ad.
   *
   * @return {boolean} if true videoplayer may hide is own icons to not duplicate
   */


  Linear.prototype.getAdIcons = function getAdIcons() {
    return this._attributes.icons;
  };

  /**
   * setAdVolume
   *
   * @param {number} volume  between 0 and 1
   */


  Linear.prototype.setAdVolume = function setAdVolume(volume) {
    console.log('setAdVolume called', volume);
    if (volume < 0 || volume > 1) {
      return this.emit('AdError', 'volume is not valid');
    }

    if (this._videoSlot) {
      this.set('volume', volume);
      this._videoSlot.volume = volume;

      if (typeof this._videoSlot.muted !== 'undefined') {
        this._videoSlot.muted = false;
      }
    }

    this.emit('AdVolumeChange', volume);
  };

  Linear.prototype.emitVpaidMethodInvocations = function emitVpaidMethodInvocations() {
    var _this6 = this;

    vpaidMethods.forEach(function (name) {
      var originalReference = _this6[name];
      _this6[name] = function () {
        for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
          rest[_key] = arguments[_key];
        }

        _this6.emit.apply(_this6, [name + '()'].concat(rest));
        return originalReference.apply(_this6, rest);
      };
    }, this);
  };

  return Linear;
}(TinyEmitter);

module.exports = Linear;

/***/ }),

/***/ "WSn2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"multiCtaWrapper":"multiCtaWrapper__uXaKn","bottom":"bottom__1dwlH","left":"left__3IQ2h","right":"right__37Gc5","vertical":"vertical__3e7ax","top":"top__6XUMV","center":"center__aSAL5","multiCtaPreview":"multiCtaPreview__3kULr","ctaBtnWrapper":"ctaBtnWrapper__ahjQ3","multiCtaBtn":"multiCtaBtn__1xLUc","playStore":"playStore__2BO6c","appStore":"appStore__3eCQD","appButtons":"appButtons__1aeaE"};

/***/ }),

/***/ "WZrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dAjQ":
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;

/***/ }),

/***/ "eW0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("5D9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !process.env || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "esOn":
/***/ (function(module, exports) {

var el = void 0;
module.exports = function (type) {
  if (!el) {
    el = document.createElement('video');
  }
  return !!el.canPlayType(type).replace(/no/, '');
};

/***/ }),

/***/ "ew2L":
/***/ (function(module, exports, __webpack_require__) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var vpaidLifeCycle = __webpack_require__("wPdU");
var quartiles = [{
  value: 0,
  name: vpaidLifeCycle[0]
}, {
  value: 0.25,
  name: vpaidLifeCycle[1]
}, {
  value: 0.50,
  name: vpaidLifeCycle[2]
}, {
  value: 0.75,
  name: vpaidLifeCycle[3]
}];
function handleTimeupdate() {
  var upcomingQuartileIndex = this.quartileIndexEmitted + 1;
  var upcomingQuartile = quartiles[upcomingQuartileIndex];
  if (upcomingQuartile && this.el.currentTime / this.el.duration > upcomingQuartile.value) {
    this.quartileIndexEmitted = upcomingQuartileIndex;
    this.emit(upcomingQuartile.name);
  }
}

function handleEnded() {
  this.emit(vpaidLifeCycle[4]);
  // Garbage collect event listeners
  this.removeEventListeners();
}

var VideoTracker = function () {
  /**
   * [constructor description]
   * @param  {[type]} el      [description]
   * @param  {TinyEmitter} emitter [description]
   * @return {[type]}         [description]
   */
  function VideoTracker(el, emitter) {
    var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'AdVideo';

    _classCallCheck(this, VideoTracker);

    this.el = el;
    this.emitter = emitter;
    this.prefix = prefix;
    this.quartileIndexEmitted = -1;
    this.addEventListeners();
  }

  VideoTracker.prototype.emit = function emit() {
    for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
      rest[_key] = arguments[_key];
    }

    var eventName = this.prefix + rest[0];
    return this.emitter.emit.apply(this.emitter, [eventName].concat(rest.splice(1)));
  };

  VideoTracker.prototype.addEventListeners = function addEventListeners() {
    this.events = {
      handleTimeupdate: handleTimeupdate.bind(this),
      handleEnded: handleEnded.bind(this)
    };
    this.el.addEventListener('timeupdate', this.events.handleTimeupdate);
    this.el.addEventListener('ended', this.events.handleEnded);
  };

  VideoTracker.prototype.removeEventListeners = function removeEventListeners() {
    this.el.removeEventListener('timeupdate', this.events.handleTimeupdate);
    this.el.removeEventListener('ended', this.events.handleEnded);
  };

  return VideoTracker;
}();

module.exports = VideoTracker;

/***/ }),

/***/ "f+DB":
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && msCrypto.getRandomValues.bind(msCrypto);
if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

/***/ }),

/***/ "f6jQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"productShowcaseWrapper":"productShowcaseWrapper__1THur","bottom":"bottom__3v761","left":"left__3KkeH","right":"right__xGHQn","inactive":"inactive__Oezx4","imagesWrapper":"imagesWrapper__wUEmX","collections":"collections__3ZjrJ","footer":"footer__NFcUf","swiperArrowBtn":"swiperArrowBtn__2OJA6","tagTitle":"tagTitle__9YAwA","ctaBtn":"ctaBtn__1aa67","shadow":"shadow__EKEd4","showcaseIconWrapper":"showcaseIconWrapper__iK2We","pulse":"pulse__3KdIV","showcaseIcon":"showcaseIcon__e6Ck6","closeBtnWrapper":"closeBtnWrapper__2Kczz","pulsate":"pulsate__3RLO6","pulsateBubbles":"pulsateBubbles__1_l6A","moveX":"moveX__2U3tN","click2Call__ring":"click2Call__ring__1IaQ2","click2Call__disc":"click2Call__disc__JBMJE","flip":"flip__1sZnE","displayImageAnim":"displayImageAnim__3BiOC","scaleIntoView":"scaleIntoView__aHM_h","scaleOutOfView":"scaleOutOfView__gFHaV","fadeOut":"fadeOut__1A4Ti","ctaAnimation":"ctaAnimation__23-ku","ctaAnimationPulse":"ctaAnimationPulse__bWCXr","LandscapeOTTAnimateIntoView":"LandscapeOTTAnimateIntoView__1qVrT","fadeIn":"fadeIn__3T_IT","moveOutTop":"moveOutTop__3mzAe","moveOutBottom":"moveOutBottom__1zGFC","moveOutRight":"moveOutRight__1lszy","rotate":"rotate__2QLvX","dash":"dash__3Sse-","move":"move__1SQZH","collectionPreviewTitle":"collectionPreviewTitle__1qY9f","collectionThumb":"collectionThumb__3UPXy","displayImageFadeIn":"displayImageFadeIn__2V0vn","displayImageZoomIn":"displayImageZoomIn__1XZcs","displayTextMoveIn":"displayTextMoveIn__2pMzI","displayFadeOut":"displayFadeOut__15nd9","scale":"scale__gDMpW","progressWidth":"progressWidth__6IW_a","slideIn":"slideIn__2ETcB","slideInLeft":"slideInLeft__1lbIj","hotspotCtaFadeIn":"hotspotCtaFadeIn__3Z2W5","hotspotCtaScaleIn":"hotspotCtaScaleIn__1AniA","hotspotCtaScaleOut":"hotspotCtaScaleOut__3v9H8"};

/***/ }),

/***/ "hVVj":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("f+DB");
var bytesToUuid = __webpack_require__("dAjQ");

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;

/***/ }),

/***/ "ipN0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"modalWrapper__3mNO-","modalContainer":"modalContainer__1q1gR","controls":"controls__1QR-J","iconClose":"iconClose__3iY3p"};

/***/ }),

/***/ "oaCj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pulsate":"pulsate__hb_3c","pulsateBubbles":"pulsateBubbles__NkHtu","moveX":"moveX__2VeJL","click2Call__ring":"click2Call__ring__3Lcc0","click2Call__disc":"click2Call__disc__12-64","flip":"flip__2ckqx","displayImageAnim":"displayImageAnim__1j901","scaleIntoView":"scaleIntoView__2nb5H","scaleOutOfView":"scaleOutOfView__2Zj2Z","fadeOut":"fadeOut__3NUrs","pulse":"pulse__oYKpC","ctaAnimation":"ctaAnimation__D77_A","ctaAnimationPulse":"ctaAnimationPulse__2hv84","LandscapeOTTAnimateIntoView":"LandscapeOTTAnimateIntoView__1BqvK","fadeIn":"fadeIn__3ObX4","moveOutTop":"moveOutTop__QQ-3v","moveOutBottom":"moveOutBottom__11lOW","moveOutRight":"moveOutRight__vVRk-","rotate":"rotate__1AOhs","dash":"dash__2SrAB","move":"move__1TbHB","collectionPreviewTitle":"collectionPreviewTitle__1EKEG","collectionThumb":"collectionThumb__1ftEf","displayImageFadeIn":"displayImageFadeIn__1Mikc","displayImageZoomIn":"displayImageZoomIn__3xcGy","displayTextMoveIn":"displayTextMoveIn__3O8kt","displayFadeOut":"displayFadeOut__2Rzbo","scale":"scale__1v_Ay","progressWidth":"progressWidth__3JUB-","slideIn":"slideIn__3PWPi","slideInLeft":"slideInLeft__2uGq8","hotspotCtaFadeIn":"hotspotCtaFadeIn__2_zmX","hotspotCtaScaleIn":"hotspotCtaScaleIn__2EbMX","hotspotCtaScaleOut":"hotspotCtaScaleOut__lidMc"};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "tSbV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IframeVideoContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("UXWH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var IframeVideoContainer = function (_Component) {
  _inherits(IframeVideoContainer, _Component);

  function IframeVideoContainer(props) {
    _classCallCheck(this, IframeVideoContainer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var video = props.video;

    _this.origin = props.domain ? props.domain : window.location.hostname === 'localhost' ? 'http://localhost:8080' : window.location.origin;
    _this.url = window.location.hostname === 'localhost' ? _this.origin + '/' + video.videoId + '?' + (!props.stopAutoplay ? 'autoplay=1&' : '') + 'nologo=1&dp=1' + (props.enableBridge ? '&brg=1' : '') : _this.origin + '/videos/share/v2/' + (video && video.videoId) + '?' + (!props.stopAutoplay ? 'autoplay=1&' : '') + 'nologo=1&dp=1' + (props.enableBridge ? '&brg=1' : '');
    return _this;
  }

  IframeVideoContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.video.videoId !== nextProps.video.videoId) {
      var video = nextProps.video;
      this.origin = nextProps.domain ? nextProps.domain : window.location.hostname === 'localhost' ? 'http://localhost:8080' : window.location.origin;
      this.url = window.location.hostname === 'localhost' ? this.origin + '/' + video.videoId + '?' + (!nextProps.stopAutoplay ? 'autoplay=1&' : '') + 'nologo=1&dp=1' + (this.props.enableBridge ? '&brg=1' : '') : this.origin + '/videos/share/v2/' + (video && video.videoId) + '?' + (!nextProps.stopAutoplay ? 'autoplay=1&' : '') + 'nologo=1&dp=1' + (this.props.enableBridge ? '&brg=1' : '');
    }
  };

  IframeVideoContainer.prototype.render = function render(props, state) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': 'iframeVideoWrapper', style: props.iframeClipPath },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'iframeVideoContainer' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('iframe', { src: this.url, allow: 'autoplay' })
      )
    );
  };

  return IframeVideoContainer;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "takr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vweF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialShareIcons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("W8q4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard__ = __webpack_require__("y78Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("xdL+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper__ = __webpack_require__("EIet");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "zmdi zmdi-facebook" });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "zmdi zmdi-twitter" });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "zmdi zmdi-linkedin" });

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "zmdi zmdi-whatsapp" });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "zmdi zmdi-email" });

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "zmdi zmdi-check" });

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "span",
  null,
  "copied"
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])("i", { className: "zmdi zmdi-link" });

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  "span",
  null,
  "copy"
);

var SocialShareIcons = function (_Component) {
  _inherits(SocialShareIcons, _Component);

  function SocialShareIcons(props) {
    _classCallCheck(this, SocialShareIcons);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onCopyEvent = function (name, link) {
      _this.setState({ copied: true }, function () {
        clearTimeout(_this.copyTimeout);
        _this.copyTimeout = setTimeout(function () {
          _this.setState({ copied: false });
        }, 1000);
        _this.logEngagementEvent(name); // share specific engagement event---
        _this.logEngagementEvent(name, 'engagement');
      });
    };

    _this.handleShareIconClick = function (icon, link) {
      var url = "";
      switch (icon.name) {
        case "facebook":
          url = "https://www.facebook.com/sharer.php?u=" + link;
          break;
        case "twitter":
          url = "https://twitter.com/intent/tweet?url=" + link;
          break;
        case "linkedin":
          url = "https://www.linkedin.com/cws/share?url=" + link;
          break;
        case "whatsapp":
          url = "https://wa.me/?text=" + link;
          break;
        case "email":
          url = "mailto:?subject=" + "Wootag" + "&body=" + link;
          break;
      }
      if (_this.props.onShareIconClick) {
        _this.props.onShareIconClick();
      }
      _this.logEngagementEvent(icon.name); // share specific engagagement event---
      _this.logEngagementEvent(icon.name, 'engagement');
      window.open(url);
    };

    _this.renderIcon = function (iconName) {
      var iconEle = "";
      switch (iconName) {
        case "facebook":
          iconEle = _ref;
          break;
        case "twitter":
          iconEle = _ref2;
          break;
        case "linkedin":
          iconEle = _ref3;
          break;
        case "whatsapp":
          iconEle = _ref4;
          break;
        case "email":
          iconEle = _ref5;
          break;
        case "link":
          iconEle = _this.state.copied ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { className: "wt-share-copy-link" },
            _ref6,
            _this.props.size === "large" && _ref7
          ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            "div",
            { className: "wt-share-copy-link" },
            _ref8,
            _this.props.size === "large" && _ref9
          );
          break;
      }
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        "div",
        { className: "wt-social-share-icon " + iconName },
        iconEle
      );
    };

    _this.logEngagementEvent = function (name, event) {
      var engagements = Object(__WEBPACK_IMPORTED_MODULE_4__helper__["n" /* getEngagements */])(_this.props.tag);
      var action = engagements && engagements[0];
      var actionValueFormtted = action.slug || "share";

      var tag_id = _this.props.tag.id;
      var tag_label = _this.props.tag && _this.props.tag.details && (_this.props.tag.details.preview_title || _this.props.tag.details.title);
      var engagement_id = action && action.id;

      var options = {
        type: actionValueFormtted,
        sub_type: null,
        event: event || "share_engagement",
        event_type: actionValueFormtted,
        tag_id: tag_id,
        tag_label: tag_label,
        engagement_id: engagement_id,
        share_platform: name,
        //   share_link: link,
        current_duration: _this.props.getCurrentTime()
      };
      _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* constants */].LOG_EVENT_ENGAGEMENT, {
        tag: _this.props.tag,
        options: options
      });
    };

    _this.copyTimeout = null;
    _this.state = {
      copied: false
    };
    return _this;
  }

  SocialShareIcons.prototype.render = function render(props, state) {
    var _this2 = this;

    var tag = props.tag,
        size = props.size;

    var engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
    var layout = props.layout || engagement && engagement.layout || 'color';
    var attr = engagement && engagement.attr && JSON.parse(engagement.attr);
    var enabledAttr = attr && attr.filter(function (item) {
      return item.enabled;
    });
    var link = engagement && engagement.link;
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      "ul",
      { "class": "wt-social-share " + layout + " " + (size || "") },
      enabledAttr && enabledAttr.map(function (icon, idx) {
        var isCopy = icon.name === "link";
        if (isCopy) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            __WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard__["CopyToClipboard"],
            { text: link, onCopy: _this2.onCopyEvent.bind(_this2, icon.name, link) },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              "li",
              { key: "icon-" + idx },
              _this2.renderIcon(icon.name)
            )
          );
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          "li",
          {
            key: "icon-" + idx,
            onClick: _this2.handleShareIconClick.bind(_this2, icon, link)
          },
          _this2.renderIcon(icon.name)
        );
      })
    );
  };

  return SocialShareIcons;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "wOWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("WZrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper__ = __webpack_require__("EIet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("xdL+");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'custom-seekbar-still' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', { className: 'zmdi zmdi-pause' });

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', { className: 'zmdi zmdi-play' });

var VideoPlayer = function (_Component) {
  _inherits(VideoPlayer, _Component);

  function VideoPlayer(props) {
    _classCallCheck(this, VideoPlayer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.destroy = function () {
      console.log('destroy video player');
    };

    _this.getSeekValue = function () {
      var duration = _this.getDuration();
      var currentTime = _this.getCurrentTime();

      if (!duration) return 0;else return currentTime / duration * 100;
    };

    _this.handlePlayControlButtonClick = function (e) {
      if (_this.videoEl.paused) {
        _this.play();
        _this.setState({ play: true });
        // this.props.handleVideoEvent();
      } else {
        _this.pause();
        _this.setState({ play: false });
      }
    };

    _this.handleSeek = function (e) {
      var offsetX = e.offsetX;
      var seekWidth = e.target && e.target.offsetWidth;
      var pos = offsetX / seekWidth * 100;

      var duration = _this.videoEl.duration;
      var seektime = pos / 100 * duration;

      _this.videoEl.currentTime = seektime;
    };

    _this.handleVideoClick = function (e) {
      clearTimeout(_this.activeTimer);

      if (_this.state.isActive === 'vjs-user-active') {
        if (_this.state.play !== null) {
          _this.setState({
            isActive: 'vjs-user-inactive'
          });
        } else {
          _this.videoEl.play();
        }
      } else {
        _this.activeTimer = setTimeout(function () {
          _this.setState({
            isActive: 'vjs-user-inactive'
          });
        }, 5000);

        _this.setState({
          isActive: 'vjs-user-active'
        });
      }
    };

    _this.handleTimeUpdate = function () {
      var currentTime = Math.floor(_this.getCurrentTime());
      _this.setState({
        currentTime: currentTime,
        elapsedTime: currentTime
      });

      if (_this.lastRecordedDuration !== currentTime) {
        _this.lastRecordedDuration = currentTime;
        if (currentTime % 5 === 0) {
          var video = _this.state.source;
          var id = video.id;

          if (id) {
            _this.props.logDataEvent({
              video_id: id,
              parent_video_id: _this.props.videoId,
              type: 'view',
              subtype: null,
              event: 'view',
              current_duration: currentTime,
              duration: 5
            });
          }
        }
      }

      /**
      * Showcase video quartile event---
      */
      var quartileEventNames = __WEBPACK_IMPORTED_MODULE_3__config__["b" /* constants */].QUARTILE_EVENT_TYPES;

      var videoDuration = Math.floor(_this.getDuration());
      var currentQuarter = Math.floor(currentTime / (videoDuration / 4));

      if (!_this.trackViewStatus[currentQuarter]) {
        _this.trackViewStatus[currentQuarter] = true;
        var _video = _this.state.source;
        var _id = _video.id || 0; // Sending video_id as 0 by default---
        _this.props.eventBus(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* constants */].LOG_EVENT_QUARTILE, _extends({
          video_id: _id,
          parent_video_id: _this.props.videoId,
          tag: _this.props.tag,
          type: 'showcase_quartile',
          event: 'showcase_quartile',
          current_duration: _this.getCurrentTime(),
          event_type: quartileEventNames[currentQuarter]
        }, _this.props.eventData || {}));
      }
    };

    _this.handlePlayEvent = function () {
      _this.setState({
        isPlaying: true
      }, function () {
        _this.props.handleVideoEvent();
      });
    };

    _this.handlePauseEvent = function () {
      _this.setState({
        isPlaying: false
      });
    };

    _this.play = function () {
      _this.videoEl && _this.videoEl.play();
    };

    _this.pause = function () {
      _this.videoEl && _this.videoEl.pause();
    };

    _this.getCurrentTime = function () {
      if (_this.videoEl) {
        return _this.videoEl.currentTime;
      } else return 0;
    };

    _this.setCurrentTime = function () {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (_this.videoEl) {
        _this.videoEl.currentTime = num;
      }
    };

    _this.getDuration = function () {
      if (_this.videoEl) {
        return _this.videoEl.duration;
      } else return 0;
    };

    _this.state = {
      isActive: 'vjs-user-active',
      play: null
    };
    _this.trackViewStatus = {};
    return _this;
  }

  VideoPlayer.prototype.componentWillMount = function componentWillMount() {
    this.setState({
      source: Object(__WEBPACK_IMPORTED_MODULE_2__helper__["A" /* getVideoURL */])(this.props.item.url, typeof this.props.item.adunit_sizes !== 'undefined' ? this.props.item.adunit_sizes : this.props.item.sizes),
      currentTime: 0,
      elapsedTime: 0
    });
  };

  VideoPlayer.prototype.componentDidMount = function componentDidMount() {
    var currentTime = Math.floor(this.getCurrentTime());
    this.bindEvents();
    this.setState({
      currentTime: currentTime,
      elapsedTime: currentTime
    });
  };

  VideoPlayer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.setState({
      source: null,
      currentTime: 0,
      elapsedTime: 0
    });

    this.unbindEvents();
  };

  VideoPlayer.prototype.render = function render(props, state) {
    var _this2 = this;

    var customSeek = {
      width: this.getSeekValue() + '%',
      background: '#fff'
    };
    var playControlStyle = {
      backgroundColor: props.tag.details.color + '80' || 'transparent'
    };
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': 'vjs-wrap-module video-player-module video-js ' + this.state.isActive, 'data-vjs-player': true, key: this.props.item.url },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('video', { id: 'video.' + props.index,
        'class': 'videoplayer video-js',
        autoplay: props.autoplay,
        poster: props.item.cover_image_selected,
        playsinline: true,
        onClick: this.handleVideoClick,
        onFocus: this.handleVideoClick,
        ref: function ref(el) {
          return _this2.videoEl = el;
        },
        src: this.state.source,
        muted: this.props.isMuted,
        type: 'video/' + props.item.extension }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'custom-controls' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': 'custom-seekbar', ref: function ref(el) {
              return _this2.progressHolderEl = el;
            }, onClick: this.handleSeek },
          _ref,
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'custom-seekbar-progress', style: customSeek })
        )
      ),
      this.state.isActive && !this.props.hideControls ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { onClick: this.handlePlayControlButtonClick, className: 'wt-screen-playControl', style: playControlStyle },
        this.state.isPlaying ? _ref2 : _ref3
      ) : null
    );
  };

  VideoPlayer.prototype.bindEvents = function bindEvents() {
    this.videoEl.addEventListener('timeupdate', this.handleTimeUpdate);
    this.videoEl.addEventListener('play', this.handlePlayEvent);
    this.videoEl.addEventListener('pause', this.handlePauseEvent);
  };

  VideoPlayer.prototype.unbindEvents = function unbindEvents() {
    this.videoEl.removeEventListener('timeupdate', this.handleTimeUpdate);
    this.videoEl.removeEventListener('play', this.handlePlayEvent);
    this.videoEl.removeEventListener('pause', this.handlePauseEvent);
  };

  return VideoPlayer;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ }),

/***/ "wPdU":
/***/ (function(module, exports) {

module.exports = ['Start', 'FirstQuartile', 'Midpoint', 'ThirdQuartile', 'Complete'];

/***/ }),

/***/ "wRU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("UQex");
var invariant = __webpack_require__("wRU+");
var ReactPropTypesSecret = __webpack_require__("Asjh");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "xbqV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__("JUot");

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
      message,
      reselectPrevious,
      range,
      selection,
      mark,
      success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function (e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        e.clipboardData.clearData();
        e.clipboardData.setData(options.format, text);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;

/***/ }),

/***/ "xdL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return links; });
/* unused harmony export engagementTypeMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return icons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return themes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return regex; });
/* harmony export (immutable) */ __webpack_exports__["f"] = setDomain;


var ENV = "production";
var constants = Object.freeze({
  NO_LOADER_NETWORKS: ['LiTv'],
  NO_UMUTE_NETWORKS: ['LiTv', 'OneAd'],
  TEMP_VIEWER_ID: 'TEMP_ID',
  ENV_DEV: 'development',
  ENV_STAGING: 'staging',
  ENV_PROD: 'production',
  S3_BUCKET_PROD: 'wootag-output-beta',
  S3_BUCKET_STAGING: 'wootag-output-beta',

  DEFAULT_BUCKET_ID: '5D031B-E763-3C90',
  DEFAULT_VIDEO_ID: 'AD842E-1AF5-85D6',

  ORIENTATION_PORTRAIT: 'portrait',
  ORIENTATION_LANDSCAPE: 'landscape',

  EDITOR_MODE: 'editorMode',
  DURATION_MODE: 'durationMode',
  CHAPTER_VIEW: 'chapterView',
  PREVIEW_MODE: 'previewMode',
  TAG_OPEN: 'tagOpen',
  TAG_PREVIEW_SMALL_HEIGHT: 480,

  CLICKTHRU_NETWORKS: ['OneAd', 'Xandr/OneAd', 'LiTv'],

  AUTO_EVENT_DELAY: 2000, // delay (in ms) for auto events---
  INTERACTING_EVENT_DELAY: 3000, // delay (in ms) for interacting event fired if tag stays open for this much time---
  INTERACTION_START_EVENT_DELAY: 2000, // delay (in ms) for interaction start event fired if tag stays open for this much time---
  QUARTILE_EVENT_TYPES: ['str', 'frq', 'mid', 'thq', 'com'],
  AGE_GATE_ACCEPTED: 'accepted',
  AGE_GATE_REJECTED: 'rejected',
  LOG_EVENT_CLICK_MANUAL: 'EVT/LOG_EVENT_CLICK_MANUAL',
  LOG_EVENT_CLICK_AUTO: 'EVT/LOG_EVENT_CLICK_AUTO',
  // LOG_EVENT_CLICK_PREVIEW: 'EVT/LOG_EVENT_CLICK_PREVIEW',
  LOG_EVENT_ENGAGEMENT: 'EVT/LOG_EVENT_ENGAGEMENT',
  LOG_EVENT_TAG_OPEN: 'EVT/LOG_EVENT_TAG_OPEN',
  LOG_EVENT_TAG_CLOSE: 'EVT/LOG_EVENT_TAG_CLOSE',
  LOG_EVENT_VIEW: 'EVT/LOG_EVENT_VIEW',
  LOG_EVENT_UNIQUE: 'EVT/LOG_EVENT_UNIQUE',
  LOG_EVENT_UNIQUE_2SEC: 'EVT/LOG_EVENT_UNIQUE_2SEC',
  LOG_EVENT_PLAY: 'EVT/LOG_EVENT_PLAY',
  LOG_EVENT_PAUSE: 'EVT/LOG_EVENT_PAUSE',
  LOG_EVENT_FF: 'EVT/LOG_EVENT_FF',
  LOG_EVENT_VOLUME: 'EVT/LOG_EVENT_VOLUME',
  LOG_EVENT_FOCUS_OUT: 'EVT/LOG_EVENT_FOCUS_OUT',
  LOG_EVENT_FOCUS_IN: 'EVT/LOG_EVENT_FOCUS_IN',
  LOG_EVENT_CONTINUE: 'EVT/LOG_EVENT_CONTINUE',
  LOG_EVENT_REPEAT: 'EVT/LOG_EVENT_REPEAT',
  LOG_EVENT_EMOJI_CLICK: 'EVT/LOG_EVENT_EMOJI_CLICK',
  LOG_EVENT_COMPLETION: 'EVT/LOG_EVENT_COMPLETION',
  LOG_EVENT_QUARTILE: 'EVT/LOG_EVENT_QUARTILE',
  LOG_EVENT_INTERACTING: 'EVT/LOG_EVENT_INTERACTING',
  LOG_EVENT_INTERACTION_START: 'EVT/LOG_EVENT_INTERACTION_START',
  LOG_EVENT_ENDCARD_PREVIEW: 'EVT/LOG_EVENT_ENDCARD_PREVIEW',
  LOG_EVENT_INTERACTION: 'EVT/LOG_EVENT_INTERACTION',
  LOG_EVENT_GALLERY_INTERACTION: 'EVT/LOG_EVENT_GALLERY_INTERACTION',
  LOG_EVENT_FORM_INSIGHT: 'EVT/LOG_EVENT_FORM_INSIGHT'
});

var config = {
  ver: '3.0.0',
  env: ENV,
  STAGING_DOMAIN: 'https://stagingwt.wootag.com',
  PROD_DOMAIN: 'https://www.wootag.com',
  PREPROD_DOMAIN: 'https://preprod.wootag.com',
  GOOGLE_MAP_KEY: ENV === constants.ENV_DEV ? 'AIzaSyDbAhCZcZEBu25gAsCob9ce_fktiZlAh30' : 'AIzaSyDbAhCZcZEBu25gAsCob9ce_fktiZlAh30',
  DOMAIN: ENV === constants.ENV_DEV ? 'https://stagingwt.wootag.com' : window.location.origin,
  CDN: ENV === constants.ENV_DEV ? 'https://stagecdn.wootag.com' : 'https://cdn.wootag.com',
  S3_BUCKET: ENV === constants.ENV_PROD ? constants.S3_BUCKET_PROD : constants.S3_BUCKET_STAGING,
  DEFAULT_BUCKET_ID: ENV !== constants.ENV_PROD ? constants.DEFAULT_BUCKET_ID : null,
  DEFAULT_VIDEO_ID: ENV !== constants.ENV_PROD ? constants.DEFAULT_VIDEO_ID : null,
  TAG_PREVIEW_INDENT: 40,

  engagementTypes: {
    inVideo: 'In-Video',
    outVideo: 'Out-Video',
    inOutVideo: 'In + Out-Video'
  },

  targets: {
    devices: {
      mobile: 'mobile',
      desktop: 'desktop',
      tablet: 'tablet',
      windows: 'windows',
      macos: 'macos',
      ios: 'ios',
      chromeos: 'chromeos',
      android: 'android'
    }
  }
};

var links = {
  swiperCSS: 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.4.2/css/swiper.min.css',
  swiperJS: 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.3.3/js/swiper.min.js',
  fontpath: 'https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css',
  typeface: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap',
  getJSON: function getJSON(bucket, videoId, previewLink) {
    if (previewLink) {
      return config.DOMAIN + '/api/v2/datajson/' + bucket + '/' + videoId + '?mode=preview';
    } else {
      return config.DOMAIN + '/api/v2/datajson/' + bucket + '/' + videoId;
    }
  },
  getCaptions: function getCaptions(bucket, videoId) {
    return config.CDN + '/' + bucket + '/' + videoId + '/captions.json';
  },
  getAdJSON: function getAdJSON(domain, bucket, videoId) {
    return domain + '/api/v2/datajson/' + bucket + '/' + videoId;
  },
  getUserJSON: function getUserJSON(bucketId) {
    return config.DOMAIN + '/api/v2/userjson/' + bucketId;
  },
  sendLogs: function sendLogs(domain) {
    if (domain) {
      return domain + '/api/v1/data/track/event';
    } else {
      return config.DOMAIN + '/api/v1/data/track/event';
    }
  },
  submitPoll: function submitPoll(domain) {
    if (domain) {
      return domain + '/api/v1/data/polls/polls';
    } else {
      return config.DOMAIN + '/api/v1/data/polls/polls';
    }
  },
  getThirdPartyProductData: function getThirdPartyProductData(_ref) {
    var domain = _ref.domain,
        bucket = _ref.bucket,
        videoId = _ref.videoId,
        tagId = _ref.tagId,
        platform = _ref.platform;

    var dom = domain || config.DOMAIN;
    return dom + '/api/v2/productjson/' + bucket + '/' + videoId + '/' + platform + '/' + tagId;
  },
  submitPollOption: config.DOMAIN + '/api/polls/poll',
  mapsapi: 'https://maps.googleapis.com/maps/api/js?key=' + config.GOOGLE_MAP_KEY + '&libraries=places,geometry',
  geoLocationService: 'https://www.googleapis.com/geolocation/v1/geolocate?key=' + config.GOOGLE_MAP_KEY,
  reverseGeocodeService: 'https://maps.googleapis.com/maps/api/geocode/json?latlng={{#latlng}}&language=en&key=' + config.GOOGLE_MAP_KEY,
  mapsPinActive: 'https://cdn.wootag.com/wootag/pin_active.png',
  mapsPinInactive: 'https://cdn.wootag.com/wootag/pin_inactive.png',
  mapsDirections: 'https://www.google.com/maps/dir/?api=1&',
  getGeoLocation: function getGeoLocation(domain) {
    var apiDomain = domain || config.DOMAIN;
    return apiDomain + '/api/v2/geo';
  },
  setGeoLocation: function setGeoLocation(domain) {
    var apiDomain = domain || config.DOMAIN;
    return apiDomain + '/api/v2/geo/cache';
  },
  limitedOfferCodeUsed: getStatsEndpoint(ENV) + '/api/v1/stats/offers/count?video_id={{#videoId}}&tag_id={{#tagId}}',
  fetchRedeemCode: function fetchRedeemCode(domain) {
    if (domain) {
      return domain + '/api/v1/getoffercode';
    } else {
      config.DOMAIN + '/api/v1/getoffercode';
    }
  },
  getProjectVideoId: function getProjectVideoId(domain, videoString) {
    return domain + '/project/customadunit/v2/' + videoString;
  }
};

var engagementTypeMap = {
  100: 'mail',
  101: 'tel'
};

var icons = {
  facebook: 'zmdi zmdi-facebook',
  twitter: 'zmdi zmdi-twitter',
  linkedin: 'zmdi zmdi-linkedin',
  instagram: 'zmdi zmdi-instagram',
  google: 'zmdi zmdi-google'
};

var themes = {
  red: '#F00',
  blue: '#33b0e8',
  white: '#FFF',
  gray: '#999',
  black: '#000',

  variants: {
    light: {
      BACKGROUND: 'rgb(238, 238, 238)',
      BACKGROUND_TAGHEADER: '#f9fafc',
      TEXT: 'rgb(32, 34, 38)',
      TEXTHEADING: 'rgb(95, 101, 108)',
      TEXT_SUBHEADING: 'rgb(158, 158, 158)',
      BORDER_COLOR: '#e5e9ed'
    },
    dark: {
      BACKGROUND: 'rgb(238, 238, 238)',
      BACKGROUND_TAGHEADER: '#f9fafc',
      TEXT: 'rgb(32, 34, 38)',
      TEXTHEADING: 'rgb(95, 101, 108)',
      TEXT_SUBHEADING: 'rgb(158, 158, 158)',
      BORDER_COLOR: '#e5e9ed'
    }
  }
};

var regex = {
  httpCheck: /^(http|https):\/\//,
  extractVideoID: /[A-Z0-9]{6}\-[A-Z0-9]{4}\-[A-Z0-9]{10}\-[A-Z0-9]{4}\-[A-Z0-9]{4}/gi,
  betweenDoubleCurlyBracesInc: /{{(.*?)}}/
};

function getLogsEndpoint(env) {
  var host = window.location.host;
  if (!!host && host.indexOf('wootag.com') !== -1) {
    return 'https://' + host + '/api/v1/data/track/event';
  }
  return config.STAGING_DOMAIN + '/api/v1/data/track/event';
};

function getStatsEndpoint(env) {
  var host = window.location.host;
  if (!!host && host.indexOf('wootag.com') !== -1) {
    return 'https://' + host;
  }
  return config.STAGING_DOMAIN;
};

function getPollsEndpoint(env) {
  var host = window.location.host;
  if (!!host && host.indexOf('wootag.com') !== -1) {
    return 'https://' + host + '/api/v1/data/polls/polls';
  }

  return config.STAGING_DOMAIN + '/api/v1/data/polls/polls';
};

function setDomain(domain) {
  config.DOMAIN = domain;
};

/***/ }),

/***/ "y78Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__("UHtZ"),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.js